webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    validateEmail: function validateEmail(rule, value, callback) {
        var reg = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error('Invalid email.'));
        }
    },
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var role = exports.role = '';
var serverUrl = exports.serverUrl = "https://bpisglobal.com/liugh-web/";
var url = exports.url = "/";
var defaultPageSize = exports.defaultPageSize = 50;

var conditions = exports.conditions = ["New", "Refurbished", "Used like new", "Used very good", "Used good", "Used acceptable", "Collectible like new", "Collectible very good", "Collectible good", "Collectible acceptable"];

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(51);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(61);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(209);

var _axios2 = _interopRequireDefault(_axios);

var _nprogress = __webpack_require__(206);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _globalVar = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.baseURL = _globalVar.serverUrl;
_axios2.default.defaults.transformRequest = function (data) {
    data = (0, _stringify2.default)(data);
    return data;
};

_axios2.default.interceptors.request.use(function (config) {
    var token = sessionStorage.getItem("authorization");
    if (token) {
        config.headers['Authorization'] = token;
    }
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    }

    _nprogress2.default.start();
    return config;
}, function (error) {
    _nprogress2.default.done();
    return _promise2.default.reject(error.response);
});

function handle401Error() {
    console.log('Handling 401 error - Token expired');

    sessionStorage.removeItem("authorization");
    sessionStorage.removeItem("user");
    localStorage.removeItem("authorization");

    if (window.addRouFlag !== undefined) {
        window.addRouFlag = false;
    }

    if (window.Vue && window.Vue.prototype.$message) {
        window.Vue.prototype.$message.error('登录已过期，请重新登录');
    }

    setTimeout(function () {
        console.log('Redirecting to login page:', _globalVar.url + "/");
        window.location.href = _globalVar.url + "/";
    }, 500);
}

_axios2.default.interceptors.response.use(function (response) {
    _nprogress2.default.done();

    if (response.data && response.data.status === 401) {
        console.log('Detected 401 in response data, handling...');
        handle401Error();
        return _promise2.default.reject(new Error('Token expired'));
    }
    return response;
}, function (error) {
    _nprogress2.default.done();

    if (error.response && error.response.status === 401) {
        console.log('Detected HTTP 401, handling...');
        handle401Error();
        return _promise2.default.reject(new Error('Token expired'));
    }

    if (error.message && error.message.includes('401')) {
        console.log('Detected 401 in error message, handling...');
        handle401Error();
        return _promise2.default.reject(new Error('Token expired'));
    }
    return _promise2.default.reject(error);
});
exports.default = _axios2.default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserBalance = exports.getDoctorNurse = exports.getMemberWithGroup = exports.getNurseDoctor = exports.invitationDoctor = exports.getAdminInvitationList = exports.editUserStatus = exports.getAllMemberList = exports.getMemberById = exports.getGroupById = exports.addGroup = exports.deleteGroup = exports.getGroupList = exports.getDoctorMemberList = exports.editInvitationStatus = exports.getInvitations = exports.invitationRegister = exports.getDoctorMembers = exports.editMember = exports.getMembersById = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMembersById = exports.getMembersById = function getMembersById(params) {
    return _axiosInit2.default.post('/member/getMemberById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editMember = exports.editMember = function editMember(params) {
    return _axiosInit2.default.post('/member/editInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorMembers = exports.getDoctorMembers = function getDoctorMembers(params) {
    return _axiosInit2.default.post('/member/getListByLogin', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var invitationRegister = exports.invitationRegister = function invitationRegister(params) {
    return _axiosInit2.default.post('/invitation/inviteUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInvitations = exports.getInvitations = function getInvitations(params) {
    return _axiosInit2.default.post('/invitation/invitationList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editInvitationStatus = exports.editInvitationStatus = function editInvitationStatus(params) {
    return _axiosInit2.default.post('/invitation/editInvitaStatus', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorMemberList = exports.getDoctorMemberList = function getDoctorMemberList(params) {
    return _axiosInit2.default.post('/member/getAllUserByLogin', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getGroupList = exports.getGroupList = function getGroupList(params) {
    return _axiosInit2.default.post('/group/getList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteGroup = exports.deleteGroup = function deleteGroup(params) {
    return _axiosInit2.default.post('/group/delGroupById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addGroup = exports.addGroup = function addGroup(params) {
    return _axiosInit2.default.post('/group/saveOrUpdateGroup', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getGroupById = exports.getGroupById = function getGroupById(params) {
    return _axiosInit2.default.post('/group/getGroupInfoById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getMemberById = exports.getMemberById = function getMemberById(params) {
    return _axiosInit2.default.post('/member/getMemberById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getAllMemberList = exports.getAllMemberList = function getAllMemberList(params) {
    return _axiosInit2.default.post('/admin/queryUsersInfoList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editUserStatus = exports.editUserStatus = function editUserStatus(params) {
    return _axiosInit2.default.post('/admin/modifyUserStatus', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getAdminInvitationList = exports.getAdminInvitationList = function getAdminInvitationList(params) {
    return _axiosInit2.default.post('/admin/invitationList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var invitationDoctor = exports.invitationDoctor = function invitationDoctor(params) {
    return _axiosInit2.default.post('/admin/InvitedDoctor', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getNurseDoctor = exports.getNurseDoctor = function getNurseDoctor(params) {
    return _axiosInit2.default.post('/member/getDoctorInfoByCurrentUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getMemberWithGroup = exports.getMemberWithGroup = function getMemberWithGroup(params) {
    return _axiosInit2.default.post('/group/getGroupAndMemberInfoList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorNurse = exports.getDoctorNurse = function getDoctorNurse(params) {
    return _axiosInit2.default.post('/offer/getNurseInfoListByCurrentUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getUserBalance = exports.getUserBalance = function getUserBalance(params) {
    return _axiosInit2.default.post('/member/getMemberBalance', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.postExportExcel = exports.exportExcel = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var exportExcel = exports.exportExcel = function exportExcel(param) {
    return _axiosInit2.default.get(param.url, { responseType: 'blob' }).then(function (res) {
        var blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        var fileName = param.fileName;
        if ('download' in document.createElement('a')) {
            var elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
        } else {
            navigator.msSaveBlob(blob, fileName);
        }
    }).catch(function (error) {
        return error;
    });
};

var postExportExcel = exports.postExportExcel = function postExportExcel(param) {
    return _axiosInit2.default.post(param.url, param, { responseType: 'blob' }).then(function (res) {
        var blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        var fileName = param.fileName;
        if ('download' in document.createElement('a')) {
            var elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
        } else {
            navigator.msSaveBlob(blob, fileName);
        }
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetPassword = exports.validateResetPassword = exports.requestForgetPassword = exports.getNurseHome = exports.getDoctorHome = exports.logout = exports.getCurrentUser = exports.changeUserInfo = exports.changePassword = exports.register = exports.validateRegister = exports.login = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var login = exports.login = function login(params) {
    return _axiosInit2.default.post('/invite/inviteLogin', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var validateRegister = exports.validateRegister = function validateRegister(params) {
    return _axiosInit2.default.post('/invite/validateInvitedId', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var register = exports.register = function register(params) {
    return _axiosInit2.default.post('/invite/inviteRegister', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var changePassword = exports.changePassword = function changePassword(params) {
    return _axiosInit2.default.post('/invitation/changePwd', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var changeUserInfo = exports.changeUserInfo = function changeUserInfo(params) {
    return _axiosInit2.default.post('/user/modifyPhoneNumber', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCurrentUser = exports.getCurrentUser = function getCurrentUser(params) {
    return _axiosInit2.default.post('/user/currentUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var logout = exports.logout = function logout(params) {
    return _axiosInit2.default.post('/invitation/logout', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorHome = exports.getDoctorHome = function getDoctorHome(params) {
    return _axiosInit2.default.post('/common/getDoctorHomeData', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getNurseHome = exports.getNurseHome = function getNurseHome(params) {
    return _axiosInit2.default.post('/statistics/statisticsNurseData', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var requestForgetPassword = exports.requestForgetPassword = function requestForgetPassword(params) {
    return _axiosInit2.default.post('/passwordResetRequest/sendResetPasswordEmail', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var validateResetPassword = exports.validateResetPassword = function validateResetPassword(params) {
    return _axiosInit2.default.post('/passwordResetRequest/validateResetId', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var resetPassword = exports.resetPassword = function resetPassword(params) {
    return _axiosInit2.default.post('/passwordResetRequest/resetPassword', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendEmail = exports.getStorageFeeList = exports.getWarehouseForWarehouseAdmin = exports.getCurrentWarehouse = exports.addWarehouses = exports.deleteWarehouses = exports.getWarehousesById = exports.getWarehouses = exports.getNurseWarehouses = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNurseWarehouses = exports.getNurseWarehouses = function getNurseWarehouses(params) {
    return _axiosInit2.default.post('/warehouse/queryWareHouseInfoListForNurse', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getWarehouses = exports.getWarehouses = function getWarehouses(params) {
    return _axiosInit2.default.post('/warehouse/queryWareHouseInfoList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getWarehousesById = exports.getWarehousesById = function getWarehousesById(params) {
    return _axiosInit2.default.post('/warehouse/queryWareHouseById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteWarehouses = exports.deleteWarehouses = function deleteWarehouses(params) {
    return _axiosInit2.default.post('/warehouse/deleteWareHouseById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addWarehouses = exports.addWarehouses = function addWarehouses(params) {
    return _axiosInit2.default.post('/warehouse/addWareHouse', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCurrentWarehouse = exports.getCurrentWarehouse = function getCurrentWarehouse(params) {
    return _axiosInit2.default.post('/warehouse/queryCurrentWareHouse', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getWarehouseForWarehouseAdmin = exports.getWarehouseForWarehouseAdmin = function getWarehouseForWarehouseAdmin(params) {
    return _axiosInit2.default.post('/warehouse/getWarehouseByUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getStorageFeeList = exports.getStorageFeeList = function getStorageFeeList(params) {
    return _axiosInit2.default.post('/storageChargeStatistics/getStorageChargeTotal', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var sendEmail = exports.sendEmail = function sendEmail(params) {
    return _axiosInit2.default.post('/warehouse/sendUpcMatchEmailToDoctor', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canTrackingBeClaimed = exports.getAvailableInboundsForClaim = exports.batchRemoveImportTracking = exports.removeImportTracking = exports.getQtyByTracking = exports.bulkClaim = exports.claimTracking = exports.editInboundTracking = exports.bulkReverse = exports.reverseById = exports.bulkConfirm = exports.getBulkConfirmListByBatchNum = exports.bulkRemove = exports.getBatchNumberList = exports.editTrackingById = exports.getTrackingById = exports.removeTracking = exports.importTracking = exports.getTrackingConfirmList = exports.getDoctorTrackingList = exports.getTrackingList = exports.getBatchNumber = exports.cancelInboundByDoctor = exports.cancelNurseInbound = exports.confirmNurseInbound = exports.getNurseConfirmList = exports.getInboundDetail = exports.getUnClaimTracking = exports.getInboundHistoryList = exports.getCancelInboundList = exports.getInboundDetailList = exports.getProductInboundList = exports.getInboundList = undefined;

var _promise = __webpack_require__(51);

var _promise2 = _interopRequireDefault(_promise);

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInboundList = exports.getInboundList = function getInboundList(params) {
    var list = [{
        id: "1",
        offer: "product1",
        quantity: "100",
        createDate: "2019-07-20 12:00:00"
    }, {
        id: "1",
        offer: "product2",
        quantity: "150",
        createDate: "2019-07-20 12:00:00"
    }];
    return _promise2.default.resolve(list);
};

var getProductInboundList = exports.getProductInboundList = function getProductInboundList(params) {
    return _axiosInit2.default.post("/inbound/getDetailByProductNo", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getInboundDetailList = exports.getInboundDetailList = function getInboundDetailList(params) {
    return _axiosInit2.default.post("/inbound/getOfferDetail", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getCancelInboundList = exports.getCancelInboundList = function getCancelInboundList(params) {
    return _axiosInit2.default.post("/inbound/getInboundCancelInfoByDoctorId", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getInboundHistoryList = exports.getInboundHistoryList = function getInboundHistoryList(params) {
    return _axiosInit2.default.post("/inbound/getHistoryInboundData", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getUnClaimTracking = exports.getUnClaimTracking = function getUnClaimTracking(params) {
    return _axiosInit2.default.post("/inbound/getUnClaimTracking", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getInboundDetail = exports.getInboundDetail = function getInboundDetail(params) {
    return _axiosInit2.default.post("/inbound/getInBoundById", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getNurseConfirmList = exports.getNurseConfirmList = function getNurseConfirmList(params) {
    return _axiosInit2.default.post("/inbound/getInboundListByStatus", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var confirmNurseInbound = exports.confirmNurseInbound = function confirmNurseInbound(params) {
    return _axiosInit2.default.post("/inbound/nurseAddStock", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var cancelNurseInbound = exports.cancelNurseInbound = function cancelNurseInbound(params) {
    return _axiosInit2.default.post("/inbound/cancelInboundById", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var cancelInboundByDoctor = exports.cancelInboundByDoctor = function cancelInboundByDoctor(params) {
    return _axiosInit2.default.post("/inbound/cancelInboundByDoctor", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getBatchNumber = exports.getBatchNumber = function getBatchNumber(params) {
    return _axiosInit2.default.post("/inbound/getBatchNumber", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getTrackingList = exports.getTrackingList = function getTrackingList(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getNoMatchData", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorTrackingList = exports.getDoctorTrackingList = function getDoctorTrackingList(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getTrackingListForDoctor", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTrackingConfirmList = exports.getTrackingConfirmList = function getTrackingConfirmList(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getComfiringDataAndProductList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var importTracking = exports.importTracking = function importTracking(params) {
    return _axiosInit2.default.post("/confirmWarehouse/saveImportData", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var removeTracking = exports.removeTracking = function removeTracking(params) {
    return _axiosInit2.default.post("/confirmWarehouse/removeById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTrackingById = exports.getTrackingById = function getTrackingById(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getDetailById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editTrackingById = exports.editTrackingById = function editTrackingById(params) {
    return _axiosInit2.default.post("/confirmWarehouse/editById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBatchNumberList = exports.getBatchNumberList = function getBatchNumberList(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getBatchNumberByType", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var bulkRemove = exports.bulkRemove = function bulkRemove(params) {
    return _axiosInit2.default.post("/confirmWarehouse/batchBulkRemoveByBatchNumber", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBulkConfirmListByBatchNum = exports.getBulkConfirmListByBatchNum = function getBulkConfirmListByBatchNum(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getComfiringDataAndProductList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var bulkConfirm = exports.bulkConfirm = function bulkConfirm(params) {
    return _axiosInit2.default.post("/confirmWarehouse/batchBulkComfirmed", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var reverseById = exports.reverseById = function reverseById(params) {
    return _axiosInit2.default.post("/confirmWarehouse/reverseByCwId", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var bulkReverse = exports.bulkReverse = function bulkReverse(params) {
    return _axiosInit2.default.post("/confirmWarehouse/reverseByBatchNumber", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editInboundTracking = exports.editInboundTracking = function editInboundTracking(params) {
    return _axiosInit2.default.post("/confirmWarehouse/editTracking", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var claimTracking = exports.claimTracking = function claimTracking(params) {
    return _axiosInit2.default.post("/inbound/nurseClaimCompareInboundDetail", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var bulkClaim = exports.bulkClaim = function bulkClaim(params) {
    return _axiosInit2.default.post("/inbound/bulkClaim", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getQtyByTracking = exports.getQtyByTracking = function getQtyByTracking(params) {
    return _axiosInit2.default.post("/common/getNumBytrackingS", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var removeImportTracking = exports.removeImportTracking = function removeImportTracking(params) {
    return _axiosInit2.default.post("/inbound/deleteUnClaimedTrackingImportData", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var batchRemoveImportTracking = exports.batchRemoveImportTracking = function batchRemoveImportTracking(params) {
    return _axiosInit2.default.post("/inbound/batchDeleteUnClaimedTrackingImportData", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getAvailableInboundsForClaim = exports.getAvailableInboundsForClaim = function getAvailableInboundsForClaim(params) {
    return _axiosInit2.default.get("/inbound/available-for-claim", { params: params }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var canTrackingBeClaimed = exports.canTrackingBeClaimed = function canTrackingBeClaimed(params) {
    return _axiosInit2.default.post("/inbound/canTrackingBeClaimed", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.distributeProductTempate = exports.getProductTemplateListByCondition = exports.deleteProductTemplate = exports.getDistributedDoctorName = exports.getProductTemplateById = exports.addProductTemplate = exports.getServiceList = exports.getSizeList = exports.getStockHistory = exports.deleteProduct = exports.getProductFBM = exports.getNotClaimed = exports.getFBM = exports.editFBM = exports.editReportStatus = exports.getInventoryReportList = exports.getInventoryByProduct = exports.reportInventory = exports.getZeroInventory = exports.getUserInventory = exports.getProductById = exports.getDoctorProductList = exports.addProduct = exports.getInventory = exports.getDoctorProduct = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDoctorProduct = exports.getDoctorProduct = function getDoctorProduct(params) {
    return _axiosInit2.default.post('/products/getProductListByCurrentUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventory = exports.getInventory = function getInventory(params) {
    return _axiosInit2.default.post('/products/getProductList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addProduct = exports.addProduct = function addProduct(params) {
    return _axiosInit2.default.post('/products/saveOrUpdateById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorProductList = exports.getDoctorProductList = function getDoctorProductList(params) {
    return _axiosInit2.default.post('/products/getDoctorProductList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductById = exports.getProductById = function getProductById(params) {
    return _axiosInit2.default.post('/products/getProductAndDiscount', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getUserInventory = exports.getUserInventory = function getUserInventory(params) {
    return _axiosInit2.default.post('/inbound/getUserInventoryList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getZeroInventory = exports.getZeroInventory = function getZeroInventory(params) {
    return _axiosInit2.default.post('/inbound/getUserInventoryZeroList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var reportInventory = exports.reportInventory = function reportInventory(params) {
    return _axiosInit2.default.post('/inventoryReport/saveOrUpdateReportInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventoryByProduct = exports.getInventoryByProduct = function getInventoryByProduct(params) {
    return _axiosInit2.default.post('/inventoryReport/getInventoryListByProduct', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventoryReportList = exports.getInventoryReportList = function getInventoryReportList(params) {
    return _axiosInit2.default.post('/inventoryReport/getInventoryReportList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editReportStatus = exports.editReportStatus = function editReportStatus(params) {
    return _axiosInit2.default.post('/inventoryReport/changeInventoryReportStausById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editFBM = exports.editFBM = function editFBM(params) {
    return _axiosInit2.default.post('/fbm/saveOrUpdateFbmInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getFBM = exports.getFBM = function getFBM(params) {
    return _axiosInit2.default.post('/fbm/getFbmList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getNotClaimed = exports.getNotClaimed = function getNotClaimed(params) {
    return _axiosInit2.default.post('/confirmWarehouse/getNotClaimedList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductFBM = exports.getProductFBM = function getProductFBM(params) {
    return _axiosInit2.default.post('/fbm/getProductFBM', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteProduct = exports.deleteProduct = function deleteProduct(params) {
    return _axiosInit2.default.post('/products/deleteProduct', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getStockHistory = exports.getStockHistory = function getStockHistory(params) {
    return _axiosInit2.default.post('/stockOperationLog/getStockOperationLogList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getSizeList = exports.getSizeList = function getSizeList(params) {
    return _axiosInit2.default.post('/boxsizes/selectOptions', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getServiceList = exports.getServiceList = function getServiceList(params) {
    return _axiosInit2.default.post('/serviceFee/selectOptions', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addProductTemplate = exports.addProductTemplate = function addProductTemplate(params) {
    return _axiosInit2.default.post('/products_template/saveOrUpdateTemplateById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductTemplateById = exports.getProductTemplateById = function getProductTemplateById(params) {
    return _axiosInit2.default.post('/products_template/getProductTemplateById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDistributedDoctorName = exports.getDistributedDoctorName = function getDistributedDoctorName(params) {
    return _axiosInit2.default.post('/products_template/getDistributedDoctorName', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteProductTemplate = exports.deleteProductTemplate = function deleteProductTemplate(params) {
    return _axiosInit2.default.post('/products_template/deleteProductTemplate', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductTemplateListByCondition = exports.getProductTemplateListByCondition = function getProductTemplateListByCondition(params) {
    return _axiosInit2.default.post('/products_template/getProductListByCondition', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var distributeProductTempate = exports.distributeProductTempate = function distributeProductTempate(params) {
    return _axiosInit2.default.post('/products_template/distribute', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(840),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(816),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(723)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(851),
  /* scopeId */
  "data-v-cb3238cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getOfferClaimDetails = exports.getOfferDetail = exports.getOpenOffers = exports.removeProposedOffer = exports.editProposedOfferStatus = exports.requestProposedOffers = exports.getProposedOffers = exports.expiredOffers = exports.addOffer = exports.editOfferStatus = exports.getOfferById = exports.getNurseOffer = exports.getDoctorOffer = exports.takeOffer = exports.getTakeOfferDetail = exports.getProposedOfferList = exports.getNurseOfferHistoryList = undefined;

var _promise = __webpack_require__(51);

var _promise2 = _interopRequireDefault(_promise);

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNurseOfferHistoryList = exports.getNurseOfferHistoryList = function getNurseOfferHistoryList(params) {
    return _axiosInit2.default.post('/offer/getOfferTakeListHistory', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getProposedOfferList = exports.getProposedOfferList = function getProposedOfferList(params) {
    return _axiosInit2.default.post('/offer/getOfferListByStatus', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getTakeOfferDetail = exports.getTakeOfferDetail = function getTakeOfferDetail(params) {
    return _axiosInit2.default.post('/offer/getOfferTakeListByStatusAndOfferNo', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var takeOffer = exports.takeOffer = function takeOffer(params) {
    return _axiosInit2.default.post('/offerTake/takeOffer', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getDoctorOffer = exports.getDoctorOffer = function getDoctorOffer(params) {
    return _axiosInit2.default.post('/offer/queryOfferInfoList', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getNurseOffer = exports.getNurseOffer = function getNurseOffer(params) {
    return _axiosInit2.default.post('/offer/getOfferListByDoctorId', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getOfferById = exports.getOfferById = function getOfferById(params) {
    return _axiosInit2.default.post('/offer/queryOfferInfoById', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var editOfferStatus = exports.editOfferStatus = function editOfferStatus(params) {
    return _axiosInit2.default.post('/offer/changeOfferStausById', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var addOffer = exports.addOffer = function addOffer(params) {
    return _axiosInit2.default.post('/offer/saveOrUpdateOfferInfo', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var expiredOffers = exports.expiredOffers = function expiredOffers(params) {
    return _axiosInit2.default.post('/offer/queryExpiredOfferInfoListForNurse', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getProposedOffers = exports.getProposedOffers = function getProposedOffers(params) {
    return _axiosInit2.default.post('/offerProposed/getOfferProposedList', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var requestProposedOffers = exports.requestProposedOffers = function requestProposedOffers(params) {
    return _axiosInit2.default.post('/offerProposed/saveOrUpdateProposedInfo', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var editProposedOfferStatus = exports.editProposedOfferStatus = function editProposedOfferStatus(params) {
    return _axiosInit2.default.post('/offerProposed/changeProposedStausById', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var removeProposedOffer = exports.removeProposedOffer = function removeProposedOffer(params) {
    return _axiosInit2.default.post('/offerProposed/removeProposedOffer', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getOpenOffers = exports.getOpenOffers = function getOpenOffers(params) {
    var list = [{
        id: "1",
        product: 'Product1',
        price: "100",
        total: 100,
        user: "护士1",
        quantity: 15,
        createBy: "神医1",
        createDate: "2019-07-15 07:00:00",
        expires: '2019-07-20 00:00:00',
        note: 'test add offer',
        bonus: "10",
        serviceTag: false,
        scope: "private",
        notify: true,
        users: [1, 2, 3],
        status: "archived"
    }, {
        id: "2",
        product: 'Product2',
        price: "90",
        total: 150,
        quantity: 20,
        user: "护士1",
        createBy: "神医1",
        createDate: "2019-07-15 07:00:00",
        expires: '2019-07-15 00:00:00',
        note: 'test add offer',
        bonus: "10",
        serviceTag: false,
        scope: "private",
        notify: true,
        users: [1, 2],
        status: "archived"
    }, {
        id: "2",
        product: 'Product3',
        price: "150",
        total: 120,
        quantity: 100,
        user: "护士2",
        createBy: "神医1",
        createDate: "2019-07-15 07:00:00",
        expires: '2019-07-15 00:00:00',
        note: 'test add offer',
        bonus: "10",
        serviceTag: false,
        scope: "private",
        notify: true,
        users: [1, 2],
        status: "canceled"
    }];
    return _promise2.default.resolve(list);
};

var getOfferDetail = exports.getOfferDetail = function getOfferDetail(params) {
    var list = [{
        id: "1",
        product: 'Product1',
        price: "100",
        quantity: "20",
        user: "护士1",
        company: "神医1",
        warehouse: "FL 0001",
        date: "2019-07-20 12:00:00"
    }, {
        id: "2",
        product: 'Product1',
        price: "105",
        quantity: "15",
        user: "护士1",
        company: "神医1",
        warehouse: "FL 0002",
        date: "2019-07-20 12:00:00"
    }, {
        id: "1",
        product: 'Product1',
        price: "105",
        quantity: "30",
        user: "护士2",
        company: "神医1",
        warehouse: "FL 0002",
        date: "2019-07-20 12:00:00"
    }];
    return _promise2.default.resolve(list);
};

var getOfferClaimDetails = exports.getOfferClaimDetails = function getOfferClaimDetails(params) {
    return _axiosInit2.default.post('/offer/getOfferClaimDetails', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uploadET = exports.updateOutboundStatus = exports.getCustomizationProduct = exports.markChecked = exports.getTransferUserInfoWithWarehouseByDoctorNo = exports.getTransferUserInfoByDoctorNo = exports.getTransferList = exports.getOutboundList = exports.deleteCustomizationTemplate = exports.addCustomizationTemplate = exports.getOutboundByProduct = exports.getProductsByWarehouseId = exports.getInventorySummary = exports.transferTo = exports.getProductFBM = exports.getInventoryList = exports.deleteInstruction = exports.addInstruction = exports.getInstructionListByPage = exports.getInstructionList = exports.outbound = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var outbound = exports.outbound = function outbound(params) {
    return _axiosInit2.default.post('/outbound/submitOutBound', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInstructionList = exports.getInstructionList = function getInstructionList(params) {
    return _axiosInit2.default.post('/instruction/getListByUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInstructionListByPage = exports.getInstructionListByPage = function getInstructionListByPage(params) {
    return _axiosInit2.default.post('/instruction/getList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addInstruction = exports.addInstruction = function addInstruction(params) {
    return _axiosInit2.default.post('/instruction/addOrEditInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteInstruction = exports.deleteInstruction = function deleteInstruction(params) {
    return _axiosInit2.default.post('/instruction/deleteInstruction', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventoryList = exports.getInventoryList = function getInventoryList(params) {
    return _axiosInit2.default.post('/outbound/getOutBoundAddProduct', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductFBM = exports.getProductFBM = function getProductFBM(params) {
    return _axiosInit2.default.post('/transfer/getProductFBM', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var transferTo = exports.transferTo = function transferTo(params) {
    return _axiosInit2.default.post('/transfer/transferTo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventorySummary = exports.getInventorySummary = function getInventorySummary(params) {
    return _axiosInit2.default.post('/outbound/getOutBoundProductSummary', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductsByWarehouseId = exports.getProductsByWarehouseId = function getProductsByWarehouseId(params) {
    return _axiosInit2.default.post('/outbound/getProductsByWarehouseId', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getOutboundByProduct = exports.getOutboundByProduct = function getOutboundByProduct(params) {
    return _axiosInit2.default.post('/outbound/getOutboundByProduct', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addCustomizationTemplate = exports.addCustomizationTemplate = function addCustomizationTemplate(params) {
    return _axiosInit2.default.post('/outbound/addOrUpdateCustomizationTemplate4Outbound', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteCustomizationTemplate = exports.deleteCustomizationTemplate = function deleteCustomizationTemplate(params) {
    return _axiosInit2.default.post('/outbound/removeCustomizationTemplate4Outbound', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getOutboundList = exports.getOutboundList = function getOutboundList(params) {
    return _axiosInit2.default.post('/outbound/getDataByType', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransferList = exports.getTransferList = function getTransferList(params) {
    return _axiosInit2.default.post('/transfer/getTransferList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransferUserInfoByDoctorNo = exports.getTransferUserInfoByDoctorNo = function getTransferUserInfoByDoctorNo(params) {
    return _axiosInit2.default.post('/transfer/getTransferUserInfoByDoctorNo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransferUserInfoWithWarehouseByDoctorNo = exports.getTransferUserInfoWithWarehouseByDoctorNo = function getTransferUserInfoWithWarehouseByDoctorNo(params) {
    return _axiosInit2.default.post('/transfer/getTransferUserInfoWithWarehouseByDoctorNo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var markChecked = exports.markChecked = function markChecked(params) {
    return _axiosInit2.default.post('/transfer/markChecked', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomizationProduct = exports.getCustomizationProduct = function getCustomizationProduct(params) {
    return _axiosInit2.default.post('/outbound/getCustomizationTemplate4Outbound', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var updateOutboundStatus = exports.updateOutboundStatus = function updateOutboundStatus(params) {
    return _axiosInit2.default.post('/outbound/changeOutboundStausById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var uploadET = exports.uploadET = function uploadET(params) {
    return _axiosInit2.default.post('/outboundFile/upload', params, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteNurseBanks = exports.getNurseBanks = exports.addBanks = exports.queryBankById = exports.getTransaction = exports.addAdjust = exports.getBalance = exports.pay = exports.queryPaymentById = exports.getTransactionHistory = exports.getPendingTransaction = exports.editPaymentStatus = exports.getBankList = exports.addPaymentRequest = exports.getPaymentRequest = undefined;

var _promise = __webpack_require__(51);

var _promise2 = _interopRequireDefault(_promise);

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPaymentRequest = exports.getPaymentRequest = function getPaymentRequest(params) {
    return _axiosInit2.default.post("/payment/getPayments", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addPaymentRequest = exports.addPaymentRequest = function addPaymentRequest(params) {
    return _axiosInit2.default.post("/payment/saveOrUpdateById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBankList = exports.getBankList = function getBankList(params) {
    return _axiosInit2.default.post("/bank/queryBankInfoListNoPage", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editPaymentStatus = exports.editPaymentStatus = function editPaymentStatus(params) {
    return _axiosInit2.default.post("/payment/updatePaymentStatus", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getPendingTransaction = exports.getPendingTransaction = function getPendingTransaction(params) {
    return _axiosInit2.default.post("/payment/getPendingTransaction", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransactionHistory = exports.getTransactionHistory = function getTransactionHistory(params) {
    return _axiosInit2.default.post("/payment/getTransactionHistory", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var queryPaymentById = exports.queryPaymentById = function queryPaymentById(params) {
    return _axiosInit2.default.post("/payment/queryPaymentInfo", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var pay = exports.pay = function pay(params) {
    return _axiosInit2.default.post("/payment/pay", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBalance = exports.getBalance = function getBalance(params) {
    return _axiosInit2.default.post("/payment/getBalance", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addAdjust = exports.addAdjust = function addAdjust(params) {
    return _axiosInit2.default.post("/payment/addAdjustBalance", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransaction = exports.getTransaction = function getTransaction(params) {
    var list = [{
        title: "Withdraw to chase visa 123456",
        user: "护士1",
        amount: 1555,
        balance: "0",
        note: "支付$1555"
    }, {
        user: "护士1",
        product: "product3",
        price: 80,
        quantity: 1,
        amount: 80,
        warehouse: "FL0002",
        date: "2019-08-01",
        balance: "1555"
    }, {
        user: "护士1",
        product: "product2",
        price: 95,
        quantity: 5,
        amount: "475",
        warehouse: "FL0001",
        date: "2019-08-01",
        balance: "1475"
    }, {
        user: "护士1",
        product: "product1",
        price: 100,
        quantity: 10,
        amount: 1000,
        warehouse: "FL0001",
        date: "2019-07-31",
        balance: "1000"
    }];
    return _promise2.default.resolve(list);
};

var queryBankById = exports.queryBankById = function queryBankById(params) {
    return _axiosInit2.default.post("/bank/queryBankInfoById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addBanks = exports.addBanks = function addBanks(params) {
    return _axiosInit2.default.post("/bank/saveOrUpdateBankInfo", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getNurseBanks = exports.getNurseBanks = function getNurseBanks(params) {
    return _axiosInit2.default.post("/bank/queryBankInfoList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteNurseBanks = exports.deleteNurseBanks = function deleteNurseBanks(params) {
    return _axiosInit2.default.post("/bank/deleteBankInfoById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(837),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mixedPackageApi = undefined;

var _promise = __webpack_require__(51);

var _promise2 = _interopRequireDefault(_promise);

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixedPackageApi = exports.mixedPackageApi = {
    createMixedPackage: function createMixedPackage(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/create', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getMixedPackageList: function getMixedPackageList(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/list', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getMixedPackageDetail: function getMixedPackageDetail(mixedPackageId) {
        return _axiosInit2.default.get('/mixed-package/warehouse/detail/' + mixedPackageId).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    cancelMixedPackage: function cancelMixedPackage(mixedPackageId) {
        return _axiosInit2.default.delete('/mixed-package/warehouse/cancel/' + mixedPackageId).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getClaimListForReview: function getClaimListForReview(params) {
        console.log('API: getClaimListForReview called with params:', params);
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/review', params).then(function (res) {
            console.log('API: getClaimListForReview success response:', res);
            return res.data;
        }).catch(function (err) {
            console.log('API: getClaimListForReview error:', err);
            throw err;
        });
    },
    approveClaim: function approveClaim(claimId) {
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/' + claimId + '/approve', {}).then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    },
    adjustClaimQuantity: function adjustClaimQuantity(claimId, params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/' + claimId + '/adjust', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    },
    rejectClaim: function rejectClaim(claimId, params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/' + claimId + '/reject', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    },
    rollbackClaimToPending: function rollbackClaimToPending(claimId) {
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/' + claimId + '/rollback', {}).then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    },
    batchDistribute: function batchDistribute(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/batch-distribute', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    },
    batchDistributeWithIndividualSettings: function batchDistributeWithIndividualSettings(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/batch-distribute-individual', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    },
    getUnclaimedItems: function getUnclaimedItems(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/unclaimed-items', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    exportUnclaimedItems: function exportUnclaimedItems(params) {
        return _axiosInit2.default.post('/excel/exportUnclaimedItems', params, { responseType: 'blob' }).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    exportPendingBatches: function exportPendingBatches(params) {
        return _axiosInit2.default.post('/excel/exportPendingBatches', params, { responseType: 'blob' }).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    countPendingClaims: function countPendingClaims() {
        return _axiosInit2.default.get('/mixed-package/warehouse/pending-claims-count').then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    },
    searchClaimableItems: function searchClaimableItems(params) {
        return _axiosInit2.default.post('/mixed-package/claim/search', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getAccessibleWarehouses: function getAccessibleWarehouses(params) {
        return _axiosInit2.default.post('/mixed-package/claim/accessible-warehouses', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    submitClaim: function submitClaim(params) {
        return _axiosInit2.default.post('/mixed-package/claim/submit', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getMyClaimList: function getMyClaimList(params) {
        return _axiosInit2.default.post('/mixed-package/claim/my-claims', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    cancelClaim: function cancelClaim(claimId) {
        return _axiosInit2.default.delete('/mixed-package/claim/' + claimId).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getPendingClaimQuantity: function getPendingClaimQuantity(inboundNo) {
        return _axiosInit2.default.get('/mixed-package/claim/inbound/' + inboundNo + '/pending-quantity').then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    checkTrackingExists: function checkTrackingExists(tracking) {
        return _axiosInit2.default.get('/mixed-package/check-tracking/' + tracking).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    setForceChargeTime: function setForceChargeTime(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/set-force-charge-time', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    },
    setForceChargeTimeWithIndividualSettings: function setForceChargeTimeWithIndividualSettings(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/set-force-charge-time-individual', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    },
    batchApprove: function batchApprove(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/claims/batch-approve', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    reverseByPackageId: function reverseByPackageId(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/reverse-by-id', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    generateBatchNumber: function generateBatchNumber() {
        return _axiosInit2.default.post('/mixed-package/batch/generateBatchNumber').then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    validateUPCs: function validateUPCs(params) {
        return _axiosInit2.default.post('/mixed-package/batch/validateUPCs', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    batchTextImport: function batchTextImport(params) {
        return _axiosInit2.default.post('/mixed-package/batch/textImport', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    batchExcelImport: function batchExcelImport(formData) {
        return _axiosInit2.default.post('/mixed-package/batch/excelImport', formData).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getPendingBatches: function getPendingBatches(params) {
        return _axiosInit2.default.post('/mixed-package/batch/pending-batches', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getPendingPackages: function getPendingPackages(params) {
        return _axiosInit2.default.post('/mixed-package/batch/pending-packages', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    confirmSinglePackage: function confirmSinglePackage(params) {
        return _axiosInit2.default.post('/mixed-package/batch/confirm-single-package', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            console.error('confirmSinglePackage API error:', err);
            return _promise2.default.reject(err);
        });
    },
    cancelSinglePackage: function cancelSinglePackage(params) {
        return _axiosInit2.default.post('/mixed-package/batch/cancel-single-package', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getPackageDetail: function getPackageDetail(params) {
        return _axiosInit2.default.post('/mixed-package/batch/package-detail', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    deleteUPCFromPackage: function deleteUPCFromPackage(params) {
        return _axiosInit2.default.post('/mixed-package/batch/delete-upc', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    editUPCInPackage: function editUPCInPackage(params) {
        return _axiosInit2.default.post('/mixed-package/batch/edit-upc', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getBatchDetail: function getBatchDetail(batchNumber) {
        return _axiosInit2.default.get('/mixed-package/batch/batch-detail/' + batchNumber).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    bulkConfirmBatch: function bulkConfirmBatch(params) {
        return _axiosInit2.default.post('/mixed-package/batch/bulkConfirm', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getReversibleBatches: function getReversibleBatches(params) {
        return _axiosInit2.default.post('/mixed-package/batch/reversible-batches', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    checkBatchReversibility: function checkBatchReversibility(batchNumber) {
        return _axiosInit2.default.get('/mixed-package/batch/check-reversibility/' + batchNumber).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    bulkReverseBatch: function bulkReverseBatch(params) {
        return _axiosInit2.default.post('/mixed-package/batch/bulkReverse', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    cancelPendingBatch: function cancelPendingBatch(batchNumber) {
        return _axiosInit2.default.delete('/mixed-package/batch/cancel/' + batchNumber).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    estimateBatchOperationTime: function estimateBatchOperationTime(batchNumber, operationType) {
        return _axiosInit2.default.get('/mixed-package/batch/estimate-time/' + batchNumber + '?operationType=' + operationType).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getBatchNumbers: function getBatchNumbers(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/batch-numbers', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    getPackagesByBatchNumber: function getPackagesByBatchNumber(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/packages-by-batch', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    batchBulkReverse: function batchBulkReverse(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/batch-bulk-reverse', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return err;
        });
    },
    updateMixedPackageUPCQty: function updateMixedPackageUPCQty(params) {
        return _axiosInit2.default.post('/mixed-package/warehouse/update-upc-qty', params).then(function (res) {
            return res.data;
        }).catch(function (err) {
            throw err;
        });
    }
};

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(841),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(844),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editDiscount = exports.getDiscountList = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDiscountList = exports.getDiscountList = function getDiscountList(params) {
    return _axiosInit2.default.post('/discount/getDiscountList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editDiscount = exports.editDiscount = function editDiscount(params) {
    return _axiosInit2.default.post('/discount/addOrEditDiscount', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pay4Warehouse = exports.queryPaymentById4Warehouse = exports.editPaymentStatus4Warehouse = exports.addPaymentRequest4Warehouse = exports.getPaymentRequest4Warehouse = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPaymentRequest4Warehouse = exports.getPaymentRequest4Warehouse = function getPaymentRequest4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/getPayments', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addPaymentRequest4Warehouse = exports.addPaymentRequest4Warehouse = function addPaymentRequest4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/saveOrUpdateById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editPaymentStatus4Warehouse = exports.editPaymentStatus4Warehouse = function editPaymentStatus4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/updatePaymentStatus', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var queryPaymentById4Warehouse = exports.queryPaymentById4Warehouse = function queryPaymentById4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/queryPaymentInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var pay4Warehouse = exports.pay4Warehouse = function pay4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/pay', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.warehouseFeeSummary = exports.warehouseFeeDetail = exports.storageFeePay = exports.getWarehouseList = exports.getDoctorList = exports.testRebuildStorageFeeByDaily = exports.testGenStorageFeeByDaily = exports.testGenStorageFeeByMonthly = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var testGenStorageFeeByMonthly = exports.testGenStorageFeeByMonthly = function testGenStorageFeeByMonthly(params) {
    return _axiosInit2.default.get('/thirdPartyLogin/sina_qq', { params: { log_id: params.logId } }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var testGenStorageFeeByDaily = exports.testGenStorageFeeByDaily = function testGenStorageFeeByDaily(params) {
    return _axiosInit2.default.get('/thirdPartyLogin/sina_qqq', { params: {} }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var testRebuildStorageFeeByDaily = exports.testRebuildStorageFeeByDaily = function testRebuildStorageFeeByDaily(params) {
    return _axiosInit2.default.get('/thirdPartyLogin/sina_163', { params: { dates: params.dates } }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorList = exports.getDoctorList = function getDoctorList(params) {
    return _axiosInit2.default.post('/storageFeePayment/getDoctorPaymentList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getWarehouseList = exports.getWarehouseList = function getWarehouseList(params) {
    return _axiosInit2.default.post('/storageFeePayment/getWarehousePaymentList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var storageFeePay = exports.storageFeePay = function storageFeePay(params) {
    return _axiosInit2.default.post('/storageFeePayment/pay', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var warehouseFeeDetail = exports.warehouseFeeDetail = function warehouseFeeDetail(params) {
    return _axiosInit2.default.post('/storageFeePayment/warehouseFeeDetail', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var warehouseFeeSummary = exports.warehouseFeeSummary = function warehouseFeeSummary(params) {
    return _axiosInit2.default.post('/storageFeePayment/warehouseFeeSummary', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(838),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(814),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(717)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(836),
  /* scopeId */
  "data-v-701242b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(854),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(846),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(705)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(809),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */,
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Print = function Print(dom, options) {
    if (!(this instanceof Print)) return new Print(dom, options);

    this.options = this.extend({
        'noPrint': '.no-print'
    }, options);

    if (typeof dom === "string") {
        this.dom = document.querySelector(dom);
    } else {
        this.isDOM(dom);
        this.dom = this.isDOM(dom) ? dom : dom.$el;
    }

    this.init();
};
Print.prototype = {
    init: function init() {
        var content = this.getStyle() + this.getHtml();
        this.writeIframe(content);
    },
    extend: function extend(obj, obj2) {
        for (var k in obj2) {
            obj[k] = obj2[k];
        }
        return obj;
    },

    getStyle: function getStyle() {
        var str = "",
            styles = document.querySelectorAll('style,link');
        for (var i = 0; i < styles.length; i++) {
            str += styles[i].outerHTML;
        }
        str += "<style>" + (this.options.noPrint ? this.options.noPrint : '.no-print') + "{display:none;}</style>";

        return str;
    },

    getHtml: function getHtml() {
        var inputs = document.querySelectorAll('input');
        var textareas = document.querySelectorAll('textarea');
        var selects = document.querySelectorAll('select');

        for (var k = 0; k < inputs.length; k++) {
            if (inputs[k].type == "checkbox" || inputs[k].type == "radio") {
                if (inputs[k].checked == true) {
                    inputs[k].setAttribute('checked', "checked");
                } else {
                    inputs[k].removeAttribute('checked');
                }
            } else if (inputs[k].type == "text") {
                inputs[k].setAttribute('value', inputs[k].value);
            } else {
                inputs[k].setAttribute('value', inputs[k].value);
            }
        }

        for (var k2 = 0; k2 < textareas.length; k2++) {
            if (textareas[k2].type == 'textarea') {
                textareas[k2].innerHTML = textareas[k2].value;
            }
        }

        for (var k3 = 0; k3 < selects.length; k3++) {
            if (selects[k3].type == 'select-one') {
                var child = selects[k3].children;
                for (var i in child) {
                    if (child[i].tagName == 'OPTION') {
                        if (child[i].selected == true) {
                            child[i].setAttribute('selected', "selected");
                        } else {
                            child[i].removeAttribute('selected');
                        }
                    }
                }
            }
        }
        return this.dom.outerHTML;
    },

    writeIframe: function writeIframe(content) {
        var w,
            doc,
            iframe = document.createElement('iframe'),
            f = document.body.appendChild(iframe);
        iframe.id = "myIframe";

        iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
        w = f.contentWindow || f.contentDocument;
        doc = f.contentDocument || f.contentWindow.document;
        doc.open();
        doc.write(content);
        doc.close();
        var _this = this;
        iframe.onload = function () {
            _this.toPrint(w);
            setTimeout(function () {
                document.body.removeChild(iframe);
            }, 100);
        };
    },

    toPrint: function toPrint(frameWindow) {
        try {
            setTimeout(function () {
                frameWindow.focus();
                try {
                    if (!frameWindow.document.execCommand('print', false, null)) {
                        frameWindow.print();
                    }
                } catch (e) {
                    frameWindow.print();
                }
                frameWindow.close();
            }, 10);
        } catch (err) {
            console.log('err', err);
        }
    },
    isDOM: (typeof HTMLElement === 'undefined' ? 'undefined' : (0, _typeof3.default)(HTMLElement)) === 'object' ? function (obj) {
        return obj instanceof HTMLElement;
    } : function (obj) {
        return obj && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
    }
};
Print.install = function (Vue, options) {
    Vue.prototype.$print = Print;
};
exports.default = Print;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.superAdminRouter = exports.warehouseAdminRoutes = exports.nurseRoutes = exports.doctorRoutes = exports.defaultRoutes = undefined;

var _Login = __webpack_require__(779);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(778);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(106);

var _Home2 = _interopRequireDefault(_Home);

var _register = __webpack_require__(800);

var _register2 = _interopRequireDefault(_register);

var _forgetPassword = __webpack_require__(792);

var _forgetPassword2 = _interopRequireDefault(_forgetPassword);

var _changePassword = __webpack_require__(781);

var _changePassword2 = _interopRequireDefault(_changePassword);

var _doctorRouter = __webpack_require__(416);

var _doctorRouter2 = _interopRequireDefault(_doctorRouter);

var _nurseRouter = __webpack_require__(417);

var _nurseRouter2 = _interopRequireDefault(_nurseRouter);

var _warehouseAdminRouter = __webpack_require__(419);

var _warehouseAdminRouter2 = _interopRequireDefault(_warehouseAdminRouter);

var _superAdminRouter = __webpack_require__(418);

var _superAdminRouter2 = _interopRequireDefault(_superAdminRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultRoutes = exports.defaultRoutes = [{
    path: '/register',
    component: _register2.default,
    name: '',
    hidden: true
}, {
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/forgetPassword',
    component: _forgetPassword2.default,
    name: '',
    hidden: true
}, {
    path: '/changePassword',
    component: _changePassword2.default,
    name: '',
    hidden: true
}, {
    path: '/home',
    component: _Home2.default,
    name: '',
    hidden: true,
    beforeEnter: function beforeEnter(to, from, next) {
        if (from.path === "/login") {
            var user = window.sessionStorage.getItem("user");
            if (user) {
                user = JSON.parse(user);
                var roleId = user.roleId;
                if (roleId === '0') {
                    next({ path: "/users" });
                } else if (roleId === '3') {
                    next({ path: "/inbound" });
                } else {
                    next({ path: "/overview" });
                }
            }
        } else {
            next();
        }
    }
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}];

var doctorRoutes = exports.doctorRoutes = _doctorRouter2.default;

var nurseRoutes = exports.nurseRoutes = _nurseRouter2.default;

var warehouseAdminRoutes = exports.warehouseAdminRoutes = _warehouseAdminRouter2.default;

var superAdminRouter = exports.superAdminRouter = _superAdminRouter2.default;

exports.default = defaultRoutes;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(207);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(420);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(421);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(718)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(842),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ElButton',

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.$options.propsData.hasOwnProperty('disabled') ? this.disabled : (this.elForm || {}).disabled;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _input = __webpack_require__(357);

var _input2 = _interopRequireDefault(_input);

var _focus = __webpack_require__(360);

var _focus2 = _interopRequireDefault(_focus);

var _repeatClick = __webpack_require__(359);

var _repeatClick2 = _interopRequireDefault(_repeatClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElInputNumber',
  mixins: [(0, _focus2.default)('input')],
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  directives: {
    repeatClick: _repeatClick2.default
  },
  components: {
    ElInput: _input2.default
  },
  props: {
    step: {
      type: Number,
      default: 1
    },
    stepStrictly: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    value: {},
    disabled: Boolean,
    size: String,
    controls: {
      type: Boolean,
      default: true
    },
    controlsPosition: {
      type: String,
      default: ''
    },
    name: String,
    label: String,
    placeholder: String,
    precision: {
      type: Number,
      validator: function validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      }
    }
  },
  data: function data() {
    return {
      currentValue: 0,
      userInput: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        var newVal = value === undefined ? value : Number(value);
        if (newVal !== undefined) {
          if (isNaN(newVal)) {
            return;
          }

          if (this.stepStrictly) {
            var stepPrecision = this.getPrecision(this.step);
            var precisionFactor = Math.pow(10, stepPrecision);
            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
          }

          if (this.precision !== undefined) {
            newVal = this.toPrecision(newVal, this.precision);
          }
        }
        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
        this.currentValue = newVal;
        this.userInput = null;
        this.$emit('input', newVal);
      }
    }
  },
  computed: {
    minDisabled: function minDisabled() {
      return this._decrease(this.value, this.step) < this.min;
    },
    maxDisabled: function maxDisabled() {
      return this._increase(this.value, this.step) > this.max;
    },
    numPrecision: function numPrecision() {
      var value = this.value,
          step = this.step,
          getPrecision = this.getPrecision,
          precision = this.precision;

      var stepPrecision = getPrecision(step);
      if (precision !== undefined) {
        if (stepPrecision > precision) {
          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
        }
        return precision;
      } else {
        return Math.max(getPrecision(value), stepPrecision);
      }
    },
    controlsAtRight: function controlsAtRight() {
      return this.controls && this.controlsPosition === 'right';
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    inputNumberSize: function inputNumberSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputNumberDisabled: function inputNumberDisabled() {
      return this.disabled || !!(this.elForm || {}).disabled;
    },
    displayValue: function displayValue() {
      if (this.userInput !== null) {
        return this.userInput;
      }

      var currentValue = this.currentValue;

      if (typeof currentValue === 'number') {
        if (this.stepStrictly) {
          var stepPrecision = this.getPrecision(this.step);
          var precisionFactor = Math.pow(10, stepPrecision);
          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
        }

        if (this.precision !== undefined) {
          currentValue = currentValue.toFixed(this.precision);
        }
      }

      return currentValue;
    }
  },
  methods: {
    toPrecision: function toPrecision(num, precision) {
      if (precision === undefined) precision = this.numPrecision;
      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
    },
    getPrecision: function getPrecision(value) {
      if (value === undefined) return 0;
      var valueString = value.toString();
      var dotPosition = valueString.indexOf('.');
      var precision = 0;
      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }
      return precision;
    },
    _increase: function _increase(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.numPrecision);

      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
    },
    _decrease: function _decrease(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.numPrecision);

      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
    },
    increase: function increase() {
      if (this.inputNumberDisabled || this.maxDisabled) return;
      var value = this.value || 0;
      var newVal = this._increase(value, this.step);
      this.setCurrentValue(newVal);
    },
    decrease: function decrease() {
      if (this.inputNumberDisabled || this.minDisabled) return;
      var value = this.value || 0;
      var newVal = this._decrease(value, this.step);
      this.setCurrentValue(newVal);
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    setCurrentValue: function setCurrentValue(newVal) {
      var oldVal = this.currentValue;
      if (typeof newVal === 'number' && this.precision !== undefined) {
        newVal = this.toPrecision(newVal, this.precision);
      }
      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) return;
      this.userInput = null;
      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInput: function handleInput(value) {
      this.userInput = value;
    },
    handleInputChange: function handleInputChange(value) {
      var newVal = value === '' ? undefined : Number(value);
      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal);
      }
      this.userInput = null;
    },
    select: function select() {
      this.$refs.input.select();
    }
  },
  mounted: function mounted() {
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('role', 'spinbutton');
    innerInput.setAttribute('aria-valuemax', this.max);
    innerInput.setAttribute('aria-valuemin', this.min);
    innerInput.setAttribute('aria-valuenow', this.currentValue);
    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
  },
  updated: function updated() {
    if (!this.$refs || !this.$refs.input) return;
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('aria-valuenow', this.currentValue);
  }
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emitter = __webpack_require__(216);

var _emitter2 = _interopRequireDefault(_emitter);

var _migrating = __webpack_require__(361);

var _migrating2 = _interopRequireDefault(_migrating);

var _calcTextareaHeight = __webpack_require__(358);

var _calcTextareaHeight2 = _interopRequireDefault(_calcTextareaHeight);

var _merge = __webpack_require__(363);

var _merge2 = _interopRequireDefault(_merge);

var _shared = __webpack_require__(364);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [_emitter2.default, _migrating2.default],

  inheritAttrs: false,

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      textareaCalcStyle: {},
      hovering: false,
      focused: false,
      isComposing: false,
      passwordVisible: false
    };
  },


  props: {
    value: [String, Number],
    size: String,
    resize: String,
    form: String,
    disabled: Boolean,
    readonly: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },

    autoComplete: {
      type: String,
      validator: function validator(val) {
        "production" !== 'production' && console.warn('[Element Warn][Input]\'auto-complete\' property will be deprecated in next major version. please use \'autocomplete\' instead.');
        return true;
      }
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      default: false
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    tabindex: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    validateState: function validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return (0, _merge2.default)({}, this.textareaCalcStyle, { resize: this.resize });
    },
    inputSize: function inputSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputDisabled: function inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    nativeInputValue: function nativeInputValue() {
      return this.value === null || this.value === undefined ? '' : String(this.value);
    },
    showClear: function showClear() {
      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
    },
    showPwdVisible: function showPwdVisible() {
      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
    },
    isWordLimitVisible: function isWordLimitVisible() {
      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
    },
    upperLimit: function upperLimit() {
      return this.$attrs.maxlength;
    },
    textLength: function textLength() {
      if (typeof this.value === 'number') {
        return String(this.value).length;
      }

      return (this.value || '').length;
    },
    inputExceed: function inputExceed() {
      return this.isWordLimitVisible && this.textLength > this.upperLimit;
    }
  },

  watch: {
    value: function value(val) {
      this.$nextTick(this.resizeTextarea);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [val]);
      }
    },
    nativeInputValue: function nativeInputValue() {
      this.setNativeInputValue();
    },
    type: function type() {
      var _this = this;

      this.$nextTick(function () {
        _this.setNativeInputValue();
        _this.resizeTextarea();
        _this.updateIconOffset();
      });
    }
  },

  methods: {
    focus: function focus() {
      this.getInput().focus();
    },
    blur: function blur() {
      this.getInput().blur();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          'click': 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
      }
    },
    select: function select() {
      this.getInput().select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: (0, _calcTextareaHeight2.default)(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = (0, _calcTextareaHeight2.default)(this.$refs.textarea, minRows, maxRows);
    },
    setNativeInputValue: function setNativeInputValue() {
      var input = this.getInput();
      if (!input) return;
      if (input.value === this.nativeInputValue) return;
      input.value = this.nativeInputValue;
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleCompositionStart: function handleCompositionStart(event) {
      this.$emit('compositionstart', event);
      this.isComposing = true;
    },
    handleCompositionUpdate: function handleCompositionUpdate(event) {
      this.$emit('compositionupdate', event);
      var text = event.target.value;
      var lastCharacter = text[text.length - 1] || '';
      this.isComposing = !(0, _shared.isKorean)(lastCharacter);
    },
    handleCompositionEnd: function handleCompositionEnd(event) {
      this.$emit('compositionend', event);
      if (this.isComposing) {
        this.isComposing = false;
        this.handleInput(event);
      }
    },
    handleInput: function handleInput(event) {
      if (this.isComposing) return;

      if (event.target.value === this.nativeInputValue) return;

      this.$emit('input', event.target.value);

      this.$nextTick(this.setNativeInputValue);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    calcIconOffset: function calcIconOffset(place) {
      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
      if (!elList.length) return;
      var el = null;
      for (var i = 0; i < elList.length; i++) {
        if (elList[i].parentNode === this.$el) {
          el = elList[i];
          break;
        }
      }
      if (!el) return;
      var pendantMap = {
        suffix: 'append',
        prefix: 'prepend'
      };

      var pendant = pendantMap[place];
      if (this.$slots[pendant]) {
        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
      } else {
        el.removeAttribute('style');
      }
    },
    updateIconOffset: function updateIconOffset() {
      this.calcIconOffset('prefix');
      this.calcIconOffset('suffix');
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
    },
    handlePasswordVisible: function handlePasswordVisible() {
      var _this2 = this;

      this.passwordVisible = !this.passwordVisible;
      this.$nextTick(function () {
        _this2.focus();
      });
    },
    getInput: function getInput() {
      return this.$refs.input || this.$refs.textarea;
    },
    getSuffixVisible: function getSuffixVisible() {
      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
    }
  },

  created: function created() {
    this.$on('inputSelect', this.select);
  },
  mounted: function mounted() {
    this.setNativeInputValue();
    this.resizeTextarea();
    this.updateIconOffset();
  },
  updated: function updated() {
    this.$nextTick(this.updateIconOffset);
  }
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ElLink',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    underline: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    href: String,
    icon: String
  },

  methods: {
    handleClick: function handleClick(event) {
      if (!this.disabled) {
        if (!this.href) {
          this.$emit('click', event);
        }
      }
    }
  }
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

var _emitter = __webpack_require__(216);

var _emitter2 = _interopRequireDefault(_emitter);

var _util = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_emitter2.default],

  name: 'ElOption',

  componentName: 'ElOption',

  inject: ['select'],

  props: {
    value: {
      required: true
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false
    };
  },


  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    itemSelected: function itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.value);
      } else {
        return this.contains(this.select.value, this.value);
      }
    },
    limitReached: function limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
      } else {
        return false;
      }
    }
  },

  watch: {
    currentLabel: function currentLabel() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    },
    value: function value(val, oldVal) {
      var _select = this.select,
          remote = _select.remote,
          valueKey = _select.valueKey;

      if (!this.created && !remote) {
        if (valueKey && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : (0, _typeof3.default)(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
          return;
        }
        this.dispatch('ElSelect', 'setSelected');
      }
    }
  },

  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.select.valueKey;
        return (0, _util.getValueByPath)(a, valueKey) === (0, _util.getValueByPath)(b, valueKey);
      }
    },
    contains: function contains() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments[1];

      if (!this.isObject) {
        return arr && arr.indexOf(target) > -1;
      } else {
        var valueKey = this.select.valueKey;
        return arr && arr.some(function (item) {
          return (0, _util.getValueByPath)(item, valueKey) === (0, _util.getValueByPath)(target, valueKey);
        });
      }
    },
    handleGroupDisabled: function handleGroupDisabled(val) {
      this.groupDisabled = val;
    },
    hoverItem: function hoverItem() {
      if (!this.disabled && !this.groupDisabled) {
        this.select.hoverIndex = this.select.options.indexOf(this);
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
      }
    },
    queryChange: function queryChange(query) {
      this.visible = new RegExp((0, _util.escapeRegexpString)(query), 'i').test(this.currentLabel) || this.created;
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  },

  created: function created() {
    this.select.options.push(this);
    this.select.cachedOptions.push(this);
    this.select.optionsCount++;
    this.select.filteredOptionsCount++;

    this.$on('queryChange', this.queryChange);
    this.$on('handleGroupDisabled', this.handleGroupDisabled);
  },
  beforeDestroy: function beforeDestroy() {
    var _select2 = this.select,
        selected = _select2.selected,
        multiple = _select2.multiple;

    var selectedOptions = multiple ? selected : [selected];
    var index = this.select.cachedOptions.indexOf(this);
    var selectedIndex = selectedOptions.indexOf(this);

    if (index > -1 && selectedIndex < 0) {
      this.select.cachedOptions.splice(index, 1);
    }
    this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'app',
    components: {}
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(61);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'BulkConfirmResultDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    result: {
      type: Object,
      default: function _default() {
        return {
          totalPackages: 0,
          successCount: 0,
          failedCount: 0,
          createdPackageIds: [],
          failureRecords: [],
          batchNumber: ''
        };
      }
    }
  },
  data: function data() {
    return {
      retrying: false
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        this.$emit('update:visible', value);
      }
    },
    summaryTitle: function summaryTitle() {
      if (this.result.failedCount === 0) {
        return 'All Packages Created Successfully!';
      } else if (this.result.successCount === 0) {
        return 'All Packages Failed to Create';
      } else {
        return 'Bulk Confirm Completed with Mixed Results';
      }
    },
    summaryType: function summaryType() {
      if (this.result.failedCount === 0) {
        return 'success';
      } else if (this.result.successCount === 0) {
        return 'error';
      } else {
        return 'warning';
      }
    },
    duplicateCount: function duplicateCount() {
      var _this = this;

      return this.result.failureRecords.filter(function (record) {
        return _this.isDuplicateTracking(record);
      }).length;
    },
    retryableCount: function retryableCount() {
      return this.result.failureRecords.filter(function (record) {
        return record.canRetry;
      }).length;
    },
    nonRetryableCount: function nonRetryableCount() {
      return this.result.failureRecords.filter(function (record) {
        return !record.canRetry;
      }).length;
    },
    hasRetryableFailures: function hasRetryableFailures() {
      return this.retryableCount > 0;
    }
  },
  methods: {
    formatPackageId: function formatPackageId(packageId) {
      if ((typeof packageId === 'undefined' ? 'undefined' : (0, _typeof3.default)(packageId)) === 'object') {
        return packageId.mixedPackageId || packageId.packageId || packageId.id || (0, _stringify2.default)(packageId);
      }

      return packageId;
    },
    isDuplicateTracking: function isDuplicateTracking(record) {
      if (!record.errorMessage) return false;

      var errorMsg = record.errorMessage.toLowerCase();
      return errorMsg.includes('快递单号已存在') || errorMsg.includes('tracking number already exists') || errorMsg.includes('duplicate tracking') || errorMsg.includes('tracking号重复') || errorMsg.includes('duplicate entry') && errorMsg.includes('uk_tracking');
    },
    retryFailures: function retryFailures() {
      var retryableRecords = this.result.failureRecords.filter(function (record) {
        return record.canRetry;
      });

      if (retryableRecords.length === 0) {
        this.$message.warning('No retryable failures found');
        return;
      }

      var retryData = {
        failedRecords: retryableRecords,
        batchNumber: this.result.batchNumber
      };

      this.$emit('retry-failed', retryData);
    },
    continueOperation: function continueOperation() {
      this.$emit('continue', this.result);
      this.closeDialog();
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    copyFailedData: function copyFailedData() {
      var _this2 = this;

      if (!this.result.failureRecords || this.result.failureRecords.length === 0) {
        this.$message.warning('No failed tracking numbers to copy');
        return;
      }

      try {
        var failedTrackingNumbers = this.result.failureRecords.map(function (record) {
          return record.tracking;
        }).filter(function (tracking) {
          return tracking;
        }).join('\n');
        navigator.clipboard.writeText(failedTrackingNumbers).then(function () {
          _this2.$message.success(_this2.result.failureRecords.length + ' failed tracking numbers copied to clipboard');
        }).catch(function (err) {
          _this2.fallbackCopyToClipboard(failedTrackingNumbers);
        });
      } catch (error) {
        this.$message.error('Failed to copy tracking numbers to clipboard');
      }
    },
    fallbackCopyToClipboard: function fallbackCopyToClipboard(text) {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        if (successful) {
          this.$message.success(this.result.failureRecords.length + ' failed records copied to clipboard');
        } else {
          this.$message.error('Failed to copy data to clipboard');
        }
      } catch (err) {
        this.$message.error('Failed to copy data to clipboard');
      } finally {
        document.body.removeChild(textArea);
      }
    },
    exportFailedData: function exportFailedData() {
      var _this3 = this;

      if (!this.result.failureRecords || this.result.failureRecords.length === 0) {
        this.$message.warning('No failed data to export');
        return;
      }

      try {
        var headers = ['Tracking Number', 'UPC Items', 'Error Reason', 'Can Retry', 'Batch Number', 'Export Time'];
        var csvRows = [];

        csvRows.push(headers.map(function (header) {
          return '"' + header + '"';
        }).join(','));

        var exportTime = new Date().toISOString().replace('T', ' ').substr(0, 19);
        this.result.failureRecords.forEach(function (record) {
          var row = [record.tracking || '', record.itemCount || 0, (record.errorMessage || 'Unknown error').replace(/"/g, '""'), record.canRetry ? 'Yes' : 'No', _this3.result.batchNumber || '', exportTime];
          csvRows.push(row.map(function (cell) {
            return '"' + cell + '"';
          }).join(','));
        });

        var csvContent = csvRows.join('\n');
        var BOM = '\uFEFF';
        var blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement('a');

        if (link.download !== undefined) {
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);

          var timestamp = new Date().toISOString().slice(0, 19).replace(/[T:]/g, '-');
          var batchPart = this.result.batchNumber ? '_' + this.result.batchNumber : '';
          var filename = 'bulk_confirm_failed_packages' + batchPart + '_' + timestamp + '.csv';

          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);

          this.$message.success('Failed packages exported to ' + filename);
        } else {
          this.$message.error('Export is not supported by this browser');
        }
      } catch (error) {
        this.$message.error('Failed to export data');
      }
    }
  }
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(110);

var _from2 = _interopRequireDefault(_from);

var _set = __webpack_require__(145);

var _set2 = _interopRequireDefault(_set);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ImportResultDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    result: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          totalCount: 0,
          successCount: 0,
          failedCount: 0,
          successTrackings: [],
          successDetails: null,
          failedRecords: []
        };
      }
    }
  },

  data: function data() {
    return {
      dialogVisible: false,
      activeTab: 'success',

      successSearch: '',
      failedSearch: '',
      errorTypeFilter: '',

      successCurrentPage: 1,
      successPageSize: 20,
      failedCurrentPage: 1,
      failedPageSize: 20
    };
  },


  watch: {
    visible: function visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.resetFilters();

        this.activeTab = this.result.failedCount > 0 ? 'failed' : 'success';
      }
    },
    dialogVisible: function dialogVisible(val) {
      this.$emit('update:visible', val);
    }
  },

  computed: {
    successData: function successData() {
      if (this.result.successDetails) {
        return this.result.successDetails;
      }
      return (this.result.successTrackings || []).map(function (tracking) {
        return { tracking: tracking };
      });
    },
    failedData: function failedData() {
      return this.result.failedRecords || [];
    },
    filteredSuccessData: function filteredSuccessData() {
      var data = this.successData;

      if (this.successSearch) {
        var search = this.successSearch.toLowerCase();
        data = data.filter(function (item) {
          var tracking = (item.tracking || item || '').toString().toLowerCase();
          return tracking.includes(search);
        });
      }

      var start = (this.successCurrentPage - 1) * this.successPageSize;
      var end = start + this.successPageSize;
      return data.slice(start, end);
    },
    filteredFailedData: function filteredFailedData() {
      var _this = this;

      var data = this.failedData;

      if (this.failedSearch) {
        var search = this.failedSearch.toLowerCase();
        data = data.filter(function (item) {
          var content = (item.rawContent || item.content || '').toString().toLowerCase();
          var error = (item.errorMessage || item.error || '').toString().toLowerCase();
          return content.includes(search) || error.includes(search);
        });
      }

      if (this.errorTypeFilter) {
        data = data.filter(function (item) {
          var error = item.errorMessage || item.error || '';
          return error.includes(_this.errorTypeFilter);
        });
      }

      var start = (this.failedCurrentPage - 1) * this.failedPageSize;
      var end = start + this.failedPageSize;
      return data.slice(start, end);
    },
    uniqueErrorTypes: function uniqueErrorTypes() {
      var errorTypes = new _set2.default();
      this.failedData.forEach(function (item) {
        var error = item.errorMessage || item.error || '';
        if (error) {
          if (error.includes('duplicate')) errorTypes.add('Duplicate');else if (error.includes('format')) errorTypes.add('Format Error');else if (error.includes('validation')) errorTypes.add('Validation Error');else if (error.includes('not found')) errorTypes.add('Not Found');else if (error.includes('length')) errorTypes.add('Length Error');else errorTypes.add('Other');
        }
      });
      return (0, _from2.default)(errorTypes);
    },
    tableHeight: function tableHeight() {
      var currentTabData = this.activeTab === 'success' ? this.successData : this.failedData;
      var recordCount = currentTabData.length;

      var minHeight = 200;
      var maxHeight = 500;
      var baseHeight = 150;
      var rowHeight = 40;

      var calculatedHeight = Math.min(Math.max(minHeight, baseHeight + recordCount * rowHeight), maxHeight);

      return calculatedHeight;
    }
  },

  methods: {
    resetFilters: function resetFilters() {
      this.successSearch = '';
      this.failedSearch = '';
      this.errorTypeFilter = '';
      this.successCurrentPage = 1;
      this.failedCurrentPage = 1;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    handleContinue: function handleContinue() {
      this.$emit('continue', this.result);
      this.handleClose();
    },
    handleRetryFailed: function handleRetryFailed() {
      var retryData = this.failedData.map(function (record) {
        return record.rawContent || record.content || '';
      }).filter(function (content) {
        return content.trim().length > 0;
      }).join('\n');

      this.$emit('retry-failed', {
        failedRecords: this.failedData,
        retryData: retryData,
        failedCount: this.result.failedCount
      });
      this.handleClose();
    },
    handleSuccessPageChange: function handleSuccessPageChange(page) {
      this.successCurrentPage = page;
    },
    handleFailedPageChange: function handleFailedPageChange(page) {
      this.failedCurrentPage = page;
    },
    getShortErrorMessage: function getShortErrorMessage(error) {
      if (!error) return 'Unknown error';
      if (error.length <= 50) return error;
      return error.substring(0, 47) + '...';
    },
    showFullErrorMessage: function showFullErrorMessage(row) {
      var _this2 = this;

      var content = row.rawContent || row.content || 'No content';
      var error = row.errorMessage || row.error || 'Unknown error';
      var lineNumber = row.lineNumber || 'Unknown';

      this.$msgbox({
        title: 'Error Details - Line ' + lineNumber,
        message: '\n          <div style="text-align: left;">\n            <div style="margin-bottom: 15px;">\n              <strong>Content:</strong>\n              <div style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin-top: 5px; font-family: monospace; word-break: break-all;">\n                ' + content + '\n              </div>\n            </div>\n            <div>\n              <strong>Error Message:</strong>\n              <div style="background: #fef0f0; padding: 10px; border-radius: 4px; margin-top: 5px; color: #f56c6c; border-left: 4px solid #f56c6c;">\n                ' + error + '\n              </div>\n            </div>\n          </div>\n        ',
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'Close',
        showCancelButton: true,
        cancelButtonText: 'Copy Content',
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'cancel') {
            _this2.copyToClipboard(content);
          }
          done();
        }
      }).catch(function () {});
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this3 = this;

      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(function () {
          _this3.$message.success('Copied to clipboard');
        }).catch(function () {
          _this3.fallbackCopyToClipboard(text);
        });
      } else {
        this.fallbackCopyToClipboard(text);
      }
    },
    fallbackCopyToClipboard: function fallbackCopyToClipboard(text) {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.$message.success('Copied to clipboard');
      } catch (err) {
        this.$message.error('Failed to copy to clipboard');
      }
      document.body.removeChild(textArea);
    },
    copyFailedData: function copyFailedData() {
      var failedLines = this.failedData.map(function (item) {
        return item.rawContent || item.content || '';
      }).filter(function (line) {
        return line.trim();
      }).join('\n');

      this.copyToClipboard(failedLines);
    },
    exportSuccessData: function exportSuccessData() {
      var content = this.successData.map(function (item) {
        if (item.tracking) {
          return item.tracking;
        }
        return item;
      }).join('\n');

      this.downloadFile(content, 'import_success.txt');
    },
    exportFailedData: function exportFailedData() {
      var content = this.failedData.map(function (item) {
        var line = item.rawContent || item.content || '';
        var error = item.errorMessage || item.error || '';
        return line + '\t// Error: ' + error;
      }).join('\n');

      this.downloadFile(content, 'import_failed.txt');
    },
    downloadFile: function downloadFile(content, filename) {
      var blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
      var link = document.createElement('a');
      if (link.download !== undefined) {
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    getDisplayErrorMessage: function getDisplayErrorMessage(row) {
      var errorMessage = row.errorMessage || row.error || 'Unknown error';
      var rawContent = row.rawContent || row.content || '';

      if (!rawContent) {
        return errorMessage;
      }

      var cleanRawContent = String(rawContent).trim();

      var displayContent = cleanRawContent.length > 80 ? cleanRawContent.substring(0, 77) + '...' : cleanRawContent;

      if (errorMessage.includes('格式错误') || errorMessage.includes('应为：') || errorMessage.includes('实际字段数')) {
        return '\u274C \u683C\u5F0F\u9519\u8BEF\uFF1A"' + displayContent + '" (' + this.extractFieldCountInfo(errorMessage) + ')';
      }

      if (errorMessage.includes('UPC') && (errorMessage.includes('不存在') || errorMessage.includes('invalid'))) {
        return '\u274C UPC\u4E0D\u5B58\u5728\uFF1A"' + displayContent + '"';
      }

      if (errorMessage.includes('duplicate') || errorMessage.includes('重复') || errorMessage.includes('已存在')) {
        return '\u274C \u91CD\u590D\u6570\u636E\uFF1A"' + displayContent + '"';
      }

      if (errorMessage.includes('length') || errorMessage.includes('长度')) {
        return '\u274C \u957F\u5EA6\u9519\u8BEF\uFF1A"' + displayContent + '"';
      }

      return '\u274C "' + displayContent + '" - ' + errorMessage;
    },
    extractFieldCountInfo: function extractFieldCountInfo(errorMessage) {
      var match = errorMessage.match(/实际字段数[：:]\s*(\d+)/);
      if (match) {
        return '\u5E94\u4E3A3\u4E2A\u5B57\u6BB5\uFF0C\u5B9E\u9645' + match[1] + '\u4E2A';
      }
      return '字段数量不正确';
    }
  }
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(113);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(111);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mixedPackage = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'InboundStatusCard',
  props: {
    inbound: {
      type: Object,
      required: true
    },
    showActions: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      pendingClaims: 0,
      refreshing: false,
      statusLoaded: false
    };
  },

  computed: {
    safeInbound: function safeInbound() {
      return this.inbound || {};
    },
    takeQuantity: function takeQuantity() {
      var qty = this.safeInbound.qty;
      return qty !== null && qty !== undefined && !isNaN(qty) ? Number(qty) : 0;
    },
    totalRemaining: function totalRemaining() {
      var leftNum = this.safeInbound.leftNum;
      return leftNum !== null && leftNum !== undefined && !isNaN(leftNum) ? Number(leftNum) : 0;
    },
    safePendingClaims: function safePendingClaims() {
      return this.pendingClaims !== null && this.pendingClaims !== undefined && !isNaN(this.pendingClaims) ? Number(this.pendingClaims) : 0;
    },
    availableToClaim: function availableToClaim() {
      return Math.max(0, this.totalRemaining - this.safePendingClaims);
    },
    safePrice: function safePrice() {
      var price = this.safeInbound.price;
      return price !== null && price !== undefined && !isNaN(price) && price > 0 ? Number(price) : null;
    },
    hasValidData: function hasValidData() {
      return this.safeInbound && (this.safeInbound.inboundNo || this.safeInbound.qty !== undefined);
    }
  },
  mounted: function mounted() {
    this.loadPendingClaims();
  },

  watch: {
    'inbound.inboundNo': {
      handler: function handler() {
        this.loadPendingClaims();
      },

      immediate: true
    }
  },
  methods: {
    loadPendingClaims: function loadPendingClaims() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var result;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.inbound || !_this.inbound.inboundNo)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return _mixedPackage.mixedPackageApi.getPendingClaimQuantity(_this.inbound.inboundNo);

              case 5:
                result = _context.sent;

                if (result.code === '200' || result.code === 200) {
                  _this.pendingClaims = result.data || 0;
                  _this.statusLoaded = true;
                } else {
                  console.warn('获取待处理认领数量失败:', result.message);
                  _this.pendingClaims = 0;
                }
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](2);

                console.error('获取Inbound状态失败:', _context.t0);
                _this.pendingClaims = 0;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 9]]);
      }))();
    },
    refreshStatus: function refreshStatus() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.refreshing = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.loadPendingClaims();

              case 4:
                _this2.$emit('status-refreshed', {
                  inboundNo: _this2.inbound.inboundNo,
                  pendingClaims: _this2.pendingClaims,
                  available: Math.max(0, _this2.inbound.leftNum - _this2.pendingClaims)
                });

              case 5:
                _context2.prev = 5;

                _this2.refreshing = false;
                return _context2.finish(5);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1,, 5, 8]]);
      }))();
    },
    getStatusTipMessage: function getStatusTipMessage() {
      return 'You have ' + this.safePendingClaims + ' items awaiting warehouse review. Only ' + this.availableToClaim + ' items are available for new claims.';
    }
  }
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalVar = __webpack_require__(7);

var _securityService = __webpack_require__(49);

var _memberService = __webpack_require__(17);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    computed: {
        getRoutes: function getRoutes() {
            return global.antRouter;
        }
    },
    data: function data() {
        return {
            currentCompany: "",
            user: {},
            doctors: [],
            sysName: 'BSCI',
            collapsed: false,
            sysUserName: '',
            sysUserAvatar: '',
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            }
        };
    },

    methods: {
        changeDoctor: function changeDoctor() {
            this.$refs.child.$emit('changeDoctor', this.currentCompany);
            window.sessionStorage.setItem("currentCompany", this.currentCompany);
        },
        getDoctors: function getDoctors() {
            var _this = this;

            (0, _memberService.getNurseDoctor)().then(function (res) {
                if (res.status === 200) {
                    _this.doctors = res.result;
                    if (_this.doctors.length > 0) {
                        var currentCompany = window.sessionStorage.getItem("currentCompany");
                        if (!currentCompany) {
                            window.sessionStorage.setItem("currentCompany", _this.doctors[0].userNo);
                            _this.currentCompany = res.result[0].userNo;
                        } else {
                            _this.currentCompany = currentCompany;
                        }
                    }
                }
            });
        },

        logout: function logout() {
            this.$confirm('Are you sure?', 'Warning', {}).then(function () {
                (0, _securityService.logout)().then(function (res) {
                    sessionStorage.removeItem('user');
                    sessionStorage.removeItem('authorization');
                    sessionStorage.removeItem('currentCompany');
                    window.location.href = _globalVar.url;
                }).catch(function () {
                    sessionStorage.removeItem('user');
                    sessionStorage.removeItem('authorization');
                    sessionStorage.removeItem('currentCompany');
                    window.location.href = _globalVar.url;
                });
            }).catch(function () {});
        },

        collapse: function collapse() {
            this.collapsed = !this.collapsed;
        },
        showMenu: function showMenu(i, status) {
            this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
        }
    },
    mounted: function mounted() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.user = user;
            this.sysUserName = user.username || '';
            if (user.roleId === '2' || user.roleId === "3") {
                this.getDoctors();
            }
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(61);

var _stringify2 = _interopRequireDefault(_stringify);

var _securityService = __webpack_require__(49);

var _memberService = __webpack_require__(17);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            obj: {
                currentCompany: ""
            },
            doctors: [],
            selectCompanyVisible: false,
            logining: false,
            ruleForm2: {
                account: '',
                checkPass: ''
            },
            rule: {
                currentCompany: [{ required: true, message: 'You must select a company before login.', trigger: 'blur' }]
            },
            rules2: {
                account: [{ required: true, message: 'Please enter username', trigger: 'blur' }],
                checkPass: [{ required: true, message: 'Please enter password', trigger: 'blur' }]
            },
            checked: true
        };
    },

    methods: {
        handleSelectCompany: function handleSelectCompany() {
            var _this2 = this;

            this.$refs.obj.validate(function (valid) {
                if (valid) {
                    window.sessionStorage.setItem("currentCompany", _this2.obj.currentCompany);
                    _this2.$router.push({ path: '/home' });
                }
            });
        },
        handleReset2: function handleReset2() {
            this.$refs.ruleForm2.resetFields();
        },
        getDoctors: function getDoctors() {
            var _this3 = this;

            (0, _memberService.getNurseDoctor)().then(function (res) {
                if (res.status === 200) {
                    _this3.doctors = res.result;
                    _this3.selectCompanyVisible = true;
                    if (_this3.doctors.length == 1) {
                        _this3.obj.currentCompany = _this3.doctors[0].userNo;
                        if (_this3.obj.currentCompany) {
                            window.sessionStorage.setItem("currentCompany", _this3.obj.currentCompany);
                            _this3.$router.push({ path: '/home' });
                        }
                    }
                }
            });
        },
        handleSubmit2: function handleSubmit2(ev) {
            var _this4 = this;

            var _this = this;
            this.$refs.ruleForm2.validate(function (valid) {
                if (valid) {
                    _this4.logining = true;
                    var loginParams = { userName: _this4.ruleForm2.account, password: _this4.ruleForm2.checkPass };
                    (0, _securityService.login)(loginParams).then(function (data) {
                        _this4.logining = false;
                        if (data.status === 200) {
                            sessionStorage.setItem('user', (0, _stringify2.default)(data.result.user));
                            sessionStorage.setItem("authorization", data.result.user.token);
                            if (data.result.user.roleId == 1 || data.result.user.roleId == 0) {
                                _this4.$router.push({ path: '/home' });
                            } else {
                                _this4.getDoctors();
                            }
                        } else {
                            _this4.$message.error(data.message);
                        }
                    }).catch(function (data) {
                        console.log(data);
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(17);

var _globalVar = __webpack_require__(7);

var _button = __webpack_require__(104);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElButton: _button2.default },
    data: function data() {
        return {
            loading: false,
            firstListLoading: false,
            secondListLoading: false,
            pageSize: _globalVar.defaultPageSize,

            activeName: "first",

            filters: {
                email: '',
                invitationEmail: ""
            },

            users: [],
            invitations: [],

            total: 0,
            userPage: 1,

            invitationPage: 1,
            invitationTotal: 0,

            invitationVisible: false,

            editLoading: false,

            addLoading: false,
            invitationRules: {
                email: [{ required: true, message: 'Email is required.', trigger: 'blur' }, { validator: _util2.default.validateEmail, trigger: 'blur' }]
            },

            member: {
                id: "",
                userName: "",
                email: "",
                phone: "",
                status: "",
                pendingTransaction: 7,
                pendingAmount: "",
                alias: ""
            },
            group: {
                id: '',
                groupName: "",
                users: [],
                pendingTransaction: 7,
                pendingAmount: ""
            },
            invitation: {
                id: "",
                email: ""
            }

        };
    },

    methods: {
        formatRole: function formatRole(row, column) {
            if (row.status === 0) {
                return "Pending";
            } else if (row.status === 1) {
                return "Approve";
            } else {
                return "Reject";
            }
        },
        formatTimesTamp: function formatTimesTamp(row, column) {
            var date = row.createTime || row.createDate;
            return _util2.default.formatDate.format(new Date(date), 'yyyy-MM-dd hh:mm:ss');
        },
        handleUserPageChange: function handleUserPageChange(val) {
            this.userPage = val;
            this.getUserList();
        },
        handleInvitationPageChange: function handleInvitationPageChange(val) {
            this.invitationPage = val;
            this.getInvitationList();
        },
        editUserStatus: function editUserStatus(id, status) {
            var _this = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                (0, _memberService.editUserStatus)({ userNo: id, status: status }).then(function (res) {
                    if (res.status === 200) {
                        _this.$message({
                            message: res.message,
                            type: "success"
                        });
                        _this.getUserList();
                    } else {
                        _this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                });
            }).catch(function () {});
        },
        getUserList: function getUserList() {
            var _this2 = this;

            var para = {
                current: this.userPage,
                size: this.pageSize,
                condition: this.filters.email
            };

            this.firstListLoading = true;
            (0, _memberService.getAllMemberList)(para).then(function (res) {
                _this2.firstListLoading = false;
                if (res.status === 200) {
                    _this2.users = res.result.records;
                    _this2.total = res.result.total;
                } else {
                    _this2.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getInvitationList: function getInvitationList() {
            var _this3 = this;

            var para = {
                current: this.invitationPage,
                size: this.pageSize,
                condition: this.filters.invitationEmail
            };

            this.secondListLoading = true;
            (0, _memberService.getAdminInvitationList)(para).then(function (res) {
                _this3.secondListLoading = false;
                if (res.status === 200) {
                    _this3.invitations = res.result.records;
                    _this3.invitationTotal = res.result.total;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        invitationRegister: function invitationRegister(param) {
            var _this4 = this;

            this.$refs.invitation.validate(function (valid) {
                if (valid) {
                    (0, _memberService.invitationDoctor)({ email: _this4.invitation.email }).then(function (res) {
                        if (res.status === 200) {
                            _this4.$message({
                                message: 'Success',
                                type: 'success'
                            });
                            _this4.invitationVisible = false;
                            _this4.getInvitationList();
                            _this4.$refs.invitation.resetFields();
                        } else {
                            _this4.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        return console.log(error);
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getUserList();
        this.getInvitationList();
    }
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _securityService = __webpack_require__(49);

var id = "";
var validate = false;
exports.default = {
    data: function data() {
        return {
            validate: validate,
            loading: false,
            ruleForm2: {
                id: id,
                password: '',
                rePassword: ''
            },
            rules2: {
                password: [{ required: true, message: 'Please enter password', trigger: 'blur' }],
                rePassword: [{ required: true, message: 'Please confirm password', trigger: 'blur' }, { validator: this.validatePassword, trigger: 'blur' }]
            },
            checked: true
        };
    },

    methods: {
        validatePassword: function validatePassword(rule, value, callback) {
            if (this.ruleForm2.password !== this.ruleForm2.rePassword) {
                callback(new Error('Password not match.'));
            } else {
                callback();
            }
        },
        submitRegister: function submitRegister() {},
        handleSubmit: function handleSubmit(ev) {
            var _this2 = this;

            var _this = this;
            this.$refs.ruleForm2.validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    var params = {
                        rePassword: _this2.ruleForm2.rePassword,
                        password: _this2.ruleForm2.password,
                        id: _this2.ruleForm2.id
                    };
                    (0, _securityService.resetPassword)(params).then(function (data) {
                        _this2.loading = false;
                        if (data.status === 200) {
                            _this2.$message.success("Reset Password Success.");
                            setTimeout(function () {
                                _this2.$router.push({ path: "/login" });
                            }, 3000);
                        } else {
                            _this2.$message.error(data.message);
                        }
                    }).catch(function (error) {
                        _this2.loading = false;
                        console.log(error);
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
    created: function created() {
        var _this3 = this;

        var query = this.$route.query;
        if (!query.id) {
            this.$router.push({ path: "/login" });
        } else {
            this.ruleForm2.id = query.id;
            (0, _securityService.validateResetPassword)({ id: this.ruleForm2.id }).then(function (data) {
                if (data.status === 200) {
                    _this3.validate = true;
                } else {
                    _this3.validate = false;
                    setTimeout(function () {
                        _this3.$router.push({ path: "/login" });
                    }, 3000);
                    _this3.$message.error(data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    }
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _inboundService = __webpack_require__(77);

var _offerService = __webpack_require__(107);

var _inventoryService = __webpack_require__(78);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(22);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            pageSize: _globalVar.defaultPageSize,

            currentDetailNo: "",
            inboundDetailPage: 1,
            inboundDetailTotal: 0,

            viewInboundPage: 1,
            viewInboundTotal: 0,

            historyPage: 1,
            historyTotal: 0,

            cancelPage: 1,
            cancelTotal: 0,

            reportPage: 1,
            reportTotal: 0,

            trackingPage: 1,
            trackingTotal: 0,

            activeName: "first",
            filters: {
                name: '',
                reportFilter: "",
                cancelFilter: "",
                viewedInboundFilter: "",
                historyFilter: "",
                trackingNumFilter: "",
                trackingWarehouse: "",
                trackingDate: ""
            },

            detailLoading: false,
            firstLoading: false,
            secondLoading: false,
            thirdLoading: false,
            fourthLoading: false,
            fiveLoading: false,

            cancelList: [],
            viewedInbound: [],
            reportedInbound: [],
            inboundHistory: [],
            inboundDetail: [],
            trackingList: [],
            total: 0,
            page: 1,
            listLoading: false,
            detailVisible: false,
            globalLoading: false

        };
    },

    methods: {
        cancelInbound: function cancelInbound(inboundNo) {
            var _this = this;

            if (!inboundNo) {
                this.$message.error("Empty InboundNo");
                return;
            }
            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _inboundService.cancelInboundByDoctor)({ inboundNo: inboundNo }).then(function (res) {
                    if (res.status === 200) {
                        _this.$message.success(res.message);
                        _this.getInboundList();
                    } else {
                        _this.$message.error(res.message);
                    }
                });
            }).catch(function () {});
        },
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.exportExcel)(param).then(function () {});
        },
        editReportStatus: function editReportStatus(id, status, row) {
            var _this2 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                row.loading = true;
                var param = {
                    id: id,
                    status: status
                };
                _this2.globalLoading = true;
                (0, _inventoryService.editReportStatus)(param).then(function (data) {
                    row.loading = false;
                    _this2.globalLoading = false;
                    if (data.status === 200) {
                        _this2.$message.success(data.message);
                        _this2.getReportList();
                    } else {
                        _this2.$message.error(data.message);
                    }
                });
            }).catch(function () {
                _this2.globalLoading = false;
            });
        },
        changeHistoryList: function changeHistoryList(val) {
            this.historyPage = val;
            this.getInboundHistoryList();
        },
        changeViewList: function changeViewList(val) {
            this.viewInboundPage = val;
            this.getInboundList();
        },
        changeReportPage: function changeReportPage(val) {
            this.reportPage = val;
            this.getReportList();
        },
        changeCancelList: function changeCancelList(val) {
            this.cancelPage = val;
            this.getCancelInboundList();
        },
        handleClick: function handleClick(tab, event) {
            if (tab.paneName === "first" && this.viewedInbound.length === 0) {
                this.getInboundList();
            } else if (tab.paneName === "second" && this.reportedInbound.length === 0) {
                this.getReportList();
            } else if (tab.paneName === "third" && this.inboundHistory.length === 0) {
                this.getInboundHistoryList();
            } else if (tab.paneName === "fourth" && this.cancelList.length === 0) {
                this.getCancelInboundList();
            }
        },
        getInboundList: function getInboundList() {
            var _this3 = this;

            var param = {
                current: this.viewInboundPage,
                size: this.pageSize,
                condition: this.filters.viewedInboundFilter
            };
            this.firstLoading = true;
            (0, _inboundService.getInboundDetailList)(param).then(function (data) {
                _this3.firstLoading = false;
                if (data.status === 200) {
                    _this3.viewedInbound = data.result.records;
                    _this3.viewInboundTotal = data.result.total;
                }
            });
        },
        getReportList: function getReportList() {
            var _this4 = this;

            var param = {
                current: this.reportPage,
                size: this.pageSize,
                condition: this.filters.reportFilter,
                status: this.filters.reportStatus
            };
            this.secondLoading = true;
            this.reportedInbound = [];
            (0, _inventoryService.getInventoryReportList)(param).then(function (data) {
                _this4.secondLoading = false;
                if (data.status === 200) {
                    data.result.records.forEach(function (item) {
                        item.loading = false;
                        _this4.reportedInbound.push(item);
                    });
                    _this4.reportTotal = data.result.total;
                }
            });
        },
        getInboundHistoryList: function getInboundHistoryList() {
            var _this5 = this;

            var param = {
                current: this.historyPage,
                size: this.pageSize,
                productName: this.filters.historyFilter
            };
            this.thirdLoading = true;
            (0, _inboundService.getInboundHistoryList)(param).then(function (data) {
                _this5.thirdLoading = false;
                if (data.status === 200) {
                    _this5.inboundHistory = data.result.records;
                    _this5.historyTotal = data.result.total;
                }
            });
        },
        getCancelInboundList: function getCancelInboundList() {
            var _this6 = this;

            var param = {
                current: this.cancelPage,
                size: this.pageSize,
                productName: this.filters.cancelFilter
            };
            this.fourthLoading = true;
            (0, _inboundService.getCancelInboundList)(param).then(function (data) {
                _this6.fourthLoading = false;
                if (data.status === 200) {
                    _this6.cancelList = data.result.records;
                    _this6.cancelTotal = data.result.total;
                }
            });
        },
        getInboundDetailList: function getInboundDetailList(id) {
            var _this7 = this;

            if (id) {
                this.currentDetailNo = id;
            }
            var param = {
                offerNo: this.currentDetailNo,
                current: this.inboundDetailPage,
                size: this.pageSize,
                productName: ""
            };
            this.detailLoading = true;
            (0, _inboundService.getInboundDetailList)(param).then(function (data) {
                _this7.detailLoading = false;
                if (data.status === 200) {
                    _this7.inboundDetail = data.result.records;
                    _this7.inboundDetailTotal = data.result.total;
                    _this7.detailVisible = true;
                }
            });
        },
        changeTracking: function changeTracking(val) {
            this.trackingPage = val;
            this.getTrackingList();
        },
        getTrackingList: function getTrackingList() {
            var _this8 = this;

            var param = {
                current: this.trackingPage,
                size: this.pageSize,
                warehouseNo: this.filters.trackingWarehouse,
                startDate: "",
                endDate: "",
                tracking: this.filters.trackingNumFilter
            };
            if (this.filters.trackingDate) {
                param.startDate = this.filters.trackingDate[0];
                param.endDate = this.filters.trackingDate[2];
            }
            this.fiveLoading = true;
            (0, _inboundService.getDoctorTrackingList)(param).then(function (data) {
                _this8.fiveLoading = false;
                if (data.status === 200) {
                    _this8.trackingList = data.result.records;
                    _this8.trackingTotal = data.result.total;
                }
            });
        }
    },
    mounted: function mounted() {
        this.getInboundList();
        this.getTrackingList();
        this.getReportList();
        this.getInboundHistoryList();
        this.getCancelInboundList();
        var active = this.$route.params.active;
        if (active) {
            this.activeName = active;
        }
    }
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(144);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(143);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _inventoryService = __webpack_require__(78);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

var _inboundService = __webpack_require__(77);

var _warehouseService = __webpack_require__(50);

var _memberService = __webpack_require__(17);

var _outboundService = __webpack_require__(108);

var _exportService = __webpack_require__(22);

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            pageSize: _globalVar.defaultPageSize,

            conditions: _globalVar.conditions,
            activeName: "first",
            filters: {
                fbmWarehouse: "",
                fbmStatus: "",
                reportFilter: "",
                inboundFilter: "",
                inboundUser: "",
                outboundUser: "",
                tracking: "",
                name: '',
                product: "",
                inboundType: "",
                inventoryProductSummary: "",
                notClaimedTracking: "",
                stockFilter: ""
            },
            fbmDetailVisible: false,

            currentDetailNo: "",
            currentInventroy: "",

            products: [],
            inventoryPage: 1,
            inventoryTotal: 0,

            inboundPage: 1,
            inboundTotal: 0,

            reportPage: 1,
            reportTotal: 0,

            outboundPage: 1,
            outboundTotal: 0,

            notClaimedPage: 1,
            notClaimedTotal: 0,

            inventorySummaryPage: 1,
            inventorySummaryTotal: 0,

            stockPage: 1,
            stockTotal: 0,

            fbmDetail: [],
            fbmPage: 1,
            fbmTotal: 0,

            total: 0,
            page: 1,
            listLoading: false,
            sels: [],

            nurseList: [],
            inboundList: [],
            outboundList: [],
            fbmList: [],
            fmaList: [],
            reportedInbound: [],
            notClaimed: [],
            inventoriesSummary: [],
            stockList: [],

            members: [],

            sizeList: [],

            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,
            fourthListLoading: false,
            fiveListLoading: false,
            sixListLoading: false,

            editFBMVisible: false,
            editFormVisible: false,
            editLoading: false,
            inventorySummaryLoading: false,

            addFormVisible: false,
            loading: false,
            formRules: {
                product: [{ required: true, message: 'Product Name is required.', trigger: 'blur' }],
                price: [{ required: true, message: 'Price is required.', trigger: 'blur' }]
            },
            fbmFormRules: {
                warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
                quantity: [{ required: true, message: 'Quantity is required.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
            },

            inputVisible: false,
            inputValue: "",

            detailVisible: false,
            fbmDetailLoading: false,

            editProduct: {
                id: "",
                product: '',
                condition: "New",
                price: "",
                asin: "",
                upc: "",
                weight: '',
                note: "",
                size: ""
            },

            addProduct: {
                id: "",
                product: '',
                condition: "New",
                price: "",
                asin: "",
                upc: "",
                weight: '',
                note: "",
                size: ""
            },
            fbm: {
                warehouseNo: "",
                price: 0,
                quantity: 0,
                productNo: "",
                productName: "",
                note: ""
            },
            warehouseList: []
        };
    },

    methods: {
        deleteProduct: function deleteProduct(productNo) {
            var _this = this;

            (0, _inventoryService.getProductFBM)({ productNo: productNo }).then(function (data) {
                if (data.status == "200") {
                    if (data.result > 0) {
                        _this.$message.error("You can't delete a product if FBM left more then 0.");
                    } else {
                        _this.$confirm("Are you sure?", "Warning", {
                            type: "warning"
                        }).then(function () {
                            (0, _inventoryService.deleteProduct)({ productNo: productNo }).then(function (data) {
                                if (data.status == "200") {
                                    _this.$message.success("Success");
                                    _this.getInventory();
                                } else {
                                    _this.$message.error(data.message);
                                }
                            });
                        }).catch(function () {});
                    }
                }
            });
        },
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.exportExcel)(param).then(function () {});
        },
        tableRowClassName: function tableRowClassName(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            if (row.stock === 0) {
                return 'warning';
            } else {
                return '';
            }
        },
        handleInventorySummaryPageChange: function handleInventorySummaryPageChange(val) {
            this.inventorySummaryPage = val;
            this.getInventorySummary();
        },
        getInventorySummary: function getInventorySummary() {
            var _this2 = this;

            var param = {
                current: this.inventorySummaryPage,
                size: this.pageSize,
                productName: this.filters.inventoryProductSummary
            };
            this.inventorySummaryLoading = true;
            return (0, _outboundService.getInventorySummary)(param).then(function (data) {
                _this2.inventorySummaryLoading = false;
                if (data.status === 200) {
                    _this2.inventoriesSummary = data.result.records;
                    _this2.inventorySummaryTotal = data.result.total;
                }
            });
        },
        handleInventoryDetailPageChange: function handleInventoryDetailPageChange(val) {
            this.fbmPage = val;
            this.getInventoryDetail();
        },
        getInventoryDetail: function getInventoryDetail() {
            var _this3 = this;

            var param = {
                current: this.fbmPage,
                size: this.pageSize,
                productName: this.filters.inventoryProduct,
                nurseId: this.filters.inventoryNurse,
                productNo: this.currentDetailNo
            };
            this.fbmDetailLoading = true;
            return (0, _outboundService.getInventoryList)(param).then(function (data) {
                _this3.fbmDetailLoading = false;
                if (data.status === 200) {
                    _this3.fbmDetail = data.result.records;
                    _this3.fbmTotal = data.result.total;
                }
            });
        },
        getNotClaimed: function getNotClaimed() {
            var _this4 = this;

            var param = {
                current: this.notClaimedPage,
                size: this.pageSize,
                productNo: this.currentDetailNo,
                tracking: this.filters.notClaimedTracking
            };
            this.fiveListLoading = true;
            (0, _inventoryService.getNotClaimed)(param).then(function (res) {
                _this4.fiveListLoading = false;
                if (res.status === 200) {
                    _this4.notClaimed = res.result.records;
                    _this4.notClaimedTotal = res.result.total;
                }
            });
        },
        getDoctorMembers: function getDoctorMembers() {
            var _this5 = this;

            (0, _memberService.getDoctorMemberList)({}).then(function (data) {
                if (data.status === 200) {
                    _this5.members = data.result;
                }
            });
        },
        getSizeList: function getSizeList() {
            var _this6 = this;

            (0, _inventoryService.getSizeList)({}).then(function (data) {
                if (data.status === 200) {
                    _this6.sizeList = data.result;
                }
            });
        },
        getFBMList: function getFBMList() {
            var _this7 = this;

            var param = {
                current: this.fbmPage,
                size: this.pageSize,
                warehouseNo: this.filters.fbmWarehouse,
                type: this.filters.fbmStatus,
                productNo: this.currentDetailNo
            };
            this.thirdListLoading = true;
            (0, _inventoryService.getFBM)(param).then(function (data) {
                _this7.thirdListLoading = false;
                if (data.status === 200) {
                    _this7.fbmList = data.result.records;
                    _this7.fbmTotal = data.result.total;
                }
            });
        },
        addFBM: function addFBM() {
            var _this8 = this;

            this.$refs.fbm.validate(function (valid) {
                if (valid) {
                    var param = {
                        productNo: _this8.fbm.productNo,
                        price: _this8.fbm.price,
                        warehouseNo: _this8.fbm.warehouseNo,
                        note: _this8.fbm.note,
                        qty: _this8.fbm.quantity
                    };
                    _this8.loading = true;
                    (0, _inventoryService.editFBM)(param).then(function (data) {
                        _this8.loading = false;
                        if (data.status === 200) {
                            _this8.$message.success(data.message);
                            _this8.editFBMVisible = false;
                            _this8.$refs.fbm.resetFields();
                            _this8.getInventory();
                        } else {
                            _this8.$message.error(data.message);
                        }
                    });
                }
            });
        },
        checkQuantity: function checkQuantity(rule, value, callback) {
            if (!value > 0) {
                return callback(new Error('Quantity must more than 1.'));
            } else {
                callback();
            }
        },
        getCurrentWarehouse: function getCurrentWarehouse() {
            var _this9 = this;

            (0, _warehouseService.getCurrentWarehouse)({}).then(function (data) {
                if (data.status === 200) {
                    _this9.warehouseList = data.result;
                }
            });
        },
        showEditFBM: function showEditFBM(row) {
            this.fbm.productName = row.productName;
            this.fbm.productNo = row.productNo;
            this.editFBMVisible = true;
        },
        changeNotClaimedPage: function changeNotClaimedPage(val) {
            this.notClaimedPage = val;
            this.getNotClaimed();
        },
        changeReportPage: function changeReportPage(val) {
            this.reportPage = val;
            this.getReportList();
        },
        changeFBMPage: function changeFBMPage(val) {
            this.fbmPage = val;
            this.getFBMList();
        },
        changeStockPage: function changeStockPage(val) {
            this.stockPage = val;
            this.getStockList();
        },
        getReportList: function getReportList() {
            var _this10 = this;

            var param = {
                current: this.reportPage,
                size: this.pageSize,
                condition: this.filters.reportFilter,
                status: this.filters.reportStatus,
                productId: this.currentDetailNo
            };
            this.fourthListLoading = true;
            (0, _inventoryService.getInventoryReportList)(param).then(function (data) {
                _this10.fourthListLoading = false;
                if (data.status === 200) {
                    _this10.reportedInbound = data.result.records;
                    _this10.reportTotal = data.result.total;
                }
            });
        },
        getInboundList: function getInboundList() {
            var _this11 = this;

            var param = {
                current: this.inboundPage,
                size: this.pageSize,
                productNo: this.currentDetailNo,
                condition: this.filters.inboundFilter,
                userNo: this.filters.inboundUser,
                type: this.filters.inboundType,
                tracking: this.filters.tracking
            };
            this.firstListLoading = true;
            (0, _inboundService.getProductInboundList)(param).then(function (data) {
                _this11.firstListLoading = false;
                if (data.status === 200) {
                    _this11.inboundList = data.result.records;
                    _this11.inboundTotal = data.result.total;
                }
            });
        },
        getOutboundList: function getOutboundList() {
            var _this12 = this;

            var param = {
                current: this.outboundPage,
                size: this.pageSize,
                productNo: this.currentDetailNo,
                userNo: this.filters.outboundUser
            };
            this.thirdListLoading = true;
            (0, _outboundService.getOutboundByProduct)(param).then(function (data) {
                _this12.thirdListLoading = false;
                if (data.status === 200) {
                    _this12.outboundList = data.result.records;
                    _this12.outboundTotal = data.result.total;
                }
            });
        },
        getStockList: function getStockList() {
            var _this13 = this;

            var param = {
                current: this.stockPage,
                size: this.pageSize,
                productNo: this.currentDetailNo,
                bizType: this.filters.stockFilter
            };
            this.sixListLoading = true;
            (0, _inventoryService.getStockHistory)(param).then(function (data) {
                _this13.sixListLoading = false;
                if (data.status === 200) {
                    _this13.stockList = data.result.records;
                    _this13.stockTotal = data.result.total;
                }
            });
        },
        showDetail: function showDetail(id) {
            this.currentDetailNo = id;
            this.detailVisible = true;
            this.filters.tracking = "";
            this.getInboundList();
            this.getReportList();
            this.getOutboundList();
            this.getNotClaimed();
            this.getInventoryDetail();
            this.getStockList();
        },
        handleInventoryChange: function handleInventoryChange(val) {
            this.inventoryPage = val;
            this.getInventory();
        },
        handleEditProduct: function handleEditProduct(row) {
            this.editProduct = row;
            this.editFormVisible = true;
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
        },
        handleChangeInboundList: function handleChangeInboundList(val) {
            this.inboundPage = val;
            this.getInboundList();
        },
        handleChangeOutboundList: function handleChangeOutboundList(val) {
            this.outboundPage = val;
            this.getOutboundList();
        },
        getInventory: function getInventory() {
            var _this14 = this;

            var para = {
                current: this.inventoryPage,
                size: this.pageSize,
                condition: this.filters.name
            };
            this.listLoading = true;
            (0, _inventoryService.getInventory)(para).then(function (res) {
                _this14.listLoading = false;
                if (res.status === 200) {
                    _this14.products = res.result.records;
                    _this14.inventoryTotal = res.result.total;
                }
            });
        },

        handleEdit: function handleEdit(index, row) {
            this.editFormVisible = true;
            this.editForm = (0, _assign2.default)({}, row);
        },

        editSubmit: function editSubmit() {
            var _this15 = this;

            this.$refs.editProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productNo: _this15.editProduct.productNo,

                        condition: _this15.editProduct.condition,
                        asin: _this15.editProduct.asin,
                        upc: _this15.editProduct.upc,
                        weight: _this15.editProduct.weight,
                        note: _this15.editProduct.note,
                        price: _this15.editProduct.price
                    };
                    _this15.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this15.loading = false;
                        if (res.status === 200) {
                            _this15.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this15.editFormVisible = false;
                            _this15.$refs.editProduct.resetFields();
                            _this15.getInventory();
                        } else {
                            _this15.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },

        handleAddProduct: function handleAddProduct() {
            var _this16 = this;

            this.$refs.addProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productName: _this16.addProduct.product,
                        condition: _this16.addProduct.condition,
                        asin: _this16.addProduct.asin,
                        upc: _this16.addProduct.upc,
                        weight: _this16.addProduct.weight,
                        note: _this16.addProduct.note,
                        price: _this16.addProduct.price
                    };
                    _this16.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this16.loading = false;
                        if (res.status === 200) {
                            _this16.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this16.addFormVisible = false;
                            _this16.$refs.addProduct.resetFields();
                            _this16.getInventory();
                        } else {
                            _this16.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        exportInventoryInboundHistory: function exportInventoryInboundHistory() {
            console.log('开始导出，currentDetailNo:', this.currentDetailNo);
            console.log('过滤条件:', this.filters);

            if (!this.currentDetailNo) {
                this.$message.warning('请先选择一个产品查看详情');
                return;
            }

            var param = {
                productNo: this.currentDetailNo,
                tracking: this.filters.tracking || '',
                userNo: this.filters.inboundUser || '',
                type: this.filters.inboundType || ''
            };

            console.log('导出参数:', param);

            var queryString = (0, _keys2.default)(param).filter(function (key) {
                return param[key] !== '' && param[key] != null;
            }).map(function (key) {
                return encodeURIComponent(key) + "=" + encodeURIComponent(param[key]);
            }).join('&');

            var fullUrl = "/excel/exportInventoryInboundHistory?" + queryString;
            console.log('完整请求URL:', fullUrl);

            var reqParam = {
                url: fullUrl,
                fileName: 'inventory_inbound_history.xls'
            };
            (0, _exportService.exportExcel)(reqParam).then(function () {});
        },
        goToMixedPackageClaim: function goToMixedPackageClaim() {
            this.$router.push('/mixedPackageClaim');
        }
    },
    mounted: function mounted() {
        this.getInventory();
        this.getCurrentWarehouse();
        this.getDoctorMembers();
    }
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = __webpack_require__(145);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(110);

var _from2 = _interopRequireDefault(_from);

var _vueQuillEditor = __webpack_require__(76);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _offerService = __webpack_require__(107);

var _inventoryService = __webpack_require__(78);

var _memberService = __webpack_require__(17);

var _exportService = __webpack_require__(22);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },
            relistFormVisible: false,
            offerDetailVisible: false,
            offerHistory: [],
            proposedOffers: [],
            offerDetails: [],

            claimDetailVisible: false,
            claimDetailLoading: false,
            claimDetails: null,
            claimDetailPage: 1,
            claimDetailPageSize: 50,
            claimDetailTotal: 0,
            currentOfferNo: "",
            conditions: _globalVar.conditions,
            activeName: "first",
            filters: {
                offerDetailFilter: "",
                historyFilter: "",
                proposedFilter: "",
                openOfferFilter: "",
                name: '',
                status: ""
            },
            currentDetailNo: "",

            products: [],
            openOffers: [],

            nurseList: [],

            pageSize: _globalVar.defaultPageSize,
            total: 0,
            page: 1,

            offerDetailPage: 1,
            offerDetailTotal: 0,

            historyPage: 1,
            historyTotal: 0,

            proposedPage: 1,
            proposedTotal: 0,

            openOfferPage: 0,
            openOfferTotal: 0,

            loading: false,
            listLoading: false,
            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,

            groups: [],

            addProductVisible: false,
            inputVisible: false,
            inputValue: "",

            editFormVisible: false,
            editOffer: {},
            relistOffer: {
                newExpireDate: ""
            },
            editLoading: false,

            editOfferFormRules: {
                productNo: [{ required: true, message: 'Product is required.', trigger: 'blur' }],
                price: [{ required: true, message: 'Price is required.', trigger: 'blur' }],
                quantity: [{ required: true, message: 'Original Total is required.', trigger: 'blur' }],
                leftNum: [{ required: true, message: 'Left is required.', trigger: 'blur' }],
                expireDate: [{ required: true, message: 'Expire Date is required.', trigger: 'blur' }],
                bouns: [{ required: true, message: 'Bonus is required.', trigger: 'blur' }]
            },

            addOfferFormRules: {
                productNo: [{ required: true, message: 'Product is required.', trigger: 'blur' }],
                price: [{ required: true, message: 'Price is required.', trigger: 'blur' }],
                total: [{ required: true, message: 'Total is required.', trigger: 'blur' }],
                expireDate: [{ required: true, message: 'Expire Date is required.', trigger: 'blur' }],
                bouns: [{ required: true, message: 'Bonus is required.', trigger: 'blur' }]
            },

            addProductFormRules: {
                product: [{ required: true, message: 'Product Name is  required.', trigger: 'blur' }],
                price: [{ required: true, message: 'Price is required.', trigger: 'blur' }]
            },

            addProduct: {
                id: "",
                product: '',
                condition: "New",
                price: "",
                asin: "",
                upc: "",
                weight: '',
                note: ""
            },

            addFormVisible: false,
            addLoading: false,
            addFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            addOffer: {
                id: "",
                title: "",
                productNo: '',
                price: "",
                total: 0,
                expireDate: '',
                note: '',
                bouns: "",
                scope: "public",
                notify: true,
                users: []
            },
            defaultProps: {
                children: 'members',
                label: 'label'
            },
            dateOption: {
                disabledDate: function disabledDate(date) {
                    return date.getTime() < Date.now() - 8.64e7;
                }
            }
        };
    },

    methods: {
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.exportExcel)(param).then(function () {});
        },
        getNurseList: function getNurseList() {
            var _this = this;

            (0, _memberService.getDoctorNurse)().then(function (data) {
                if (data.status === 200) {
                    _this.nurseList = data.result;
                }
            });
        },
        getOfferDetail: function getOfferDetail(id) {
            var _this2 = this;

            if (id) {
                this.currentDetailNo = id;
            }
            var param = {
                offerNo: id ? id : this.currentDetailNo,
                current: this.offerDetailPage,
                size: this.pageSize,
                userNo: this.filters.offerDetailFilter
            };
            this.listLoading = true;
            (0, _offerService.getTakeOfferDetail)(param).then(function (data) {
                _this2.listLoading = false;
                if (data.status === 200) {
                    _this2.offerDetails = data.result.records;
                    _this2.offerDetailTotal = data.result.total;
                    _this2.offerDetailVisible = true;
                } else {
                    _this2.$message.error(data.messaeg);
                }
            });
        },
        confirmProposed: function confirmProposed(id, status) {
            var _this3 = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _offerService.editProposedOfferStatus)({ id: id, status: status }).then(function (res) {
                    if (res.status === 200) {
                        _this3.$message.success(res.message);
                        _this3.getProposedOffers();
                    } else {
                        _this3.$message.error(res.message);
                        _this3.getProposedOffers();
                    }
                });
            }).catch(function () {});
        },
        getProposedOffers: function getProposedOffers() {
            var _this4 = this;

            var param = {
                current: this.proposedPage,
                size: this.pageSize,
                condition: this.filters.proposedFilter,
                status: this.filters.status
            };
            this.secondListLoading = true;
            (0, _offerService.getProposedOffers)(param).then(function (data) {
                _this4.secondListLoading = false;
                if (data.status === 200) {
                    _this4.proposedOffers = data.result.records;
                    _this4.proposedTotal = data.result.total;
                }
            });
        },
        formatProposedStatus: function formatProposedStatus(row, column) {
            if (row.status === 0) {
                return "Pending";
            } else if (row.status === 1) {
                return "Confirmed";
            } else if (row.status === 3) {
                return "Cancelled";
            } else {
                return "Rejected";
            }
        },
        getMembers: function getMembers() {
            var _this5 = this;

            (0, _memberService.getMemberWithGroup)().then(function (res) {
                console.log(res);
                if (res.status === 200) {
                    var groups = [];
                    var unGroup = { label: "No Group", members: [] };
                    res.result.forEach(function (item) {
                        if (item.groupName) {
                            var result = groups.find(function (group) {
                                return item.groupName === group.label;
                            });
                            if (result) {
                                result.members.push({ label: item.userName, userNo: item.userNo });
                            } else {
                                groups.push({ label: item.groupName, members: [{ label: item.userName, userNo: item.userNo }] });
                            }
                        } else {
                            unGroup.members.push({ label: item.userName, userNo: item.userNo });
                        }
                    });
                    if (unGroup.members.length > 0) {
                        groups.unshift(unGroup);
                    }
                    _this5.groups = groups;
                }
            });
        },
        archiveOffer: function archiveOffer(offerId) {
            var _this6 = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _offerService.editOfferStatus)({ offerNo: offerId, status: 'archived' }).then(function (res) {
                    if (res.status === 200) {
                        _this6.$message.success(res.message);
                        _this6.getOpenOffers();
                        _this6.getOfferHistory();
                    } else {
                        _this6.$message.error(res.message);
                    }
                });
            }).catch(function () {});
        },
        getProductList: function getProductList() {
            var _this7 = this;

            (0, _inventoryService.getDoctorProduct)({ condition: "" }).then(function (res) {
                if (res.status === 200) {
                    _this7.products = res.result;
                }
            });
        },
        showAddProduct: function showAddProduct() {
            var _this8 = this;

            var temp = new Date();
            temp.setDate(temp.getDate() + 3);
            this.addOffer.expireDate = _util2.default.formatDate.format(temp, 'yyyy-MM-dd hh:mm:ss');
            (0, _memberService.getDoctorMemberList)({ roleId: 2 }).then(function (res) {
                if (res.status === 200) {
                    _this8.addFormVisible = true;
                    _this8.members = res.result;
                }
            });
        },
        handleAddProduct: function handleAddProduct() {
            var _this9 = this;

            this.$refs.addProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productName: _this9.addProduct.product,
                        condition: _this9.addProduct.condition,
                        asin: _this9.addProduct.asin,
                        upc: _this9.addProduct.upc,
                        weight: _this9.addProduct.weight,
                        note: _this9.addProduct.note,
                        price: _this9.addProduct.price
                    };
                    _this9.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this9.loading = false;
                        if (res.status === 200) {
                            _this9.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this9.$refs.addProduct.resetFields();
                            _this9.addProductVisible = false;
                            _this9.getProductList();
                        } else {
                            _this9.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        handleChangeOfferDetail: function handleChangeOfferDetail(val) {
            this.offerDetailPage = val;
            this.getOfferDetail();
        },
        handleChangeOfferHistory: function handleChangeOfferHistory(val) {
            this.historyPage = val;
            this.getOfferHistory();
        },
        handleChangeOpenOffer: function handleChangeOpenOffer(val) {
            this.openOfferPage = val;
            this.getOpenOffers();
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
        },
        getOpenOffers: function getOpenOffers() {
            var _this10 = this;

            var param = {
                current: this.openOfferPage,
                size: this.pageSize,
                condition: this.filters.openOfferFilter,
                status: "offering"
            };
            this.firstListLoading = true;
            (0, _offerService.getDoctorOffer)(param).then(function (res) {
                _this10.firstListLoading = false;
                if (res.status === 200) {
                    _this10.openOffers = res.result.records;
                    _this10.openOfferTotal = res.result.total;
                } else {
                    _this10.$message.error(res.message);
                }
            });
        },
        getOfferHistory: function getOfferHistory() {
            var _this11 = this;

            var param = {
                current: this.historyPage,
                size: this.pageSize,
                condition: this.filters.historyFilter,
                status: this.filters.status
            };
            this.thirdListLoading = true;
            (0, _offerService.getDoctorOffer)(param).then(function (res) {
                _this11.thirdListLoading = false;
                if (res.status === 200) {
                    _this11.offerHistory = res.result.records;
                    _this11.historyTotal = res.result.total;
                } else {
                    _this11.$message.error(res.message);
                }
            });
        },

        showEditOffer: function showEditOffer(offerId) {
            var _this12 = this;

            (0, _offerService.getOfferById)({ offerNo: offerId }).then(function (res) {
                if (res.status === 200) {
                    _this12.editFormVisible = true;
                    _this12.editOffer = res.result.offer;
                    if (res.result.offerUsers) {
                        var users = res.result.offerUsers.split(",");
                        _this12.editOffer.users = users;
                    }
                }
            });
        },
        reListOffer: function reListOffer(offerId) {
            var _this13 = this;

            (0, _offerService.getOfferById)({ offerNo: offerId }).then(function (res) {
                if (res.status === 200) {
                    _this13.relistFormVisible = true;
                    _this13.relistOffer = res.result.offer;
                    var temp = new Date();
                    temp.setDate(temp.getDate() + 3);

                    _this13.$set(_this13.relistOffer, "newExpireDate", _util2.default.formatDate.format(temp, 'yyyy-MM-dd hh:mm:ss'));
                    if (res.result.offerUsers) {
                        var users = res.result.offerUsers.split(",");
                        _this13.relistOffer.users = users;
                    }
                }
            });
        },
        handleAddOffer: function handleAddOffer() {
            var _this14 = this;

            this.$refs.addOffer.validate(function (valid) {
                if (valid) {
                    _this14.loading = true;
                    var param = {
                        productNo: _this14.addOffer.productNo,
                        price: _this14.addOffer.price,
                        quantity: _this14.addOffer.total,
                        leftNum: _this14.addOffer.total,
                        expireDate: _this14.addOffer.expireDate,
                        bouns: _this14.addOffer.bouns,
                        scope: _this14.addOffer.scope,
                        note: _this14.addOffer.note,
                        notify: _this14.addOffer.notify
                    };
                    if (_this14.addOffer.scope === "private") {
                        var checked = _this14.$refs.tree.getCheckedKeys();
                        if (checked.length > 0) {
                            checked = checked.filter(function (item) {
                                return item !== undefined;
                            });
                        }
                        var array = (0, _from2.default)(new _set2.default(checked));
                        param.nurseStr = array.join(",");
                    }
                    (0, _offerService.addOffer)(param).then(function (res) {
                        _this14.loading = false;
                        if (res.status === 200) {
                            _this14.addFormVisible = false;
                            _this14.$message.success(res.message);
                            _this14.$refs.addOffer.resetFields();
                            _this14.getOpenOffers();
                        } else {
                            _this14.$message.error(res.message);
                        }
                    });
                }
            });
        },
        handleEditOffer: function handleEditOffer() {
            var _this15 = this;

            this.loading = true;
            this.$refs.editOffer.validate(function (valid) {
                _this15.loading = false;
                if (valid) {
                    var param = {
                        offerNo: _this15.editOffer.offerNo,
                        price: _this15.editOffer.price,
                        quantity: _this15.editOffer.quantity,
                        leftNum: _this15.editOffer.leftNum,
                        expireDate: _this15.editOffer.expireDate,
                        bouns: _this15.editOffer.bouns,
                        scope: _this15.editOffer.scope,
                        notify: _this15.editOffer.notify,
                        note: _this15.editOffer.note
                    };
                    (0, _offerService.addOffer)(param).then(function (res) {
                        if (res.status === 200) {
                            _this15.editFormVisible = false;
                            _this15.$message.success(res.message);
                            _this15.getOpenOffers();
                            _this15.getOfferHistory();
                        } else {
                            _this15.$message.error(res.message);
                        }
                    });
                }
            });
        },
        handleReListOffer: function handleReListOffer() {
            var _this16 = this;

            this.loading = true;
            this.$refs.relistOffer.validate(function (valid) {
                _this16.loading = false;
                if (valid) {
                    var param = {
                        offerNo: _this16.relistOffer.offerNo,
                        price: _this16.relistOffer.price,
                        quantity: _this16.relistOffer.quantity,
                        leftNum: _this16.relistOffer.leftNum,
                        expireDate: _this16.relistOffer.newExpireDate,
                        bouns: _this16.relistOffer.bouns,
                        scope: _this16.relistOffer.scope,
                        notify: _this16.relistOffer.notify,
                        note: _this16.relistOffer.note,
                        status: "offering"
                    };
                    (0, _offerService.addOffer)(param).then(function (res) {
                        if (res.status === 200) {
                            _this16.relistFormVisible = false;
                            _this16.$message.success(res.message);
                            _this16.getOpenOffers();
                            _this16.getOfferHistory();
                        } else {
                            _this16.$message.error(res.message);
                        }
                    });
                }
            });
        },
        showOfferClaimDetails: function showOfferClaimDetails(offerNo) {
            this.currentOfferNo = offerNo;
            this.claimDetailPage = 1;
            this.claimDetailVisible = true;
            this.getOfferClaimDetails();
        },
        getOfferClaimDetails: function getOfferClaimDetails() {
            var _this17 = this;

            this.claimDetailLoading = true;

            var params = {
                offerNo: this.currentOfferNo,
                current: this.claimDetailPage,
                size: this.claimDetailPageSize
            };

            (0, _offerService.getOfferClaimDetails)(params).then(function (res) {
                _this17.claimDetailLoading = false;
                if (res.status === 200) {
                    _this17.claimDetails = res.result;

                    if (res.result.total !== undefined) {
                        _this17.claimDetailTotal = res.result.total;
                    } else {
                        _this17.claimDetailTotal = res.result.claimRecords ? res.result.claimRecords.length : 0;
                    }
                } else {
                    _this17.$message.error(res.message || '获取认领详情失败');
                    _this17.claimDetailVisible = false;
                }
            }).catch(function (error) {
                _this17.claimDetailLoading = false;
                _this17.$message.error('获取认领详情失败: ' + error.message);
                _this17.claimDetailVisible = false;
            });
        },
        handleChangeClaimDetail: function handleChangeClaimDetail(page) {
            this.claimDetailPage = page;
            this.getOfferClaimDetails();
        }
    },
    mounted: function mounted() {
        this.getOpenOffers();
        this.getProductList();
        this.getMembers();
        this.getProposedOffers();
        this.getOfferHistory();
        this.getNurseList();
        var active = this.$route.params.active;
        if (active) {
            this.activeName = active;
        }
    }
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

var _jquery = __webpack_require__(286);

var _jquery2 = _interopRequireDefault(_jquery);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(17);

var _inventoryService = __webpack_require__(78);

var _outboundService = __webpack_require__(108);

var _warehouseService = __webpack_require__(50);

var _button = __webpack_require__(104);

var _button2 = _interopRequireDefault(_button);

var _main = __webpack_require__(298);

var _main2 = _interopRequireDefault(_main);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

var _input = __webpack_require__(105);

var _input2 = _interopRequireDefault(_input);

var _globalVar = __webpack_require__(7);

var _vueQuillEditor = __webpack_require__(76);

var _exportService = __webpack_require__(22);

var _inputNumber = __webpack_require__(297);

var _inputNumber2 = _interopRequireDefault(_inputNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ElInputNumber: _inputNumber2.default,
        ElInput: _input2.default,
        ElOption: _option2.default,
        ElLink: _main2.default,
        ElButton: _button2.default },
    data: function data() {
        return {
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },
            activeName: "first",
            filters: {
                workingFilter: "",
                workingMainFilter: "",
                archivedFilter: "",
                archivedMainFilter: "",
                closeFilter: "",
                closeMainFilter: "",
                inventoryProduct: "",
                inventoryProductSummary: "",
                inventoryNurse: "",
                inventorySummaryNurse: "",
                customizationName: "",
                name: '',
                transferFilter: "",
                productFilter: "",
                fbmFilter: ""
            },
            headers: {
                Authorization: window.sessionStorage.getItem("authorization")
            },
            uploadUrl: _globalVar.serverUrl + "/outboundFile/upload",

            pageSize: _globalVar.defaultPageSize,

            inventoryLoading: false,
            inventorySummaryLoading: false,

            inventorySummaryPage: 1,
            inventorySummaryTotal: 0,

            inventorySummaryByUserPage: 1,
            inventorySummaryByUserTotal: 0,

            inventoryPage: 1,
            inventoryTotal: 0,

            customizationPage: 1,
            customizationTotal: 0,
            customizationLoading: false,

            instructionTemps: [],
            instruction: {},

            workingList: [],
            workingPage: 1,
            workingTotal: 0,
            workingLoading: false,

            archivedList: [],
            archivedPage: 1,
            archivedTotal: 0,
            archivedLoading: false,

            instructionTemplateVisiable: false,
            instructionListPage: [],
            instructionPage: 1,
            instructionTotal: 0,
            instructionLoading: false,

            closeList: [],
            closePage: 1,
            closeTotal: 0,
            closeLoading: false,

            transferList: [],
            transferPage: 1,
            transferTotal: 0,
            transferLoading: false,
            transferModelVisiable: false,

            transferLogsPage: 1,
            transferLogsPageSize: 50,
            transferLogsWorkingTotal: 0,
            transferLogsList: [],
            transferLogsLoading: false,

            productList: [],
            productPage: 1,
            productTotal: 0,
            productLoading: false,

            fbmDetail: [],
            fbmPage: 1,
            fbmTotal: 0,
            fbmLoading: false,

            serviceList: [],

            editCustomizationVisible: false,
            addCustomizationVisible: false,
            customizationProduct: [],
            addInstructionVisible: false,
            editInstructionVisible: false,
            workingOutboundList: [],
            inventories: [],
            inventoriesSummary: [],
            inventoriesSummaryByUser: [],
            outboundItems: [],
            archivedOutbound: [],
            total: 0,
            invitationTotalPage: 0,
            invitationPage: 1,
            listLoading: false,
            sels: [],
            customizationVisible: false,
            addInventory: false,
            inventroySummary: false,
            fbmModelVisiable: false,

            currentInventroy: "",

            currentDetailNo: "",

            nurseList: [],
            warehouses: [],

            loading: false,

            outbound: {
                id: "",
                warehouseNo: "",
                items: [],
                packageLabel: "",
                trackingNumber: "",
                carrier: "",
                carrierName: "",
                user: "",
                note: "",
                instruction: "",
                priority: 0,

                splitPackagesNum: 0,
                fileId: "",
                mainProduct: "",
                mainProductName: ""
            },

            selectedInstruction: null,

            members: [],

            addInstructionRule: {
                name: [{ required: true, message: 'Name is required.', trigger: 'blur' }]
            },

            customizationRule: {
                warehouse: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
                name: [{ required: true, message: 'Template name is required.', trigger: 'blur' }],
                mainProduct: [{ required: true, message: 'Main Product is required.', trigger: 'blur' }],
                mainProductQty: [{ required: true, message: 'Main Product Qty is required.', trigger: 'blur' }]
            },

            transferRule: {
                to: [{ required: true, message: 'Transfer To is required.', trigger: 'blur' }],
                transferQty: [{ required: true, message: 'Transfer Qty is required.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
            },

            addInstruction: {
                name: "",
                text: "",
                note: ""
            },
            editInstructionObj: {
                name: "",
                text: "",
                note: "",
                id: ""
            },
            customization: {
                name: "",
                warehouse: "",
                mainProduct: "",
                mainProductQty: "",
                sub: []
            },

            editCustomization: {
                id: "",
                name: "",
                warehouse: "",
                sub: [],
                mainProduct: "",
                mainProductQty: ""
            },

            transferForm: {
                productNo: "",
                productName: "",
                warehouseNo: "",
                warehouse: "",
                qty: "",
                to: "",
                transferQty: "",
                upc: ""
            },
            fileList: [],
            uploadForm: new FormData(),
            currentUser: null
        };
    },

    methods: {
        checkQuantity: function checkQuantity(rule, value, callback) {
            if (!value > 0) {
                return callback(new Error('Quantity must more than 1.'));
            } else {
                callback();
            }
        },
        exportExcel: function exportExcel(url, fileName, type) {
            var param = {
                url: url,
                fileName: fileName,
                status: type
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },
        closeOutbound: function closeOutbound(id) {
            var _this = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                var param = {
                    outboundNo: id,
                    status: 3
                };
                (0, _outboundService.updateOutboundStatus)(param).then(function (data) {
                    if (data.status === 200) {
                        _this.$message.success(data.message);
                        _this.getWorkingOutboundList();
                        _this.getCloseOutboundList();
                    } else {
                        _this.$message.error(data.message);
                    }
                });
            }).catch(function () {});
        },
        download: function download(id) {
            window.open(_globalVar.serverUrl + "/outboundFile/exportPackageLabelImageById?outboundNo=" + id, "_blank");
        },
        deleteCustomization: function deleteCustomization(id) {
            var _this2 = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _outboundService.deleteCustomizationTemplate)({ customization_id: id }).then(function (res) {
                    if (res.status === 200) {
                        _this2.$message.success(res.message);
                        _this2.getCustomizationProduct();
                    } else {
                        _this2.$message.error(res.message);
                    }
                });
            }).catch(function () {});
        },
        deleteEditSub: function deleteEditSub(row) {
            this.editCustomization.sub.splice(this.editCustomization.sub.indexOf(row), 1);
        },
        deleteSub: function deleteSub(row) {
            this.customization.sub.splice(this.customization.sub.indexOf(row), 1);
        },
        openNewCustomizationWindow: function openNewCustomizationWindow() {
            var _this3 = this;

            this.addCustomizationVisible = true;
            this.$nextTick(function () {
                _this3.$refs.customization.resetFields();
            });
        },
        addCustomizationTemplate: function addCustomizationTemplate() {
            var _this4 = this;

            this.$refs.customization.validate(function (valid) {
                if (valid) {
                    var _ret = function () {
                        var items = [];
                        var products = _this4.customization.sub;

                        var _loop = function _loop(i) {
                            if (!products[i].productNo) {
                                _this4.$message.error("You must select a product for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (products[i].productNo == _this4.customization.mainProduct) {
                                _this4.$message.error("You select a sub product same with main product, please delete this product or replace.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (!products[i].service) {
                                _this4.$message.error("You must select a service for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            var exsit = items.find(function (f) {
                                return f.productNo == products[i].productNo;
                            });
                            if (exsit) {
                                _this4.$message.error("Duplicate product in the list.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            } else {
                                items.push({ productNo: products[i].productNo, qty: products[i].qty, service: products[i].service ? products[i].service : "None" });
                            }
                        };

                        for (var i = 0; i < products.length; i++) {
                            var _ret2 = _loop(i);

                            if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
                        }

                        var param = {
                            items: items,
                            templateName: _this4.customization.name,
                            warehouseNo: _this4.customization.warehouse,
                            product_no: _this4.customization.mainProduct,
                            mainProductQty: _this4.customization.mainProductQty
                        };
                        _this4.loading = true;
                        (0, _outboundService.addCustomizationTemplate)(param).then(function (data) {
                            _this4.loading = false;
                            if (data.status === 200) {
                                _this4.addCustomizationVisible = false;
                                _this4.getCustomizationProduct();
                                _this4.$refs.customization.resetFields();
                                _this4.customization.sub = [];
                                _this4.$message.success(data.message);
                            } else {
                                _this4.$message.error(data.message);
                            }
                        });
                    }();

                    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
                }
            });
        },
        editCustomizationTemplate: function editCustomizationTemplate() {
            var _this5 = this;

            this.$refs.editCustomization.validate(function (valid) {
                if (valid) {
                    var _ret3 = function () {
                        var items = [];
                        var products = _this5.editCustomization.sub;

                        var _loop2 = function _loop2(i) {
                            if (!products[i].productNo) {
                                _this5.$message.error("You must select a product for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (products[i].productNo == _this5.editCustomization.mainProduct) {
                                _this5.$message.error("You select a sub product same with main product, please delete this product or replace.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (!products[i].qty) {
                                _this5.$message.error("You must set quantity for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (!products[i].service) {
                                _this5.$message.error("You must select a service for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            var exsit = items.find(function (f) {
                                return f.productNo == products[i].productNo;
                            });
                            if (exsit) {
                                _this5.$message.error("Duplicate product in the list.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            } else {
                                items.push({ productNo: products[i].productNo, qty: products[i].qty, service: products[i].service ? products[i].service : "None" });
                            }
                        };

                        for (var i = 0; i < products.length; i++) {
                            var _ret4 = _loop2(i);

                            if ((typeof _ret4 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret4)) === "object") return _ret4.v;
                        }

                        var param = {
                            customizationOutboundId: _this5.editCustomization.id,
                            items: items,
                            templateName: _this5.editCustomization.name,
                            warehouseNo: _this5.editCustomization.warehouse,
                            product_no: _this5.editCustomization.mainProduct,
                            mainProductQty: _this5.editCustomization.mainProductQty
                        };
                        _this5.loading = true;
                        (0, _outboundService.addCustomizationTemplate)(param).then(function (data) {
                            _this5.loading = false;
                            if (data.status === 200) {
                                _this5.editCustomizationVisible = false;
                                _this5.getCustomizationProduct();
                                _this5.$refs.editCustomization.resetFields();
                                _this5.editCustomization.sub = [];
                                _this5.$message.success(data.message);
                            } else {
                                _this5.$message.error(data.message);
                            }
                        });
                    }();

                    if ((typeof _ret3 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret3)) === "object") return _ret3.v;
                }
            });
        },
        getProductsByWarehouseId: function getProductsByWarehouseId(id) {
            var _this6 = this;

            if (this.customization.warehouse || id) {
                this.customization.sub = [];
                this.editCustomization.sub = [];
                return (0, _outboundService.getProductsByWarehouseId)({ warehouseNo: this.customization.warehouse || id }).then(function (data) {
                    if (data.status === 200) {
                        var param = {
                            warehouseNo: _this6.customization.warehouse || id
                        };
                        (0, _inventoryService.getServiceList)(param).then(function (data) {
                            if (data.status === 200) {
                                _this6.serviceList = data.result;
                            }
                        });
                        _this6.inventories = data.result;
                    }
                });
            } else {
                this.inventories = [];
            }
        },
        handleOutbound: function handleOutbound() {
            var _this7 = this;

            if (this.outbound.items.length === 0) {
                this.$message.error("You must select a product to shipment.");
                return;
            }
            if (!this.outbound.user) {
                this.$message.error("You must select a user to notify.");
                return;
            }
            if (this.outbound.splitPackagesNum < 1) {
                this.$message.error("You must set Numb of box Per Shipment greater than 0.");
                return;
            }
            var data = [];
            for (var i = 0; i < this.outbound.items.length; i++) {
                var item = this.outbound.items[i];
                if (item.items) {
                    if (!item.toShip) {
                        this.$message.error("Toship can't be empty.");
                        return;
                    } else {
                        var sub = item.items;
                        for (var j = 0; j < sub.length; j++) {
                            data.push({ toShip: item.toShip * sub[j].qty, productNo: sub[j].productNo, service: sub[j].service });
                        }
                    }
                } else {
                    if (item.toShip) {
                        data.push({ toShip: item.toShip, qty: item.qty, inboundNo: item.boundId, type: item.type, productNo: item.productNo, service: item.service });
                    } else {
                        this.$message.error("Toship can't be empty.");
                        return;
                    }
                }
            }

            var param = {
                data: data,
                fileNo: "",
                carrier: this.outbound.carrier,
                carrierName: this.outbound.carrierName,
                instruction: this.outbound.instruction,
                note: this.outbound.note,
                notifiyUserNo: this.outbound.user,
                priority: this.outbound.priority,

                splitPackagesNum: this.outbound.splitPackagesNum,
                tracking: this.outbound.trackingNumber,
                warehouseNo: this.outbound.warehouseNo,
                mainProduct: this.outbound.mainProduct
            };

            this.uploadForm = new FormData();
            this.$refs.upload.submit();
            var files = this.uploadForm.get("file");
            if (!files) {
                this.$message.error("Please upload package label before submit.");
                return;
            }
            this.loading = true;
            _jquery2.default.ajax({
                url: _globalVar.serverUrl + '/outboundFile/uploadFiles',
                type: "POST",
                data: this.uploadForm,
                cache: false,
                processData: false,
                contentType: false,
                beforeSend: function beforeSend(xhr) {
                    xhr.setRequestHeader("Authorization", window.sessionStorage.getItem("authorization"));
                }
            }).then(function (response) {
                if (response.status === 200) {
                    param.fileNo = response.result;
                    (0, _outboundService.outbound)(param).then(function (data) {
                        _this7.loading = false;
                        if (data.status === 200) {
                            _this7.fileList = [];
                            _this7.$message.success(data.message);
                            _this7.$refs.outbound.resetFields();
                            _this7.outbound.warehouseNo = "";
                            _this7.outbound.fileId = "";
                            _this7.outbound.items = [];
                            _this7.activeName = "second";
                            _this7.selectedInstruction = null;
                            _this7.outbound.mainProduct = "";
                            _this7.getWorkingOutboundList();
                        } else {
                            _this7.$message.error(data.message);
                        }
                    });
                } else {
                    _this7.$message.error(data.message);
                }
            });
        },
        removeFile: function removeFile() {
            this.outbound.fileId = "";
        },
        upload: function upload(file) {
            this.uploadForm.append('file', file.file);
        },
        uploadError: function uploadError(a) {
            this.$message.error(a.message);
            this.$refs.upload.clearFiles();
        },
        changeToship: function changeToship(value, row) {
            if (row.sub) {
                for (var i = 0; i < row.sub.length; i++) {
                    row.sub[i].quantity = row.sub[i].quantity * value;
                }
            }
        },
        addEditAccessories: function addEditAccessories() {
            this.editCustomization.sub.push({ productNo: "", qty: 1 });
        },
        addAccessories: function addAccessories() {
            this.customization.sub.push({ productNo: "", qty: 1 });
        },
        getCustomizationProduct: function getCustomizationProduct() {
            var _this8 = this;

            var param = {
                current: this.customizationPage,
                size: this.pageSize,
                condition: this.filters.customizationName
            };
            this.customizationLoading = true;
            (0, _outboundService.getCustomizationProduct)(param).then(function (data) {
                _this8.customizationLoading = false;
                if (data.status === 200) {
                    _this8.customizationProduct = data.result.records;
                    _this8.customizationTotal = data.result.total;
                }
            });
        },
        changeCustomizationPage: function changeCustomizationPage(val) {
            this.customizationPage = val;
            this.customizationVisible = true;
            this.getCustomizationProduct();
        },
        formatOutboundShipment: function formatOutboundShipment(row, columns) {
            return row.product + " * " + row.quantity;
        },
        removeInventory: function removeInventory(row) {
            this.outbound.items.splice(this.outbound.items.indexOf(row), 1);

            if (row.mainProductId) {
                this.outbound.mainProduct = "";
            }

            if (this.outbound.items.length === 0) {
                this.outbound.warehouseNo = "";
                this.outbound.user = "";
                this.outbound.mainProduct = "";
            }
        },
        selectInventory: function selectInventory(row) {
            var _this9 = this;

            if (row.selected) {
                var selectedItem = this.outbound.items.find(function (item) {
                    return item.productNo == row.productNo && _this9.outbound.warehouseNo == item.warehouseNo;
                });
                if (selectedItem) {
                    this.outbound.items.splice(this.outbound.items.indexOf(selectedItem), 1);
                }
                this.$set(row, "selected", false);
                if (this.outbound.items.length == 0) {
                    this.outbound.warehouseNo = "";
                    this.outbound.mainProduct = "";
                }
                return;
            }
            this.$set(row, 'toShip', 1);
            var exsit = this.outbound.items.filter(function (item) {
                return item.productNo == row.productNo && item.warehouseNo == row.warehouseNo;
            });
            if (exsit.length > 0) {
                this.$message.error("Product selected.");
                return;
            }
            if (!this.outbound.warehouseNo) {
                this.$set(row, "selected", true);
                this.outbound.items.push(row);
                this.outbound.warehouseNo = row.warehouseNo;
                this.addInventory = false;
                this.inventroySummary = false;
                this.outbound.user = row.warehouseUserNo;
            } else {
                if (this.outbound.warehouseNo == row.warehouseNo) {
                    this.$set(row, "selected", true);
                    this.outbound.items.push(row);
                    this.addInventory = false;
                    this.inventroySummary = false;
                } else {
                    this.$message.error("Products from different warehouses cannot be shipped out together.");
                }
            }
        },
        eitCustomization: function eitCustomization(row) {
            var _this10 = this;

            var param = {
                warehouseNo: row.warehouseNo
            };
            (0, _inventoryService.getServiceList)(param).then(function (data) {
                if (data.status === 200) {
                    _this10.serviceList = data.result;
                }
            });
            (0, _outboundService.getProductsByWarehouseId)({ warehouseNo: row.warehouseNo }).then(function (data) {
                if (data.status === 200) {
                    _this10.inventories = data.result;
                    _this10.editCustomization.id = row.id;
                    _this10.editCustomization.warehouse = row.warehouseNo;
                    _this10.editCustomization.mainProduct = row.mainProductId;
                    _this10.editCustomization.qty = row.qty;
                    var sub = row.items.filter(function (item) {
                        return item.productNo != row.mainProductId;
                    });
                    sub.forEach(function (item) {
                        item.productNo = item.productNo.toString();

                        var inventory = _this10.inventories.filter(function (i) {
                            return i.productNo == item.productNo;
                        });
                        if (inventory) {
                            item.fbm = inventory[0].fbm;
                        }
                    });
                    _this10.editCustomization.sub = sub;
                    _this10.editCustomization.name = row.templateName;
                    _this10.editCustomizationVisible = true;
                }
            });
        },
        selectCustomization: function selectCustomization(row) {
            row.qty = row.stock;
            if (!row.mainProductId) {
                this.$message.error("You must select a main product before outbound.");
                return;
            }
            this.$set(row, "toShip", 1);

            row.items.forEach(function (item) {
                item.type = 3;
            });
            if (!this.outbound.warehouseNo) {
                this.outbound.items.push(row);
                this.outbound.warehouseNo = row.warehouseNo;
                this.customizationVisible = false;
                this.outbound.user = row.warehouseUserNo;
            } else {
                if (this.outbound.warehouseNo == row.warehouseNo) {
                    this.outbound.items.push(row);
                    this.customizationVisible = false;
                } else {
                    this.$message.error("Products from different warehouses cannot be shipped out together.");
                }
            }
            if (row.mainProductId) {
                this.outbound.mainProduct = row.mainProductId;
                this.outbound.mainProductName = row.mainProductName;
            }
            this.outbound.note = row.templateName;
        },
        showAddInventory: function showAddInventory() {
            var _this11 = this;

            this.filters.inventoryNurse = "";
            this.filters.inventorySummaryNurse = "";
            this.getInventorySummary().then(function (data) {
                _this11.inventroySummary = true;
                _this11.filters.inventorySummaryNurse = "";
            });
        },
        getInventorySummary: function getInventorySummary() {
            var _this12 = this;

            var param = {
                current: this.inventorySummaryPage,
                size: this.pageSize,
                productName: this.filters.inventoryProductSummary
            };
            this.inventorySummaryLoading = true;
            return (0, _outboundService.getInventorySummary)(param).then(function (data) {
                _this12.inventorySummaryLoading = false;
                if (data.status === 200) {
                    _this12.inventoriesSummary = data.result.records;
                    _this12.inventorySummaryTotal = data.result.total;
                }
            });
        },
        getInventory: function getInventory(productNo) {
            var _this13 = this;

            if (productNo) {
                this.currentInventroy = productNo;
            }
            var param = {
                current: this.inventoryPage,
                size: this.pageSize,
                productName: this.filters.inventoryProduct,
                nurseId: this.filters.inventoryNurse,
                productNo: productNo ? productNo : this.currentInventroy
            };
            this.addInventory = true;
            this.inventoryLoading = true;
            return (0, _outboundService.getInventoryList)(param).then(function (data) {
                _this13.inventoryLoading = false;
                if (data.status === 200) {
                    _this13.inventories = data.result.records;
                    _this13.inventoryTotal = data.result.total;
                    _this13.inventories.forEach(function (item) {
                        var selected = _this13.outbound.items.filter(function (i) {
                            return i.productNo == item.productNo && i.warehouseNo == item.warehouseNo;
                        });
                        if (selected && selected.length > 0) {
                            _this13.$set(item, "selected", true);
                        }
                    });
                }
            });
        },
        getInventorySummaryByUser: function getInventorySummaryByUser() {
            var _this14 = this;

            if (this.filters.inventorySummaryNurse) {
                var param = {
                    current: this.inventorySummaryByUserPage,
                    size: this.pageSize,
                    productName: this.filters.inventoryProductSummary,
                    nurseId: this.filters.inventorySummaryNurse
                };
                this.inventoryLoading = true;
                return (0, _outboundService.getInventoryList)(param).then(function (data) {
                    _this14.inventoryLoading = false;
                    if (data.status === 200) {
                        _this14.inventoriesSummaryByUser = data.result.records;
                        _this14.inventorySummaryByUserTotal = data.result.total;
                        _this14.inventoriesSummaryByUser.forEach(function (item) {
                            var selected = _this14.outbound.items.filter(function (i) {
                                return i.productNo == item.productNo && i.warehouseNo == item.warehouseNo;
                            });
                            if (selected && selected.length > 0) {
                                _this14.$set(item, "selected", true);
                            }
                        });
                    }
                });
            } else {
                this.getInventorySummary();
            }
        },
        searchInventorySummary: function searchInventorySummary() {
            if (this.filters.inventorySummaryNurse) {
                this.getInventorySummaryByUser();
            } else {
                this.getInventorySummary();
            }
        },
        handleInventorySummaryByUserPageChange: function handleInventorySummaryByUserPageChange(val) {
            this.inventorySummaryByUserPage = val;
            this.getInventorySummaryByUser();
        },
        handleInventoryPageChange: function handleInventoryPageChange(val) {
            this.inventoryPage = val;
            this.getInventory(this.currentInventroy);
        },
        handleInventorySummaryPageChange: function handleInventorySummaryPageChange(val) {
            this.inventorySummaryPage = val;
            this.getInventorySummary();
        },
        changeWorkingList: function changeWorkingList(val) {
            this.workingPage = val;
            this.getWorkingOutboundList();
        },
        getWorkingOutboundList: function getWorkingOutboundList() {
            var _this15 = this;

            var param = {
                current: this.workingPage,
                size: this.pageSize,
                status: 1,
                condition: this.filters.workingFilter,
                main: this.filters.workingMainFilter
            };
            this.workingLoading = true;
            (0, _outboundService.getOutboundList)(param).then(function (data) {
                _this15.workingLoading = false;
                if (data.status === 200) {
                    _this15.workingList = data.result.records;
                    _this15.workingTotal = data.result.total;
                }
            });
        },
        getTransferList: function getTransferList() {
            var _this16 = this;

            var param = {
                current: this.transferPage,
                size: this.pageSize,
                condition: this.filters.transferFilter
            };
            this.transferLoading = true;
            (0, _outboundService.getTransferList)(param).then(function (data) {
                _this16.workingLoading = false;
                if (data.status === 200) {
                    _this16.transferList = data.result.records;
                    _this16.transferTotal = data.result.total;
                }
            });
        },
        handleTabClick: function handleTabClick(tab) {
            if (tab.name === 'six') {
                this.getTrasferUserLogs();
            }
        },
        getTrasferUserLogs: function getTrasferUserLogs() {
            var _this17 = this;

            var param = {
                current: this.transferLogsPage,
                size: this.transferLogsPageSize,
                doctorNo: this.currentUser.userNo
            };
            this.transferLogsLoading = true;
            (0, _outboundService.getTransferUserInfoByDoctorNo)(param).then(function (data) {
                _this17.transferLogsLoading = false;
                if (data.status === 200) {
                    _this17.transferLogsList = data.result.records;
                    _this17.transferLogsWorkingTotal = data.result.total;
                }
            });
        },
        changeArchivedList: function changeArchivedList(val) {
            this.archivedPage = val;
            this.getArchivedOutboundList();
        },
        getArchivedOutboundList: function getArchivedOutboundList() {
            var _this18 = this;

            var param = {
                current: this.archivedPage,
                size: this.pageSize,
                status: 2,
                condition: this.filters.archivedFilter,
                main: this.filters.archivedMainFilter
            };
            this.archivedLoading = true;
            (0, _outboundService.getOutboundList)(param).then(function (data) {
                _this18.archivedLoading = false;
                if (data.status === 200) {
                    _this18.archivedList = data.result.records;
                    _this18.archivedTotal = data.result.total;
                }
            });
        },
        changeCloseList: function changeCloseList(val) {
            this.closePage = val;
            this.getCloseOutboundList();
        },
        changeTransferList: function changeTransferList(val) {
            this.transferPage = val;
            this.getTransferList();
        },
        getCloseOutboundList: function getCloseOutboundList() {
            var _this19 = this;

            var param = {
                current: this.closePage,
                size: this.pageSize,
                status: 3,
                condition: this.filters.closeFilter,
                main: this.filters.closeMainFilter
            };
            this.closeLoading = true;
            (0, _outboundService.getOutboundList)(param).then(function (data) {
                _this19.closeLoading = false;
                if (data.status === 200) {
                    _this19.closeList = data.result.records;
                    _this19.closeTotal = data.result.total;
                }
            });
        },
        changeInstruction: function changeInstruction(selected) {
            this.outbound.note = selected.instructionNote;
            this.outbound.instruction = selected.instructionText;
        },
        getInstructionList: function getInstructionList() {
            var _this20 = this;

            (0, _outboundService.getInstructionList)({}).then(function (data) {
                if (data.status === 200) {
                    _this20.instructionTemps = data.result;
                }
            });
        },
        handleAddInstruction: function handleAddInstruction() {
            var _this21 = this;

            this.$refs.addInstruction.validate(function (valid) {
                if (valid) {
                    var param = {
                        instructionName: _this21.addInstruction.name,
                        instructionText: _this21.addInstruction.text,
                        instructionNote: _this21.addInstruction.note
                    };
                    (0, _outboundService.addInstruction)(param).then(function (data) {
                        if (data.status === 200) {
                            _this21.$message.success(data.message);
                            _this21.$refs.addInstruction.resetFields();
                            _this21.addInstructionVisible = false;
                            _this21.getInstructionList();
                            _this21.getInstructionListByPage();
                        } else {
                            _this21.$message.error(data.message);
                        }
                    });
                }
            });
        },
        handleEditInstruction: function handleEditInstruction() {
            var _this22 = this;

            this.$refs.editInstructionObj.validate(function (valid) {
                if (valid) {
                    var param = {
                        instructionName: _this22.editInstructionObj.name,
                        instructionText: _this22.editInstructionObj.text,
                        instructionNote: _this22.editInstructionObj.note,
                        id: _this22.editInstructionObj.id
                    };
                    (0, _outboundService.addInstruction)(param).then(function (data) {
                        if (data.status === 200) {
                            _this22.$message.success(data.message);
                            _this22.$refs.editInstructionObj.resetFields();
                            _this22.editInstructionVisible = false;
                            _this22.getInstructionList();
                            _this22.getInstructionListByPage();
                        } else {
                            _this22.$message.error(data.message);
                        }
                    });
                }
            });
        },
        editInstruction: function editInstruction(row) {
            this.editInstructionObj.name = row.instructionName;
            this.editInstructionObj.note = row.instructionNote;
            this.editInstructionObj.text = row.instructionText;
            this.editInstructionObj.id = row.id;
            this.editInstructionVisible = true;
        },
        deleteInstruction: function deleteInstruction(id) {
            var _this23 = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                var param = {
                    id: id
                };
                (0, _outboundService.deleteInstruction)(param).then(function (data) {
                    if (data.status === 200) {
                        _this23.$message.success(data.message);
                        _this23.getInstructionListByPage();
                        _this23.getInstructionList();
                    } else {
                        _this23.$message.error(data.message);
                    }
                });
            }).catch(function () {});
        },
        getNurseList: function getNurseList() {
            var _this24 = this;

            (0, _memberService.getDoctorNurse)().then(function (data) {
                if (data.status === 200) {
                    _this24.nurseList = data.result;
                }
            });
        },
        getDoctorMembers: function getDoctorMembers() {
            var _this25 = this;

            (0, _memberService.getDoctorMemberList)({}).then(function (data) {
                if (data.status === 200) {
                    _this25.members = data.result;
                }
            });
        },
        getWarehouse: function getWarehouse() {
            var _this26 = this;

            (0, _warehouseService.getCurrentWarehouse)({}).then(function (data) {
                if (data.status === 200) {
                    _this26.warehouses = data.result;
                }
            });
        },
        getInstructionListByPage: function getInstructionListByPage() {
            var _this27 = this;

            var param = {
                current: this.instructionPage,
                size: this.pageSize
            };
            this.instructionLoading = true;
            (0, _outboundService.getInstructionListByPage)(param).then(function (data) {
                _this27.instructionLoading = false;
                if (data.status === 200) {
                    _this27.instructionListPage = data.result.records;
                    _this27.instructionTotal = data.result.total;
                    _this27.instructionTemplateVisiable = true;
                }
            });
        },
        handleChangeInstructionListByPage: function handleChangeInstructionListByPage(val) {
            this.instructionPage = val;
            this.getInstructionListByPage();
        },
        showProductList: function showProductList() {
            this.fbmModelVisiable = true;
            this.getTransferProductList();
        },
        getTransferProductList: function getTransferProductList() {
            var _this28 = this;

            var param = {
                current: this.productPage,
                size: this.pageSize,
                condition: this.filters.productFilter
            };
            this.productLoading = true;
            (0, _inventoryService.getInventory)(param).then(function (res) {
                _this28.productLoading = false;
                if (res.status === 200) {
                    _this28.productList = res.result.records;
                    _this28.productTotal = res.result.total;
                }
            });
        },
        handleProductPageChange: function handleProductPageChange(val) {
            this.productPage = val;
            this.getTransferProductList();
        },
        showWarehouseFBM: function showWarehouseFBM(productNo) {
            this.fbmModelVisiable = true;
            this.currentDetailNo = productNo;
            this.getInventoryDetail();
        },
        getInventoryDetail: function getInventoryDetail() {
            var _this29 = this;

            var param = {
                current: this.fbmPage,
                size: this.pageSize,
                productName: this.filters.fbmFilter,
                productNo: this.currentDetailNo,
                warehouseOnly: "1"
            };
            this.fbmLoading = true;
            return (0, _outboundService.getInventoryList)(param).then(function (data) {
                _this29.fbmLoading = false;
                if (data.status === 200) {
                    _this29.fbmDetail = data.result.records;
                    _this29.fbmTotal = data.result.total;
                }
            });
        },
        handleInventoryDetailPageChange: function handleInventoryDetailPageChange(val) {
            this.fbmPage = val;
            this.getInventoryDetail();
        },
        showTransfer: function showTransfer(productNo, warehouseNo) {
            var _this30 = this;

            (0, _outboundService.getProductFBM)({ productId: productNo, warehouseNo: warehouseNo }).then(function (data) {
                _this30.transferModelVisiable = true;
                _this30.transferForm.to = "";
                _this30.transferForm.transferQty = "";
                if (data.status === 200) {
                    _this30.transferForm.productName = data.result.productNme;
                    _this30.transferForm.qty = data.result.qty;
                    _this30.transferForm.warehouse = data.result.warehouse;
                    _this30.transferForm.upc = data.result.upc;
                    _this30.transferForm.productNo = productNo;
                    _this30.transferForm.warehouseNo = warehouseNo;
                }
            });
        },
        transferTo: function transferTo() {
            var _this31 = this;

            this.$refs.transferForm.validate(function (valid) {
                if (valid) {
                    _this31.loading = true;
                    (0, _outboundService.transferTo)(_this31.transferForm).then(function (data) {
                        _this31.loading = false;
                        if (data.status === 200) {
                            _this31.$message.success("Transfer Success.");
                            _this31.transferModelVisiable = false;
                            _this31.getTransferProductList();
                            _this31.getInventoryDetail();
                        } else {
                            _this31.$message.error(data.message);
                        }
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getWorkingOutboundList();
        this.getArchivedOutboundList();
        this.getCloseOutboundList();
        this.getInstructionList();
        this.getNurseList();
        this.getDoctorMembers();
        this.getWarehouse();
        this.getTransferProductList();

        var active = this.$route.params.active;
        if (active) {
            this.activeName = active;
        }

        var user = sessionStorage.getItem('user');
        user = JSON.parse(user);
        this.currentUser = user;
    }
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _securityService = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			offers: {
				open: 0,
				proposed: 0
			},
			inbound: {
				inbound: 0,
				reported: 0
			},
			outbound: {
				outbound: 0
			},
			balance: {
				request: 0,
				requestTotal: 0,
				totalBalance: 0,
				totalPending: 0
			},
			loading: false
		};
	},

	methods: {
		getDoctorHome: function getDoctorHome() {
			var _this = this;

			this.loading = true;
			(0, _securityService.getDoctorHome)().then(function (data) {
				_this.loading = false;
				if (data.status === 200) {
					_this.offers.open = data.result.offerNum;
					_this.offers.proposed = data.result.proposeNum;
					_this.inbound.inbound = data.result.inboundNum;
					_this.inbound.reported = data.result.reportNum;
					_this.outbound.outbound = data.result.outboundNum;
					_this.balance.request = data.result.paymentNum;
					_this.balance.requestTotal = data.result.amount;
					_this.balance.totalBalance = data.result.transactionAmount;
					_this.balance.totalPending = data.result.pending;
				} else {
					_this.$message.error(data.message);
				}
			});
		}
	},
	mounted: function mounted() {
		this.getDoctorHome();
	}
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueQuillEditor = __webpack_require__(76);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _offerService = __webpack_require__(107);

var _paymentService = __webpack_require__(109);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

var _exportService = __webpack_require__(22);

var _globalVar = __webpack_require__(7);

var _memberService = __webpack_require__(17);

var _inputNumber = __webpack_require__(297);

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _storageFeePaymentService = __webpack_require__(219);

var _paymentService4Warehouse = __webpack_require__(218);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ElInputNumber: _inputNumber2.default,
        ElOption: _option2.default },
    data: function data() {
        var checkAmount = function checkAmount(rule, value, callback) {
            if (value <= 0) {
                return callback(new Error('Amount must more then 0.'));
            } else {
                callback();
            }
        };
        return {
            readOlnyEditorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                readOnly: true,
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"]]
                    }
                }
            },
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },
            banks: [],
            activeName: "first",
            filters: {
                currentUser: "",
                pendingFilter: "",
                pendingUser: "",
                paymentFilter: "",
                paymentStatus: "",
                warehousePaymentStatus: "",
                balanceFilter: "",
                historyFilter: "",
                name: '',
                user: "",
                productName: "",
                feeType: "",
                conditionSearch: ""
            },

            nurseList: [],

            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,
            fourthListLoading: false,
            fifthListLoading: false,

            pageSize: _globalVar.defaultPageSize,
            paymentPage: 1,
            paymentTotal: 0,

            pendingPage: 1,
            pendingTotal: 0,

            balancePage: 1,
            balanceTotal: 0,

            historyPage: 1,
            historyTotal: 0,

            warehouseFeeDetail: [],
            warehouseFeeSummary: [],

            storageFeePaymentPage: 1,
            storageFeePaymentTotal: 0,

            warehouseFeeDetailPage: 1,
            warehouseFeeDetailTotal: 0,
            warehouseFeeDetailModelVisible: false,

            warehouseFeeSummaryPage: 1,
            warehouseFeeSummaryTotal: 0,
            warehouseFeeSummaryModelVisible: false,

            warehouseFeeLoading: false,
            warehouseFeeSummaryLoading: false,
            warehouseFeeDetailId: null,
            warehouseFeeProductNo: null,

            feeTypeList: [{ id: 0, value: "Inbound" }, { id: 1, value: "Outbound" }, { id: 2, value: "Storage" }],

            offers: [],
            pendingPayments: [],
            payments: [],
            transactions: [],
            balances: [],
            storageFeePayments: [],
            total: 0,
            invitations: [],
            invitationTotalPage: 0,
            invitationPage: 1,
            listLoading: false,
            sels: [],
            requestVisible: false,
            addGroupVisible: false,
            invitationVisible: false,
            editLoading: false,
            payRule: {
                note: [{ required: true, message: 'Note is requried.', trigger: 'blur' }]
            },

            warehouseRequestVisible: false,
            warehouseStorageFeeId: null,
            paymentLoading: false,
            paymentListVisible: false,
            warehousePayments: [],
            warehousePaymentPage: 1,
            warehousePaymentTotal: 0,

            warehousePayment: {
                warehouseUserName: "",
                amount: "",
                bank: "",
                note: "",
                paymentNo: "",
                bankAddress: ""
            },

            adjustRule: {
                nurseId: [{ required: true, message: 'User is requried.', trigger: 'blur' }],
                amount: [{ required: true, message: 'Amount is requried.', trigger: 'blur' }, { validator: checkAmount, trigger: 'blur' }],
                note: [{ required: true, message: 'Note is requried.', trigger: 'blur' }]
            },

            addFormVisible: false,
            adjustVisible: false,
            loading: false,

            payment: {
                nurseName: "",
                amount: "",
                bank: "",
                note: "",
                paymentNo: "",
                bankAddress: ""
            },
            adjust: {
                nurseId: "",
                amount: 0.0,
                note: "",
                type: 1,
                balance: 0
            }
        };
    },

    methods: {
        dateFormat: function dateFormat(row, column) {
            if (row) {
                var dT = new Date(row);
                return dT.getFullYear() + "-" + (dT.getMonth() + 1) + "-" + dT.getDate();
            } else {
                return "";
            }
        },
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.exportExcel)(param).then(function () {});
        },
        postExportExcel: function postExportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName,
                payNo: this.warehouseFeeDetailId,
                productNo: this.warehouseFeeProductNo,
                productName: this.filters.productName,
                feeType: this.filters.feeType,
                condition: this.filters.conditionSearch
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },

        formatMoney: function formatMoney(s, n) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            if (s < 0) {
                l = (Math.abs(s.split(".")[0]) + "").split("").reverse();
            }
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            if (s < 0) {
                t += "-";
            }
            var result = t.split("").reverse().join("") + "." + r;
            if (result == null || result == undefined || result.indexOf('NaN') >= 0 || result.indexOf('Undefined') >= 0) {
                result = '0.00';
            }
            return result;
        },
        tableRowClassName: function tableRowClassName(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            if (row.amount < 0 || row.total < 0) {
                return 'reported-row';
            } else {
                return 'green-row';
            }
        },
        changePaymentRequest: function changePaymentRequest(val) {
            this.paymentPage = val;
            this.getPaymentRequest();
        },
        changePendingRequest: function changePendingRequest(val) {
            this.pendingPage = val;
            this.getPendingTransaction();
        },
        changeBalance: function changeBalance(val) {
            this.balancePage = val;
            this.getBalance();
        },
        changeTransactionHistory: function changeTransactionHistory(val) {
            this.historyPage = val;
            this.getTransactionHistory();
        },
        changeStorageFeePayment: function changeStorageFeePayment(val) {
            this.storageFeePaymentPage = val;
            this.getStorageFeePaymentList();
        },
        changeWarehouseFeeDetail: function changeWarehouseFeeDetail(val) {
            this.warehouseFeeDetailPage = val;
            this.getStorageFeePaymentDetail(this.warehouseFeeProductNo, val);
        },
        changeWarehouseFeeSummary: function changeWarehouseFeeSummary(val) {
            this.warehouseFeeSummaryPage = val;
            this.getStorageFeePaymentSummary(this.warehouseFeeDetailId);
        },
        getTransactionHistory: function getTransactionHistory() {
            var _this = this;

            var param = {
                current: this.historyPage,
                size: this.pageSize,
                nurseNo: this.filters.currentUser,
                condition: this.filters.historyFilter
            };
            this.thirdListLoading = true;
            (0, _paymentService.getTransactionHistory)(param).then(function (data) {
                _this.thirdListLoading = false;
                if (data.status === 200) {
                    _this.transactions = data.result.records;
                    _this.historyTotal = data.result.total;
                }
            });
        },
        getNurseList: function getNurseList() {
            var _this2 = this;

            (0, _memberService.getDoctorNurse)().then(function (data) {
                if (data.status === 200) {
                    _this2.nurseList = data.result;
                }
            });
        },
        editPaymentStatus: function editPaymentStatus(paymentNo, status) {
            var _this3 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    paymentNo: paymentNo,
                    status: status
                };
                (0, _paymentService.editPaymentStatus)(param).then(function (data) {
                    if (data.status === 200) {
                        _this3.$message.success(data.message);
                        _this3.getPaymentRequest();
                    }
                });
            }).catch(function () {});
        },
        editWarehousePaymentStatus: function editWarehousePaymentStatus(paymentNo, status) {
            var _this4 = this;

            var param = {
                paymentNo: paymentNo,
                status: status
            };
            this.loading = true;
            (0, _paymentService4Warehouse.editPaymentStatus4Warehouse)(param).then(function (data) {
                if (data.status === 200) {
                    _this4.$message.success(data.message);
                    _this4.getPaymentRequest4Warehouse();
                }
                _this4.loading = false;
            });
        },
        requestPayment: function requestPayment(id) {
            var _this5 = this;

            (0, _paymentService.queryPaymentById)({ paymentNo: id }).then(function (data) {
                if (data.status === 200) {
                    _this5.payment.paymentNo = data.result.paymentNo;
                    _this5.payment.nurseName = data.result.nurseName;
                    _this5.payment.amount = data.result.amount;
                    _this5.payment.bank = data.result.accountType + " " + data.result.accountNumber;
                    _this5.payment.bankAddress = data.result.bankAddress;
                    _this5.requestVisible = true;
                }
            });
        },
        pay: function pay() {
            var _this6 = this;

            this.$refs.payment.validate(function (valid) {
                if (valid) {
                    _this6.loading = true;
                    var param = {
                        paymentNo: _this6.payment.paymentNo,
                        note: _this6.payment.note
                    };
                    (0, _paymentService.pay)(param).then(function (data) {
                        _this6.loading = false;
                        if (data.status === 200) {
                            _this6.$message.success(data.message);
                            _this6.requestVisible = false;
                            _this6.$refs.payment.resetFields();
                            _this6.getPaymentRequest();
                            _this6.getTransactionHistory();
                            _this6.getBalance();
                        } else {
                            _this6.$message.error(data.message);
                        }
                    });
                }
            });
        },
        requestWarehousePayment: function requestWarehousePayment(id) {
            var _this7 = this;

            (0, _paymentService4Warehouse.queryPaymentById4Warehouse)({ paymentNo: id }).then(function (data) {
                if (data.status === 200) {
                    _this7.warehousePayment.paymentNo = data.result.paymentNo;
                    _this7.warehousePayment.totalFee = data.result.totalFee;
                    _this7.warehousePayment.warehouseNote = data.result.warehouseNote;
                    _this7.warehousePayment.warehouseUserName = data.result.warehouseUserName;
                    _this7.warehousePayment.amount = data.result.amount;
                    _this7.warehousePayment.bank = data.result.accountType + " " + data.result.accountNumber;
                    _this7.warehousePayment.bankAddress = data.result.bankAddress;
                    _this7.warehouseRequestVisible = true;
                }
            });
        },
        toWarehousePay: function toWarehousePay() {
            var _this8 = this;

            this.$refs.warehousePayment.validate(function (valid) {
                if (valid) {
                    _this8.loading = true;
                    var param = {
                        paymentNo: _this8.warehousePayment.paymentNo,
                        note: _this8.warehousePayment.note
                    };
                    (0, _paymentService4Warehouse.pay4Warehouse)(param).then(function (data) {
                        _this8.loading = false;
                        if (data.status === 200) {
                            _this8.$message.success(data.message);
                            _this8.warehouseRequestVisible = false;
                            _this8.$refs.warehousePayment.resetFields();
                            _this8.paymentListVisible = false;
                            _this8.getStorageFeePaymentList();
                        } else {
                            _this8.$message.error(data.message);
                        }
                    });
                }
            });
        },
        requestStorageFeePayment: function requestStorageFeePayment(id) {
            var _this9 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                _this9.loading = true;
                var param = {
                    id: id
                };
                (0, _storageFeePaymentService.storageFeePay)(param).then(function (data) {
                    _this9.loading = false;
                    if (data.status === 200 && data.result.flag) {
                        _this9.$message.success(data.message);
                        _this9.getStorageFeePaymentList();
                    } else {
                        _this9.$message.error(data.message);
                    }
                });
            });
        },
        getBalance: function getBalance() {
            var _this10 = this;

            var param = {
                current: this.balancePage,
                size: this.pageSize,
                userNo: this.filters.balanceFilter
            };
            this.fourthListLoading = true;
            (0, _paymentService.getBalance)(param).then(function (data) {
                _this10.fourthListLoading = false;
                if (data.status === 200) {
                    _this10.balances = data.result.records;
                    _this10.balanceTotal = data.result.total;
                }
            });
        },
        changeOfferSelect: function changeOfferSelect() {},
        handleClick: function handleClick() {},
        getPendingTransaction: function getPendingTransaction() {
            var _this11 = this;

            var param = {
                current: this.pendingPage,
                size: this.pageSize,
                condition: this.filters.pendingFilter,
                userNo: this.filters.pendingUser
            };
            this.secondListLoading = true;
            (0, _paymentService.getPendingTransaction)(param).then(function (data) {
                _this11.secondListLoading = false;
                if (data.status === 200) {
                    _this11.pendingPayments = data.result.records;
                    _this11.pendingTotal = data.result.total;
                }
            });
        },
        getPaymentRequest: function getPaymentRequest() {
            var _this12 = this;

            var param = {
                current: this.paymentPage,
                size: this.pageSize,
                condition: this.filters.paymentFilter,
                status: this.filters.paymentStatus
            };
            this.firstListLoading = true;
            (0, _paymentService.getPaymentRequest)(param).then(function (data) {
                _this12.firstListLoading = false;
                if (data.status === 200) {
                    _this12.payments = data.result.records;
                    _this12.paymentTotal = data.result.total;
                }
            });
        },
        getPaymentRequest4Warehouse: function getPaymentRequest4Warehouse() {
            var _this13 = this;

            var user = JSON.parse(sessionStorage.getItem("user"));
            var param = {
                current: this.warehousePaymentPage,
                size: this.pageSize,
                status: this.filters.warehousePaymentStatus,
                doctorNo: user.userNo,
                storageFeeId: this.warehouseStorageFeeId
            };
            this.firstListLoading = true;
            (0, _paymentService4Warehouse.getPaymentRequest4Warehouse)(param).then(function (data) {
                _this13.firstListLoading = false;
                if (data.status === 200) {
                    _this13.warehousePayments = data.result.records;
                    _this13.paymentTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentList: function getStorageFeePaymentList() {
            var _this14 = this;

            var param = {
                current: this.storageFeePaymentPage,
                size: this.pageSize
            };
            this.fifthListLoading = true;
            (0, _storageFeePaymentService.getDoctorList)(param).then(function (data) {
                _this14.fifthListLoading = false;
                if (data.status === 200) {
                    _this14.storageFeePayments = data.result.records;
                    _this14.storageFeePaymentTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentDetail: function getStorageFeePaymentDetail(productNo, page) {
            var _this15 = this;

            this.warehouseFeeDetailPage = page;
            if (productNo) {
                this.warehouseFeeProductNo = productNo;
            }
            var param = {
                current: page,
                size: this.pageSize,
                payNo: this.warehouseFeeDetailId,
                productNo: this.warehouseFeeProductNo,
                productName: this.filters.productName,
                feeType: this.filters.feeType
            };
            this.warehouseFeeDetailModelVisible = true;
            this.warehouseFeeLoading = true;
            (0, _storageFeePaymentService.warehouseFeeDetail)(param).then(function (data) {
                _this15.warehouseFeeLoading = false;
                if (data.status === 200) {
                    _this15.warehouseFeeDetail = data.result.records;
                    _this15.warehouseFeeDetailTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentSummary: function getStorageFeePaymentSummary(id) {
            var _this16 = this;

            this.warehouseFeeDetailId = id;
            var param = {
                current: this.warehouseFeeSummaryPage,
                size: this.pageSize,
                payNo: id,
                condition: this.filters.conditionSearch
            };
            this.warehouseFeeSummaryModelVisible = true;
            this.warehouseFeeSummaryLoading = true;
            (0, _storageFeePaymentService.warehouseFeeSummary)(param).then(function (data) {
                _this16.warehouseFeeSummaryLoading = false;
                if (data.status === 200) {
                    _this16.warehouseFeeSummary = data.result.records;
                    _this16.warehouseFeeSummaryTotal = data.result.total;
                }
            });
        },
        showAdjust: function showAdjust() {
            this.adjust.amount = 0.0;
            this.adjust.type = 1;
            this.adjust.nurseId = "";
            this.adjust.note = "";
            this.adjustVisible = true;
        },
        getNusreBalance: function getNusreBalance() {
            var _this17 = this;

            if (this.adjust.nurseId) {
                var user = JSON.parse(sessionStorage.getItem("user"));
                var param = {
                    doctorNo: user.userNo,
                    nurseNo: this.adjust.nurseId
                };
                (0, _memberService.getUserBalance)(param).then(function (res) {
                    if (res.status === 200) {
                        _this17.adjust.balance = res.result.balance;
                    }
                });
            } else {
                this.adjust.balance = 0.0;
            }
        },
        addAdjust: function addAdjust() {
            var _this18 = this;

            this.$refs.adjust.validate(function (valid) {
                if (valid) {
                    _this18.loading = true;
                    var amount = _this18.adjust.amount;
                    if (_this18.adjust.type == "1") {
                        amount = amount * -1;
                    }
                    console.log(_this18.adjust.amount);
                    var param = {
                        nurseId: _this18.adjust.nurseId,
                        amount: amount,
                        note: _this18.adjust.note
                    };

                    (0, _paymentService.addAdjust)(param).then(function (data) {
                        _this18.loading = false;
                        if (data.status === 200) {
                            _this18.adjustVisible = false;
                            _this18.$message.success("Success");
                            _this18.getTransactionHistory();
                            _this18.getBalance();
                        } else {
                            _this18.$message.error(data.message);
                        }
                    });
                }
            });
        },
        exportTransactionHistory: function exportTransactionHistory() {
            var param = {
                url: '/excel/exportTransactionHistory',
                fileName: 'Transaction History.xls',
                nurseNo: this.filters.currentUser,
                condition: this.filters.historyFilter
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },
        showAddWarehousePayment: function showAddWarehousePayment(id) {
            var _this19 = this;

            this.warehouseStorageFeeId = id;
            var user = JSON.parse(sessionStorage.getItem("user"));
            var param = {
                current: this.warehousePaymentPage,
                size: this.pageSize,
                status: this.filters.warehousePaymentStatus,
                doctorNo: user.userNo,
                storageFeeId: id
            };
            (0, _paymentService4Warehouse.getPaymentRequest4Warehouse)(param).then(function (data) {
                _this19.paymentLoading = false;
                _this19.isPaymentPending = false;
                if (data.status === 200) {
                    _this19.paymentListVisible = true;
                    _this19.warehousePayments = data.result.records;
                    _this19.paymentTotal = data.result.total;
                    for (var i = 0; i < _this19.warehousePayments.length; i++) {
                        var p = _this19.warehousePayments[i];
                        if (p.status == 0 || p.status == 1) {
                            _this19.isPaymentPending = true;
                            break;
                        }
                    }
                }
            });
        }
    },
    mounted: function mounted() {
        this.getNurseList();
        this.getPendingTransaction();
        this.getPaymentRequest();
        this.getBalance();
        this.getTransactionHistory();
        this.getStorageFeePaymentList();
        var active = this.$route.params.active;
        if (active) {
            this.activeName = active;
        }
    }
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueQuillEditor = __webpack_require__(76);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _warehouseService = __webpack_require__(50);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: 'MTD',
                    onClick: function onClick(picker) {
                        picker.$emit('pick', [new Date(), new Date()]);
                    }
                }, {
                    text: 'YTD',
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date(new Date().getFullYear(), 0);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            banks: [],
            activeName: "first",
            filters: {
                warehouse: "",
                date: "",
                product: ""
            },

            firstListLoading: false,

            pageSize: _globalVar.defaultPageSize,
            page: 1,
            total: 0,
            listLoading: false,

            list: [],
            warehouseList: []

        };
    },

    methods: {
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },

        formatMoney: function formatMoney(s, n) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            if (s < 0) {
                l = (Math.abs(s.split(".")[0]) + "").split("").reverse();
            }
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            if (s < 0) {
                t += "-";
            }
            var result = t.split("").reverse().join("") + "." + r;
            if (result == null || result == undefined || result.indexOf('NaN') >= 0 || result.indexOf('Undefined') >= 0) {
                result = '0.00';
            }
            return result;
        },
        getWarehouseList: function getWarehouseList() {
            var _this = this;

            (0, _warehouseService.getCurrentWarehouse)({}).then(function (data) {
                if (data.status === 200) {
                    _this.warehouseList = data.result;
                }
            });
        },
        changePage: function changePage(val) {
            this.page = val;
            this.getList();
        },
        getList: function getList() {
            var _this2 = this;

            var param = {
                current: this.page,
                size: this.pageSize,
                warehouse: this.filters.warehouse,
                product_name: this.filters.product
            };
            if (this.filters.date) {
                param.startDate = this.filters.date[0];
                param.endDate = this.filters.date[1];
            }
            this.listLoading = true;
            (0, _warehouseService.getStorageFeeList)(param).then(function (data) {
                _this2.listLoading = false;
                if (data.status === 200) {
                    _this2.list = data.result.records;
                    _this2.total = data.result.total;
                }
            });
        }
    },
    mounted: function mounted() {
        this.getList();
        this.getWarehouseList();
    }
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(17);

var _globalVar = __webpack_require__(7);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            loading: false,
            firstLoading: false,
            secondLoading: false,
            thirdLoading: false,
            pageSize: _globalVar.defaultPageSize,

            nurseList: [],

            activeName: "first",

            filters: {
                invitationEmail: "",
                groupCondition: "",
                username: '',
                status: ""
            },

            memberList: [],

            editGroupVisible: false,
            editGroupObj: {
                groupNo: '',
                groupName: "",
                users: [],
                pendingTransaction: 7,
                pendingAmount: ""
            },

            groups: [],
            groupTotalPage: 0,
            groupPage: 1,

            invitations: [],

            total: 0,

            invitationFilter: "",
            invitationTotalPage: 0,
            invitationPage: 1,

            membersFilter: "",
            membersTotalPage: 0,
            membersPage: 1,

            sels: [],
            editMemberObj: {},
            editMemberVisible: false,
            addGroupVisible: false,
            invitationVisible: false,

            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },
            groupFormRules: {
                groupName: [{ required: true, message: 'Group Name is required.', trigger: 'blur' }]
            },

            editForm: {
                id: 0,
                name: '',
                sex: -1,
                age: 0,
                birth: '',
                addr: ''
            },

            addFormVisible: false,
            invitationRules: {
                role: [{ required: true, message: 'Role is required.', trigger: 'blur' }],
                email: [{ required: true, message: 'Email is required.', trigger: 'blur' }, { validator: _util2.default.validateEmail, trigger: 'blur' }]
            },

            member: {
                id: "",
                userName: "",
                email: "",
                phone: "",
                status: "",
                pendingTransaction: 7,
                pendingAmount: "",
                alias: "",
                minPayment: 0
            },
            group: {
                id: '',
                groupName: "",
                users: [],
                pendingTransaction: 7,
                pendingAmount: "",
                minPayment: 0
            },
            invitation: {
                id: "",
                email: "",
                status: "",
                dateTime: "",
                role: ""
            }

        };
    },

    methods: {
        handleClick: function handleClick(tab, event) {
            if (tab.paneName === "first" && this.memberList.length === 0) {
                this.getDoctorMembers();
            } else if (tab.paneName === "second" && this.groups.length === 0) {} else if (tab.paneName === "third" && this.invitations.length === 0) {
                this.getInvitations();
            }
        },
        formatRole: function formatRole(row, column) {
            if (row.status === 0) {
                return "Pending";
            } else if (row.status === 1) {
                return "Approve";
            } else {
                return "Reject";
            }
        },
        formatMemberStatus: function formatMemberStatus(row, column) {
            if (row.status === "1") {
                return "Active";
            } else if (row.status === "2") {
                return "Limited";
            } else if (row.status === "3") {
                return "Blocked";
            }
        },
        formatTimesTamp: function formatTimesTamp(row, column) {
            return _util2.default.formatDate.format(new Date(row.createDate), 'yyyy-MM-dd hh:mm:ss');
        },
        showEditGroup: function showEditGroup(groupNo) {
            var _this = this;

            (0, _memberService.getDoctorMemberList)({ roleId: 2 }).then(function (res) {
                _this.nurseList = res.result;
                return (0, _memberService.getGroupById)({ groupNo: groupNo });
            }).then(function (res) {
                if (res.status === 200) {
                    var users = [];
                    res.result.userList.forEach(function (item) {
                        users.push(item.userNo);
                    });
                    _this.editGroupObj.users = users;
                    _this.editGroupObj.groupName = res.result.groupName;
                    _this.editGroupObj.pendingTransaction = res.result.transactions;
                    _this.editGroupObj.pendingAmount = res.result.amount;
                    _this.editGroupObj.groupNo = res.result.groupNo;
                    _this.editGroupObj.minPayment = res.result.minPayment;
                    _this.editGroupVisible = true;
                } else {
                    _this.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        showAddGroup: function showAddGroup() {
            var _this2 = this;

            (0, _memberService.getDoctorMemberList)({ roleId: 2 }).then(function (res) {
                if (res.status === 200) {
                    _this2.nurseList = res.result;
                    _this2.addGroupVisible = true;
                }
            });
        },
        getDoctorMembers: function getDoctorMembers() {
            var _this3 = this;

            this.firstLoading = true;
            var para = {
                current: this.membersPage,
                size: this.pageSize,
                userName: this.filters.username,
                status: this.filters.status
            };
            (0, _memberService.getDoctorMembers)(para).then(function (res) {
                _this3.firstLoading = false;
                if (res.status === 200) {
                    _this3.memberList = res.result.records;
                    _this3.membersTotalPage = res.result.total;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        showEditMember: function showEditMember(member) {
            var _this4 = this;

            (0, _memberService.getMembersById)({ membetId: member.membetId }).then(function (res) {
                if (res.status === 200) {
                    _this4.editMemberObj = {
                        id: "",
                        userName: member.username,
                        email: member.email,
                        status: res.result.member.status,
                        pendingTransaction: res.result.member.transactions,
                        pendingAmount: res.result.member.amount,
                        alias: res.result.member.alias,
                        memberId: res.result.member.memberId,
                        membetId: res.result.member.membetId,
                        doctorId: res.result.member.doctorId,
                        minPayment: res.result.member.minPayment
                    };
                    _this4.editMemberVisible = true;
                }
            }).catch(function (err) {});
        },
        editMember: function editMember() {
            var _this5 = this;

            var params = {
                membetId: this.editMemberObj.membetId,
                doctorId: this.editMemberObj.doctorId,
                memberId: this.editMemberObj.memberId,
                status: this.editMemberObj.status,
                transactions: this.editMemberObj.pendingTransaction,
                amount: this.editMemberObj.pendingAmount,
                alias: this.editMemberObj.alias,
                minPayment: this.editMemberObj.minPayment
            };
            this.loading = true;
            (0, _memberService.editMember)(params).then(function (res) {
                _this5.loading = false;
                if (res.status === 200) {
                    _this5.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this5.editMemberVisible = false;
                    _this5.getDoctorMembers();
                } else {
                    _this5.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        handleInvitationPageChange: function handleInvitationPageChange(val) {
            this.invitationPage = val;
            this.getInvitations();
        },
        handleMembersPageChange: function handleMembersPageChange(val) {
            this.membersPage = val;
            this.getDoctorMembers();
        },
        handleGroupPageChange: function handleGroupPageChange(val) {
            this.groupPage = val;
            this.getGroupList();
        },
        getInvitations: function getInvitations() {
            var _this6 = this;

            var para = {
                current: this.invitationPage,
                size: this.pageSize,
                condition: this.filters.invitationEmail
            };

            this.thirdLoading = true;
            (0, _memberService.getInvitations)(para).then(function (res) {
                _this6.thirdLoading = false;
                if (res.status === 200) {
                    _this6.invitations = res.result.records;
                    _this6.invitationTotalPage = res.result.total;
                } else {
                    _this6.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        invitationRegister: function invitationRegister(param) {
            var _this7 = this;

            this.$refs.invitation.validate(function (valid) {
                if (valid) {
                    _this7.loading = true;
                    (0, _memberService.invitationRegister)({ roleId: _this7.invitation.role, email: _this7.invitation.email }).then(function (res) {
                        _this7.loading = false;
                        if (res.status === 200) {
                            _this7.$message({
                                message: 'Success',
                                type: 'success'
                            });
                            _this7.invitationVisible = false;
                            _this7.getInvitations();
                            _this7.$refs.invitation.resetFields();
                        } else {
                            _this7.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        console.log(error);
                        _this7.loading = false;
                    });
                }
            });
        },
        editGroup: function editGroup() {
            var _this8 = this;

            this.$refs.editGroupObj.validate(function (valid) {
                if (valid) {
                    _this8.loading = true;
                    var params = {
                        groupName: _this8.editGroupObj.groupName,
                        userIds: _this8.editGroupObj.users.join(","),
                        transactions: _this8.editGroupObj.pendingTransaction,
                        amount: _this8.editGroupObj.pendingAmount,
                        groupNo: _this8.editGroupObj.groupNo,
                        minPayment: _this8.editGroupObj.minPayment
                    };
                    (0, _memberService.addGroup)(params).then(function (res) {
                        _this8.loading = false;
                        if (res.status === 200) {
                            _this8.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this8.editGroupVisible = false;
                            _this8.getGroupList();
                        } else {
                            _this8.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        addGroup: function addGroup() {
            var _this9 = this;

            this.$refs.group.validate(function (valid) {
                if (valid) {
                    _this9.loading = true;
                    console.log(_this9.group);
                    var params = {
                        groupName: _this9.group.groupName,
                        userIds: _this9.group.users.join(","),
                        transactions: _this9.group.pendingTransaction,
                        amount: _this9.group.pendingAmount,
                        minPayment: _this9.group.minPayment
                    };
                    (0, _memberService.addGroup)(params).then(function (res) {
                        _this9.loading = false;
                        if (res.status === 200) {
                            _this9.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this9.$refs.group.resetFields();
                            _this9.addGroupVisible = false;
                            _this9.getGroupList();
                        } else {
                            _this9.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        getGroupList: function getGroupList() {
            var _this10 = this;

            var params = {
                current: this.groupPage,
                size: this.pageSize,
                condition: this.filters.groupCondition
            };
            this.secondLoading = true;
            (0, _memberService.getGroupList)(params).then(function (res) {
                _this10.secondLoading = false;
                if (res.status === 200) {
                    _this10.groups = res.result.records;
                    _this10.groupTotalPage = res.result.total;
                }
            }).catch(function (err) {
                console.log(err);
                _this10.secondLoading = false;
            });
        },
        deleteGroup: function deleteGroup(id) {
            var _this11 = this;

            this.$confirm("Are you sure?", "warning", {
                type: "warning"
            }).then(function () {
                (0, _memberService.deleteGroup)({ groupNo: id }).then(function (res) {
                    if (res.status === 200) {
                        _this11.$message({
                            message: res.message,
                            type: "success"
                        });
                        _this11.getGroupList();
                    } else {
                        _this11.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                });
            }).catch(function (err) {
                return console.log(err);
            });
        }
    },
    mounted: function mounted() {
        this.getDoctorMembers();
        this.getGroupList();
    }
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _warehouseService = __webpack_require__(50);

var _globalVar = __webpack_require__(7);

var _memberService = __webpack_require__(17);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            filters: {
                name: ''
            },
            adminList: [],
            editWarehouseObj: {},
            warehouses: [],

            listLoading: false,
            editFormVisible: false,
            editLoading: false,
            formRules: {
                state: [{ required: true, message: 'State is required', trigger: 'blur' }],
                city: [{ required: true, message: 'City is required', trigger: 'blur' }],
                address: [{ required: true, message: 'Address is required', trigger: 'blur' }],
                zipCode: [{ required: true, message: 'Zip Code is required', trigger: 'blur' }],
                adminNo: [{ required: true, message: 'Admin is required', trigger: 'blur' }],
                transferAddrKeyWold: [{ min: 3, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur' }],
                physicalAddrKey: [{ required: true, min: 3, max: 50, message: '物理地址关键词长度在 3 到 50 个字符', trigger: 'blur' }]
            },
            addFormVisible: false,
            addLoading: false,

            warehouseForm: {
                state: '',
                city: '',
                address: '',
                zipCode: '',
                adminNo: '',
                isVisiable: "0",
                transferAddrKeyWold: '',
                physicalAddrKey: ''
            },

            page: 1,
            pageSize: _globalVar.defaultPageSize,
            total: 0

        };
    },

    methods: {
        formatAddress: function formatAddress(row, column) {
            return row.address + " " + row.city + " " + row.state;
        },
        pageChange: function pageChange(val) {
            this.page = val;
            this.getWarehouses();
        },
        getAdminList: function getAdminList() {
            var _this = this;

            (0, _memberService.getDoctorMemberList)({ roleId: 3 }).then(function (res) {
                if (res.status === 200) {
                    _this.adminList = res.result;
                }
            });
        },
        deleteWarehouses: function deleteWarehouses(id) {
            var _this2 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    warehouseNo: id
                };
                (0, _warehouseService.deleteWarehouses)(param).then(function (res) {
                    if (res.status === 200) {
                        _this2.$message({
                            message: res.message,
                            type: 'success'
                        });
                        _this2.getWarehouses();
                    } else {
                        _this2.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }).catch(function () {});
        },
        getWarehousesById: function getWarehousesById(id) {
            var _this3 = this;

            var param = {
                warehouseNo: id
            };
            (0, _warehouseService.getWarehousesById)(param).then(function (res) {
                if (res.status === 200) {
                    _this3.editWarehouseObj = res.result.warehouse;
                    _this3.editWarehouseObj.isVisiable = _this3.editWarehouseObj.isVisiable.toString();
                    _this3.editFormVisible = true;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getWarehouses: function getWarehouses() {
            var _this4 = this;

            this.listLoading = true;
            var param = {
                current: this.page,
                size: this.pageSize,
                condition: this.filters.name
            };
            (0, _warehouseService.getWarehouses)(param).then(function (res) {
                _this4.listLoading = false;
                if (res.status === 200) {
                    _this4.warehouses = res.result.records;
                    _this4.total = res.result.total;
                } else {
                    _this4.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                _this4.listLoading = false;
                console.log(error);
            });
        },
        addWarehouse: function addWarehouse() {
            var _this5 = this;

            this.$refs.warehouseForm.validate(function (valid) {
                if (valid) {
                    _this5.addLoading = true;
                    (0, _warehouseService.addWarehouses)(_this5.warehouseForm).then(function (res) {
                        _this5.addLoading = false;
                        if (res.status === 200) {
                            _this5.$refs["warehouseForm"].resetFields();
                            _this5.$message({
                                message: res.message,
                                type: 'success'
                            });
                            _this5.addFormVisible = false;
                            _this5.getWarehouses();
                        } else {
                            _this5.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this5.addLoading = false;
                    });
                }
            });
        },
        editWarehouse: function editWarehouse() {
            var _this6 = this;

            this.$refs.editWarehouseObj.validate(function (valid) {
                if (valid) {
                    _this6.addLoading = true;
                    (0, _warehouseService.addWarehouses)(_this6.editWarehouseObj).then(function (res) {
                        _this6.addLoading = false;
                        if (res.status === 200) {
                            _this6.$message({
                                message: res.message,
                                type: 'success'
                            });
                            _this6.editFormVisible = false;
                            _this6.getWarehouses();
                        } else {
                            _this6.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this6.addLoading = false;
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getWarehouses();
        this.getAdminList();
    }
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _securityService = __webpack_require__(49);

var inviteId = "";
var validate = false;
exports.default = {
    data: function data() {
        return {
            validate: validate,
            loading: false,
            ruleForm2: {
                username: '',
                email: ''
            },
            rules2: {
                username: [{ required: true, message: 'Please enter username', trigger: 'blur' }],
                email: [{ required: true, message: 'Please enter email', trigger: 'blur' }]
            },
            checked: true
        };
    },

    methods: {
        validatePassword: function validatePassword(rule, value, callback) {
            if (this.ruleForm2.password !== this.ruleForm2.rePassword) {
                callback(new Error('Password not match.'));
            } else {
                callback();
            }
        },
        submitRegister: function submitRegister() {},
        handleSubmit: function handleSubmit(ev) {
            var _this2 = this;

            var _this = this;
            this.$refs.ruleForm2.validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    var params = {
                        userName: _this2.ruleForm2.username,
                        email: _this2.ruleForm2.email
                    };
                    (0, _securityService.requestForgetPassword)(params).then(function (data) {
                        _this2.loading = false;
                        if (data.status === 200) {
                            _this2.$message.success("Email Send Success.");
                        } else {
                            _this2.$message.error(data.message);
                        }
                    }).catch(function (error) {
                        _this2.loading = false;
                        console.log(error);
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(144);

var _keys2 = _interopRequireDefault(_keys);

var _isInteger = __webpack_require__(424);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _set = __webpack_require__(145);

var _set2 = _interopRequireDefault(_set);

var _promise = __webpack_require__(51);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(146);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = __webpack_require__(220);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(113);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(111);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(112);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(61);

var _stringify2 = _interopRequireDefault(_stringify);

var _mixedPackage = __webpack_require__(142);

var _warehouseService = __webpack_require__(50);

var _memberService = __webpack_require__(17);

var _inboundService = __webpack_require__(77);

var _InboundStatusCard = __webpack_require__(777);

var _InboundStatusCard2 = _interopRequireDefault(_InboundStatusCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		InboundStatusCard: _InboundStatusCard2.default
	},
	data: function data() {
		return {
			activeName: 'claim',

			claimForm: {
				inboundNo: null,
				tracking: '',
				upc: '',
				quantity: 1,
				warehouseNo: null
			},
			claimRules: {},
			claimLoading: false,
			addToListLoading: false,
			trackingInfo: null,
			warehouses: [],
			claimList: [],
			selectedClaims: [],
			currentDoctorName: '',
			isNurse: false,
			availableInbounds: [],
			availableInboundsLoading: false,
			availableInboundsSearchTimer: null,
			selectedInboundInfo: null,
			myClaimList: [],
			myClaimListLoading: false,
			myClaimFilters: {
				tracking: '',
				upc: '',
				claimStatus: null
			},
			myClaimCurrentPage: 1,
			myClaimSize: 20,
			myClaimTotal: 0,

			claimDetailDialog: false,
			claimDetail: null,

			batchImportVisible: false,
			batchImportLoading: false,
			batchImportText: '',
			batchImportForm: {},
			batchImportPlaceholder: 'Tracking,Quantity\r\n123456789012,5\r\n234567890123 10\r\n345678901234\t3',

			doctorBatchImportVisible: false,
			doctorBatchImportLoading: false,
			doctorBatchImportText: '',
			doctorBatchImportPlaceholder: 'Tracking,UPC,Quantity\r\n123456789012,012345678901,5\r\n234567890123 098765432109 10\r\n345678901234\t111111111111\t3',

			showScrollToTopButton: false,
			scrollHandler: null
		};
	},
	mounted: function mounted() {
		var _this = this;

		var userInfo = JSON.parse(window.sessionStorage.getItem('user') || '{}');
		this.isNurse = userInfo.roleId === '2';

		if (this.isNurse) {
			this.claimRules = {
				inboundNo: [{ required: true, message: 'Please select an inbound record', trigger: 'change' }],
				tracking: [{ required: true, message: 'Please enter tracking number', trigger: 'blur' }, { min: 12, message: 'Tracking number must be at least 12 digits', trigger: 'blur' }, { max: 34, message: 'Tracking number cannot exceed 34 digits', trigger: 'blur' }],
				upc: [{ required: true, message: 'Please enter UPC', trigger: 'blur' }],
				quantity: [{ required: true, message: 'Please enter quantity', trigger: 'blur' }],
				warehouseNo: [{ required: true, message: 'Please select warehouse', trigger: 'change' }]
			};
		} else {
			this.claimRules = {
				tracking: [{ required: true, message: 'Please enter tracking number', trigger: 'blur' }, { min: 12, message: 'Tracking number must be at least 12 digits', trigger: 'blur' }, { max: 34, message: 'Tracking number cannot exceed 34 digits', trigger: 'blur' }],
				upc: [{ required: true, message: 'Please enter UPC', trigger: 'blur' }],
				quantity: [{ required: true, message: 'Please enter quantity', trigger: 'blur' }],
				warehouseNo: [{ required: true, message: 'Please select warehouse', trigger: 'change' }]
			};
		}

		this.loadClaimListFromStorage();

		this.getMyClaimList();
		this.getWarehouseList();

		if (this.isNurse) {
			this.loadAvailableInbounds();
		}

		var trackingFromQuery = this.$route.query.tracking;
		if (trackingFromQuery) {
			this.claimForm.tracking = trackingFromQuery;

			this.searchTrackingInfo();

			this.$message.success('Pre-filled tracking number: ' + trackingFromQuery + '. Please enter UPC, quantity and warehouse to claim.');
		}

		var contentContainer = document.querySelector('.content-container');
		var lastScrollTime = 0;
		this.scrollHandler = function () {
			var now = Date.now();
			if (now - lastScrollTime > 100) {
				_this.handleScroll();
				lastScrollTime = now;
			}
		};

		if (contentContainer) {
			contentContainer.addEventListener('scroll', this.scrollHandler, false);
		} else {
			window.addEventListener('scroll', this.scrollHandler, false);
		}

		this.handleScroll();
	},
	beforeDestroy: function beforeDestroy() {
		if (this.scrollHandler) {
			var contentContainer = document.querySelector('.content-container');
			if (contentContainer) {
				contentContainer.removeEventListener('scroll', this.scrollHandler, false);
			} else {
				window.removeEventListener('scroll', this.scrollHandler, false);
			}
		}
	},


	methods: {
		getStorageKey: function getStorageKey() {
			var userInfo = JSON.parse(window.sessionStorage.getItem('user') || '{}');
			return 'mixedPackageClaims_' + (userInfo.userNo || 'unknown');
		},
		loadClaimListFromStorage: function loadClaimListFromStorage() {
			try {
				var storageKey = this.getStorageKey();
				var savedClaims = localStorage.getItem(storageKey);
				if (savedClaims) {
					var claims = JSON.parse(savedClaims);

					if (Array.isArray(claims) && claims.length <= 1000) {
						this.claimList = claims;
						if (claims.length > 0) {
							this.$message.info('Restored ' + claims.length + ' items from previous session');
						}
					}
				}
			} catch (error) {
				this.claimList = [];
			}
		},
		saveClaimListToStorage: function saveClaimListToStorage() {
			try {
				var storageKey = this.getStorageKey();
				localStorage.setItem(storageKey, (0, _stringify2.default)(this.claimList));
			} catch (error) {}
		},
		clearClaimListFromStorage: function clearClaimListFromStorage() {
			try {
				var storageKey = this.getStorageKey();
				localStorage.removeItem(storageKey);
			} catch (error) {}
		},
		searchTrackingInfo: function searchTrackingInfo() {
			var _this2 = this;

			if (!this.claimForm.tracking) {
				this.trackingInfo = null;
				return;
			}

			var params = {
				tracking: this.claimForm.tracking,
				currentCompany: window.sessionStorage.getItem("currentCompany") };

			_mixedPackage.mixedPackageApi.searchClaimableItems(params).then(function (res) {
				if (res.code === 200 || res.code === '200' || res.code === '200') {
					var data = res.result || res.data;
					if (data && data.length > 0) {
						_this2.trackingInfo = {
							tracking: _this2.claimForm.tracking,
							warehouse: data[0].warehouse,
							packageStatus: data[0].packageStatus,
							totalItems: data[0].totalItems,
							note: data[0].note
						};
					} else {
						_this2.trackingInfo = null;
					}
				}
			}).catch(function () {
				_this2.trackingInfo = null;
			});
		},
		resetClaimForm: function resetClaimForm() {
			this.claimForm = {
				inboundNo: null,
				tracking: '',
				upc: '',
				quantity: 1,
				warehouseNo: null
			};
			this.trackingInfo = null;
			this.$refs.claimForm.resetFields();
		},
		getMyClaimList: function getMyClaimList() {
			var _this3 = this;

			this.myClaimListLoading = true;
			var params = (0, _extends3.default)({
				current: this.myClaimCurrentPage,
				size: this.myClaimSize
			}, this.myClaimFilters);

			_mixedPackage.mixedPackageApi.getMyClaimList(params).then(function (res) {
				if (res.code === 200 || res.code === '200') {
					_this3.myClaimList = res.result.records || res.data && res.data.records || [];
					_this3.myClaimTotal = res.result.total || res.data && res.data.total || 0;
				}
				_this3.myClaimListLoading = false;
			}).catch(function () {
				_this3.myClaimListLoading = false;
			});
		},
		handleMyClaimSizeChange: function handleMyClaimSizeChange(val) {
			this.myClaimSize = val;
			this.getMyClaimList();
		},
		handleMyClaimCurrentChange: function handleMyClaimCurrentChange(val) {
			this.myClaimCurrentPage = val;
			this.getMyClaimList();
		},
		cancelClaim: function cancelClaim(row) {
			var _this4 = this;

			this.$confirm('Are you sure to cancel this claim?', 'Confirm', {
				type: 'warning'
			}).then(function () {
				_mixedPackage.mixedPackageApi.cancelClaim(row.claimId).then(function (res) {
					if (res.code === 200 || res.code === '200') {
						_this4.$message.success('Claim cancelled successfully');
						_this4.getMyClaimList();
					} else {
						_this4.$message.error(res.message || 'Cancel failed');
					}
				});
			});
		},
		viewClaimDetail: function viewClaimDetail(row) {
			this.claimDetail = row;
			this.claimDetailDialog = true;
		},
		loadAvailableInbounds: function loadAvailableInbounds() {
			var _this5 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var response, data;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return (0, _inboundService.getAvailableInboundsForClaim)({
									doctorNo: window.sessionStorage.getItem("currentCompany")
								});

							case 3:
								response = _context.sent;


								if (response.code === 200 || response.code === '200') {
									data = response.result || response.data || [];

									_this5.availableInbounds = data.filter(function (inbound) {
										return inbound.status === 0 && inbound.leftNum > 0;
									});

									if (_this5.availableInbounds.length === 0) {
										_this5.$message.info('No incomplete inbound records available for claiming');
									}
								}
								_context.next = 10;
								break;

							case 7:
								_context.prev = 7;
								_context.t0 = _context['catch'](0);

								_this5.$message.error('Failed to load available inbounds: ' + (_context.t0.message || 'Unknown error'));

							case 10:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this5, [[0, 7]]);
			}))();
		},
		searchAvailableInbounds: function searchAvailableInbounds() {
			var _this6 = this;

			var upc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (_this6.availableInboundsSearchTimer) {
									clearTimeout(_this6.availableInboundsSearchTimer);
								}

								if (!(upc === '' || upc === null || upc === undefined)) {
									_context3.next = 4;
									break;
								}

								_this6.availableInbounds = [];
								return _context3.abrupt('return');

							case 4:
								if (!(upc.length < 4)) {
									_context3.next = 6;
									break;
								}

								return _context3.abrupt('return');

							case 6:
								_this6.availableInboundsSearchTimer = setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
									var response, data;
									return _regenerator2.default.wrap(function _callee2$(_context2) {
										while (1) {
											switch (_context2.prev = _context2.next) {
												case 0:
													_this6.availableInboundsLoading = true;
													_context2.prev = 1;
													_context2.next = 4;
													return (0, _inboundService.getAvailableInboundsForClaim)({
														doctorNo: window.sessionStorage.getItem("currentCompany"),
														upc: upc.trim()
													});

												case 4:
													response = _context2.sent;


													if (response.code === 200 || response.code === '200') {
														data = response.result || response.data || [];

														_this6.availableInbounds = data.filter(function (inbound) {
															return inbound.status === 0 && inbound.leftNum > 0;
														});

														if (_this6.availableInbounds.length === 0) {
															_this6.$message.info('No available inbounds found for this UPC');
														}
													} else {
														_this6.$message.warning('Failed to search inbounds');
														_this6.availableInbounds = [];
													}
													_context2.next = 14;
													break;

												case 8:
													_context2.prev = 8;
													_context2.t0 = _context2['catch'](1);

													_this6.availableInboundsLoading = false;
													console.error('Error searching available inbounds:', _context2.t0);
													_this6.$message.error('Failed to search available inbounds: ' + (_context2.t0.message || 'Unknown error'));
													_this6.availableInbounds = [];

												case 14:
													_context2.prev = 14;

													_this6.availableInboundsLoading = false;
													return _context2.finish(14);

												case 17:
												case 'end':
													return _context2.stop();
											}
										}
									}, _callee2, _this6, [[1, 8, 14, 17]]);
								})), 300);

							case 7:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this6);
			}))();
		},
		onInboundChange: function onInboundChange(inboundNo) {
			var _this7 = this;

			this.selectedInboundInfo = this.availableInbounds.find(function (i) {
				return i.inboundNo === inboundNo;
			});

			if (!inboundNo || !this.selectedInboundInfo) {
				this.selectedInboundInfo = null;
				this.claimForm.upc = '';
				this.claimForm.warehouseNo = null;
				return;
			}

			if (this.selectedInboundInfo.leftNum <= 0) {
				this.$message.warning('This inbound record has no remaining quantity to claim');
				this.claimForm.inboundNo = null;
				this.selectedInboundInfo = null;
				this.claimForm.upc = '';
				this.claimForm.warehouseNo = null;
			} else {
				(function () {
					var inboundWarehouseNo = _this7.selectedInboundInfo.warehouseNo;
					_this7.claimForm.warehouseNo = inboundWarehouseNo;

					var warehouseFound = false;
					var warehouseName = '';
					var warehouseGroup = '';
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = (0, _getIterator3.default)(_this7.warehouses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var group = _step.value;

							var warehouse = group.options.find(function (w) {
								return w.warehouseNo === inboundWarehouseNo;
							});
							if (warehouse) {
								warehouseFound = true;
								warehouseName = warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address;
								warehouseGroup = group.label;
								break;
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					if (_this7.selectedInboundInfo.upc) {
						_this7.claimForm.upc = _this7.selectedInboundInfo.upc;

						if (warehouseFound) {
							var groupInfo = warehouseGroup === 'Current Doctor Warehouses' ? '' : ' (' + warehouseGroup + ')';
							_this7.$message.success('Auto-filled - UPC: ' + _this7.selectedInboundInfo.upc + ' | Warehouse: ' + warehouseName + groupInfo);
						} else {
							_this7.$message.success('Auto-filled - UPC: ' + _this7.selectedInboundInfo.upc);
						}
					} else {
						_this7.claimForm.upc = '';
						if (warehouseFound) {
							var _groupInfo = warehouseGroup === 'Current Doctor Warehouses' ? '' : ' (' + warehouseGroup + ')';
							_this7.$message.success('Warehouse auto-selected: ' + warehouseName + _groupInfo);
						}
						_this7.$message.warning('Selected inbound record has no UPC information');
					}
				})();
			}
		},
		getMaxClaimableQty: function getMaxClaimableQty() {
			return this.selectedInboundInfo ? this.selectedInboundInfo.leftNum : 999;
		},
		validateUpcMatch: function validateUpcMatch() {
			if (this.selectedInboundInfo && this.claimForm.upc) {
				if (!this.selectedInboundInfo.upc) {
					this.$message.warning('Selected inbound record has no UPC information');
					return;
				}
				if (this.selectedInboundInfo.upc !== this.claimForm.upc) {
					this.$message.warning('UPC mismatch! Expected: ' + this.selectedInboundInfo.upc + ', Entered: ' + this.claimForm.upc);
				}
			}
		},
		getUpcPlaceholder: function getUpcPlaceholder() {
			if (this.isNurse) {
				if (this.selectedInboundInfo && this.selectedInboundInfo.upc) {
					return '\uD83D\uDD12 Auto-filled from Inbound (read-only)';
				} else if (this.selectedInboundInfo) {
					return 'Selected Inbound has no UPC';
				} else {
					return 'Select an Inbound record first';
				}
			} else {
				return 'Enter UPC';
			}
		},
		getWarehousePlaceholder: function getWarehousePlaceholder() {
			if (this.isNurse) {
				if (this.selectedInboundInfo && this.selectedInboundInfo.warehouseNo) {
					return '\uD83D\uDD12 Auto-selected from Inbound';
				} else if (this.selectedInboundInfo) {
					return 'Loading warehouse from Inbound...';
				} else {
					return 'Select an Inbound record first';
				}
			} else {
				return 'Select warehouse';
			}
		},
		formatDate: function formatDate(date) {
			if (!date) return '';
			return new Date(date).toLocaleString();
		},
		getStatusText: function getStatusText(status) {
			var statusMap = {
				0: 'Pending',
				1: 'Partial Claimed',
				2: 'All Claimed',
				3: 'Completed'
			};
			return statusMap[status] || 'Unknown';
		},
		getStatusTagType: function getStatusTagType(status) {
			var typeMap = {
				0: '',
				1: 'warning',
				2: 'success',
				3: 'info'
			};
			return typeMap[status] || '';
		},
		getClaimStatusTagType: function getClaimStatusTagType(status) {
			var typeMap = {
				0: 'warning',
				1: 'success',
				2: 'info',
				3: 'danger',
				4: 'primary'
			};
			return typeMap[status] || '';
		},
		getClaimStatusText: function getClaimStatusText(status) {
			var statusMap = {
				0: 'Pending Review',
				1: 'Approved',
				2: 'Distributed',
				3: 'Rejected',
				4: 'Quantity Adjusted'
			};
			return statusMap[status] || 'Unknown';
		},
		getWarehouseList: function getWarehouseList() {
			var _this8 = this;

			var userInfo = JSON.parse(window.sessionStorage.getItem('user') || '{}');
			var userRoleId = userInfo.roleId;
			var currentCompany = window.sessionStorage.getItem("currentCompany");

			if (userRoleId === '1') {
				_mixedPackage.mixedPackageApi.getAccessibleWarehouses({
					currentCompany: currentCompany
				}).then(function (res) {
					if (res.code === 200 || res.code === '200') {
						_this8.warehouses = [];
						var doctorWarehouses = {
							label: 'Accessible Warehouses',
							options: res.result || []
						};
						if (doctorWarehouses.options.length > 0) {
							_this8.warehouses.push(doctorWarehouses);
						}
					} else {
						_this8.$message.error('获取仓库列表失败，请联系管理员');
					}
				}).catch(function (error) {
					_this8.$message.error('获取仓库列表失败，请联系管理员');
				});
			} else if (userRoleId === '2') {
				var param = {
					doctorNo: currentCompany
				};

				(0, _warehouseService.getNurseWarehouses)(param).then(function (res) {
					if (res.status === 200) {
						_this8.warehouses = [];
						var currentDoctorWarehouses = {
							label: 'Current Doctor Warehouses',
							options: []
						};
						var accessibleWarehouses = {
							label: 'Accessible Warehouses for Claims',
							options: []
						};

						res.result.forEach(function (item) {
							if (item.isDoctor === 0) {
								if (item.userNo === currentCompany) {
									currentDoctorWarehouses.options.push(item);
								} else {
									accessibleWarehouses.options.push(item);
								}
							}
						});

						if (currentDoctorWarehouses.options.length > 0) {
							_this8.warehouses.push(currentDoctorWarehouses);
						}

						if (accessibleWarehouses.options.length > 0) {
							_this8.warehouses.push(accessibleWarehouses);
						}

						_this8.getCurrentDoctorName();
					} else {
						_this8.$message.error('获取仓库列表失败，请联系管理员');
					}
				}).catch(function (error) {
					_this8.$message.error('获取仓库列表失败，请联系管理员');
				});
			}
		},
		getCurrentDoctorName: function getCurrentDoctorName() {
			var _this9 = this;

			var currentCompany = window.sessionStorage.getItem("currentCompany");
			if (currentCompany) {
				(0, _memberService.getNurseDoctor)().then(function (res) {
					if (res.status === 200 && res.result) {
						var currentDoctor = res.result.find(function (doctor) {
							return doctor.userNo === currentCompany;
						});
						if (currentDoctor) {
							_this9.currentDoctorName = currentDoctor.userName;
						}
					}
				}).catch(function (error) {
					_this9.currentDoctorName = 'Current Doctor';
				});
			}
		},
		onInboundStatusRefreshed: function onInboundStatusRefreshed(statusData) {
			if (this.selectedInboundInfo && this.selectedInboundInfo.inboundNo === statusData.inboundNo) {
				this.loadAvailableInbounds();

				this.$message.info('Status refreshed: ' + statusData.available + ' items available for claiming');
			}
		},
		addToClaimList: function addToClaimList() {
			var _this10 = this;

			if (this.claimList.length >= 1000) {
				this.$message.error('Maximum 1000 items allowed in claim list. Please submit current items or clear the list to add more.');
				return;
			}

			this.$refs.claimForm.validate(function (valid) {
				if (valid) {
					if (_this10.isNurse) {
						if (!_this10.selectedInboundInfo) {
							_this10.$message.warning('Please select an inbound record first');
							return;
						}

						if (!_this10.selectedInboundInfo.upc) {
							_this10.$message.warning('Selected inbound record has no UPC information');
							return;
						}
						if (_this10.selectedInboundInfo.upc !== _this10.claimForm.upc) {
							_this10.$message.warning('UPC mismatch! Expected: ' + _this10.selectedInboundInfo.upc + ', Entered: ' + _this10.claimForm.upc);
							return;
						}

						if (_this10.claimForm.quantity > _this10.selectedInboundInfo.leftNum) {
							_this10.$message.warning('Quantity exceeds remaining claimable amount (' + _this10.selectedInboundInfo.leftNum + ')');
							return;
						}
					}

					var existingItem = _this10.claimList.find(function (item) {
						return item.tracking === _this10.claimForm.tracking && (_this10.isNurse ? item.inboundNo === _this10.claimForm.inboundNo : item.upc === _this10.claimForm.upc);
					});

					if (existingItem) {
						if (_this10.isNurse) {
							_this10.$message.warning('This tracking number is already claimed for this inbound record');
						} else {
							_this10.$message.warning('This tracking number is already claimed for this UPC');
						}
						return;
					}

					var selectedWarehouse = null;
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;

					try {
						for (var _iterator2 = (0, _getIterator3.default)(_this10.warehouses), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var group = _step2.value;

							selectedWarehouse = group.options.find(function (w) {
								return w.warehouseNo === _this10.claimForm.warehouseNo;
							});
							if (selectedWarehouse) break;
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}

					var warehouseName = selectedWarehouse ? selectedWarehouse.state + ' ' + selectedWarehouse.city + ' ' + selectedWarehouse.address : 'Unknown Warehouse';

					var claimItem = {
						tracking: _this10.claimForm.tracking,
						upc: _this10.claimForm.upc,
						quantity: _this10.claimForm.quantity,
						warehouseNo: _this10.claimForm.warehouseNo,
						warehouseName: warehouseName
					};

					if (_this10.isNurse && _this10.selectedInboundInfo) {
						claimItem.inboundNo = _this10.claimForm.inboundNo;
						claimItem.inboundInfo = _this10.selectedInboundInfo.productName + ' (' + _this10.selectedInboundInfo.inboundNo + ')';
						claimItem.productName = _this10.selectedInboundInfo.productName;
						claimItem.locked = true;
					} else {
						claimItem.inboundInfo = 'UPC: ' + _this10.claimForm.upc;
						claimItem.productName = 'Mixed Package - ' + _this10.claimForm.upc;
					}

					_this10.claimList.push(claimItem);

					_this10.saveClaimListToStorage();

					_this10.$message.success('Added to claim list successfully');

					_this10.claimForm.tracking = '';
					_this10.claimForm.quantity = 1;

					if (_this10.isNurse) {} else {
						_this10.claimForm.upc = '';
					}
				}
			});
		},
		removeFromClaimList: function removeFromClaimList(index) {
			var removedItem = this.claimList[index];
			this.claimList.splice(index, 1);

			this.selectedClaims = this.selectedClaims.filter(function (item) {
				return !(item.tracking === removedItem.tracking && item.upc === removedItem.upc && item.warehouseNo === removedItem.warehouseNo);
			});

			this.saveClaimListToStorage();

			this.$message.success('Item removed from claim list');
		},
		clearClaimList: function clearClaimList() {
			var _this11 = this;

			this.$confirm('Are you sure to clear all claim items?', 'Confirm', {
				type: 'warning'
			}).then(function () {
				_this11.claimList = [];
				_this11.selectedClaims = [];

				_this11.clearClaimListFromStorage();
				_this11.$message.success('Claim list cleared');
			});
		},
		handleSelectionChange: function handleSelectionChange(selection) {
			this.selectedClaims = selection;
		},
		selectAllClaims: function selectAllClaims() {
			this.$refs.claimTable.toggleAllSelection();
		},
		clearSelection: function clearSelection() {
			var _this12 = this;

			if (this.selectedClaims.length === 0) {
				return;
			}

			var itemsToRemove = [].concat((0, _toConsumableArray3.default)(this.selectedClaims));

			itemsToRemove.forEach(function (selectedItem) {
				var index = _this12.claimList.findIndex(function (item) {
					return item.tracking === selectedItem.tracking && item.upc === selectedItem.upc && item.warehouseNo === selectedItem.warehouseNo;
				});

				if (index !== -1) {
					_this12.removeFromClaimList(index);
				}
			});

			this.$message.success('Removed ' + itemsToRemove.length + ' selected items');
		},
		submitSelectedClaims: function submitSelectedClaims() {
			var _this13 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var confirmed, successCount, failCount, successfulItems, failedItems, totalItems, i, item, params, res;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								if (!(_this13.selectedClaims.length === 0)) {
									_context4.next = 3;
									break;
								}

								_this13.$message.warning('Please select items to submit');
								return _context4.abrupt('return');

							case 3:
								_context4.next = 5;
								return _this13.$confirm('Are you sure to submit ' + _this13.selectedClaims.length + ' selected claim items?', 'Confirm Submission', {
									type: 'warning'
								}).catch(function () {
									return false;
								});

							case 5:
								confirmed = _context4.sent;

								if (confirmed) {
									_context4.next = 8;
									break;
								}

								return _context4.abrupt('return');

							case 8:

								_this13.claimLoading = true;
								successCount = 0;
								failCount = 0;
								successfulItems = [];
								failedItems = [];
								totalItems = _this13.selectedClaims.length;
								i = 0;

							case 15:
								if (!(i < _this13.selectedClaims.length)) {
									_context4.next = 37;
									break;
								}

								item = _this13.selectedClaims[i];
								params = {
									tracking: item.tracking,
									upc: item.upc,
									quantity: item.quantity,
									warehouseNo: item.warehouseNo,
									targetDoctorNo: window.sessionStorage.getItem("currentCompany"),
									currentCompany: window.sessionStorage.getItem("currentCompany") };

								if (_this13.isNurse && item.inboundNo) {
									params.inboundNo = item.inboundNo;
								}

								_context4.prev = 19;

								_this13.$message.info('Processing claim ' + (i + 1) + '/' + totalItems + ': ' + item.upc, {
									duration: 1000,
									showClose: true
								});

								_context4.next = 23;
								return _mixedPackage.mixedPackageApi.submitClaim(params);

							case 23:
								res = _context4.sent;


								if (res.code === 200 || res.code === '200') {
									successCount++;
									successfulItems.push(item);
								} else {
									failCount++;
									failedItems.push((0, _extends3.default)({}, item, {
										errorMessage: res.message || res.result || 'Unknown error'
									}));
								}
								_context4.next = 31;
								break;

							case 27:
								_context4.prev = 27;
								_context4.t0 = _context4['catch'](19);

								failCount++;
								failedItems.push((0, _extends3.default)({}, item, {
									errorMessage: _context4.t0.message || 'Network error'
								}));

							case 31:
								if (!(i < _this13.selectedClaims.length - 1)) {
									_context4.next = 34;
									break;
								}

								_context4.next = 34;
								return new _promise2.default(function (resolve) {
									return setTimeout(resolve, 200);
								});

							case 34:
								i++;
								_context4.next = 15;
								break;

							case 37:

								_this13.claimLoading = false;

								_this13.claimList = _this13.claimList.filter(function (item) {
									return !successfulItems.some(function (successItem) {
										return successItem.tracking === item.tracking && successItem.upc === item.upc && successItem.warehouseNo === item.warehouseNo;
									});
								});

								_this13.saveClaimListToStorage();

								_this13.selectedClaims = [];

								if (failCount === 0 && _this13.claimList.length === 0) {
									_this13.clearClaimListFromStorage();
								}

								if (failCount === 0) {
									_this13.$message.success('All ' + successCount + ' claims submitted successfully!');
								} else if (successCount === 0) {
									_this13.$message.error('All ' + failCount + ' claims failed to submit.');

									_this13.showDetailedErrors(failedItems, 'Submission Errors');
								} else {
									_this13.$message.warning(successCount + ' claims succeeded, ' + failCount + ' claims failed. Failed items remain in the list.');

									_this13.showDetailedErrors(failedItems, 'Failed Claims', 'warning');
								}

								if (successCount > 0) {
									_this13.getMyClaimList();
								}

							case 44:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this13, [[19, 27]]);
			}))();
		},
		showBatchImportDialog: function showBatchImportDialog() {
			if (!this.isNurse || !this.claimForm.inboundNo) {
				this.$message.warning('Please select an Inbound record first');
				return;
			}

			this.batchImportText = '';
			this.batchImportVisible = true;
		},
		importBatchClaims: function importBatchClaims() {
			if (!this.isNurse || !this.claimForm.inboundNo || !this.selectedInboundInfo) {
				this.$message.error('Please select an Inbound record first');
				return;
			}

			this.batchImportLoading = true;
			var text = this.batchImportText.trim();

			if (!text) {
				this.$message.error('Please enter tracking data');
				this.batchImportLoading = false;
				return;
			}

			var remainingCapacity = 1000 - this.claimList.length;
			if (remainingCapacity < 0) {
				this.$message.error('Claim list is full. Maximum 1000 items. Please submit current items to add more.');
				this.batchImportLoading = false;
				return;
			}

			try {
				var parsedItems = this.parseTextData(text);

				if (parsedItems.length === 0) {
					this.$message.error('No valid tracking data found');
					this.batchImportLoading = false;
					return;
				}

				if (parsedItems.length > remainingCapacity) {
					this.$message.warning('Only ' + remainingCapacity + ' items can be added. Claim list can hold maximum 1000 items total. Processing first ' + remainingCapacity + ' items.');
				}

				var _validateBatchItems = this.validateBatchItems(parsedItems),
				    validItems = _validateBatchItems.validItems,
				    invalidItems = _validateBatchItems.invalidItems,
				    duplicateItems = _validateBatchItems.duplicateItems;

				if (invalidItems.length > 0) {
					var errorMsg = invalidItems.length + ' invalid items: ' + invalidItems.map(function (item) {
						return item.tracking + ":" + item.reason;
					}).join('\n');

					this.$message({
						type: 'warning',
						dangerouslyUseHTMLString: true,
						message: errorMsg.replace(/\n/g, '<br>')
					});
					return;
				}

				if (duplicateItems.length > 0) {
					var duplicateMsg = duplicateItems.length + ' duplicate/existing items: ' + duplicateItems.join(', ');
					this.$message.info(duplicateMsg);
					return;
				}

				var addedCount = 0;
				for (var i = 0; i < validItems.length; i++) {
					if (this.claimList.length >= 1000) {
						this.$message.warning('Reached maximum capacity (1000 items). Added ' + addedCount + ' items.');
						break;
					}

					var item = validItems[i];

					var claimItem = {
						tracking: item.tracking,
						upc: this.selectedInboundInfo.upc,
						quantity: item.quantity || 1,
						warehouseNo: this.selectedInboundInfo.warehouseNo,
						warehouseName: this.getWarehouseNameByNo(this.selectedInboundInfo.warehouseNo),
						inboundNo: this.claimForm.inboundNo,
						inboundInfo: this.selectedInboundInfo.productName + ' (' + this.selectedInboundInfo.inboundNo + ')',
						productName: this.selectedInboundInfo.productName,
						locked: true
					};

					this.claimList.push(claimItem);
					addedCount++;
				}

				this.saveClaimListToStorage();

				this.batchImportVisible = false;
				this.batchImportText = '';

				var message = 'Successfully added ' + addedCount + ' items to claim list';
				this.$message.success(message);
			} catch (error) {
				this.$message.error('Error parsing data: ' + error.message);
			} finally {
				this.batchImportLoading = false;
			}
		},
		parseTextData: function parseTextData(text) {
			var items = [];
			var lines = text.split('\n');

			lines.forEach(function (line, index) {
				line = line.trim();

				if (!line || line.toLowerCase().includes('tracking')) {
					return;
				}

				var parts = [];
				if (line.includes(',')) {
					parts = line.split(',').map(function (p) {
						return p.trim();
					}).filter(function (p) {
						return p;
					});
				} else {
					parts = line.split(/[\s\t]+/).filter(function (p) {
						return p;
					});
				}

				if (parts.length >= 1) {
					var tracking = parts[0];
					var quantity = parseInt(parts[1]) || 1;

					items.push({
						tracking: tracking,
						quantity: quantity,
						lineNo: index + 1
					});
				}
			});

			return items;
		},
		validateBatchItems: function validateBatchItems(items) {
			var _this14 = this;

			var validItems = [];
			var invalidItems = [];
			var duplicateItems = [];
			var trackingSet = new _set2.default();

			items.forEach(function (item) {
				var tracking = item.tracking || '';
				var quantity = item.quantity || 1;

				if (!tracking) {
					invalidItems.push((0, _extends3.default)({}, item, { reason: 'Empty tracking number' }));
					return;
				}

				if (tracking.length < 12 || tracking.length > 34) {
					invalidItems.push({
						tracking: tracking,
						reason: 'Tracking length must be 12-34 characters, got ' + tracking.length
					});
					return;
				}

				if (quantity < 1 || quantity > 10000 || !(0, _isInteger2.default)(quantity)) {
					invalidItems.push({
						tracking: tracking,
						reason: 'Invalid quantity(1 ~ 10000): ' + quantity
					});
					return;
				}

				if (trackingSet.has(tracking)) {
					duplicateItems.push(tracking);
					return;
				}

				var exists = _this14.claimList.find(function (claimItem) {
					return claimItem.tracking === tracking && claimItem.inboundNo === _this14.claimForm.inboundNo;
				});
				if (exists) {
					duplicateItems.push(tracking);
					return;
				}

				trackingSet.add(tracking);
				validItems.push(item);
			});

			return { validItems: validItems, invalidItems: invalidItems, duplicateItems: duplicateItems };
		},
		getWarehouseNameByNo: function getWarehouseNameByNo(warehouseNo) {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = (0, _getIterator3.default)(this.warehouses), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var group = _step3.value;

					var warehouse = group.options.find(function (w) {
						return w.warehouseNo === warehouseNo;
					});
					if (warehouse) {
						return warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address;
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return 'Unknown Warehouse';
		},
		showDoctorBatchImportDialog: function showDoctorBatchImportDialog() {
			if (this.isNurse || !this.claimForm.warehouseNo) {
				this.$message.warning('Please select a Warehouse first');
				return;
			}

			this.doctorBatchImportText = '';
			this.doctorBatchImportVisible = true;
		},
		importDoctorBatchClaims: function importDoctorBatchClaims() {
			if (this.isNurse || !this.claimForm.warehouseNo) {
				this.$message.error('Please select a Warehouse first');
				return;
			}

			this.doctorBatchImportLoading = true;
			var text = this.doctorBatchImportText.trim();

			if (!text) {
				this.$message.error('Please enter tracking data');
				this.doctorBatchImportLoading = false;
				return;
			}

			var remainingCapacity = 1000 - this.claimList.length;
			if (remainingCapacity <= 0) {
				this.$message.error('Claim list is full. Maximum 1000 items. Please submit current items to add more.');
				this.doctorBatchImportLoading = false;
				return;
			}

			try {
				var parsedItems = this.parseDoctorTextData(text);

				if (parsedItems.length === 0) {
					this.$message.error('No valid tracking data found');
					this.doctorBatchImportLoading = false;
					return;
				}

				if (parsedItems.length > remainingCapacity) {
					this.$message.warning('Only ' + remainingCapacity + ' items can be added. Claim list can hold maximum 1000 items total. Processing first ' + remainingCapacity + ' items.');
				}

				var _validateDoctorBatchI = this.validateDoctorBatchItems(parsedItems),
				    validItems = _validateDoctorBatchI.validItems,
				    invalidItems = _validateDoctorBatchI.invalidItems,
				    duplicateItems = _validateDoctorBatchI.duplicateItems;

				if (invalidItems.length > 0) {
					var errorMsg = invalidItems.length + ' invalid items: ' + invalidItems.map(function (item) {
						return item.tracking;
					}).join(', ');
					this.$message.warning(errorMsg);
				}

				if (duplicateItems.length > 0) {
					var duplicateMsg = duplicateItems.length + ' duplicate/existing items: ' + duplicateItems.join(', ');
					this.$message.info(duplicateMsg);
				}

				var addedCount = 0;
				for (var i = 0; i < validItems.length; i++) {
					if (this.claimList.length >= 1000) {
						this.$message.warning('Reached maximum capacity (1000 items). Added ' + addedCount + ' items.');
						break;
					}

					var item = validItems[i];

					var claimItem = {
						tracking: item.tracking,
						upc: item.upc,
						quantity: item.quantity || 1,
						warehouseNo: this.claimForm.warehouseNo,
						warehouseName: this.getWarehouseNameByNo(this.claimForm.warehouseNo),
						productName: 'Mixed Package - ' + item.upc
					};

					this.claimList.push(claimItem);
					addedCount++;
				}

				this.saveClaimListToStorage();

				this.doctorBatchImportVisible = false;
				this.doctorBatchImportText = '';

				var message = 'Successfully added ' + addedCount + ' items to claim list';
				if (invalidItems.length > 0) {
					message += ' (' + invalidItems.length + ' invalid items skipped)';
				}
				if (duplicateItems.length > 0) {
					message += ' (' + duplicateItems.length + ' duplicates skipped)';
				}
				this.$message.success(message);
			} catch (error) {
				this.$message.error('Error parsing data: ' + error.message);
			} finally {
				this.doctorBatchImportLoading = false;
			}
		},
		parseDoctorTextData: function parseDoctorTextData(text) {
			var items = [];
			var lines = text.split('\n');

			lines.forEach(function (line, index) {
				line = line.trim();

				if (!line || line.toLowerCase().includes('tracking')) {
					return;
				}

				var parts = [];
				if (line.includes(',')) {
					parts = line.split(',').map(function (p) {
						return p.trim();
					}).filter(function (p) {
						return p;
					});
				} else {
					parts = line.split(/[\s\t]+/).filter(function (p) {
						return p;
					});
				}

				if (parts.length >= 2) {
					var tracking = parts[0];
					var upc = parts[1];
					var quantity = parseInt(parts[2]) || 1;

					items.push({
						tracking: tracking,
						upc: upc,
						quantity: quantity,
						lineNo: index + 1
					});
				}
			});

			return items;
		},
		validateDoctorBatchItems: function validateDoctorBatchItems(items) {
			var _this15 = this;

			var validItems = [];
			var invalidItems = [];
			var duplicateItems = [];
			var trackingUpcSet = new _set2.default();

			items.forEach(function (item) {
				var tracking = item.tracking || '';
				var upc = item.upc || '';
				var quantity = item.quantity || 1;

				if (!tracking) {
					invalidItems.push((0, _extends3.default)({}, item, { reason: 'Empty tracking number' }));
					return;
				}

				if (tracking.length < 12 || tracking.length > 34) {
					invalidItems.push({
						tracking: tracking,
						reason: 'Tracking length must be 12-34 characters, got ' + tracking.length
					});
					return;
				}

				if (!upc) {
					invalidItems.push((0, _extends3.default)({}, item, { reason: 'Empty UPC' }));
					return;
				}

				if (upc.length < 5 || upc.length > 20) {
					invalidItems.push({
						tracking: tracking,
						upc: upc,
						reason: 'UPC length must be 5-20 characters, got ' + upc.length
					});
					return;
				}

				if (quantity < 1 || quantity > 10000 || !(0, _isInteger2.default)(quantity)) {
					invalidItems.push({
						tracking: tracking,
						reason: 'Invalid quantity: ' + quantity
					});
					return;
				}

				var trackingUpcKey = tracking + '|' + upc;
				if (trackingUpcSet.has(trackingUpcKey)) {
					duplicateItems.push(tracking);
					return;
				}

				var exists = _this15.claimList.find(function (claimItem) {
					return claimItem.tracking === tracking && claimItem.upc === upc && claimItem.warehouseNo === _this15.claimForm.warehouseNo;
				});
				if (exists) {
					duplicateItems.push(tracking);
					return;
				}

				trackingUpcSet.add(trackingUpcKey);
				validItems.push(item);
			});

			return { validItems: validItems, invalidItems: invalidItems, duplicateItems: duplicateItems };
		},
		showDetailedErrors: function showDetailedErrors(failedItems, title) {
			var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'error';

			if (!failedItems || failedItems.length === 0) return;

			var errorStats = {};
			var itemDetails = [];

			failedItems.forEach(function (item, index) {
				var errorMsg = item.errorMessage || 'Unknown error';

				if (errorStats[errorMsg]) {
					errorStats[errorMsg]++;
				} else {
					errorStats[errorMsg] = 1;
				}

				if (index < 10) {
					var tracking = item.tracking || 'N/A';
					var upc = item.upc || 'N/A';
					var _errorMsg = item.errorMessage || 'Unknown error';
					itemDetails.push(index + 1 + '. Tracking: ' + tracking + ' | UPC: ' + upc + '<br>&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #E6A23C;">Error: ' + _errorMsg + '</span>');
				}
			});

			var content = '<div style="text-align: left; max-height: 400px; overflow-y: auto;">';

			content += '<h4>Error Summary:</h4><ul>';
			(0, _keys2.default)(errorStats).forEach(function (error) {
				content += '<li><strong>' + error + '</strong> (' + errorStats[error] + ' items)</li>';
			});
			content += '</ul>';

			if (itemDetails.length > 0) {
				content += '<h4>Failed Items Details ' + (failedItems.length > 10 ? '(showing first 10)' : '') + ':</h4>';
				content += '<div style="font-family: monospace; font-size: 12px; background: #f5f5f5; padding: 10px; border-radius: 4px;">';
				content += itemDetails.join('<br>');
				if (failedItems.length > 10) {
					content += '<br>... and ' + (failedItems.length - 10) + ' more items';
				}
				content += '</div>';
			}

			content += '</div>';

			this.$msgbox({
				title: title,
				message: content,
				type: type,
				dangerouslyUseHTMLString: true,
				showClose: true,
				closeOnClickModal: true,
				customClass: 'error-details-dialog',
				confirmButtonText: 'OK'
			}).catch(function () {});
		},
		handleScroll: function handleScroll() {
			var contentContainer = document.querySelector('.content-container');
			var scrollY = 0;

			if (contentContainer) {
				scrollY = contentContainer.scrollTop;
			} else {
				scrollY = window.pageYOffset || document.documentElement.scrollTop;
			}

			this.showScrollToTopButton = scrollY > 300;
		},
		handleScrollToTopClick: function handleScrollToTopClick() {
			console.log('回到顶部按钮被点击');

			var contentContainer = document.querySelector('.content-container');

			if (contentContainer) {
				contentContainer.scrollTop = 0;
				console.log('已将 .content-container 滚动到顶部');
			} else {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
				console.log('使用window.scrollTo滚动到顶部');
			}

			this.showScrollToTopButton = false;
		}
	},

	watch: {
		activeName: function activeName(newVal) {
			if (newVal === 'myClaims') {
				this.getMyClaimList();
			}
		}
	}
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(61);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(51);

var _promise2 = _interopRequireDefault(_promise);

var _from = __webpack_require__(110);

var _from2 = _interopRequireDefault(_from);

var _map = __webpack_require__(423);

var _map2 = _interopRequireDefault(_map);

var _toConsumableArray2 = __webpack_require__(146);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = __webpack_require__(220);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(112);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(113);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(111);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(221);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _mixedPackage = __webpack_require__(142);

var _warehouseService = __webpack_require__(50);

var _inboundService = __webpack_require__(77);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(22);

var _ImportResultDialog = __webpack_require__(776);

var _ImportResultDialog2 = _interopRequireDefault(_ImportResultDialog);

var _BulkConfirmResultDialog = __webpack_require__(775);

var _BulkConfirmResultDialog2 = _interopRequireDefault(_BulkConfirmResultDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _defineProperty3.default)({
  name: 'MixedPackageList',
  components: {
    ImportResultDialog: _ImportResultDialog2.default,
    BulkConfirmResultDialog: _BulkConfirmResultDialog2.default
  },
  data: function data() {
    var _ref;

    return _ref = {
      activeName: 'toConfirm',
      pageSize: 20,

      filters: {
        batchFilter: '',
        trackingFilter: '',
        packageFilter: '',
        packageStatus: '',
        claimFilter: '',
        claimStatus: '',
        unclaimedFilter: '',
        dateRange: []
      },

      availableBatches: [],
      availableBatchesLoading: false,

      packageFilters: {
        batchNumber: '',
        tracking: '',
        upc: '',
        packageStatus: null,
        warehouseNo: null
      },

      mixedPackageBatches: [],
      mixedPackageBatchesLoading: false,
      mixedPackageBatchSearchTimer: null,
      pendingBatchSearchTimer: null,

      claimFilters: {
        batchNumber: null,
        tracking: '',
        upc: '',
        warehouseNo: null,
        claimStatus: null
      },
      claimCurrentPage: 1,
      claimSize: 20,
      pendingClaimsCount: 0,

      claimsBatches: [],
      claimsBatchesLoading: false,
      claimsBatchSearchTimer: null,

      packageCurrentPage: 1,
      packageSize: 20,

      warehouses: [],

      claimWarehouses: [],

      createPackageDialog: false,
      createPackageLoading: false,
      createPackageForm: {
        tracking: '',
        warehouseNo: null,
        items: [{ upc: '', qty: 1 }]
      },
      createPackageRules: {
        tracking: [{ required: true, message: 'Please enter tracking number', trigger: 'blur' }, { min: 12, message: 'Tracking number must be at least 12 digits', trigger: 'blur' }, { max: 34, message: 'Tracking number cannot exceed 34 digits', trigger: 'blur' }],
        warehouseNo: [{ required: true, message: 'Please select warehouse', trigger: 'change' }]
      },

      pendingPackageList: [],
      pendingBatchLoading: false,
      pendingBatchTotal: 0,
      currentPendingBatchPage: 1,
      selectedPackages: [],

      packageList: [],
      packageLoading: false,
      packageTotal: 0,
      currentPackagePage: 1
    }, (0, _defineProperty3.default)(_ref, 'selectedPackages', []), (0, _defineProperty3.default)(_ref, 'claimList', []), (0, _defineProperty3.default)(_ref, 'claimLoading', false), (0, _defineProperty3.default)(_ref, 'claimTotal', 0), (0, _defineProperty3.default)(_ref, 'selectedClaims', []), (0, _defineProperty3.default)(_ref, 'currentClaimPage', 1), (0, _defineProperty3.default)(_ref, 'unclaimedList', []), (0, _defineProperty3.default)(_ref, 'unclaimedLoading', false), (0, _defineProperty3.default)(_ref, 'unclaimedTotal', 0), (0, _defineProperty3.default)(_ref, 'currentUnclaimedPage', 1), (0, _defineProperty3.default)(_ref, 'unclaimedFilters', {
      upc: ''
    }), (0, _defineProperty3.default)(_ref, 'unclaimedCurrentPage', 1), (0, _defineProperty3.default)(_ref, 'unclaimedSize', 20), (0, _defineProperty3.default)(_ref, 'packageDetailDialogVisible', false), (0, _defineProperty3.default)(_ref, 'packageDetailLoading', false), (0, _defineProperty3.default)(_ref, 'currentPackageDetail', null), (0, _defineProperty3.default)(_ref, 'batchImportDialogVisible', false), (0, _defineProperty3.default)(_ref, 'importing', false), (0, _defineProperty3.default)(_ref, 'importForm', {
      batchNumber: '',
      warehouseNo: '',
      importMethod: 'text',
      textContent: '',
      excelFile: null
    }), (0, _defineProperty3.default)(_ref, 'importRules', {
      warehouseNo: [{ required: true, message: 'Please select a warehouse', trigger: 'change' }],
      textContent: [{ required: true, message: 'Please enter package data', trigger: 'blur' }]
    }), (0, _defineProperty3.default)(_ref, 'excelFileList', []), (0, _defineProperty3.default)(_ref, 'warehouses', []), (0, _defineProperty3.default)(_ref, 'excelUploadUrl', ''), (0, _defineProperty3.default)(_ref, 'uploadHeaders', {}), (0, _defineProperty3.default)(_ref, 'excelUploadData', {}), (0, _defineProperty3.default)(_ref, 'importResultDialogVisible', false), (0, _defineProperty3.default)(_ref, 'importResultData', {
      totalCount: 0,
      successCount: 0,
      failedCount: 0,
      successTrackings: [],
      successDetails: null,
      failedRecords: []
    }), (0, _defineProperty3.default)(_ref, 'bulkConfirmResultDialogVisible', false), (0, _defineProperty3.default)(_ref, 'bulkConfirmResultData', {
      totalPackages: 0,
      successCount: 0,
      failedCount: 0,
      createdPackageIds: [],
      failureRecords: [],
      batchNumber: ''
    }), (0, _defineProperty3.default)(_ref, 'batchDetailDialogVisible', false), (0, _defineProperty3.default)(_ref, 'batchDetailLoading', false), (0, _defineProperty3.default)(_ref, 'currentPackageDetail', null), (0, _defineProperty3.default)(_ref, 'selectedUPCs', []), (0, _defineProperty3.default)(_ref, 'bulkConfirmDialogVisible', false), (0, _defineProperty3.default)(_ref, 'bulkConfirming', false), (0, _defineProperty3.default)(_ref, 'batchApproveDialogVisible', false), (0, _defineProperty3.default)(_ref, 'batchApproving', false), (0, _defineProperty3.default)(_ref, 'batchDistributeDialogVisible', false), (0, _defineProperty3.default)(_ref, 'batchDistributing', false), (0, _defineProperty3.default)(_ref, 'adjustClaimDialogVisible', false), (0, _defineProperty3.default)(_ref, 'adjusting', false), (0, _defineProperty3.default)(_ref, 'currentClaimForAdjust', null), (0, _defineProperty3.default)(_ref, 'adjustForm', {
      newQuantity: 1,
      adjustReason: ''
    }), (0, _defineProperty3.default)(_ref, 'adjustRules', {
      newQuantity: [{ required: true, message: 'Please enter new quantity', trigger: 'blur' }],
      adjustReason: [{ required: true, message: 'Please enter adjustment reason', trigger: 'blur' }]
    }), (0, _defineProperty3.default)(_ref, 'rejectClaimDialogVisible', false), (0, _defineProperty3.default)(_ref, 'rejecting', false), (0, _defineProperty3.default)(_ref, 'currentClaimForReject', null), (0, _defineProperty3.default)(_ref, 'rejectForm', {
      rejectReason: ''
    }), (0, _defineProperty3.default)(_ref, 'rejectRules', {
      rejectReason: [{ required: true, message: 'Please enter reject reason', trigger: 'blur' }]
    }), (0, _defineProperty3.default)(_ref, 'forceChargeTimeDialogVisible', false), (0, _defineProperty3.default)(_ref, 'settingForceCharge', false), (0, _defineProperty3.default)(_ref, 'forceChargeForm', {
      forceChargeTime: '',
      reason: ''
    }), (0, _defineProperty3.default)(_ref, 'forceChargeRules', {
      forceChargeTime: [{ required: true, message: 'Please select force charge time', trigger: 'change' }],
      reason: [{ required: true, message: 'Please enter reason', trigger: 'blur' }]
    }), (0, _defineProperty3.default)(_ref, 'adjustQuantityDialog', false), (0, _defineProperty3.default)(_ref, 'adjustQuantityLoading', false), (0, _defineProperty3.default)(_ref, 'adjustQuantityForm', {
      claimId: null,
      originalQty: 0,
      newQuantity: 0,
      maxQty: 0,
      reason: ''
    }), (0, _defineProperty3.default)(_ref, 'adjustQuantityRules', {
      newQuantity: [{ required: true, message: 'Please enter new quantity', trigger: 'blur' }]
    }), (0, _defineProperty3.default)(_ref, 'rejectClaimDialog', false), (0, _defineProperty3.default)(_ref, 'rejectClaimLoading', false), (0, _defineProperty3.default)(_ref, 'rejectClaimForm', {
      claimId: null,
      reason: ''
    }), (0, _defineProperty3.default)(_ref, 'rejectClaimRules', {
      reason: [{ required: true, message: 'Please enter rejection reason', trigger: 'blur' }]
    }), (0, _defineProperty3.default)(_ref, 'batchDistributeDialog', false), (0, _defineProperty3.default)(_ref, 'batchDistributeLoading', false), (0, _defineProperty3.default)(_ref, 'batchDistributeForm', {
      chargeTimeOption: 'normal',
      customChargeTime: null
    }), (0, _defineProperty3.default)(_ref, 'singleDistributeDialog', false), (0, _defineProperty3.default)(_ref, 'singleDistributeLoading', false), (0, _defineProperty3.default)(_ref, 'singleDistributeClaim', null), (0, _defineProperty3.default)(_ref, 'singleDistributeForm', {
      chargeTimeOption: 'normal',
      customChargeTime: null
    }), (0, _defineProperty3.default)(_ref, 'setChargeTimeDialog', false), (0, _defineProperty3.default)(_ref, 'setChargeTimeLoading', false), (0, _defineProperty3.default)(_ref, 'setChargeTimeForm', {
      chargeTimeOption: 'normal',
      customChargeTime: null
    }), (0, _defineProperty3.default)(_ref, 'claimDetailDialog', false), (0, _defineProperty3.default)(_ref, 'claimDetail', null), (0, _defineProperty3.default)(_ref, 'editUPCDialog', false), (0, _defineProperty3.default)(_ref, 'savingUPCEdit', false), (0, _defineProperty3.default)(_ref, 'editUPCForm', {
      upc: '',
      quantity: 1,
      originalUpc: '',
      originalQuantity: 1
    }), (0, _defineProperty3.default)(_ref, 'editUPCRules', {
      upc: [{ required: true, message: 'UPC code is required', trigger: 'blur' }, { min: 1, max: 50, message: 'UPC code must be 1-50 characters', trigger: 'blur' }],
      quantity: [{ required: true, message: 'Quantity is required', trigger: 'blur' }, { type: 'number', min: 1, max: 9999, message: 'Quantity must be between 1 and 9999', trigger: 'blur' }]
    }), (0, _defineProperty3.default)(_ref, 'editingUPCIndex', -1), (0, _defineProperty3.default)(_ref, 'batchBulkReverseDialogVisible', false), (0, _defineProperty3.default)(_ref, 'batchBulkReverseLoading', false), (0, _defineProperty3.default)(_ref, 'selectedBatchNumber', ''), (0, _defineProperty3.default)(_ref, 'availableBatchNumbers', []), (0, _defineProperty3.default)(_ref, 'batchPackagesList', []), (0, _defineProperty3.default)(_ref, 'batchPackagesLoading', false), (0, _defineProperty3.default)(_ref, 'editMixedPackageUPCQtyDialog', false), (0, _defineProperty3.default)(_ref, 'editingMixedPackageUPCQty', false), (0, _defineProperty3.default)(_ref, 'editMixedPackageUPCQtyForm', {
      detailId: null,
      mixedPackageId: null,
      upc: '',
      productName: '',
      currentTotalQty: 0,
      claimedQty: 0,
      newTotalQty: 0,
      reason: ''
    }), (0, _defineProperty3.default)(_ref, 'editMixedPackageUPCQtyRules', {
      newTotalQty: [{ required: true, message: 'Please enter new total quantity', trigger: 'blur' }, { type: 'number', min: 0, message: 'Quantity cannot be negative', trigger: 'blur' }]
    }), (0, _defineProperty3.default)(_ref, 'timer', null), _ref;
  },


  computed: {
    dynamicPendingPageSize: function dynamicPendingPageSize() {
      return this.filters.batchFilter && this.filters.batchFilter.trim() !== '' ? 50 : this.pageSize;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.getPendingPackages();
    this.getAvailableBatches();
    this.getWarehouseList();
    this.loadClaimWarehouses();
    this.refreshPendingCount();

    this.timer = setInterval(function () {
      _this.refreshPendingCount();
    }, 120000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    if (this.mixedPackageBatchSearchTimer) {
      clearTimeout(this.mixedPackageBatchSearchTimer);
    }
    if (this.pendingBatchSearchTimer) {
      clearTimeout(this.pendingBatchSearchTimer);
    }
  },


  watch: {
    activeName: function activeName(newTab) {
      switch (newTab) {
        case 'toConfirm':
          this.getPendingPackages();
          break;
        case 'packages':
          this.getMixedPackageList();
          break;
        case 'claims':
          this.getClaimList();
          this.refreshPendingCount();
          break;
        case 'unclaimed':
          this.getUnclaimedItems();
          break;
      }
    }
  },

  methods: (_methods = {
    getPendingPackages: function getPendingPackages() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var params, response, rawRecords;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.pendingBatchLoading = true;
                _context.prev = 1;
                params = {
                  current: _this2.currentPendingBatchPage,
                  size: _this2.dynamicPendingPageSize || 50,
                  batchNumber: _this2.filters.batchFilter || null,
                  tracking: _this2.filters.trackingFilter || null
                };
                _context.next = 5;
                return _mixedPackage.mixedPackageApi.getPendingPackages(params);

              case 5:
                response = _context.sent;


                if (response && (response.code === 200 || response.code === '200')) {
                  rawRecords = response.result.records || [];

                  _this2.pendingPackageList = rawRecords.map(function (record) {
                    var importDate = record.importDate || record.import_date || record.createTime || record.create_time || record.createdDate || record.created_date || '';

                    if (importDate) {
                      try {
                        if (typeof importDate === 'string' && importDate.includes('T')) {
                          importDate = _this2.formatDate(new Date(importDate));
                        } else if (typeof importDate === 'number') {
                          importDate = _this2.formatDate(new Date(importDate));
                        } else if (importDate instanceof Date) {
                          importDate = _this2.formatDate(importDate);
                        } else {
                          importDate = _this2.formatDate(new Date(importDate));
                        }
                      } catch (error) {
                        importDate = importDate.toString();
                      }
                    }

                    var transformed = {
                      id: record.id || record.recordId || '',
                      batchNumber: record.batchNumber || record.batch_number || record.batchNo || '',
                      tracking: record.tracking || record.trackingNumber || '',
                      itemCount: record.itemCount || record.item_count || record.itemNum || 0,
                      warehouseName: record.warehouseName || record.warehouse_name || record.warehouse || '',
                      importDate: importDate,
                      status: record.status || 'pending',
                      note: record.note || record.description || '',
                      items: record.items || [] };
                    return transformed;
                  });

                  _this2.pendingBatchTotal = response.result.total || 0;
                } else {
                  _this2.$message.error(response.msg || 'Failed to load pending packages');
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                _this2.$message.error('Error loading pending packages: ' + _context.t0.message);

              case 12:
                _context.prev = 12;

                _this2.pendingBatchLoading = false;
                return _context.finish(12);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 9, 12, 15]]);
      }))();
    },
    getAvailableBatches: function getAvailableBatches() {
      var _this3 = this;

      var searchKeyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var params, response, batches;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.availableBatchesLoading = true;
                _context2.prev = 1;
                params = {
                  current: 1,
                  size: 50,
                  keyword: searchKeyword };
                _context2.next = 5;
                return _mixedPackage.mixedPackageApi.getPendingBatches(params);

              case 5:
                response = _context2.sent;


                if (response && (response.code === 200 || response.code === '200')) {
                  batches = response.result.records || [];

                  _this3.availableBatches = batches.map(function (batch) {
                    return {
                      batchNumber: batch.batchNumber || batch.batch_number
                    };
                  });
                } else {
                  console.error('Failed to load available batches:', response.msg);
                  _this3.availableBatches = [];
                }
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                console.error('Error loading available batches:', _context2.t0.message);
                _this3.availableBatches = [];

              case 13:
                _context2.prev = 13;

                _this3.availableBatchesLoading = false;
                return _context2.finish(13);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 9, 13, 16]]);
      }))();
    },
    searchPendingBatchNumbers: function searchPendingBatchNumbers(query) {
      var _this4 = this;

      if (this.pendingBatchSearchTimer) {
        clearTimeout(this.pendingBatchSearchTimer);
      }

      if (query === '' || query === null || query === undefined) {
        this.getAvailableBatches('');
        return;
      }

      if (query.length < 2) {
        return;
      }

      this.pendingBatchSearchTimer = setTimeout(function () {
        _this4.getAvailableBatches(query);
      }, 300);
    },
    handlePendingBatchDropdownVisible: function handlePendingBatchDropdownVisible(visible) {
      if (visible && this.availableBatches.length === 0) {
        this.getAvailableBatches('');
      }
    },
    handlePendingBatchNumberChange: function handlePendingBatchNumberChange(value) {
      console.log('Pending batch number changed:', value);

      this.currentPendingBatchPage = 1;

      this.getPendingPackages();
    },
    handlePendingBatchNumberClear: function handlePendingBatchNumberClear() {
      console.log('Pending batch number cleared');

      this.currentPendingBatchPage = 1;

      this.getPendingPackages();
    },
    changePendingBatchPage: function changePendingBatchPage(page) {
      this.currentPendingBatchPage = page;
      this.getPendingPackages();
    },
    handlePendingBatchSizeChange: function handlePendingBatchSizeChange(val) {
      this.pageSize = val;
      this.currentPendingBatchPage = 1;
      this.getPendingPackages();
    },
    handlePackageSelection: function handlePackageSelection(selection) {
      this.selectedPackages = selection;
    },
    getBatchStatusType: function getBatchStatusType(status) {
      var statusMap = {
        'pending': '',
        'processing': 'warning',
        'confirmed': 'success',
        'failed': 'danger'
      };
      return statusMap[status] || '';
    },
    getMixedPackageList: function getMixedPackageList() {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var params, response;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.packageLoading = true;
                _context3.prev = 1;
                params = (0, _extends3.default)({
                  current: _this5.packageCurrentPage,
                  size: _this5.packageSize
                }, _this5.packageFilters);
                _context3.next = 5;
                return _mixedPackage.mixedPackageApi.getMixedPackageList(params);

              case 5:
                response = _context3.sent;

                if (response && (response.code === 200 || response.code === '200')) {
                  _this5.packageList = response.result.records || response.data && response.data.records || [];
                  _this5.packageTotal = response.result.total || response.data && response.data.total || 0;
                } else {
                  _this5.$message.error(response.msg || 'Failed to load packages');
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](1);

                _this5.$message.error('Error loading packages: ' + _context3.t0.message);

              case 12:
                _context3.prev = 12;

                _this5.packageLoading = false;
                return _context3.finish(12);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 9, 12, 15]]);
      }))();
    },
    getMixedPackageBatches: function getMixedPackageBatches() {
      var _this6 = this;

      var searchKeyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var params, response, resultData, batchNumbers;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.mixedPackageBatchesLoading = true;
                _context4.prev = 1;
                params = {
                  current: 1,
                  size: 50,
                  keyword: searchKeyword };
                _context4.next = 5;
                return _mixedPackage.mixedPackageApi.getBatchNumbers(params);

              case 5:
                response = _context4.sent;


                if (response && (response.code === 200 || response.code === '200')) {
                  resultData = response.result || {};
                  batchNumbers = resultData.batchNumbers || [];

                  if (Array.isArray(response.result)) {
                    batchNumbers = response.result;
                  }

                  _this6.mixedPackageBatches = batchNumbers.map(function (batchNumber) {
                    return {
                      batchNumber: batchNumber
                    };
                  });
                } else {
                  console.error('Failed to load mixed package batches:', response.msg);
                  _this6.mixedPackageBatches = [];
                }
                _context4.next = 13;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](1);

                console.error('Error loading mixed package batches:', _context4.t0.message);
                _this6.mixedPackageBatches = [];

              case 13:
                _context4.prev = 13;

                _this6.mixedPackageBatchesLoading = false;
                return _context4.finish(13);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[1, 9, 13, 16]]);
      }))();
    },
    searchBatchNumbers: function searchBatchNumbers(query) {
      var _this7 = this;

      if (this.mixedPackageBatchSearchTimer) {
        clearTimeout(this.mixedPackageBatchSearchTimer);
      }

      if (query === '' || query === null || query === undefined) {
        this.getMixedPackageBatches('');
        return;
      }

      if (query.length < 2) {
        return;
      }

      this.mixedPackageBatchSearchTimer = setTimeout(function () {
        _this7.getMixedPackageBatches(query);
      }, 300);
    },
    handleBatchDropdownVisible: function handleBatchDropdownVisible(visible) {
      if (visible && this.mixedPackageBatches.length === 0) {
        this.getMixedPackageBatches('');
      }
    },
    handleBatchNumberChange: function handleBatchNumberChange(value) {
      console.log('Batch number changed:', value);

      this.packageCurrentPage = 1;

      this.getMixedPackageList();
    },
    handleBatchNumberClear: function handleBatchNumberClear() {
      console.log('Batch number cleared');

      this.packageCurrentPage = 1;

      this.getMixedPackageList();
    },
    handlePackageSizeChange: function handlePackageSizeChange(val) {
      this.packageSize = val;
      this.getMixedPackageList();
    },
    handlePackageCurrentChange: function handlePackageCurrentChange(val) {
      this.packageCurrentPage = val;
      this.getMixedPackageList();
    },
    changePackagePage: function changePackagePage(page) {
      this.currentPackagePage = page;
      this.getMixedPackageList();
    },
    exportMixedPackages: function exportMixedPackages() {
      var param = {
        url: '/excel/exportMixedPackages',
        fileName: 'MixedPackages.xls',
        doctorNo: window.sessionStorage.getItem('currentCompany'),
        batchNumber: this.packageFilters.batchNumber,
        tracking: this.packageFilters.tracking,
        upc: this.packageFilters.upc,
        packageStatus: this.packageFilters.packageStatus,
        warehouseNo: this.packageFilters.warehouseNo
      };
      (0, _exportService.postExportExcel)(param).then(function () {});
    }
  }, (0, _defineProperty3.default)(_methods, 'handlePackageSelection', function handlePackageSelection(selection) {
    this.selectedPackages = selection;
  }), (0, _defineProperty3.default)(_methods, 'getPackageStatusType', function getPackageStatusType(status) {
    var statusMap = {
      'active': 'success',
      'cancelled': 'danger',
      'pending': 'warning',
      0: '',
      1: 'warning',
      2: 'success',
      3: 'info'
    };
    return statusMap[status] || '';
  }), (0, _defineProperty3.default)(_methods, 'getClaimList', function getClaimList() {
    var _this8 = this;

    this.claimLoading = true;
    var params = (0, _extends3.default)({
      current: this.claimCurrentPage,
      size: this.claimSize
    }, this.claimFilters);

    return _mixedPackage.mixedPackageApi.getClaimListForReview(params).then(function (res) {
      if (res.code === 200 || res.code === '200') {
        _this8.claimList = res.result.records || res.data && res.data.records || [];
        _this8.claimTotal = res.result.total || res.data && res.data.total || 0;
      } else {
        _this8.$message.error(res.message || 'Failed to load claims');
      }
      _this8.claimLoading = false;
      return res;
    }).catch(function (err) {
      if (!_this8.handleApiError(err)) {
        _this8.$message.error('Error loading claims: ' + (err.message || 'Unknown error'));
      }
      _this8.claimLoading = false;
      throw err;
    });
  }), (0, _defineProperty3.default)(_methods, 'exportClaimList', function exportClaimList() {
    var _this9 = this;

    var param = (0, _extends3.default)({
      url: '/excel/exportMixedPackageClaims',
      fileName: 'ClaimsReview.xls'
    }, this.claimFilters);
    (0, _exportService.postExportExcel)(param).then(function () {
      _this9.$message.success('Export completed successfully');
    }).catch(function (err) {
      _this9.$message.error('Export failed: ' + (err.message || 'Unknown error'));
    });
  }), (0, _defineProperty3.default)(_methods, 'handleClaimSizeChange', function handleClaimSizeChange(val) {
    this.claimSize = val;
    this.getClaimList();
  }), (0, _defineProperty3.default)(_methods, 'handleClaimCurrentChange', function handleClaimCurrentChange(val) {
    this.claimCurrentPage = val;
    this.getClaimList();
  }), (0, _defineProperty3.default)(_methods, 'handleClaimSelectionChange', function handleClaimSelectionChange(selection) {
    this.selectedClaims = selection;
  }), (0, _defineProperty3.default)(_methods, 'changeClaimPage', function changeClaimPage(page) {
    this.claimCurrentPage = page;
    this.getClaimList();
  }), (0, _defineProperty3.default)(_methods, 'getClaimStatusType', function getClaimStatusType(status) {
    var statusMap = {
      0: 'warning',
      1: 'primary',
      2: 'success',
      3: 'danger',
      4: 'info',
      5: 'info' };
    return statusMap[status] || '';
  }), (0, _defineProperty3.default)(_methods, 'getClaimsBatches', function getClaimsBatches() {
    var _this10 = this;

    var searchKeyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
      var params, response, resultData, batchNumbers;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this10.claimsBatchesLoading = true;
              _context5.prev = 1;
              params = {
                current: 1,
                size: 50,
                keyword: searchKeyword };
              _context5.next = 5;
              return _mixedPackage.mixedPackageApi.getBatchNumbers(params);

            case 5:
              response = _context5.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                resultData = response.result || {};
                batchNumbers = resultData.batchNumbers || [];

                if (Array.isArray(response.result)) {
                  batchNumbers = response.result;
                }

                _this10.claimsBatches = batchNumbers.map(function (batchNumber) {
                  return {
                    batchNumber: batchNumber
                  };
                });
              } else {
                console.error('Failed to load claims batches:', response.msg);
                _this10.claimsBatches = [];
              }
              _context5.next = 13;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5['catch'](1);

              console.error('Error loading claims batches:', _context5.t0.message);
              _this10.claimsBatches = [];

            case 13:
              _context5.prev = 13;

              _this10.claimsBatchesLoading = false;
              return _context5.finish(13);

            case 16:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this10, [[1, 9, 13, 16]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'searchClaimsBatchNumbers', function searchClaimsBatchNumbers(query) {
    var _this11 = this;

    if (this.claimsBatchSearchTimer) {
      clearTimeout(this.claimsBatchSearchTimer);
    }

    if (query === '' || query === null || query === undefined) {
      this.getClaimsBatches('');
      return;
    }

    if (query.length < 2) {
      return;
    }

    this.claimsBatchSearchTimer = setTimeout(function () {
      _this11.getClaimsBatches(query);
    }, 300);
  }), (0, _defineProperty3.default)(_methods, 'handleClaimsBatchDropdownVisible', function handleClaimsBatchDropdownVisible(visible) {
    if (visible && this.claimsBatches.length === 0) {
      this.getClaimsBatches('');
    }
  }), (0, _defineProperty3.default)(_methods, 'handleClaimsBatchNumberChange', function handleClaimsBatchNumberChange(value) {
    console.log('Claims batch number changed:', value);

    this.claimCurrentPage = 1;

    this.getClaimList();
  }), (0, _defineProperty3.default)(_methods, 'handleClaimsBatchNumberClear', function handleClaimsBatchNumberClear() {
    console.log('Claims batch number cleared');

    this.claimCurrentPage = 1;

    this.getClaimList();
  }), (0, _defineProperty3.default)(_methods, 'getUnclaimedItems', function getUnclaimedItems() {
    var _this12 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
      var params, response;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this12.unclaimedLoading = true;
              _context6.prev = 1;
              params = (0, _extends3.default)({
                current: _this12.unclaimedCurrentPage,
                size: _this12.unclaimedSize
              }, _this12.unclaimedFilters);
              _context6.next = 5;
              return _mixedPackage.mixedPackageApi.getUnclaimedItems(params);

            case 5:
              response = _context6.sent;

              if (response && (response.code === 200 || response.code === '200')) {
                _this12.unclaimedList = response.result.records || response.data && response.data.records || [];
                _this12.unclaimedTotal = response.result.total || response.data && response.data.total || 0;
              } else {
                _this12.$message.error(response.msg || 'Failed to load unclaimed items');
              }
              _context6.next = 12;
              break;

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6['catch'](1);

              _this12.$message.error('Error loading unclaimed items: ' + _context6.t0.message);

            case 12:
              _context6.prev = 12;

              _this12.unclaimedLoading = false;
              return _context6.finish(12);

            case 15:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this12, [[1, 9, 12, 15]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'getUnclaimedItemsList', function getUnclaimedItemsList() {
    var _this13 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this13.getUnclaimedItems();

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this13);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'changeUnclaimedPage', function changeUnclaimedPage(page) {
    this.unclaimedCurrentPage = page;
    this.getUnclaimedItems();
  }), (0, _defineProperty3.default)(_methods, 'handleUnclaimedSizeChange', function handleUnclaimedSizeChange(val) {
    this.unclaimedSize = val;
    this.getUnclaimedItems();
  }), (0, _defineProperty3.default)(_methods, 'handleUnclaimedCurrentChange', function handleUnclaimedCurrentChange(val) {
    this.unclaimedCurrentPage = val;
    this.getUnclaimedItems();
  }), (0, _defineProperty3.default)(_methods, 'showBatchImport', function showBatchImport() {
    var _this14 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
      var loading, batchResponse;
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              loading = _this14.$loading({
                lock: true,
                text: 'Preparing batch import...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context8.prev = 1;

              _this14.resetImportFormFields();

              _context8.next = 5;
              return (0, _inboundService.getBatchNumber)();

            case 5:
              batchResponse = _context8.sent;

              if (!(batchResponse && batchResponse.status === 200)) {
                _context8.next = 10;
                break;
              }

              _this14.importForm.batchNumber = batchResponse.result.batchNumber;
              _context8.next = 12;
              break;

            case 10:
              _this14.$message.error('Failed to generate batch number: ' + (batchResponse.message || 'Unknown error'));
              return _context8.abrupt('return');

            case 12:
              _context8.next = 14;
              return _this14.loadWarehouses();

            case 14:
              _this14.initializeExcelUploadConfig();

              _this14.batchImportDialogVisible = true;
              _context8.next = 21;
              break;

            case 18:
              _context8.prev = 18;
              _context8.t0 = _context8['catch'](1);

              _this14.$message.error('Error opening import dialog: ' + _context8.t0.message);

            case 21:
              _context8.prev = 21;

              loading.close();
              return _context8.finish(21);

            case 24:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this14, [[1, 18, 21, 24]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'loadClaimWarehouses', function loadClaimWarehouses() {
    var _this15 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
      var response;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return (0, _warehouseService.getWarehouseForWarehouseAdmin)({});

            case 3:
              response = _context9.sent;


              if (response.code === 200 || response.code === '200') {
                _this15.claimWarehouses = response.records || [];
              } else {
                _this15.$message.error('Failed to load claim warehouses: ' + response.msg);
              }
              _context9.next = 10;
              break;

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9['catch'](0);

              _this15.$message.error('Failed to load claim warehouses: ' + _context9.t0.message);

            case 10:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this15, [[0, 7]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'loadWarehouses', function loadWarehouses() {
    var _this16 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
      var currentCompany, response;
      return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              currentCompany = window.sessionStorage.getItem("currentCompany");
              _context10.next = 4;
              return (0, _warehouseService.getWarehouseForWarehouseAdmin)({
                doctorNo: currentCompany
              });

            case 4:
              response = _context10.sent;


              if (response.code === 200 || response.code === '200') {
                _this16.warehouses = response.records || [];

                if (_this16.warehouses.length === 1) {
                  _this16.importForm.warehouseNo = _this16.warehouses[0].warehouseNo;
                }
              } else {
                _this16.$message.error('Failed to load warehouses: ' + response.msg);
              }
              _context10.next = 11;
              break;

            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10['catch'](0);

              _this16.$message.error('Failed to load warehouses: ' + _context10.t0.message);

            case 11:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this16, [[0, 8]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'resetImportForm', function resetImportForm() {
    var currentBatchNumber = this.importForm.batchNumber;
    this.resetImportFormFields();

    this.importForm.batchNumber = currentBatchNumber;
  }), (0, _defineProperty3.default)(_methods, 'resetImportFormFields', function resetImportFormFields() {
    this.importForm.warehouseNo = '';
    this.importForm.importMethod = 'text';
    this.importForm.textContent = '';
    this.importForm.excelFile = null;
    this.excelFileList = [];

    if (this.$refs.importForm) {
      this.$refs.importForm.clearValidate();
    }
  }), (0, _defineProperty3.default)(_methods, 'closeBatchImportDialog', function closeBatchImportDialog() {
    this.batchImportDialogVisible = false;
    this.resetImportForm();
  }), (0, _defineProperty3.default)(_methods, 'parseTextData', function parseTextData(textContent) {

    if (!textContent || !textContent.trim()) {
      return textContent;
    }

    var text = textContent.trim();

    if (!text.includes('\n')) {
      var items = this.smartSplitSingleLine(text);
      if (items.length > 1) {
        text = items.join('\n');
      } else if (items.length === 1 && items[0] !== text.trim()) {
        text = items[0];
      }
    } else {
      var lines = text.split('\n');
      var allProcessedLines = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(lines), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var line = _step.value;

          var trimmedLine = line.trim();
          if (!trimmedLine) continue;

          var linePackages = this.smartSplitSingleLine(trimmedLine);
          allProcessedLines.push.apply(allProcessedLines, (0, _toConsumableArray3.default)(linePackages));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      text = allProcessedLines.join('\n');
    }

    return text;
  }), (0, _defineProperty3.default)(_methods, 'smartSplitSingleLine', function smartSplitSingleLine(text) {
    if (text.indexOf("\t") !== -1) {
      var parts = text.split("\t").map(function (part) {
        return part.trim();
      }).filter(function (part) {
        return part.length > 0;
      });
      if (parts.length === 3 && parts.every(function (part) {
        return part.length > 0;
      })) {
        var cleanPackage = parts.join(',');
        return [cleanPackage];
      }
    }

    var commaCount = (text.match(/,/g) || []).length;

    if (commaCount >= 6 && commaCount % 3 === 0) {
      var expectedPackageCount = commaCount / 3;

      var packages = text.split(/\s{2,}/).filter(function (item) {
        return item.trim().length > 0;
      });

      if (packages.length !== expectedPackageCount) {
        packages = text.split(/\s+/).filter(function (item) {
          return item.trim().length > 0;
        });
      }

      var validPackages = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(packages), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          var trimmed = item.trim();
          var _parts = trimmed.split(',');
          if (_parts.length === 3 && _parts.every(function (part) {
            return part.trim().length > 0;
          })) {
            var _cleanPackage = _parts.map(function (part) {
              return part.trim();
            }).join(',');
            validPackages.push(_cleanPackage);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (validPackages.length === expectedPackageCount) {
        return validPackages;
      }
    }

    if (commaCount >= 3) {
      var intelligentPackages = this.intelligentPackageSplit(text);
      if (intelligentPackages.length > 1) {
        return intelligentPackages;
      }
    }

    var singleParts = text.split(',');
    if (singleParts.length === 3 && singleParts.every(function (part) {
      return part.trim().length > 0;
    })) {
      var singlePackage = singleParts.map(function (part) {
        return part.trim();
      }).join(',');
      return [singlePackage];
    }

    return [text.trim()];
  }), (0, _defineProperty3.default)(_methods, 'intelligentPackageSplit', function intelligentPackageSplit(text) {
    var complexMatches = this.complexPatternMatch(text);
    if (complexMatches.length > 1) {
      return complexMatches;
    }

    var packagePattern = /([A-Za-z0-9]+),([^,\s]+),(\d*)/g;
    var matches = [];
    var match = void 0;

    while ((match = packagePattern.exec(text)) !== null) {
      var tracking = match[1].trim();
      var product = match[2].trim();
      var quantity = match[3].trim();

      if (tracking && product) {
        var cleanPackage = [tracking, product, quantity || ''].join(',');
        matches.push(cleanPackage);
      }
    }

    return matches;
  }), (0, _defineProperty3.default)(_methods, 'complexPatternMatch', function complexPatternMatch(text) {
    var trackingPattern = /\b\d{20,}\b/g;
    var trackings = [];
    var trackingMatch = void 0;

    while ((trackingMatch = trackingPattern.exec(text)) !== null) {
      trackings.push({
        value: trackingMatch[0],
        start: trackingMatch.index,
        end: trackingMatch.index + trackingMatch[0].length
      });
    }

    if (trackings.length < 2) {
      return [];
    }

    var packages = [];

    for (var i = 0; i < trackings.length; i++) {
      var tracking = trackings[i];

      var nextTrackingStart = i + 1 < trackings.length ? trackings[i + 1].start : text.length;
      var packageText = text.substring(tracking.start, nextTrackingStart).trim();

      var packageInfo = this.extractPackageInfo(packageText, tracking.value);
      if (packageInfo) {
        packages.push(packageInfo);
      }
    }

    return packages;
  }), (0, _defineProperty3.default)(_methods, 'extractPackageInfo', function extractPackageInfo(text, tracking) {
    var remaining = text.replace(tracking, '').trim();

    var cleaned = remaining.replace(/^,\s*/, '').trim();

    var parts = cleaned.split(',').map(function (part) {
      return part.trim();
    }).filter(function (part) {
      return part.length > 0;
    });

    if (parts.length >= 1) {
      var product = parts[0];
      var quantity = parts.length >= 2 ? parts[1] : '';

      var packageInfo = [tracking, product, quantity].join(',');
      return packageInfo;
    }

    return null;
  }), (0, _defineProperty3.default)(_methods, 'manualParsePackages', function manualParsePackages(text) {
    var singlePackageTest = text.split(',');
    if (singlePackageTest.length === 3 && singlePackageTest.every(function (part) {
      return part.trim().length > 0;
    })) {
      var cleanedSingle = singlePackageTest.map(function (part) {
        return part.trim();
      }).join(',');
      return [cleanedSingle];
    }

    var commaPositions = [];
    for (var i = 0; i < text.length; i++) {
      if (text[i] === ',') {
        commaPositions.push(i);
      }
    }

    if (commaPositions.length % 2 !== 0) {
      return [text.trim()];
    }

    var packages = [];

    for (var _i = 0; _i < commaPositions.length; _i += 2) {
      var start = _i === 0 ? 0 : commaPositions[_i - 1] + 1;
      var end = _i + 1 < commaPositions.length ? commaPositions[_i + 1] : text.length;

      if (_i + 2 < commaPositions.length) {
        var nextStart = commaPositions[_i + 1] + 1;
        while (end < text.length && /\s/.test(text[end])) {
          end++;
        }

        var nextPackageStart = nextStart;
        while (nextPackageStart < text.length && /\s/.test(text[nextPackageStart])) {
          nextPackageStart++;
        }

        end = nextPackageStart;
      }

      var packageText = text.substring(start, end).trim();
      var parts = packageText.split(',');

      if (parts.length === 3 && parts.every(function (part) {
        return part.trim().length > 0;
      })) {
        var cleanedPackage = parts.map(function (part) {
          return part.trim();
        }).join(',');
        packages.push(cleanedPackage);
      }
    }

    if (packages.length > 0) {
      return packages;
    }

    return [text.trim()];
  }), (0, _defineProperty3.default)(_methods, 'initializeExcelUploadConfig', function initializeExcelUploadConfig() {
    this.excelUploadUrl = _globalVar.serverUrl + '/mixed-package/batch/excelImport';
    this.uploadHeaders = {
      Authorization: window.sessionStorage.getItem("authorization")
    };

    this.excelUploadData = {
      batchNumber: this.importForm.batchNumber,
      warehouseNo: this.importForm.warehouseNo
    };
  }), (0, _defineProperty3.default)(_methods, 'handleExcelUploadSuccess', function handleExcelUploadSuccess(response) {
    if (response && (response.code === 200 || response.code === '200')) {
      var result = response.result;
      this.showImportResultSummary(result);
      this.closeBatchImportDialog();
    } else {
      this.$message.error(response.message || response.msg || 'Import failed');
    }
    this.excelFileList = [];
  }), (0, _defineProperty3.default)(_methods, 'handleExcelUploadError', function handleExcelUploadError(error) {
    this.$message.error('Excel upload failed: ' + (error.message || 'Unknown error'));
    this.excelFileList = [];
  }), (0, _defineProperty3.default)(_methods, 'handleExcelChange', function handleExcelChange(file, fileList) {
    this.excelFileList = fileList;
  }), (0, _defineProperty3.default)(_methods, 'validateImportData', function validateImportData() {
    var _this17 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
      return _regenerator2.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return _this17.$refs.importForm.validate();

            case 3:
              if (!(_this17.importForm.importMethod === 'text')) {
                _context11.next = 8;
                break;
              }

              _context11.next = 6;
              return _this17.executeImport();

            case 6:
              _context11.next = 10;
              break;

            case 8:
              _context11.next = 10;
              return _this17.executeExcelUpload();

            case 10:
              _context11.next = 14;
              break;

            case 12:
              _context11.prev = 12;
              _context11.t0 = _context11['catch'](0);

            case 14:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this17, [[0, 12]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'executeExcelUpload', function executeExcelUpload() {
    var _this18 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
      return _regenerator2.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (!(_this18.excelFileList.length === 0)) {
                _context12.next = 3;
                break;
              }

              _this18.$message.error('Please select an Excel file first');
              return _context12.abrupt('return');

            case 3:
              _this18.excelUploadData = {
                batchNumber: _this18.importForm.batchNumber,
                warehouseNo: _this18.importForm.warehouseNo
              };

              _this18.$refs.excelUpload.submit();

            case 5:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this18);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'executeImport', function executeImport() {
    var _this19 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
      var parsedTextContent, response, result;
      return _regenerator2.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _this19.importing = true;
              _context13.prev = 1;
              parsedTextContent = _this19.parseTextData(_this19.importForm.textContent);
              _context13.next = 5;
              return _mixedPackage.mixedPackageApi.batchTextImport({
                batchNumber: _this19.importForm.batchNumber,
                warehouseNo: _this19.importForm.warehouseNo,
                textContent: parsedTextContent
              });

            case 5:
              response = _context13.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                result = response.result;

                _this19.showImportResultSummary(result);
                _this19.closeBatchImportDialog();
                _this19.getPendingPackages();
                _this19.getAvailableBatches();
              } else {
                _this19.$message.error(response.message || response.msg || 'Import failed');
              }
              _context13.next = 12;
              break;

            case 9:
              _context13.prev = 9;
              _context13.t0 = _context13['catch'](1);

              _this19.$message.error('Import error: ' + _context13.t0.message);

            case 12:
              _context13.prev = 12;

              _this19.importing = false;
              return _context13.finish(12);

            case 15:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this19, [[1, 9, 12, 15]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showImportResultSummary', function showImportResultSummary(result) {
    var failedRecords = result.failedRecords || result.failureRecords || [];
    var successTrackings = result.successTrackings || [];
    var successDetails = result.successDetails || null;

    var totalCount = result.totalCount || 0;
    var successCount = result.successCount || 0;
    var failedCount = result.failedCount || 0;

    if (successTrackings.length > 0 && successCount !== successTrackings.length) {
      successCount = successTrackings.length;
    }

    if (failedRecords.length > 0 && failedCount !== failedRecords.length) {
      failedCount = failedRecords.length;
    }

    var calculatedTotal = successCount + failedCount;
    if (totalCount !== calculatedTotal && calculatedTotal > 0) {
      totalCount = calculatedTotal;
    }

    this.importResultData = {
      totalCount: totalCount,
      successCount: successCount,
      failedCount: failedCount,
      successTrackings: successTrackings,
      successDetails: successDetails,
      failedRecords: failedRecords.map(function (record, index) {
        return {
          lineNumber: record.lineNumber || index + 1,
          rawContent: record.rawContent || record.content || record.data || '',
          content: record.content || record.rawContent || record.data || '',
          errorMessage: record.errorMessage || record.error || record.message || 'Unknown error',
          error: record.error || record.errorMessage || record.message || 'Unknown error'
        };
      })
    };

    this.importResultDialogVisible = true;
  }), (0, _defineProperty3.default)(_methods, 'handleImportContinue', function handleImportContinue(result) {
    if (result.successCount > 0) {
      this.$message.success(result.successCount + ' tracking(s) imported successfully!');
      this.getPendingPackages();
    }
  }), (0, _defineProperty3.default)(_methods, 'handleImportResultClose', function handleImportResultClose() {
    this.importResultDialogVisible = false;
  }), (0, _defineProperty3.default)(_methods, 'handleRetryFailed', function handleRetryFailed(retryInfo) {
    this.importForm.textContent = retryInfo.retryData;
    this.importResultDialogVisible = false;
    this.batchImportDialogVisible = true;

    this.$message.info('Loaded ' + retryInfo.failedCount + ' failed records for retry. Please review and import again.');
  }), (0, _defineProperty3.default)(_methods, 'showBulkConfirm', function showBulkConfirm() {
    if (this.selectedPackages.length === 0) {
      this.$message.warning('Please select packages to confirm');
      return;
    }
    this.bulkConfirmDialogVisible = true;
  }), (0, _defineProperty3.default)(_methods, 'executeBulkConfirm', function executeBulkConfirm() {
    var _this20 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14() {
      var results, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, packageRecord, response, successResults, failedResults, successCount, failedCount;

      return _regenerator2.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _this20.bulkConfirming = true;
              _context14.prev = 1;
              results = [];
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context14.prev = 6;
              _iterator3 = (0, _getIterator3.default)(_this20.selectedPackages);

            case 8:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context14.next = 23;
                break;
              }

              packageRecord = _step3.value;
              _context14.prev = 10;
              _context14.next = 13;
              return _mixedPackage.mixedPackageApi.confirmSinglePackage({
                id: packageRecord.id,
                batchNumber: packageRecord.batchNumber,
                tracking: packageRecord.tracking
              });

            case 13:
              response = _context14.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                results.push({
                  tracking: packageRecord.tracking,
                  success: true,
                  result: response.result
                });
              } else {
                results.push({
                  tracking: packageRecord.tracking,
                  success: false,
                  error: response.msg || response.message || response.error || 'Confirmation failed'
                });
              }
              _context14.next = 20;
              break;

            case 17:
              _context14.prev = 17;
              _context14.t0 = _context14['catch'](10);

              results.push({
                tracking: packageRecord.tracking,
                success: false,
                error: _context14.t0.message || _context14.t0.toString() || 'Network or system error'
              });

            case 20:
              _iteratorNormalCompletion3 = true;
              _context14.next = 8;
              break;

            case 23:
              _context14.next = 29;
              break;

            case 25:
              _context14.prev = 25;
              _context14.t1 = _context14['catch'](6);
              _didIteratorError3 = true;
              _iteratorError3 = _context14.t1;

            case 29:
              _context14.prev = 29;
              _context14.prev = 30;

              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }

            case 32:
              _context14.prev = 32;

              if (!_didIteratorError3) {
                _context14.next = 35;
                break;
              }

              throw _iteratorError3;

            case 35:
              return _context14.finish(32);

            case 36:
              return _context14.finish(29);

            case 37:
              successResults = results.filter(function (r) {
                return r.success;
              });
              failedResults = results.filter(function (r) {
                return !r.success;
              });
              successCount = successResults.length;
              failedCount = failedResults.length;

              _this20.bulkConfirmResultData = {
                totalPackages: _this20.selectedPackages.length,
                successCount: successCount,
                failedCount: failedCount,
                createdPackageIds: successResults.map(function (r) {
                  return r.tracking;
                }).filter(Boolean),
                failureRecords: failedResults.map(function (r) {
                  return {
                    tracking: r.tracking,
                    errorMessage: _this20.formatErrorMessage(r.error) || 'Unknown error',
                    canRetry: _this20.determineCanRetry(r.error),
                    itemCount: _this20.getPackageItemCount(r.tracking)
                  };
                }),
                batchNumber: _this20.selectedPackages[0] && _this20.selectedPackages[0].batchNumber || ''
              };

              _this20.bulkConfirmDialogVisible = false;

              _this20.bulkConfirmResultDialogVisible = true;

              _this20.getPendingPackages();
              _context14.next = 50;
              break;

            case 47:
              _context14.prev = 47;
              _context14.t2 = _context14['catch'](1);

              _this20.$message.error('Bulk confirmation error: ' + _context14.t2.message);

            case 50:
              _context14.prev = 50;

              _this20.bulkConfirming = false;
              return _context14.finish(50);

            case 53:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this20, [[1, 47, 50, 53], [6, 25, 29, 37], [10, 17], [30,, 32, 36]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showBatchCancel', function showBatchCancel() {
    var _this21 = this;

    if (this.selectedPackages.length === 0) {
      this.$message.warning('Please select packages to remove');
      return;
    }

    this.$confirm('Are you sure to remove ' + this.selectedPackages.length + ' selected packages?', 'Confirm', {
      confirmButtonText: 'Remove Packages',
      cancelButtonText: 'Keep Packages',
      type: 'warning'
    }).then(function () {
      _this21.executeBatchCancel();
    }).catch(function () {});
  }), (0, _defineProperty3.default)(_methods, 'executeBatchCancel', function executeBatchCancel() {
    var _this22 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
      var loading, successCount, failedCount, failedPackages, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, packageRecord, response;

      return _regenerator2.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              loading = _this22.$loading({
                lock: true,
                text: 'Removing ' + _this22.selectedPackages.length + ' packages...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              successCount = 0;
              failedCount = 0;
              failedPackages = [];
              _context15.prev = 4;
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context15.prev = 8;
              _iterator4 = (0, _getIterator3.default)(_this22.selectedPackages);

            case 10:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context15.next = 26;
                break;
              }

              packageRecord = _step4.value;
              _context15.prev = 12;
              _context15.next = 15;
              return _mixedPackage.mixedPackageApi.cancelSinglePackage({
                id: packageRecord.id,
                batchNumber: packageRecord.batchNumber,
                tracking: packageRecord.tracking
              });

            case 15:
              response = _context15.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                successCount++;
              } else {
                failedCount++;
                failedPackages.push({
                  tracking: packageRecord.tracking,
                  error: response.msg || 'Unknown error'
                });
              }
              _context15.next = 23;
              break;

            case 19:
              _context15.prev = 19;
              _context15.t0 = _context15['catch'](12);

              failedCount++;
              failedPackages.push({
                tracking: packageRecord.tracking,
                error: _context15.t0.message
              });

            case 23:
              _iteratorNormalCompletion4 = true;
              _context15.next = 10;
              break;

            case 26:
              _context15.next = 32;
              break;

            case 28:
              _context15.prev = 28;
              _context15.t1 = _context15['catch'](8);
              _didIteratorError4 = true;
              _iteratorError4 = _context15.t1;

            case 32:
              _context15.prev = 32;
              _context15.prev = 33;

              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }

            case 35:
              _context15.prev = 35;

              if (!_didIteratorError4) {
                _context15.next = 38;
                break;
              }

              throw _iteratorError4;

            case 38:
              return _context15.finish(35);

            case 39:
              return _context15.finish(32);

            case 40:

              loading.close();

              if (successCount > 0) {
                _this22.$message.success('Batch removal completed! Success: ' + successCount + ', Failed: ' + failedCount);
                _this22.getPendingPackages();
                _this22.getAvailableBatches();
              }

              if (failedCount > 0) {
                _this22.$message.warning(failedCount + ' packages failed to remove.');
              }

              _context15.next = 49;
              break;

            case 45:
              _context15.prev = 45;
              _context15.t2 = _context15['catch'](4);

              loading.close();
              _this22.$message.error('Batch removal error: ' + _context15.t2.message);

            case 49:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this22, [[4, 45], [8, 28, 32, 40], [12, 19], [33,, 35, 39]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'viewPendingPackageDetail', function viewPendingPackageDetail(packageRecord) {
    var _this23 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16() {
      var response;
      return _regenerator2.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;

              _this23.batchDetailLoading = true;
              _this23.batchDetailDialogVisible = true;

              if (!(packageRecord.items && packageRecord.items.length > 0)) {
                _context16.next = 7;
                break;
              }

              _this23.currentPackageDetail = packageRecord;
              _context16.next = 11;
              break;

            case 7:
              _context16.next = 9;
              return _mixedPackage.mixedPackageApi.getPackageDetail({
                id: packageRecord.id,
                batchNumber: packageRecord.batchNumber,
                tracking: packageRecord.tracking
              });

            case 9:
              response = _context16.sent;

              if (response && (response.code === 200 || response.code === '200')) {
                _this23.currentPackageDetail = response.result;
              } else {
                _this23.$message.error(response.msg || 'Failed to load package detail');
                _this23.batchDetailDialogVisible = false;
              }

            case 11:
              _context16.next = 17;
              break;

            case 13:
              _context16.prev = 13;
              _context16.t0 = _context16['catch'](0);

              _this23.$message.error('Error loading package detail: ' + _context16.t0.message);
              _this23.batchDetailDialogVisible = false;

            case 17:
              _context16.prev = 17;

              _this23.batchDetailLoading = false;
              return _context16.finish(17);

            case 20:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this23, [[0, 13, 17, 20]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'refreshPendingPackageDetail', function refreshPendingPackageDetail() {
    var _this24 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17() {
      return _regenerator2.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              if (!_this24.currentPackageDetail) {
                _context17.next = 3;
                break;
              }

              _context17.next = 3;
              return _this24.viewPendingPackageDetail(_this24.currentPackageDetail);

            case 3:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this24);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'handleUPCSelectionChange', function handleUPCSelectionChange(selection) {
    this.selectedUPCs = selection;
  }), (0, _defineProperty3.default)(_methods, 'editSingleUPC', function editSingleUPC(upcItem, index) {
    var _this25 = this;

    this.$nextTick(function () {
      if (_this25.$refs.editUPCForm) {
        _this25.$refs.editUPCForm.clearValidate();
      }
    });

    this.editUPCForm = {
      upc: upcItem.upc,
      quantity: upcItem.quantity,
      originalUpc: upcItem.upc,
      originalQuantity: upcItem.quantity
    };
    this.editingUPCIndex = index;
    this.editUPCDialog = true;
  }), (0, _defineProperty3.default)(_methods, 'cancelUPCEdit', function cancelUPCEdit() {
    var _this26 = this;

    this.editUPCDialog = false;

    this.editingUPCIndex = -1;
    this.editUPCForm = {
      upc: '',
      quantity: 1,
      originalUpc: '',
      originalQuantity: 1
    };

    this.$nextTick(function () {
      if (_this26.$refs.editUPCForm) {
        _this26.$refs.editUPCForm.clearValidate();
      }
    });
  }), (0, _defineProperty3.default)(_methods, 'saveUPCEdit', function saveUPCEdit() {
    var _this27 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19() {
      var editParams, response, updatedItems;
      return _regenerator2.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return _this27.$refs.editUPCForm.validate();

            case 3:
              if (!(_this27.editUPCForm.upc === _this27.editUPCForm.originalUpc && _this27.editUPCForm.quantity === _this27.editUPCForm.originalQuantity)) {
                _context19.next = 7;
                break;
              }

              _this27.$message.info('No changes detected');
              _this27.editUPCDialog = false;
              return _context19.abrupt('return');

            case 7:

              _this27.savingUPCEdit = true;

              editParams = {
                batchNumber: _this27.currentPackageDetail.batchNumber,
                tracking: _this27.currentPackageDetail.tracking,
                originalUPC: _this27.editUPCForm.originalUpc,
                originalQuantity: _this27.editUPCForm.originalQuantity,
                newUPC: _this27.editUPCForm.upc,
                newQuantity: _this27.editUPCForm.quantity
              };
              _context19.next = 11;
              return _mixedPackage.mixedPackageApi.editUPCInPackage(editParams);

            case 11:
              response = _context19.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                _this27.$message.success('UPC edited successfully');

                if (_this27.currentPackageDetail && _this27.currentPackageDetail.items && _this27.editingUPCIndex >= 0) {
                  updatedItems = [].concat((0, _toConsumableArray3.default)(_this27.currentPackageDetail.items));

                  updatedItems[_this27.editingUPCIndex] = (0, _extends3.default)({}, updatedItems[_this27.editingUPCIndex], {
                    upc: _this27.editUPCForm.upc,
                    quantity: _this27.editUPCForm.quantity
                  });

                  _this27.$set(_this27.currentPackageDetail, 'items', updatedItems);

                  _this27.$forceUpdate();
                }

                _this27.editUPCDialog = false;

                _this27.editingUPCIndex = -1;
                _this27.editUPCForm = {
                  upc: '',
                  quantity: 1,
                  originalUpc: '',
                  originalQuantity: 1
                };

                setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18() {
                  return _regenerator2.default.wrap(function _callee18$(_context18) {
                    while (1) {
                      switch (_context18.prev = _context18.next) {
                        case 0:
                          _context18.next = 2;
                          return _this27.refreshPendingPackageDetail();

                        case 2:
                        case 'end':
                          return _context18.stop();
                      }
                    }
                  }, _callee18, _this27);
                })), 500);
              } else {
                _this27.$message.error(response.msg || 'Failed to edit UPC');
              }

              _context19.next = 20;
              break;

            case 15:
              _context19.prev = 15;
              _context19.t0 = _context19['catch'](0);

              if (!_context19.t0.message) {
                _context19.next = 19;
                break;
              }

              return _context19.abrupt('return');

            case 19:
              _this27.$message.error('Edit failed: ' + (_context19.t0.message || _context19.t0));

            case 20:
              _context19.prev = 20;

              _this27.savingUPCEdit = false;
              return _context19.finish(20);

            case 23:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this27, [[0, 15, 20, 23]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'deleteSingleUPC', function deleteSingleUPC(upcItem, index) {
    var _this28 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20() {
      return _regenerator2.default.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return _this28.$confirm('Are you sure to delete this UPC item?\n\nUPC: ' + upcItem.upc + '\nQuantity: ' + upcItem.quantity + '\nProduct: ' + (upcItem.productName || 'N/A') + '\n\nThis action cannot be undone.', 'Confirm Delete UPC', {
                confirmButtonText: 'Yes, Delete',
                cancelButtonText: 'Cancel',
                type: 'warning',
                dangerouslyUseHTMLString: true
              });

            case 3:
              _context20.next = 5;
              return _this28.deleteUPCFromPackage([upcItem]);

            case 5:
              _context20.next = 10;
              break;

            case 7:
              _context20.prev = 7;
              _context20.t0 = _context20['catch'](0);

              if (_context20.t0 !== 'cancel') {}

            case 10:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this28, [[0, 7]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'bulkDeleteUPCs', function bulkDeleteUPCs() {
    var _this29 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21() {
      var upcList;
      return _regenerator2.default.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              if (!(_this29.selectedUPCs.length === 0)) {
                _context21.next = 3;
                break;
              }

              _this29.$message.warning('Please select UPC items to delete');
              return _context21.abrupt('return');

            case 3:
              _context21.prev = 3;
              upcList = _this29.selectedUPCs.map(function (item) {
                return item.upc + ' (' + item.quantity + ')';
              }).join('\n');
              _context21.next = 7;
              return _this29.$confirm('Are you sure to delete ' + _this29.selectedUPCs.length + ' UPC item(s)?\n\n' + upcList + '\n\nThis action cannot be undone.', 'Confirm Bulk Delete', {
                confirmButtonText: 'Yes, Delete All',
                cancelButtonText: 'Cancel',
                type: 'warning',
                dangerouslyUseHTMLString: true
              });

            case 7:
              _context21.next = 9;
              return _this29.deleteUPCFromPackage(_this29.selectedUPCs);

            case 9:
              _context21.next = 14;
              break;

            case 11:
              _context21.prev = 11;
              _context21.t0 = _context21['catch'](3);

              if (_context21.t0 !== 'cancel') {}

            case 14:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this29, [[3, 11]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'deleteUPCFromPackage', function deleteUPCFromPackage(upcItems) {
    var _this30 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee23() {
      var loading, deleteParams, response, result, message, deletedUPCs;
      return _regenerator2.default.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              loading = _this30.$loading({
                lock: true,
                text: 'Deleting ' + upcItems.length + ' UPC item(s)...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context23.prev = 1;
              deleteParams = {
                batchNumber: _this30.currentPackageDetail.batchNumber,
                tracking: _this30.currentPackageDetail.tracking,
                upcItems: upcItems.map(function (item) {
                  return {
                    upc: item.upc,
                    quantity: item.quantity
                  };
                })
              };
              _context23.next = 5;
              return _mixedPackage.mixedPackageApi.deleteUPCFromPackage(deleteParams);

            case 5:
              response = _context23.sent;

              if (!(response && (response.code === 200 || response.code === '200'))) {
                _context23.next = 24;
                break;
              }

              result = response.result;
              message = 'Successfully deleted ' + result.deletedCount + '/' + result.requestedCount + ' UPC item(s)';


              if (result.deletedCount < result.requestedCount) {
                message += '\nNote: ' + (result.requestedCount - result.deletedCount) + ' item(s) were not found or already deleted';
              }

              if (result.warning) {
                message += '\n\u26A0\uFE0F ' + result.warning;
              }

              _this30.$message.success(message);

              if (!(_this30.currentPackageDetail && _this30.currentPackageDetail.items)) {
                _context23.next = 22;
                break;
              }

              deletedUPCs = upcItems.map(function (item) {
                return item.upc;
              });

              _this30.currentPackageDetail.items = _this30.currentPackageDetail.items.filter(function (item) {
                return !deletedUPCs.includes(item.upc);
              });

              _this30.currentPackageDetail.itemCount = _this30.currentPackageDetail.items.length;

              if (!(_this30.currentPackageDetail.items.length === 0)) {
                _context23.next = 21;
                break;
              }

              _this30.$message.success('All UPC items have been deleted. The package has been automatically removed from pending list.');

              _this30.batchDetailDialogVisible = false;

              _this30.$nextTick(function () {
                _this30.getPendingPackages();
              });

              return _context23.abrupt('return');

            case 21:
              _this30.$forceUpdate();

            case 22:
              _context23.next = 25;
              break;

            case 24:
              throw new Error(response.msg || 'Delete UPC failed');

            case 25:
              _this30.selectedUPCs = [];
              if (_this30.$refs.upcTable) {
                _this30.$refs.upcTable.clearSelection();
              }

              _this30.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee22() {
                return _regenerator2.default.wrap(function _callee22$(_context22) {
                  while (1) {
                    switch (_context22.prev = _context22.next) {
                      case 0:
                        _context22.next = 2;
                        return _this30.refreshPendingPackageDetail();

                      case 2:
                      case 'end':
                        return _context22.stop();
                    }
                  }
                }, _callee22, _this30);
              })));

              _context23.next = 33;
              break;

            case 30:
              _context23.prev = 30;
              _context23.t0 = _context23['catch'](1);

              _this30.$message.error('Delete failed: ' + (_context23.t0.message || _context23.t0));

            case 33:
              _context23.prev = 33;

              loading.close();
              return _context23.finish(33);

            case 36:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this30, [[1, 30, 33, 36]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'confirmBatchFromDetail', function confirmBatchFromDetail() {
    var _this31 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee24() {
      return _regenerator2.default.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              if (!_this31.currentPackageDetail) {
                _context24.next = 4;
                break;
              }

              _context24.next = 3;
              return _this31.confirmSinglePackage(_this31.currentPackageDetail);

            case 3:
              _this31.batchDetailDialogVisible = false;

            case 4:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this31);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'reversePackage', function reversePackage(packageId) {
    var _this32 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee25() {
      var response;
      return _regenerator2.default.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.prev = 0;
              _context25.next = 3;
              return _this32.$confirm('Are you sure to reverse this package?', 'Confirm', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
              });

            case 3:
              _context25.next = 5;
              return _mixedPackage.mixedPackageApi.reverseByPackageId({ packageId: packageId });

            case 5:
              response = _context25.sent;

              if (response && (response.code === 200 || response.code === '200')) {
                _this32.$message.success('Package reversed successfully');
                _this32.getMixedPackageList();
              } else {
                _this32.$message.error(response.message || response.msg || 'Failed to reverse package');
              }
              _context25.next = 12;
              break;

            case 9:
              _context25.prev = 9;
              _context25.t0 = _context25['catch'](0);

              if (_context25.t0 !== 'cancel') {
                _this32.$message.error('Error reversing package: ' + _context25.t0.message);
              }

            case 12:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this32, [[0, 9]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'viewPackageDetail', function viewPackageDetail(row) {
    var _this33 = this;

    if (!row.mixedPackageId) {
      this.$message.error('Package ID not found');
      return;
    }

    this.packageDetailLoading = true;

    _mixedPackage.mixedPackageApi.getMixedPackageDetail(row.mixedPackageId).then(function (res) {
      _this33.packageDetailLoading = false;

      if (res.code === 200 || res.code === '200') {
        _this33.currentPackageDetail = res.result || res.data;
        _this33.packageDetailDialogVisible = true;
      } else {
        _this33.$message.error(res.message || res.msg || 'Failed to load package details');
      }
    }).catch(function (err) {
      _this33.packageDetailLoading = false;
      _this33.$message.error(err.message || 'Failed to load package details');
    });
  }), (0, _defineProperty3.default)(_methods, 'approveSingleClaim', function approveSingleClaim(claim) {
    var _this34 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee26() {
      var response;
      return _regenerator2.default.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;
              _context26.next = 3;
              return _this34.$confirm('Are you sure to approve this claim?', 'Confirm', {
                confirmButtonText: 'Approve',
                cancelButtonText: 'Cancel',
                type: 'warning'
              });

            case 3:
              _context26.next = 5;
              return _mixedPackage.mixedPackageApi.approveClaim(claim.claimId);

            case 5:
              response = _context26.sent;

              if (response && (response.code === 200 || response.code === '200')) {
                _this34.$message.success('Claim approved successfully');
                _this34.getClaimList();
              } else {
                _this34.$message.error(response.msg || 'Failed to approve claim');
              }
              _context26.next = 12;
              break;

            case 9:
              _context26.prev = 9;
              _context26.t0 = _context26['catch'](0);

              if (_context26.t0 !== 'cancel') {
                _this34.$message.error('Error approving claim: ' + _context26.t0.message);
              }

            case 12:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, _this34, [[0, 9]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'distributeSingleClaim', function distributeSingleClaim(claim) {
    var _this35 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee27() {
      var response;
      return _regenerator2.default.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.prev = 0;
              _context27.next = 3;
              return _this35.$confirm('Are you sure to distribute this claim to inventory?', 'Confirm Distribution', {
                confirmButtonText: 'Distribute',
                cancelButtonText: 'Cancel',
                type: 'warning'
              });

            case 3:
              _context27.next = 5;
              return _mixedPackage.mixedPackageApi.batchDistribute({
                claimIds: [claim.claimId]
              });

            case 5:
              response = _context27.sent;

              if (response && (response.code === 200 || response.code === '200')) {
                _this35.$message.success('Claim distributed successfully');
                _this35.getClaimList();
                _this35.getMixedPackageList();
              } else {
                _this35.showFormattedError(response.msg || 'Failed to distribute claim', 'Distribute Failed');
              }
              _context27.next = 12;
              break;

            case 9:
              _context27.prev = 9;
              _context27.t0 = _context27['catch'](0);

              if (_context27.t0 !== 'cancel') {
                _this35.showFormattedError('Error distributing claim: ' + _context27.t0.message, 'Distribute Error');
              }

            case 12:
            case 'end':
              return _context27.stop();
          }
        }
      }, _callee27, _this35, [[0, 9]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showAdjustClaim', function showAdjustClaim(claim) {
    this.currentClaimForAdjust = claim;
    this.adjustForm.newQuantity = claim.claimedQty;
    this.adjustForm.adjustReason = '';
    this.adjustClaimDialogVisible = true;
  }), (0, _defineProperty3.default)(_methods, 'executeAdjustClaim', function executeAdjustClaim() {
    var _this36 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee28() {
      var response;
      return _regenerator2.default.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.prev = 0;
              _context28.next = 3;
              return _this36.$refs.adjustForm.validate();

            case 3:

              _this36.adjusting = true;
              _context28.next = 6;
              return _mixedPackage.mixedPackageApi.adjustClaimQuantity(_this36.currentClaimForAdjust.claimId, {
                newQuantity: _this36.adjustForm.newQuantity,
                adjustReason: _this36.adjustForm.adjustReason
              });

            case 6:
              response = _context28.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                _this36.$message.success('Claim quantity adjusted successfully');
                _this36.adjustClaimDialogVisible = false;
                _this36.getClaimList();
              } else {
                _this36.$message.error(response.msg || 'Failed to adjust claim quantity');
              }
              _context28.next = 13;
              break;

            case 10:
              _context28.prev = 10;
              _context28.t0 = _context28['catch'](0);

              _this36.$message.error('Error adjusting claim: ' + _context28.t0.message);

            case 13:
              _context28.prev = 13;

              _this36.adjusting = false;
              return _context28.finish(13);

            case 16:
            case 'end':
              return _context28.stop();
          }
        }
      }, _callee28, _this36, [[0, 10, 13, 16]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showRejectClaim', function showRejectClaim(claim) {
    this.currentClaimForReject = claim;
    this.rejectForm.rejectReason = '';
    this.rejectClaimDialogVisible = true;
  }), (0, _defineProperty3.default)(_methods, 'executeRejectClaim', function executeRejectClaim() {
    var _this37 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee29() {
      var response;
      return _regenerator2.default.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              _context29.prev = 0;
              _context29.next = 3;
              return _this37.$refs.rejectForm.validate();

            case 3:

              _this37.rejecting = true;
              _context29.next = 6;
              return _mixedPackage.mixedPackageApi.rejectClaim(_this37.currentClaimForReject.claimId, {
                rejectReason: _this37.rejectForm.rejectReason
              });

            case 6:
              response = _context29.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                _this37.$message.success('Claim rejected successfully');
                _this37.rejectClaimDialogVisible = false;
                _this37.getClaimList();
              } else {
                _this37.$message.error(response.msg || 'Failed to reject claim');
              }
              _context29.next = 13;
              break;

            case 10:
              _context29.prev = 10;
              _context29.t0 = _context29['catch'](0);

              _this37.$message.error('Error rejecting claim: ' + _context29.t0.message);

            case 13:
              _context29.prev = 13;

              _this37.rejecting = false;
              return _context29.finish(13);

            case 16:
            case 'end':
              return _context29.stop();
          }
        }
      }, _callee29, _this37, [[0, 10, 13, 16]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showBatchApprove', function showBatchApprove() {
    if (this.selectedClaims.length === 0) {
      this.$message.warning('Please select claims to approve');
      return;
    }

    var pendingClaims = this.selectedClaims.filter(function (claim) {
      return claim.claimStatus === 0;
    });
    if (pendingClaims.length === 0) {
      this.$message.warning('No pending claims selected');
      return;
    }

    if (pendingClaims.length < this.selectedClaims.length) {
      this.$message.warning('Only ' + pendingClaims.length + ' of ' + this.selectedClaims.length + ' selected claims are pending for approval');
    }

    this.selectedClaims = pendingClaims;
    this.batchApproveDialogVisible = true;
  }), (0, _defineProperty3.default)(_methods, 'executeBatchApprove', function executeBatchApprove() {
    var _this38 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee30() {
      var claimIds, response, result;
      return _regenerator2.default.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _this38.batchApproving = true;
              _context30.prev = 1;
              claimIds = _this38.selectedClaims.map(function (claim) {
                return claim.claimId;
              });
              _context30.next = 5;
              return _mixedPackage.mixedPackageApi.batchApprove({ claimIds: claimIds });

            case 5:
              response = _context30.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                result = response.result;

                _this38.$message.success('Batch approval completed! Approved: ' + result.successCount + ', Failed: ' + result.failedCount);
                _this38.batchApproveDialogVisible = false;
                _this38.getClaimList();
              } else {
                _this38.$message.error(response.msg || 'Batch approval failed');
              }
              _context30.next = 12;
              break;

            case 9:
              _context30.prev = 9;
              _context30.t0 = _context30['catch'](1);

              _this38.$message.error('Batch approval error: ' + _context30.t0.message);

            case 12:
              _context30.prev = 12;

              _this38.batchApproving = false;
              return _context30.finish(12);

            case 15:
            case 'end':
              return _context30.stop();
          }
        }
      }, _callee30, _this38, [[1, 9, 12, 15]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showBatchDistribute', function showBatchDistribute() {
    if (this.selectedClaims.length === 0) {
      this.$message.warning('Please select claims to distribute');
      return;
    }

    var approvedClaims = this.selectedClaims.filter(function (claim) {
      return claim.claimStatus === 1;
    });
    if (approvedClaims.length === 0) {
      this.$message.warning('No approved claims selected');
      return;
    }

    if (approvedClaims.length < this.selectedClaims.length) {
      this.$message.warning('Only ' + approvedClaims.length + ' of ' + this.selectedClaims.length + ' selected claims are approved for distribution');
    }

    this.selectedClaims = approvedClaims;
    this.batchDistributeDialogVisible = true;
  }), (0, _defineProperty3.default)(_methods, 'executeBatchDistribute', function executeBatchDistribute() {
    var _this39 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee31() {
      var claimIds, response, result;
      return _regenerator2.default.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _this39.batchDistributing = true;
              _context31.prev = 1;
              claimIds = _this39.selectedClaims.map(function (claim) {
                return claim.claimId;
              });
              _context31.next = 5;
              return _mixedPackage.mixedPackageApi.batchDistribute({
                claimIds: claimIds
              });

            case 5:
              response = _context31.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                result = response.result;

                _this39.$message.success('Batch distribution completed! Distributed: ' + result.successCount + ', Failed: ' + result.failedCount);
                _this39.batchDistributeDialogVisible = false;
                _this39.getClaimList();
                _this39.getMixedPackageList();
              } else {
                _this39.$message.error(response.msg || 'Batch distribution failed');
              }
              _context31.next = 12;
              break;

            case 9:
              _context31.prev = 9;
              _context31.t0 = _context31['catch'](1);

              _this39.$message.error('Batch distribution error: ' + _context31.t0.message);

            case 12:
              _context31.prev = 12;

              _this39.batchDistributing = false;
              return _context31.finish(12);

            case 15:
            case 'end':
              return _context31.stop();
          }
        }
      }, _callee31, _this39, [[1, 9, 12, 15]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showSetForceChargeTime', function showSetForceChargeTime() {
    if (this.selectedClaims.length === 0) {
      this.$message.warning('Please select claims to set force charge time');
      return;
    }

    this.forceChargeForm.forceChargeTime = '';
    this.forceChargeForm.reason = '';
    this.forceChargeTimeDialogVisible = true;
  }), (0, _defineProperty3.default)(_methods, 'executeSetForceChargeTime', function executeSetForceChargeTime() {
    var _this40 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee32() {
      var claimIds, response;
      return _regenerator2.default.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.prev = 0;
              _context32.next = 3;
              return _this40.$refs.forceChargeForm.validate();

            case 3:

              _this40.settingForceCharge = true;
              claimIds = _this40.selectedClaims.map(function (claim) {
                return claim.claimId;
              });
              _context32.next = 7;
              return _mixedPackage.mixedPackageApi.setForceChargeTime({
                claimIds: claimIds,
                forceChargeTime: _this40.forceChargeForm.forceChargeTime,
                reason: _this40.forceChargeForm.reason
              });

            case 7:
              response = _context32.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                _this40.$message.success('Force charge time set successfully');
                _this40.forceChargeTimeDialogVisible = false;
                _this40.getClaimList();
              } else {
                _this40.$message.error(response.msg || 'Failed to set force charge time');
              }
              _context32.next = 14;
              break;

            case 11:
              _context32.prev = 11;
              _context32.t0 = _context32['catch'](0);

              _this40.$message.error('Error setting force charge time: ' + _context32.t0.message);

            case 14:
              _context32.prev = 14;

              _this40.settingForceCharge = false;
              return _context32.finish(14);

            case 17:
            case 'end':
              return _context32.stop();
          }
        }
      }, _callee32, _this40, [[0, 11, 14, 17]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showBulkReverse', function showBulkReverse() {
    var _this41 = this;

    if (!this.selectedPackages || this.selectedPackages.length === 0) {
      this.$message.warning('Please select packages to reverse');
      return;
    }

    var reversiblePackages = this.selectedPackages;

    var actionDescription = 'This will process each package according to its type:';
    actionDescription += '\n• Manual packages: Direct deletion';
    actionDescription += '\n• Batch imported packages: Restore to pending batch';
    actionDescription += '\n• Packages with claims: Reverse claims and inventory';

    var message = 'Are you sure to reverse ' + reversiblePackages.length + ' package(s)?\n\n' + actionDescription + '\n\nThis action cannot be undone.';

    this.$confirm(message, 'Confirm Bulk Reverse', {
      type: 'warning',
      confirmButtonText: 'Yes, Reverse All',
      cancelButtonText: 'Cancel'
    }).then(function () {
      _this41.executeBulkReverse(reversiblePackages);
    }).catch(function () {});
  }), (0, _defineProperty3.default)(_methods, 'executeBulkReverse', function executeBulkReverse(packages) {
    var _this42 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee33() {
      var loading, successCount, failedCount, failedPackages, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, pkg, response, errorMsg, errorList;

      return _regenerator2.default.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              loading = _this42.$loading({
                lock: true,
                text: 'Reversing ' + packages.length + ' packages...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              successCount = 0;
              failedCount = 0;
              failedPackages = [];
              _context33.prev = 4;
              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context33.prev = 8;
              _iterator5 = (0, _getIterator3.default)(packages);

            case 10:
              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                _context33.next = 28;
                break;
              }

              pkg = _step5.value;
              _context33.prev = 12;

              console.log('Processing package: ' + pkg.tracking + ', ID: ' + pkg.mixedPackageId);
              _context33.next = 16;
              return _mixedPackage.mixedPackageApi.reverseByPackageId({
                packageId: pkg.mixedPackageId
              });

            case 16:
              response = _context33.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                successCount++;
                console.log('Package ' + pkg.tracking + ' reversed successfully');
              } else {
                failedCount++;
                errorMsg = response.message || response.msg || 'Unknown error';

                console.log('Package ' + pkg.tracking + ' failed: ' + errorMsg);
                failedPackages.push({
                  tracking: pkg.tracking,
                  error: errorMsg
                });
              }
              _context33.next = 25;
              break;

            case 20:
              _context33.prev = 20;
              _context33.t0 = _context33['catch'](12);

              failedCount++;
              console.log('Package ' + pkg.tracking + ' error: ' + _context33.t0.message);
              failedPackages.push({
                tracking: pkg.tracking,
                error: _context33.t0.message || 'Network or system error'
              });

            case 25:
              _iteratorNormalCompletion5 = true;
              _context33.next = 10;
              break;

            case 28:
              _context33.next = 34;
              break;

            case 30:
              _context33.prev = 30;
              _context33.t1 = _context33['catch'](8);
              _didIteratorError5 = true;
              _iteratorError5 = _context33.t1;

            case 34:
              _context33.prev = 34;
              _context33.prev = 35;

              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }

            case 37:
              _context33.prev = 37;

              if (!_didIteratorError5) {
                _context33.next = 40;
                break;
              }

              throw _iteratorError5;

            case 40:
              return _context33.finish(37);

            case 41:
              return _context33.finish(34);

            case 42:

              loading.close();

              if (successCount > 0) {
                _this42.$message.success('Bulk reverse completed! Success: ' + successCount + ', Failed: ' + failedCount);
                _this42.getMixedPackageList();
              }

              if (failedCount > 0) {
                errorList = failedPackages.map(function (fp, index) {
                  return index + 1 + '. Tracking: ' + fp.tracking + '\n   Error: ' + fp.error;
                }).join('\n\n');


                _this42.$msgbox({
                  title: 'Bulk Reverse Failed (' + failedCount + ' packages)',
                  message: errorList,
                  type: 'error',
                  showClose: true,
                  closeOnClickModal: true,
                  confirmButtonText: 'OK'
                }).catch(function () {});

                _this42.$message.warning(failedCount + ' packages failed to reverse. See details above.');
              }

              _context33.next = 51;
              break;

            case 47:
              _context33.prev = 47;
              _context33.t2 = _context33['catch'](4);

              loading.close();
              _this42.$message.error('Bulk reverse error: ' + _context33.t2.message);

            case 51:
            case 'end':
              return _context33.stop();
          }
        }
      }, _callee33, _this42, [[4, 47], [8, 30, 34, 42], [12, 20], [35,, 37, 41]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showBatchBulkReverse', function showBatchBulkReverse() {
    var _this43 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee34() {
      return _regenerator2.default.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              _context34.prev = 0;
              _context34.next = 3;
              return _this43.getAvailableBatchNumbers();

            case 3:
              _this43.selectedBatchNumber = '';
              _this43.batchPackagesList = [];
              _this43.batchBulkReverseDialogVisible = true;
              _context34.next = 11;
              break;

            case 8:
              _context34.prev = 8;
              _context34.t0 = _context34['catch'](0);

              _this43.$message.error('Failed to load batch numbers: ' + _context34.t0.message);

            case 11:
            case 'end':
              return _context34.stop();
          }
        }
      }, _callee34, _this43, [[0, 8]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'getAvailableBatchNumbers', function getAvailableBatchNumbers() {
    var _this44 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee35() {
      var response;
      return _regenerator2.default.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              _context35.prev = 0;
              _context35.next = 3;
              return _mixedPackage.mixedPackageApi.getBatchNumbers({});

            case 3:
              response = _context35.sent;

              if (!(response && (response.code === 200 || response.code === '200'))) {
                _context35.next = 8;
                break;
              }

              _this44.availableBatchNumbers = response.result || [];
              _context35.next = 9;
              break;

            case 8:
              throw new Error(response.message || response.msg || 'Failed to get batch numbers');

            case 9:
              _context35.next = 14;
              break;

            case 11:
              _context35.prev = 11;
              _context35.t0 = _context35['catch'](0);
              throw _context35.t0;

            case 14:
            case 'end':
              return _context35.stop();
          }
        }
      }, _callee35, _this44, [[0, 11]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'changeBatchNumberForBulkReverse', function changeBatchNumberForBulkReverse() {
    var _this45 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee36() {
      var response;
      return _regenerator2.default.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              if (_this45.selectedBatchNumber) {
                _context36.next = 3;
                break;
              }

              _this45.batchPackagesList = [];
              return _context36.abrupt('return');

            case 3:

              _this45.batchPackagesLoading = true;
              _context36.prev = 4;
              _context36.next = 7;
              return _mixedPackage.mixedPackageApi.getPackagesByBatchNumber({
                batchNumber: _this45.selectedBatchNumber
              });

            case 7:
              response = _context36.sent;

              if (!(response && (response.code === 200 || response.code === '200'))) {
                _context36.next = 12;
                break;
              }

              _this45.batchPackagesList = response.result || [];
              _context36.next = 13;
              break;

            case 12:
              throw new Error(response.message || response.msg || 'Failed to get packages');

            case 13:
              _context36.next = 19;
              break;

            case 15:
              _context36.prev = 15;
              _context36.t0 = _context36['catch'](4);

              _this45.$message.error('Failed to load packages: ' + _context36.t0.message);
              _this45.batchPackagesList = [];

            case 19:
              _context36.prev = 19;

              _this45.batchPackagesLoading = false;
              return _context36.finish(19);

            case 22:
            case 'end':
              return _context36.stop();
          }
        }
      }, _callee36, _this45, [[4, 15, 19, 22]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'executeBatchBulkReverse', function executeBatchBulkReverse() {
    var _this46 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee37() {
      var confirmMessage, response, result;
      return _regenerator2.default.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              if (!(!_this46.selectedBatchNumber || _this46.batchPackagesList.length === 0)) {
                _context37.next = 3;
                break;
              }

              _this46.$message.warning('Please select a batch and ensure there are packages to reverse');
              return _context37.abrupt('return');

            case 3:
              confirmMessage = 'Are you sure to reverse ALL ' + _this46.batchPackagesList.length + ' package(s) in batch "' + _this46.selectedBatchNumber + '"?\n\nThis will:\n- Cancel all mixed packages in this batch\n- Release all claimed items back to inventory\n- Remove all package records from the system\n\nThis action cannot be undone.';
              _context37.prev = 4;
              _context37.next = 7;
              return _this46.$confirm(confirmMessage, 'Confirm Batch Bulk Reverse', {
                type: 'warning',
                confirmButtonText: 'Yes, Reverse All',
                cancelButtonText: 'Cancel'
              });

            case 7:

              _this46.batchBulkReverseLoading = true;

              _context37.next = 10;
              return _mixedPackage.mixedPackageApi.batchBulkReverse({
                batchNumber: _this46.selectedBatchNumber
              });

            case 10:
              response = _context37.sent;

              if (!(response && (response.code === 200 || response.code === '200'))) {
                _context37.next = 19;
                break;
              }

              result = response.result;

              _this46.$message.success('Batch bulk reverse completed! Reversed: ' + (result.successCount || _this46.batchPackagesList.length) + ' packages');

              _this46.batchBulkReverseDialogVisible = false;
              _this46.getMixedPackageList();

              if (_this46.activeTabName === 'pending') {
                _this46.getPendingPackages();
              }
              _context37.next = 20;
              break;

            case 19:
              throw new Error(response.message || response.msg || 'Batch reverse failed');

            case 20:
              _context37.next = 25;
              break;

            case 22:
              _context37.prev = 22;
              _context37.t0 = _context37['catch'](4);

              if (_context37.t0 !== 'cancel') {
                _this46.$message.error('Batch bulk reverse error: ' + _context37.t0.message);
              }

            case 25:
              _context37.prev = 25;

              _this46.batchBulkReverseLoading = false;
              return _context37.finish(25);

            case 28:
            case 'end':
              return _context37.stop();
          }
        }
      }, _callee37, _this46, [[4, 22, 25, 28]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showEditUPCQty', function showEditUPCQty(detailRow) {
    this.editMixedPackageUPCQtyForm = {
      detailId: detailRow.detailId,
      mixedPackageId: this.currentPackageDetail.mixedPackageId,
      upc: detailRow.upc,
      productName: detailRow.productName,
      currentTotalQty: detailRow.totalQty,
      claimedQty: detailRow.claimedQty,
      newTotalQty: detailRow.totalQty,
      reason: ''
    };
    this.editMixedPackageUPCQtyDialog = true;
  }), (0, _defineProperty3.default)(_methods, 'confirmEditMixedPackageUPCQty', function confirmEditMixedPackageUPCQty() {
    var _this47 = this;

    this.$refs.editMixedPackageUPCQtyForm.validate(function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee38(valid) {
        var _editMixedPackageUPCQ, newTotalQty, currentTotalQty, claimedQty, detailId, params, response;

        return _regenerator2.default.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (valid) {
                  _context38.next = 2;
                  break;
                }

                return _context38.abrupt('return');

              case 2:
                _editMixedPackageUPCQ = _this47.editMixedPackageUPCQtyForm, newTotalQty = _editMixedPackageUPCQ.newTotalQty, currentTotalQty = _editMixedPackageUPCQ.currentTotalQty, claimedQty = _editMixedPackageUPCQ.claimedQty, detailId = _editMixedPackageUPCQ.detailId;

                if (!(newTotalQty < claimedQty)) {
                  _context38.next = 6;
                  break;
                }

                _this47.$message.error('New total quantity (' + newTotalQty + ') cannot be less than claimed quantity (' + claimedQty + ')');
                return _context38.abrupt('return');

              case 6:
                if (!(newTotalQty === currentTotalQty)) {
                  _context38.next = 9;
                  break;
                }

                _this47.$message.warning('Quantity has not changed');
                return _context38.abrupt('return');

              case 9:
                _context38.prev = 9;

                _this47.editingMixedPackageUPCQty = true;

                params = {
                  detailId: detailId,
                  newTotalQty: newTotalQty
                };
                _context38.next = 14;
                return _mixedPackage.mixedPackageApi.updateMixedPackageUPCQty(params);

              case 14:
                response = _context38.sent;

                if (!(response && (response.code === 200 || response.code === '200'))) {
                  _context38.next = 22;
                  break;
                }

                _this47.$message.success('UPC quantity updated successfully');
                _this47.editMixedPackageUPCQtyDialog = false;

                _context38.next = 20;
                return _this47.refreshMixedPackageDetail();

              case 20:
                _context38.next = 23;
                break;

              case 22:
                throw new Error(response.message || response.msg || 'Update failed');

              case 23:
                _context38.next = 28;
                break;

              case 25:
                _context38.prev = 25;
                _context38.t0 = _context38['catch'](9);

                _this47.$message.error('Update error: ' + _context38.t0.message);

              case 28:
                _context38.prev = 28;

                _this47.editingMixedPackageUPCQty = false;
                return _context38.finish(28);

              case 31:
              case 'end':
                return _context38.stop();
            }
          }
        }, _callee38, _this47, [[9, 25, 28, 31]]);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());
  }), (0, _defineProperty3.default)(_methods, 'exportPendingBatches', function exportPendingBatches() {
    var _this48 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee39() {
      var loading, exportParams, blob, url, link, now, timestamp;
      return _regenerator2.default.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              loading = _this48.$loading({
                lock: true,
                text: '正在导出待确认批次数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context39.prev = 1;
              exportParams = {
                batchFilter: _this48.filters.batchFilter,
                trackingFilter: _this48.filters.trackingFilter
              };
              _context39.next = 5;
              return _mixedPackage.mixedPackageApi.exportPendingBatches(exportParams);

            case 5:
              blob = _context39.sent;
              url = window.URL.createObjectURL(blob);
              link = document.createElement('a');

              link.style.display = 'none';
              link.href = url;

              now = new Date();
              timestamp = now.toISOString().slice(0, 19).replace(/[:T]/g, '-');

              link.download = 'pending_batches_' + timestamp + '.xls';

              document.body.appendChild(link);
              link.click();

              setTimeout(function () {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              }, 100);

              _this48.$message.success('导出成功！文件已开始下载');
              _context39.next = 23;
              break;

            case 19:
              _context39.prev = 19;
              _context39.t0 = _context39['catch'](1);

              console.error('Export pending batches error:', _context39.t0);
              _this48.$message.error('导出失败: ' + (_context39.t0.message || '未知错误'));

            case 23:
              _context39.prev = 23;

              loading.close();
              return _context39.finish(23);

            case 26:
            case 'end':
              return _context39.stop();
          }
        }
      }, _callee39, _this48, [[1, 19, 23, 26]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'exportPackages', function exportPackages() {
    this.$message.info('Export packages');
  }), (0, _defineProperty3.default)(_methods, 'exportClaims', function exportClaims() {
    this.$message.info('Export claims');
  }), (0, _defineProperty3.default)(_methods, 'exportUnclaimed', function exportUnclaimed() {
    var _this49 = this;

    var loading = this.$loading({
      lock: true,
      text: 'Exporting unclaimed items...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });

    var params = (0, _extends3.default)({}, this.unclaimedFilters);

    _mixedPackage.mixedPackageApi.exportUnclaimedItems(params).then(function (data) {
      loading.close();

      var blob = new Blob([data], { type: "application/vnd.ms-excel" });

      var now = new Date();
      var timestamp = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + '_' + String(now.getHours()).padStart(2, '0') + String(now.getMinutes()).padStart(2, '0');

      var fileName = 'unclaimed_items_' + timestamp + '.xlsx';

      if ('download' in document.createElement('a')) {
        var elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } else {
        navigator.msSaveBlob(blob, fileName);
      }

      _this49.$message.success('Export completed successfully');
    }).catch(function (error) {
      loading.close();
      _this49.$message.error('Export failed. Please try again.');
    });
  }), (0, _defineProperty3.default)(_methods, 'confirmSingleBatch', function confirmSingleBatch(batchNumber) {
    var _this50 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee40() {
      var response, result;
      return _regenerator2.default.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              _context40.prev = 0;
              _context40.next = 3;
              return _this50.$confirm('Are you sure to confirm this batch?', 'Confirm', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
              });

            case 3:
              _context40.next = 5;
              return _mixedPackage.mixedPackageApi.bulkConfirmBatch({ batchNumber: batchNumber });

            case 5:
              response = _context40.sent;

              if (response && (response.code === 200 || response.code === '200')) {
                result = response.result;

                _this50.$message.success('Batch confirmed! Created ' + result.successCount + ' packages, ' + result.failedCount + ' failed');
                _this50.getPendingPackages();
                _this50.getAvailableBatches();
              } else {
                _this50.$message.error(response.msg || 'Failed to confirm batch');
              }
              _context40.next = 12;
              break;

            case 9:
              _context40.prev = 9;
              _context40.t0 = _context40['catch'](0);

              if (_context40.t0 !== 'cancel') {
                _this50.$message.error('Error confirming batch: ' + _context40.t0.message);
              }

            case 12:
            case 'end':
              return _context40.stop();
          }
        }
      }, _callee40, _this50, [[0, 9]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'confirmSinglePackage', function confirmSinglePackage(packageRecord) {
    var _this51 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee41() {
      var response;
      return _regenerator2.default.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              _context41.prev = 0;
              _context41.next = 3;
              return _this51.$confirm('Are you sure to confirm this package?', 'Confirm', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
              });

            case 3:
              _context41.next = 5;
              return _mixedPackage.mixedPackageApi.confirmSinglePackage({
                id: packageRecord.id,
                batchNumber: packageRecord.batchNumber,
                tracking: packageRecord.tracking
              });

            case 5:
              response = _context41.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                _this51.$message.success('Package confirmed successfully!');
                _this51.getPendingPackages();
                _this51.getAvailableBatches();
              } else {
                _this51.$message.error(response.msg || response.message || 'Failed to confirm package');
              }
              _context41.next = 12;
              break;

            case 9:
              _context41.prev = 9;
              _context41.t0 = _context41['catch'](0);

              if (_context41.t0 !== 'cancel') {
                _this51.$message.error('Error confirming package: ' + _context41.t0.message);
              }

            case 12:
            case 'end':
              return _context41.stop();
          }
        }
      }, _callee41, _this51, [[0, 9]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'cancelSinglePackage', function cancelSinglePackage(packageRecord) {
    var _this52 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee42() {
      var response;
      return _regenerator2.default.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              _context42.prev = 0;
              _context42.next = 3;
              return _this52.$confirm('Are you sure to remove this package?', 'Confirm', {
                confirmButtonText: 'Remove Package',
                cancelButtonText: 'Keep Package',
                type: 'warning'
              });

            case 3:
              _context42.next = 5;
              return _mixedPackage.mixedPackageApi.cancelSinglePackage({
                id: packageRecord.id,
                batchNumber: packageRecord.batchNumber,
                tracking: packageRecord.tracking
              });

            case 5:
              response = _context42.sent;

              if (response && (response.code === 200 || response.code === '200')) {
                _this52.$message.success('Package removed successfully');
                _this52.getPendingPackages();
                _this52.getAvailableBatches();
              } else {
                _this52.$message.error(response.msg || 'Failed to remove package');
              }
              _context42.next = 12;
              break;

            case 9:
              _context42.prev = 9;
              _context42.t0 = _context42['catch'](0);

              if (_context42.t0 !== 'cancel') {
                _this52.$message.error('Error removing package: ' + _context42.t0.message);
              }

            case 12:
            case 'end':
              return _context42.stop();
          }
        }
      }, _callee42, _this52, [[0, 9]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'cancelSingleBatch', function cancelSingleBatch(batchNumber) {
    var _this53 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee43() {
      var response;
      return _regenerator2.default.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              _context43.prev = 0;
              _context43.next = 3;
              return _this53.$confirm('Are you sure to cancel this batch? All pending records will be deleted.', 'Confirm', {
                confirmButtonText: 'Cancel Batch',
                cancelButtonText: 'Keep Batch',
                type: 'warning'
              });

            case 3:
              _context43.next = 5;
              return _mixedPackage.mixedPackageApi.cancelPendingBatch(batchNumber);

            case 5:
              response = _context43.sent;

              if (response && (response.code === 200 || response.code === '200')) {
                _this53.$message.success('Batch cancelled successfully');
                _this53.getPendingPackages();
                _this53.getAvailableBatches();
              } else {
                _this53.$message.error(response.msg || 'Failed to cancel batch');
              }
              _context43.next = 12;
              break;

            case 9:
              _context43.prev = 9;
              _context43.t0 = _context43['catch'](0);

              if (_context43.t0 !== 'cancel') {
                _this53.$message.error('Error cancelling batch: ' + _context43.t0.message);
              }

            case 12:
            case 'end':
              return _context43.stop();
          }
        }
      }, _callee43, _this53, [[0, 9]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'reversePackage', function reversePackage(mixedPackageId) {
    var _this54 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee44() {
      var response;
      return _regenerator2.default.wrap(function _callee44$(_context44) {
        while (1) {
          switch (_context44.prev = _context44.next) {
            case 0:
              _context44.prev = 0;
              _context44.next = 3;
              return _mixedPackage.mixedPackageApi.reverseByPackageId({
                packageId: mixedPackageId
              });

            case 3:
              response = _context44.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                _this54.$message.success('Package reversed successfully');
                _this54.getMixedPackageList();
              } else {
                _this54.$message.error(response.message || response.msg || 'Failed to reverse package');
              }
              _context44.next = 10;
              break;

            case 7:
              _context44.prev = 7;
              _context44.t0 = _context44['catch'](0);

              _this54.$message.error('Error reversing package: ' + _context44.t0.message);

            case 10:
            case 'end':
              return _context44.stop();
          }
        }
      }, _callee44, _this54, [[0, 7]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'refreshMixedPackageDetail', function refreshMixedPackageDetail() {
    var _this55 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee45() {
      return _regenerator2.default.wrap(function _callee45$(_context45) {
        while (1) {
          switch (_context45.prev = _context45.next) {
            case 0:
              if (!(_this55.currentPackageDetail && _this55.currentPackageDetail.mixedPackageId)) {
                _context45.next = 3;
                break;
              }

              _context45.next = 3;
              return _this55.viewPackageDetail({ mixedPackageId: _this55.currentPackageDetail.mixedPackageId });

            case 3:
            case 'end':
              return _context45.stop();
          }
        }
      }, _callee45, _this55);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'reversePackageFromDetail', function reversePackageFromDetail() {
    var _this56 = this;

    if (!this.currentPackageDetail) {
      this.$message.error('No package selected');
      return;
    }

    this.$confirm('Are you sure to reverse this package?', 'Confirm', {
      type: 'warning'
    }).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee46() {
      var response;
      return _regenerator2.default.wrap(function _callee46$(_context46) {
        while (1) {
          switch (_context46.prev = _context46.next) {
            case 0:
              _context46.prev = 0;
              _context46.next = 3;
              return _mixedPackage.mixedPackageApi.reverseByPackageId({
                packageId: _this56.currentPackageDetail.mixedPackageId
              });

            case 3:
              response = _context46.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                _this56.$message.success('Package reversed successfully');
                _this56.packageDetailDialogVisible = false;
                _this56.getMixedPackageList();
              } else {
                _this56.$message.error(response.message || response.msg || 'Failed to reverse package');
              }
              _context46.next = 10;
              break;

            case 7:
              _context46.prev = 7;
              _context46.t0 = _context46['catch'](0);

              _this56.$message.error('Error reversing package: ' + _context46.t0.message);

            case 10:
            case 'end':
              return _context46.stop();
          }
        }
      }, _callee46, _this56, [[0, 7]]);
    }))).catch(function () {});
  }), (0, _defineProperty3.default)(_methods, 'showCreatePackage', function showCreatePackage() {
    this.createPackageDialog = true;
    this.createPackageForm = {
      tracking: '',
      warehouseNo: null,
      items: [{ upc: '', qty: 1 }]
    };
  }), (0, _defineProperty3.default)(_methods, 'addPackageItem', function addPackageItem() {
    this.createPackageForm.items.push({ upc: '', qty: 1 });
  }), (0, _defineProperty3.default)(_methods, 'removePackageItem', function removePackageItem(index) {
    if (this.createPackageForm.items.length > 1) {
      this.createPackageForm.items.splice(index, 1);
    } else {
      this.$message.warning('At least one item is required');
    }
  }), (0, _defineProperty3.default)(_methods, 'createMixedPackage', function createMixedPackage() {
    var _this57 = this;

    this.$refs.createPackageForm.validate(function (valid) {
      if (valid) {
        var validItems = _this57.createPackageForm.items.filter(function (item) {
          return item.upc && item.qty > 0;
        });

        if (validItems.length === 0) {
          _this57.$message.error('Please add at least one valid item');
          return;
        }

        var upcMap = new _map2.default();
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = (0, _getIterator3.default)(validItems), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var item = _step6.value;

            var upc = item.upc.trim();
            if (upcMap.has(upc)) {
              var existingItem = upcMap.get(upc);
              existingItem.qty += item.qty;
            } else {
              upcMap.set(upc, { upc: upc, qty: item.qty });
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        var deduplicatedItems = (0, _from2.default)(upcMap.values());

        _this57.createPackageLoading = true;
        var params = (0, _extends3.default)({}, _this57.createPackageForm, {
          items: deduplicatedItems
        });

        _mixedPackage.mixedPackageApi.createMixedPackage(params).then(function (res) {
          _this57.createPackageLoading = false;

          if (res.code === 200 || res.code === '200') {
            _this57.$message.success('Mixed package created successfully');
            _this57.createPackageDialog = false;
            _this57.resetCreateForm();
            _this57.getMixedPackageList();
          } else {
            _this57.$message.error(res.message || res.msg || 'Create failed');
          }
        }).catch(function (err) {
          _this57.createPackageLoading = false;
          _this57.$message.error(err.message || 'Create failed');
        });
      }
    });
  }), (0, _defineProperty3.default)(_methods, 'resetCreateForm', function resetCreateForm() {
    var _this58 = this;

    this.createPackageForm = {
      tracking: '',
      warehouseNo: null,
      items: [{ upc: '', qty: 1 }]
    };
    this.createPackageLoading = false;
    this.$nextTick(function () {
      if (_this58.$refs.createPackageForm) {
        _this58.$refs.createPackageForm.resetFields();
      }
    });
  }), (0, _defineProperty3.default)(_methods, 'cancelCreatePackage', function cancelCreatePackage() {
    this.createPackageDialog = false;
    this.resetCreateForm();
  }), (0, _defineProperty3.default)(_methods, 'viewClaimsForPackage', function viewClaimsForPackage(row) {
    var _this59 = this;

    this.activeName = 'claims';
    this.claimFilters.tracking = row.tracking;
    this.$nextTick(function () {
      _this59.getClaimList();
    });
  }), (0, _defineProperty3.default)(_methods, 'confirmReversePackage', function confirmReversePackage(row) {
    var _this60 = this;

    var actionDescription = '';
    if (row.packageStatus === 0) {
      actionDescription = 'This will delete the package record.';
    } else if (row.claimedItems > 0) {
      actionDescription = 'This will reverse all claims and restore inventory.';
    } else {
      actionDescription = 'This will delete the package record and restore it to pending batch for re-confirmation.';
    }

    var message = 'Are you sure to reverse this package?\n\nTracking: ' + row.tracking + '\nStatus: ' + this.getStatusText(row.packageStatus) + '\nItems: ' + (row.totalItems || 0) + ' items\n' + (row.claimedItems > 0 ? 'Claims: ' + row.claimedItems + ' claimed' : '') + '\n\n' + actionDescription + ' This action cannot be undone.';

    this.$confirm(message, 'Confirm Reverse Package', {
      type: 'warning',
      confirmButtonText: 'Yes, Reverse Package',
      cancelButtonText: 'No, Keep Package'
    }).then(function () {
      _this60.reversePackage(row.mixedPackageId);
    }).catch(function () {});
  }), (0, _defineProperty3.default)(_methods, 'getWarehouseList', function getWarehouseList() {
    var _this61 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee47() {
      var currentCompany, response;
      return _regenerator2.default.wrap(function _callee47$(_context47) {
        while (1) {
          switch (_context47.prev = _context47.next) {
            case 0:
              _context47.prev = 0;
              currentCompany = window.sessionStorage.getItem("currentCompany");
              _context47.next = 4;
              return (0, _warehouseService.getWarehouseForWarehouseAdmin)({
                doctorNo: currentCompany
              });

            case 4:
              response = _context47.sent;


              if (response.code === 200 || response.code === '200') {
                _this61.warehouses = response.records || [];
              } else {
                _this61.$message.error('Failed to load warehouses: ' + (response.msg || response.message || 'Unknown error'));

                _this61.warehouses = [];
              }

              if (_this61.warehouses.length === 1) {
                _this61.packageFilters.warehouseNo = _this61.warehouses[0].warehouseNo;
                _this61.getMixedPackageList();
              }
              _context47.next = 13;
              break;

            case 9:
              _context47.prev = 9;
              _context47.t0 = _context47['catch'](0);

              _this61.$message.error('获取仓库列表失败: ' + _context47.t0.message);
              _this61.warehouses = [];

            case 13:
            case 'end':
              return _context47.stop();
          }
        }
      }, _callee47, _this61, [[0, 9]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'getStatusText', function getStatusText(status) {
    var statusMap = {
      0: 'Pending',
      1: 'Partial Claimed',
      2: 'All Claimed',
      3: 'Completed'
    };
    return statusMap[status] || 'Unknown';
  }), (0, _defineProperty3.default)(_methods, 'getStatusTagType', function getStatusTagType(status) {
    var typeMap = {
      0: '',
      1: 'warning',
      2: 'success',
      3: 'info'
    };
    return typeMap[status] || '';
  }), (0, _defineProperty3.default)(_methods, 'formatDate', function formatDate(date) {
    if (!date) return '';
    return new Date(date).toLocaleString();
  }), (0, _defineProperty3.default)(_methods, 'getDetailStatusTagType', function getDetailStatusTagType(status) {
    var typeMap = {
      0: '',
      1: 'warning',
      2: 'success'
    };
    return typeMap[status] || '';
  }), (0, _defineProperty3.default)(_methods, 'getDetailStatusText', function getDetailStatusText(status) {
    var statusMap = {
      0: 'Unclaimed',
      1: 'Partially Claimed',
      2: 'Fully Claimed'
    };
    return statusMap[status] || 'Unknown';
  }), (0, _defineProperty3.default)(_methods, 'getClaimStatusTagType', function getClaimStatusTagType(status) {
    var typeMap = {
      0: 'warning',
      1: 'success',
      2: 'success',
      3: 'danger',
      4: 'warning' };
    return typeMap[status] || '';
  }), (0, _defineProperty3.default)(_methods, 'getClaimStatusText', function getClaimStatusText(status) {
    var statusMap = {
      0: 'Pending Review',
      1: 'Approved',
      2: 'Distributed',
      3: 'Rejected',
      4: 'Quantity Adjusted'
    };
    return statusMap[status] || 'Unknown';
  }), (0, _defineProperty3.default)(_methods, 'getTrackingArray', function getTrackingArray(trackingList) {
    if (!trackingList) return [];

    if (Array.isArray(trackingList)) {
      return trackingList.filter(function (tracking) {
        return tracking && tracking.trim();
      });
    }

    if (typeof trackingList === 'string') {
      return trackingList.split(',').map(function (tracking) {
        return tracking.trim();
      }).filter(function (tracking) {
        return tracking;
      });
    }

    return [];
  }), (0, _defineProperty3.default)(_methods, 'getDisplayTracking', function getDisplayTracking(tracking) {
    if (!tracking) return '';

    if (tracking.length > 15) {
      return tracking.substring(0, 12) + '...';
    }

    return tracking;
  }), (0, _defineProperty3.default)(_methods, 'refreshPendingCount', function refreshPendingCount() {
    var _this62 = this;

    _mixedPackage.mixedPackageApi.countPendingClaims().then(function (res) {
      if (res.code === 200 || res.code === '200') {
        _this62.pendingClaimsCount = res.result || res.data || 0;
      }
    }).catch(function () {});
  }), (0, _defineProperty3.default)(_methods, 'approveClaim', function approveClaim(row) {
    var _this63 = this;

    this.$confirm('Are you sure to approve this claim?', 'Confirm', {
      type: 'warning'
    }).then(function () {
      _mixedPackage.mixedPackageApi.approveClaim(row.claimId).then(function (res) {
        if (res.code === 200 || res.code === '200') {
          _this63.$message.success('Claim approved successfully');
          _this63.getClaimList();
          _this63.refreshPendingCount();
        } else {
          _this63.$message.error(res.message || 'Approve failed');
        }
      }).catch(function (err) {
        _this63.$message.error(err.message || 'Approve failed');
      });
    });
  }), (0, _defineProperty3.default)(_methods, 'showSingleDistribute', function showSingleDistribute(row) {
    this.singleDistributeClaim = row;
    this.singleDistributeForm = {
      chargeTimeOption: 'normal',
      customChargeTime: null
    };
    this.singleDistributeDialog = true;
  }), (0, _defineProperty3.default)(_methods, 'confirmSingleDistribute', function confirmSingleDistribute() {
    var _this64 = this;

    if (this.singleDistributeForm.chargeTimeOption === 'custom' && !this.singleDistributeForm.customChargeTime) {
      this.$message.error('Please select custom charge time');
      return;
    }

    this.singleDistributeLoading = true;

    var forceChargeTime = null;
    if (this.singleDistributeForm.chargeTimeOption === 'immediate') {
      forceChargeTime = new Date();
    } else if (this.singleDistributeForm.chargeTimeOption === 'custom') {
      forceChargeTime = new Date(this.singleDistributeForm.customChargeTime);
    }

    var params = {
      claimIds: this.singleDistributeClaim.claimId.toString()
    };

    if (forceChargeTime) {
      params.forceChargeTime = forceChargeTime;
    }

    _mixedPackage.mixedPackageApi.batchDistribute(params).then(function (res) {
      if (res.code === 200 || res.code === '200') {
        _this64.$message.success('Inventory distributed successfully');
        _this64.singleDistributeDialog = false;
        _this64.singleDistributeClaim = null;
        _this64.getClaimList();
      } else {
        _this64.showFormattedError(res.message || 'Distribute failed', 'Distribute Failed');
      }
      _this64.singleDistributeLoading = false;
    }).catch(function (err) {
      _this64.showFormattedError(err.message || 'Distribute failed', 'Distribute Error');
      _this64.singleDistributeLoading = false;
    });
  }), (0, _defineProperty3.default)(_methods, 'showAdjustQuantity', function showAdjustQuantity(row) {
    this.adjustQuantityForm = {
      claimId: row.claimId,
      originalQty: row.claimedQty,
      newQuantity: row.claimedQty,
      maxQty: row.unclaimedQty + row.claimedQty,
      reason: ''
    };
    this.adjustQuantityDialog = true;
  }), (0, _defineProperty3.default)(_methods, 'confirmAdjustQuantity', function confirmAdjustQuantity() {
    var _this65 = this;

    this.$refs.adjustQuantityForm.validate(function (valid) {
      if (valid) {
        _this65.adjustQuantityLoading = true;
        var params = {
          newQuantity: _this65.adjustQuantityForm.newQuantity,
          reason: _this65.adjustQuantityForm.reason
        };

        _mixedPackage.mixedPackageApi.adjustClaimQuantity(_this65.adjustQuantityForm.claimId, params).then(function (res) {
          if (res.code === 200 || res.code === '200') {
            _this65.$message.success('Quantity adjusted successfully');
            _this65.adjustQuantityDialog = false;
            _this65.getClaimList();
            _this65.refreshPendingCount();
          } else {
            _this65.$message.error(res.message || 'Adjust failed');
          }
          _this65.adjustQuantityLoading = false;
        }).catch(function (err) {
          _this65.$message.error(err.message || 'Adjust failed');
          _this65.adjustQuantityLoading = false;
        });
      }
    });
  }), (0, _defineProperty3.default)(_methods, 'showRejectClaim', function showRejectClaim(row) {
    this.rejectClaimForm = {
      claimId: row.claimId,
      reason: ''
    };
    this.rejectClaimDialog = true;
  }), (0, _defineProperty3.default)(_methods, 'confirmRejectClaim', function confirmRejectClaim() {
    var _this66 = this;

    this.$refs.rejectClaimForm.validate(function (valid) {
      if (valid) {
        _this66.rejectClaimLoading = true;
        var params = {
          reason: _this66.rejectClaimForm.reason
        };

        _mixedPackage.mixedPackageApi.rejectClaim(_this66.rejectClaimForm.claimId, params).then(function (res) {
          if (res.code === 200 || res.code === '200') {
            _this66.$message.success('Claim rejected successfully');
            _this66.rejectClaimDialog = false;
            _this66.getClaimList();
            _this66.refreshPendingCount();
          } else {
            _this66.$message.error(res.message || 'Reject failed');
          }
          _this66.rejectClaimLoading = false;
        }).catch(function (err) {
          _this66.$message.error(err.message || 'Reject failed');
          _this66.rejectClaimLoading = false;
        });
      }
    });
  }), (0, _defineProperty3.default)(_methods, 'showBatchApprove', function showBatchApprove() {
    var _this67 = this;

    if (this.approvableClaimsCount === 0) {
      this.$message.warning('Please select claims with "Pending Review" status to approve');
      return;
    }

    var invalidClaims = this.selectedClaims.filter(function (claim) {
      return claim.claimStatus !== 0;
    });

    if (invalidClaims.length > 0) {
      this.$message.warning(invalidClaims.length + ' selected claims cannot be approved (only "Pending Review" claims can be approved). Please adjust your selection.');
      return;
    }

    var message = 'Are you sure to approve ' + this.approvableClaimsCount + ' selected claims?\n\nAll selected claims are in "Pending Review" status and will be changed to "Approved" status.\n\nThis action cannot be undone.';

    this.$confirm(message, 'Batch Approve Confirmation', {
      type: 'warning',
      confirmButtonText: 'Yes, Approve All',
      cancelButtonText: 'Cancel'
    }).then(function () {
      _this67.confirmBatchApprove();
    });
  }), (0, _defineProperty3.default)(_methods, 'confirmBatchApprove', function confirmBatchApprove() {
    var _this68 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee48() {
      var loading, successCount, failCount, failedItems, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, claim, res;

      return _regenerator2.default.wrap(function _callee48$(_context48) {
        while (1) {
          switch (_context48.prev = _context48.next) {
            case 0:
              loading = _this68.$loading({
                lock: true,
                text: 'Approving ' + _this68.approvableClaimsCount + ' claims...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              successCount = 0;
              failCount = 0;
              failedItems = [];
              _context48.prev = 4;
              _iteratorNormalCompletion7 = true;
              _didIteratorError7 = false;
              _iteratorError7 = undefined;
              _context48.prev = 8;
              _iterator7 = (0, _getIterator3.default)(_this68.approvableClaims);

            case 10:
              if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                _context48.next = 29;
                break;
              }

              claim = _step7.value;
              _context48.prev = 12;
              _context48.next = 15;
              return _mixedPackage.mixedPackageApi.approveClaim(claim.claimId);

            case 15:
              res = _context48.sent;


              if (res.code === 200 || res.code === '200') {
                successCount++;
              } else {
                failCount++;
                failedItems.push({
                  tracking: claim.tracking,
                  upc: claim.upc,
                  error: res.message || 'Unknown error'
                });
              }
              _context48.next = 23;
              break;

            case 19:
              _context48.prev = 19;
              _context48.t0 = _context48['catch'](12);

              failCount++;
              failedItems.push({
                tracking: claim.tracking,
                upc: claim.upc,
                error: _context48.t0.message || 'Network error'
              });

            case 23:
              if (!(_this68.approvableClaims.length > 1)) {
                _context48.next = 26;
                break;
              }

              _context48.next = 26;
              return new _promise2.default(function (resolve) {
                return setTimeout(resolve, 200);
              });

            case 26:
              _iteratorNormalCompletion7 = true;
              _context48.next = 10;
              break;

            case 29:
              _context48.next = 35;
              break;

            case 31:
              _context48.prev = 31;
              _context48.t1 = _context48['catch'](8);
              _didIteratorError7 = true;
              _iteratorError7 = _context48.t1;

            case 35:
              _context48.prev = 35;
              _context48.prev = 36;

              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }

            case 38:
              _context48.prev = 38;

              if (!_didIteratorError7) {
                _context48.next = 41;
                break;
              }

              throw _iteratorError7;

            case 41:
              return _context48.finish(38);

            case 42:
              return _context48.finish(35);

            case 43:
              _context48.prev = 43;

              loading.close();
              return _context48.finish(43);

            case 46:
              _this68.getClaimList();
              _this68.refreshPendingCount();
              _this68.$refs.claimTable && _this68.$refs.claimTable.clearSelection();

              if (failCount === 0) {
                _this68.$message.success('All ' + successCount + ' claims approved successfully!');
              } else if (successCount === 0) {
                _this68.$message.error('All ' + failCount + ' approvals failed.');
                _this68.showBatchOperationErrors(failedItems, 'Approval Errors');
              } else {
                _this68.$message.warning(successCount + ' claims approved, ' + failCount + ' failed.');
                _this68.showBatchOperationErrors(failedItems, 'Partial Approval Results');
              }

            case 50:
            case 'end':
              return _context48.stop();
          }
        }
      }, _callee48, _this68, [[4,, 43, 46], [8, 31, 35, 43], [12, 19], [36,, 38, 42]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showBatchReject', function showBatchReject() {
    var _this69 = this;

    if (this.rejectableClaimsCount === 0) {
      this.$message.warning('Please select claims with "Pending Review", "Approved", or "Quantity Adjusted" status to reject');
      return;
    }

    var invalidClaims = this.selectedClaims.filter(function (claim) {
      return claim.claimStatus !== 0 && claim.claimStatus !== 1 && claim.claimStatus !== 4;
    });

    if (invalidClaims.length > 0) {
      this.$message.warning(invalidClaims.length + ' selected claims cannot be rejected (only "Pending Review", "Approved", or "Quantity Adjusted" claims can be rejected). Please adjust your selection.');
      return;
    }

    var message = 'Are you sure to reject ' + this.rejectableClaimsCount + ' selected claims?\n\nThis will change all selected claims to "Rejected" status and they cannot be processed further.\n\nThis action cannot be undone. Please provide a reason for rejection.';

    this.$prompt(message, 'Batch Reject Confirmation', {
      confirmButtonText: 'Yes, Reject All',
      cancelButtonText: 'Cancel',
      inputType: 'textarea',
      inputPlaceholder: 'Please enter the reason for rejection...',
      inputValidator: function inputValidator(value) {
        if (!value || value.trim().length === 0) {
          return 'Rejection reason is required';
        }
        if (value.trim().length < 5) {
          return 'Rejection reason must be at least 5 characters';
        }
        return true;
      }
    }).then(function (_ref6) {
      var value = _ref6.value;

      _this69.confirmBatchReject(value.trim());
    }).catch(function () {});
  }), (0, _defineProperty3.default)(_methods, 'confirmBatchReject', function confirmBatchReject(reason) {
    var _this70 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee49() {
      var loading, successCount, failCount, failedItems, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, claim, params, res;

      return _regenerator2.default.wrap(function _callee49$(_context49) {
        while (1) {
          switch (_context49.prev = _context49.next) {
            case 0:
              loading = _this70.$loading({
                lock: true,
                text: 'Rejecting ' + _this70.rejectableClaimsCount + ' claims...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              successCount = 0;
              failCount = 0;
              failedItems = [];
              _context49.prev = 4;
              _iteratorNormalCompletion8 = true;
              _didIteratorError8 = false;
              _iteratorError8 = undefined;
              _context49.prev = 8;
              _iterator8 = (0, _getIterator3.default)(_this70.rejectableClaims);

            case 10:
              if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                _context49.next = 30;
                break;
              }

              claim = _step8.value;
              _context49.prev = 12;
              params = { reason: reason };
              _context49.next = 16;
              return _mixedPackage.mixedPackageApi.rejectClaim(claim.claimId, params);

            case 16:
              res = _context49.sent;


              if (res.code === 200 || res.code === '200') {
                successCount++;
              } else {
                failCount++;
                failedItems.push({
                  tracking: claim.tracking,
                  upc: claim.upc,
                  error: res.message || 'Unknown error'
                });
              }
              _context49.next = 24;
              break;

            case 20:
              _context49.prev = 20;
              _context49.t0 = _context49['catch'](12);

              failCount++;
              failedItems.push({
                tracking: claim.tracking,
                upc: claim.upc,
                error: _context49.t0.message || 'Network error'
              });

            case 24:
              if (!(_this70.rejectableClaims.length > 1)) {
                _context49.next = 27;
                break;
              }

              _context49.next = 27;
              return new _promise2.default(function (resolve) {
                return setTimeout(resolve, 200);
              });

            case 27:
              _iteratorNormalCompletion8 = true;
              _context49.next = 10;
              break;

            case 30:
              _context49.next = 36;
              break;

            case 32:
              _context49.prev = 32;
              _context49.t1 = _context49['catch'](8);
              _didIteratorError8 = true;
              _iteratorError8 = _context49.t1;

            case 36:
              _context49.prev = 36;
              _context49.prev = 37;

              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }

            case 39:
              _context49.prev = 39;

              if (!_didIteratorError8) {
                _context49.next = 42;
                break;
              }

              throw _iteratorError8;

            case 42:
              return _context49.finish(39);

            case 43:
              return _context49.finish(36);

            case 44:
              _context49.prev = 44;

              loading.close();
              return _context49.finish(44);

            case 47:
              _this70.getClaimList();
              _this70.refreshPendingCount();
              _this70.$refs.claimTable && _this70.$refs.claimTable.clearSelection();

              if (failCount === 0) {
                _this70.$message.success('All ' + successCount + ' claims rejected successfully!');
              } else if (successCount === 0) {
                _this70.$message.error('All ' + failCount + ' rejections failed.');
                _this70.showBatchOperationErrors(failedItems, 'Rejection Errors');
              } else {
                _this70.$message.warning(successCount + ' claims rejected, ' + failCount + ' failed.');
                _this70.showBatchOperationErrors(failedItems, 'Partial Rejection Results');
              }

            case 51:
            case 'end':
              return _context49.stop();
          }
        }
      }, _callee49, _this70, [[4,, 44, 47], [8, 32, 36, 44], [12, 20], [37,, 39, 43]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'showBatchDistribute', function showBatchDistribute() {
    var _this71 = this;

    if (this.distributableClaimsCount === 0) {
      this.$message.warning('Please select claims with "Approved" or "Quantity Adjusted" status to distribute');
      return;
    }

    var invalidClaims = this.selectedClaims.filter(function (claim) {
      return claim.claimStatus !== 1 && claim.claimStatus !== 4;
    });

    if (invalidClaims.length > 0) {
      this.$message.warning(invalidClaims.length + ' selected claims cannot be distributed (only "Approved" or "Quantity Adjusted" claims can be distributed). Please adjust your selection.');
      return;
    }

    this.selectedClaims.forEach(function (claim) {
      _this71.$set(claim, 'editableChargeTime', claim.forceChargeTime || null);
    });

    this.batchDistributeForm = {
      chargeTimeOption: '',
      customChargeTime: null
    };

    this.batchDistributeDialog = true;
  }), (0, _defineProperty3.default)(_methods, 'confirmBatchDistribute', function confirmBatchDistribute() {
    this.batchDistributeLoading = true;

    this.confirmIndividualBatchDistribute();
  }), (0, _defineProperty3.default)(_methods, 'confirmIndividualBatchDistribute', function confirmIndividualBatchDistribute() {
    var _this72 = this;

    var claimRequests = this.distributableClaims.map(function (claim) {
      var request = {
        claimId: claim.claimId
      };

      if (claim.editableChargeTime) {
        request.forceChargeTime = claim.editableChargeTime;
      }

      return request;
    });

    var params = {
      claimRequests: claimRequests
    };

    _mixedPackage.mixedPackageApi.batchDistributeWithIndividualSettings(params).then(function (res) {
      if (res.code === 200 || res.code === '200') {
        if (res.result && (0, _typeof3.default)(res.result) === 'object') {
          _this72.handleBatchDistributeResult(res.result);
        } else {
          console.error('Success response but invalid result:', res.result, 'Full response:', res);
          _this72.showFormattedError('Batch distribute failed: Invalid response data', 'Batch Distribute Failed');
        }
      } else {
        _this72.showFormattedError(res.message || 'Batch distribute failed', 'Batch Distribute Failed');
      }
      _this72.batchDistributeLoading = false;
    }).catch(function (err) {
      if (err.message && err.message.includes('404')) {
        _this72.fallbackToBatchDistribute();
      } else {
        _this72.showFormattedError(err.message || 'Batch distribute failed', 'Batch Distribute Error');
        _this72.batchDistributeLoading = false;
      }
    });
  }), (0, _defineProperty3.default)(_methods, 'handleBatchDistributeResult', function handleBatchDistributeResult(result) {
    var _this73 = this;

    if (!result || (typeof result === 'undefined' ? 'undefined' : (0, _typeof3.default)(result)) !== 'object') {
      console.error('Invalid result object:', result);
      this.$message.error('Batch distribute failed: Invalid response format');
      this.batchDistributeLoading = false;
      return;
    }

    var _result$total = result.total,
        total = _result$total === undefined ? 0 : _result$total,
        _result$success = result.success,
        success = _result$success === undefined ? 0 : _result$success,
        _result$failed = result.failed,
        failed = _result$failed === undefined ? 0 : _result$failed,
        _result$successResult = result.successResults,
        successResults = _result$successResult === undefined ? [] : _result$successResult,
        _result$failedResults = result.failedResults,
        failedResults = _result$failedResults === undefined ? [] : _result$failedResults,
        _result$message = result.message,
        message = _result$message === undefined ? '' : _result$message;

    var resultMsg = '';
    var messageType = 'success';

    if (failed === 0) {
      resultMsg = '\u6279\u91CF\u4E0B\u53D1\u6210\u529F\u5B8C\u6210\uFF01\n\u603B\u8BA1: ' + total + ' \u6761\uFF0C\u5168\u90E8\u6210\u529F';
      messageType = 'success';
    } else if (success === 0) {
      resultMsg = '\u6279\u91CF\u4E0B\u53D1\u5931\u8D25\uFF01\n\u603B\u8BA1: ' + total + ' \u6761\uFF0C\u5168\u90E8\u5931\u8D25\n\n\u5931\u8D25\u8BE6\u60C5:\n';
      failedResults.forEach(function (failure, index) {
        var cleanedFailure = _this73.formatFailureMessage(failure);
        resultMsg += index + 1 + '. ' + cleanedFailure + '\n';
      });
      messageType = 'error';
    } else {
      resultMsg = '\u6279\u91CF\u4E0B\u53D1\u5B8C\u6210\uFF01\n\u603B\u8BA1: ' + total + ' \u6761\uFF0C\u6210\u529F: ' + success + ' \u6761\uFF0C\u5931\u8D25: ' + failed + ' \u6761\n\n';

      if (failed > 0) {
        resultMsg += '失败详情:\n';
        failedResults.forEach(function (failure, index) {
          var cleanedFailure = _this73.formatFailureMessage(failure);
          resultMsg += index + 1 + '. ' + cleanedFailure + '\n';
        });
      }
      messageType = 'warning';
    }

    var alertType = messageType === 'warning' ? 'warning' : messageType === 'error' ? 'error' : 'success';
    var htmlMessage = resultMsg.replace(/\n/g, '<br>');

    this.$alert(htmlMessage, '批量下发结果', {
      dangerouslyUseHTMLString: true,
      type: alertType,
      confirmButtonText: '确定',
      callback: function callback() {
        _this73.batchDistributeDialog = false;
        _this73.getClaimList();
        _this73.$refs.claimTable && _this73.$refs.claimTable.clearSelection();
      }
    });
  }), (0, _defineProperty3.default)(_methods, 'formatFailureMessage', function formatFailureMessage(failure) {
    if (!failure || typeof failure !== 'string') {
      return failure || '未知错误';
    }

    if (failure.includes('快递单号:') && failure.includes('失败原因:')) {
      return failure;
    }

    var cleanedMessage = failure;

    cleanedMessage = cleanedMessage.replace(/^UPC\s*[^:：\s]*\s*[：:]*\s*/, '');

    cleanedMessage = cleanedMessage.replace(/下发失败[：:]*\s*/, '');

    cleanedMessage = cleanedMessage.replace(/^[：:\s,，]+|[：:\s,，]+$/g, '').trim();

    if (!cleanedMessage) {
      cleanedMessage = '下发失败';
    }

    return cleanedMessage;
  }), (0, _defineProperty3.default)(_methods, 'fallbackToBatchDistribute', function fallbackToBatchDistribute() {
    var _this74 = this;

    var params = {
      claimIds: this.distributableClaims.map(function (claim) {
        return claim.claimId;
      }).join(',')
    };

    _mixedPackage.mixedPackageApi.batchDistribute(params).then(function (res) {
      if (res.code === 200 || res.code === '200') {
        _this74.$message.success('Batch distribute completed successfully');
        _this74.batchDistributeDialog = false;
        _this74.getClaimList();
        _this74.$refs.claimTable && _this74.$refs.claimTable.clearSelection();
      } else {
        _this74.showFormattedError(res.message || 'Batch distribute failed', 'Batch Distribute Failed');
      }
      _this74.batchDistributeLoading = false;
    }).catch(function (err) {
      _this74.showFormattedError(err.message || 'Batch distribute failed', 'Batch Distribute Error');
      _this74.batchDistributeLoading = false;
    });
  }), (0, _defineProperty3.default)(_methods, 'showSetChargeTime', function showSetChargeTime() {
    var _this75 = this;

    if (this.chargeEditableClaimsCount === 0) {
      this.$message.warning('Please select claims with "Approved" or "Quantity Adjusted" status to set charge time');
      return;
    }

    var invalidClaims = this.selectedClaims.filter(function (claim) {
      return claim.claimStatus !== 1 && claim.claimStatus !== 4;
    });

    if (invalidClaims.length > 0) {
      this.$message.warning(invalidClaims.length + ' selected claims cannot have their charge time modified (only "Approved" or "Quantity Adjusted" claims can be edited). Please adjust your selection.');
      return;
    }

    this.chargeEditableClaims.forEach(function (claim) {
      _this75.$set(claim, 'editableChargeTime', claim.forceChargeTime || null);
    });

    this.setChargeTimeForm = {
      chargeTimeOption: '',
      customChargeTime: null
    };

    this.setChargeTimeDialog = true;
  }), (0, _defineProperty3.default)(_methods, 'applyBatchChargeTime', function applyBatchChargeTime() {
    var _this76 = this;

    var chargeTime = null;
    if (this.batchDistributeForm.chargeTimeOption === 'immediate') {
      chargeTime = new Date().toISOString().slice(0, 19).replace('T', ' ');
    } else if (this.batchDistributeForm.chargeTimeOption === 'custom') {
      chargeTime = this.batchDistributeForm.customChargeTime;
    }

    this.selectedClaims.forEach(function (claim) {
      _this76.$set(claim, 'editableChargeTime', chargeTime);
    });

    this.$message.success('Applied batch setting to ' + this.selectedClaims.length + ' claims');
  }), (0, _defineProperty3.default)(_methods, 'applyBatchChargeTimeSetting', function applyBatchChargeTimeSetting() {
    var _this77 = this;

    var chargeTime = null;
    if (this.setChargeTimeForm.chargeTimeOption === 'immediate') {
      chargeTime = new Date().toISOString().slice(0, 19).replace('T', ' ');
    } else if (this.setChargeTimeForm.chargeTimeOption === 'custom') {
      chargeTime = this.setChargeTimeForm.customChargeTime;
    }

    this.chargeEditableClaims.forEach(function (claim) {
      _this77.$set(claim, 'editableChargeTime', chargeTime);
    });

    this.$message.success('Applied batch setting to ' + this.chargeEditableClaims.length + ' claims');
  }), (0, _defineProperty3.default)(_methods, 'confirmSetChargeTime', function confirmSetChargeTime() {
    this.setChargeTimeLoading = true;

    this.confirmIndividualSetChargeTime();
  }), (0, _defineProperty3.default)(_methods, 'confirmIndividualSetChargeTime', function confirmIndividualSetChargeTime() {
    var _this78 = this;

    var claimRequests = this.chargeEditableClaims.map(function (claim) {
      var request = {
        claimId: claim.claimId,
        forceChargeTime: claim.editableChargeTime || null
      };
      return request;
    });

    var params = {
      claimRequests: claimRequests
    };

    _mixedPackage.mixedPackageApi.setForceChargeTimeWithIndividualSettings(params).then(function (res) {
      if (res.code === 200 || res.code === '200') {
        _this78.$message.success('Charge time setting completed successfully');
        _this78.setChargeTimeDialog = false;
        _this78.getClaimList();
      } else {
        _this78.$message.error(res.message || 'Set charge time failed');
      }
      _this78.setChargeTimeLoading = false;
    }).catch(function (err) {
      if (err.message && err.message.includes('404')) {
        _this78.fallbackToSetChargeTime();
      } else {
        _this78.$message.error(err.message || 'Set charge time failed');
        _this78.setChargeTimeLoading = false;
      }
    });
  }), (0, _defineProperty3.default)(_methods, 'fallbackToSetChargeTime', function fallbackToSetChargeTime() {
    var _this79 = this;

    var params = {
      claimIds: this.editableClaimIds.join(','),
      forceChargeTime: null };

    _mixedPackage.mixedPackageApi.setForceChargeTime(params).then(function (res) {
      if (res.code === 200 || res.code === '200') {
        _this79.$message.success('Charge time setting completed successfully');
        _this79.setChargeTimeDialog = false;
        _this79.getClaimList();
      } else {
        _this79.$message.error(res.message || 'Set charge time failed');
      }
      _this79.setChargeTimeLoading = false;
    }).catch(function (err) {
      _this79.$message.error(err.message || 'Set charge time failed');
      _this79.setChargeTimeLoading = false;
    });
  }), (0, _defineProperty3.default)(_methods, 'rollbackClaimToPending', function rollbackClaimToPending(claim) {
    var _this80 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee50() {
      var response;
      return _regenerator2.default.wrap(function _callee50$(_context50) {
        while (1) {
          switch (_context50.prev = _context50.next) {
            case 0:
              _context50.prev = 0;
              _context50.next = 3;
              return _this80.$confirm('Are you sure to rollback this claim to pending status?\n\nTracking: ' + claim.tracking + '\nUPC: ' + claim.upc + '\nClaimer: ' + claim.claimerName + '\nCurrent Status: ' + claim.claimStatusDesc + '\n\nThis action will reset the claim back to pending review status, allowing warehouse administrators to re-process, adjust quantities, or reject the claim.\n\nThis action cannot be undone.', 'Confirm Rollback', {
                confirmButtonText: 'Yes, Rollback',
                cancelButtonText: 'Cancel',
                type: 'warning',
                dangerouslyUseHTMLString: true
              });

            case 3:
              _context50.next = 5;
              return _mixedPackage.mixedPackageApi.rollbackClaimToPending(claim.claimId);

            case 5:
              response = _context50.sent;


              if (response && (response.code === 200 || response.code === '200')) {
                _this80.$message.success('Claim rolled back to pending status successfully');

                _this80.getClaimList();

                _this80.refreshPendingCount();
              } else {
                _this80.$message.error(response.msg || response.message || 'Rollback failed');
              }
              _context50.next = 12;
              break;

            case 9:
              _context50.prev = 9;
              _context50.t0 = _context50['catch'](0);

              if (_context50.t0 !== 'cancel') {
                _this80.$message.error('Rollback error: ' + (_context50.t0.message || _context50.t0));
              }

            case 12:
            case 'end':
              return _context50.stop();
          }
        }
      }, _callee50, _this80, [[0, 9]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, 'viewClaimDetail', function viewClaimDetail(row) {
    this.claimDetail = row;
    this.claimDetailDialog = true;
  }), (0, _defineProperty3.default)(_methods, 'onClaimDetailClose', function onClaimDetailClose() {
    this.claimDetail = null;
  }), (0, _defineProperty3.default)(_methods, 'getQuantityTagType', function getQuantityTagType(row) {
    if (row.claimedQty > row.totalQty) {
      return 'danger';
    } else if (row.claimedQty > row.unclaimedQty) {
      return 'warning';
    }
    return 'success';
  }), (0, _defineProperty3.default)(_methods, 'showBatchOperationErrors', function showBatchOperationErrors(failedItems) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Operation Errors';

    if (!failedItems || failedItems.length === 0) return;

    var content = '<div style="text-align: left; max-height: 400px; overflow-y: auto;">';
    content += '<h4>Failed Items (' + failedItems.length + '):</h4>';
    content += '<div style="font-family: monospace; font-size: 12px; background: #f5f5f5; padding: 10px; border-radius: 4px;">';

    failedItems.forEach(function (item, index) {
      content += index + 1 + '. Tracking: ' + item.tracking + ' | UPC: ' + item.upc + '<br>';
      content += '&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #E6A23C;">Error: ' + item.error + '</span><br><br>';
    });

    content += '</div></div>';

    this.$msgbox({
      title: title,
      message: content,
      type: 'error',
      dangerouslyUseHTMLString: true,
      showClose: true,
      closeOnClickModal: true,
      confirmButtonText: 'OK'
    }).catch(function () {});
  }), (0, _defineProperty3.default)(_methods, 'getClaimStatusTagType', function getClaimStatusTagType(status) {
    var statusMap = {
      0: 'warning',
      1: 'success',
      2: 'info',
      3: 'danger',
      4: 'primary' };
    return statusMap[status] || 'info';
  }), (0, _defineProperty3.default)(_methods, 'getClaimStatusText', function getClaimStatusText(status) {
    var statusMap = {
      0: 'Pending Review',
      1: 'Approved',
      2: 'Distributed',
      3: 'Rejected',
      4: 'Quantity Adjusted'
    };
    return statusMap[status] || 'Unknown';
  }), (0, _defineProperty3.default)(_methods, 'formatErrorMessage', function formatErrorMessage(error) {
    if (!error) return null;

    var errorMessage = '';

    if (typeof error === 'string') {
      errorMessage = error;
    } else if ((typeof error === 'undefined' ? 'undefined' : (0, _typeof3.default)(error)) === 'object') {
      errorMessage = error.message || error.msg || error.error || (0, _stringify2.default)(error);
    } else {
      errorMessage = String(error);
    }

    return this.translateErrorMessage(errorMessage);
  }), (0, _defineProperty3.default)(_methods, 'translateErrorMessage', function translateErrorMessage(errorMessage) {
    if (!errorMessage) return 'Unknown error';

    if (errorMessage.includes('系统繁忙，请稍后重试')) {
      return '操作失败：可能是tracking号重复或系统繁忙，请检查该tracking是否已存在';
    }

    if (errorMessage.includes('Duplicate entry') && errorMessage.includes('uk_tracking')) {
      return '快递单号已存在，请确认后重试';
    }

    if (errorMessage.includes('duplicate tracking') || errorMessage.includes('tracking number already exists') || errorMessage.includes('快递单号已存在')) {
      return '快递单号已存在，请确认后重试';
    }

    if (errorMessage.includes('MySQLIntegrityConstraintViolationException')) {
      return '数据完整性约束违反：可能是重复数据或关联数据缺失';
    }

    if (errorMessage.includes('Network Error') || errorMessage.includes('timeout') || errorMessage.includes('connection')) {
      return '网络连接错误，请稍后重试';
    }

    if (errorMessage.includes('unauthorized') || errorMessage.includes('permission') || errorMessage.includes('权限')) {
      return '权限不足，请联系管理员';
    }

    return errorMessage.length > 150 ? errorMessage.substring(0, 150) + '...' : errorMessage;
  }), (0, _defineProperty3.default)(_methods, 'determineCanRetry', function determineCanRetry(errorMessage) {
    if (!errorMessage) return false;

    var formattedError = this.translateErrorMessage(errorMessage);

    if (formattedError.includes('快递单号已存在') || formattedError.includes('tracking number already exists') || formattedError.includes('duplicate tracking') || formattedError.includes('tracking号重复')) {
      return false;
    }

    if (formattedError.includes('数据完整性约束违反')) {
      return false;
    }

    if (formattedError.includes('权限不足')) {
      return false;
    }

    return true;
  }), (0, _defineProperty3.default)(_methods, 'getPackageItemCount', function getPackageItemCount(tracking) {
    var packageRecord = this.selectedPackages.find(function (p) {
      return p.tracking === tracking;
    });
    return packageRecord ? packageRecord.itemCount : 0;
  }), (0, _defineProperty3.default)(_methods, 'handleBulkConfirmContinue', function handleBulkConfirmContinue(result) {
    if (result.successCount > 0) {
      this.$message.success(result.successCount + ' package(s) confirmed successfully!');
    }
  }), (0, _defineProperty3.default)(_methods, 'handleBulkConfirmRetryFailed', function handleBulkConfirmRetryFailed(retryData) {
    var _this81 = this;

    var retryPackages = retryData.failedRecords.map(function (failedRecord) {
      return _this81.selectedPackages.find(function (p) {
        return p.tracking === failedRecord.tracking;
      });
    }).filter(Boolean);

    if (retryPackages.length === 0) {
      this.$message.warning('No packages found for retry');
      return;
    }

    this.selectedPackages = retryPackages;
    this.bulkConfirmResultDialogVisible = false;
    this.bulkConfirmDialogVisible = true;

    this.$message.info('Loaded ' + retryPackages.length + ' failed package(s) for retry. Please review and confirm again.');
  }), (0, _defineProperty3.default)(_methods, 'handleBulkConfirmResultClose', function handleBulkConfirmResultClose() {
    this.bulkConfirmResultDialogVisible = false;

    this.selectedPackages = [];
  }), (0, _defineProperty3.default)(_methods, 'showFormattedError', function showFormattedError(errorMessage) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Error';

    if (!errorMessage) return;

    var htmlMessage = errorMessage.replace(/\n/g, '<br>');

    this.$alert(htmlMessage, title, {
      dangerouslyUseHTMLString: true,
      type: 'error',
      confirmButtonText: '确定'
    });
  }), _methods)

}, 'computed', {
  packageInfoRows: function packageInfoRows() {
    if (!this.currentPackageDetail) return [];

    return [{
      label1: 'Package ID:',
      value1: this.currentPackageDetail.mixedPackageId,
      label2: 'Tracking Number:',
      value2: this.currentPackageDetail.tracking,
      label3: 'Warehouse:',
      value3: this.currentPackageDetail.warehouseName || this.currentPackageDetail.warehouse
    }, {
      label1: 'Status:',
      value1: this.getStatusText(this.currentPackageDetail.packageStatus),
      label2: 'Total UPC Items:',
      value2: this.currentPackageDetail.totalItems,
      label3: 'Claims:',
      value3: this.currentPackageDetail.claimedItems
    }, {
      label1: 'Create Date:',
      value1: this.formatDate(this.currentPackageDetail.createDate),
      label2: '',
      value2: '',
      label3: '',
      value3: ''
    }];
  },
  approvableClaims: function approvableClaims() {
    return this.selectedClaims.filter(function (claim) {
      return claim.claimStatus === 0;
    });
  },
  approvableClaimsCount: function approvableClaimsCount() {
    return this.approvableClaims.length;
  },
  canBatchApprove: function canBatchApprove() {
    return this.approvableClaimsCount > 0;
  },
  rejectableClaims: function rejectableClaims() {
    return this.selectedClaims.filter(function (claim) {
      return claim.claimStatus === 0 || claim.claimStatus === 1 || claim.claimStatus === 4;
    });
  },
  rejectableClaimsCount: function rejectableClaimsCount() {
    return this.rejectableClaims.length;
  },
  canBatchReject: function canBatchReject() {
    return this.rejectableClaimsCount > 0;
  },
  distributableClaims: function distributableClaims() {
    return this.selectedClaims.filter(function (claim) {
      return claim.claimStatus === 1 || claim.claimStatus === 4;
    });
  },
  distributableClaimsCount: function distributableClaimsCount() {
    return this.distributableClaims.length;
  },
  canBatchDistribute: function canBatchDistribute() {
    return this.distributableClaimsCount > 0;
  },
  chargeEditableClaims: function chargeEditableClaims() {
    return this.selectedClaims.filter(function (claim) {
      return claim.claimStatus === 1 || claim.claimStatus === 4;
    });
  },
  chargeEditableClaimsCount: function chargeEditableClaimsCount() {
    return this.chargeEditableClaims.length;
  },
  canSetForceChargeTime: function canSetForceChargeTime() {
    return this.chargeEditableClaimsCount > 0;
  },
  editableClaimIds: function editableClaimIds() {
    return this.chargeEditableClaims.map(function (claim) {
      return claim.claimId;
    });
  },
  editableClaims: function editableClaims() {
    return this.chargeEditableClaims;
  }
});

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(146);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(51);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(113);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(111);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(17);

var _inboundService = __webpack_require__(77);

var _inventoryService = __webpack_require__(78);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(22);

var _button = __webpack_require__(104);

var _button2 = _interopRequireDefault(_button);

var _input = __webpack_require__(105);

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ElInput: _input2.default,
        ElButton: _button2.default },
    created: function created() {
        var _this = this;

        this.$on('changeDoctor', function (value) {
            setTimeout(function () {
                _this.getNurseConfirmList();
                _this.getInboundHistoryList();
                _this.getReportList();
            }, 300);
        });
    },
    data: function data() {
        return {
            text: "",
            headers: {
                Authorization: window.sessionStorage.getItem("authorization")
            },
            uploadUrl: _globalVar.serverUrl + "/multiExcel/batchNurseInboundExcelImport",
            placeholder: "trackNum\r\n" + "trackNum",
            currentCompany: "",
            activeName: "first",
            filters: {
                reportStatus: "",
                reportFilter: "",
                historyFilter: "",
                confirmInboundFilter: "",
                name: ''
            },

            cancel: {
                inboundNo: "",
                cancelNum: 0
            },

            loading: false,
            modalLoading: false,
            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,

            pageSize: _globalVar.defaultPageSize,

            historyPage: 1,
            historyTotal: 0,

            confirmInboundPage: 1,
            confirmInboundTotal: 0,

            reportPage: 1,
            reportTotal: 0,

            confirmInbound: [],
            reportedInbound: [],
            inboundHistory: [],
            total: 0,
            page: 1,
            listLoading: false,

            textImportVisible: false,
            excelImportVisible: false,
            cancelInboundVisible: false,
            unClaimedTrackingVisiable: false,

            selfConfirm: {
                inboundNo: "",
                productName: "",
                company: "",
                price: "",
                num: "",
                leftNum: "",
                quantity: "",
                warehouse: ""

            },
            selfConfirmVisible: false,

            warehouseConfirm: {
                confirmed: false,
                loading: false,
                inboundNo: "",
                productName: "",
                company: "",
                price: "",
                num: "",
                leftNum: "",
                quantity: "",
                warehouse: "",
                trackingNumbers: [],
                trackingNumbersPage: [],
                trackingStatus: "All",
                unClaimedList: [],
                claimedList: [],
                unMatchedList: [],
                bulkConfirmSize: 0,
                total: 0,
                currentPage: 1
            },
            trackingNumbers: [],
            warehouseConfirmVisible: false,

            editLoading: false,

            addFormVisible: false,
            addLoading: false,
            inboundFormRules: {
                quantity: [{ required: true, message: 'Inbound quantity is required.', trigger: 'blur' }, { required: true, message: 'Inbound quantity must more than 1.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
            },
            addFormRules: {},
            uploadData: {
                inboundNo: ""
            },
            unClaimedTracking: "",
            removeMultipleSelection: "" };
    },

    methods: {
        goToMixedClaim: function goToMixedClaim() {
            var firstUnmatchedTracking = this.warehouseConfirm.unMatchedList && this.warehouseConfirm.unMatchedList.length > 0 ? this.warehouseConfirm.unMatchedList[0].tracking : '';

            this.warehouseConfirmVisible = false;

            this.$router.push({
                path: '/mixedPackageClaim',
                query: {
                    tracking: firstUnmatchedTracking
                }
            });

            this.$message.info('Redirecting to Mixed Claim page. You can claim specific items from the package.');
        },
        preview: function preview() {
            this.modalLoading = true;
        },
        getUnClaimTracking: function getUnClaimTracking() {
            var _this2 = this;

            var param = {
                fkey: this.warehouseConfirm.inboundNo
            };
            (0, _inboundService.getUnClaimTracking)(param).then(function (data) {
                if (data.status === 200) {
                    if (data.result.length > 0) {
                        _this2.unClaimedTracking = data.result.join("\n");
                        _this2.unClaimedTrackingVisiable = true;
                    } else {
                        _this2.$message.error("None UnClaimed Tracking # found.");
                    }
                } else {
                    _this2.$message.error(data.message);
                }
            });
        },
        exportExcel: function exportExcel(url, fileName, type) {
            var param = {
                url: url,
                fileName: fileName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },
        bulkConfirm: function bulkConfirm() {
            var _this3 = this;

            this.modalLoading = true;
            var param = {
                inboundNo: this.warehouseConfirm.inboundNo,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _inboundService.bulkClaim)(param).then(function (data) {
                _this3.modalLoading = false;
                if (data.status == 200) {
                    if (data.result == true) {
                        _this3.$message.success(data.message);
                    } else {
                        _this3.$message.error(data.message);
                    }
                    _this3.getInboundHistoryList();
                    _this3.confirmInboundItem(_this3.warehouseConfirm.inboundNo, 'warehouse', false);
                    _this3.getNurseConfirmList();
                } else {
                    _this3.$message.error(data.message);
                }
            });
        },
        bulkRemoveSelected: function bulkRemoveSelected() {
            var _this4 = this;

            if (!this.removeMultipleSelection || this.removeMultipleSelection.trim() === "") {
                this.$message.warning("Please select tracking numbers to remove.");
                return;
            }
            this.$confirm("Are you sure to remove selected tracking#?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    inboundNo: _this4.warehouseConfirm.inboundNo,
                    trackingNos: _this4.removeMultipleSelection
                };
                _this4.modalLoading = true;
                (0, _inboundService.batchRemoveImportTracking)(param).then(function (data) {
                    setTimeout(function () {
                        if (data.status === 200) {
                            if (data.result.length > 0) {
                                _this4.$message.warning("Exist already claimed tracking#:" + data.result);
                            } else {
                                _this4.$message.success("Success");
                            }
                            _this4.confirmInboundItem(_this4.warehouseConfirm.inboundNo, 'warehouse', false).then(function () {
                                _this4.modalLoading = false;
                            });
                        }
                    }, 600);
                });
            }).catch(function () {});
        },
        checkTrackingClaimability: function checkTrackingClaimability(inboundNo) {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var checkPromises;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                checkPromises = _this5.warehouseConfirm.unClaimedList.map(function () {
                                    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(item) {
                                        var response;
                                        return _regenerator2.default.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        _context.prev = 0;
                                                        _context.next = 3;
                                                        return (0, _inboundService.canTrackingBeClaimed)({
                                                            inboundNo: inboundNo,
                                                            tracking: item.tracking
                                                        });

                                                    case 3:
                                                        response = _context.sent;


                                                        if (response.status === 200) {
                                                            item.canClaim = response.result;
                                                        } else {
                                                            item.canClaim = false;
                                                            console.warn('\u68C0\u67E5tracking ' + item.tracking + '\u5931\u8D25:', response.message);
                                                        }
                                                        _context.next = 11;
                                                        break;

                                                    case 7:
                                                        _context.prev = 7;
                                                        _context.t0 = _context['catch'](0);

                                                        item.canClaim = false;
                                                        console.error('\u68C0\u67E5tracking ' + item.tracking + '\u5F02\u5E38:', _context.t0);

                                                    case 11:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this5, [[0, 7]]);
                                    }));

                                    return function (_x) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                _context2.next = 4;
                                return _promise2.default.all(checkPromises);

                            case 4:
                                _this5.warehouseConfirm.trackingNumbers = [].concat((0, _toConsumableArray3.default)(_this5.warehouseConfirm.unClaimedList), (0, _toConsumableArray3.default)(_this5.warehouseConfirm.unMatchedList), (0, _toConsumableArray3.default)(_this5.warehouseConfirm.claimedList));

                                _this5.warehouseConfirm.trackingNumbersPage = _this5.warehouseConfirm.trackingNumbers.slice(0, 100);

                                _context2.next = 12;
                                break;

                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2['catch'](0);

                                console.error('批量检查tracking UPC验证失败:', _context2.t0);

                                _this5.warehouseConfirm.unClaimedList.forEach(function (item) {
                                    item.canClaim = true;
                                });

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this5, [[0, 8]]);
            }))();
        },
        claim: function claim(item) {
            var _this6 = this;

            var param = {
                inboundNo: this.warehouseConfirm.inboundNo,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                tracking: item.tracking,
                qty: item.qty
            };
            item.loading = true;
            this.modalLoading = true;
            return (0, _inboundService.claimTracking)(param).then(function (data) {
                item.loading = false;
                _this6.modalLoading = false;
                if (data.status === 200) {
                    if (data.result) {
                        _this6.$refs.warehouseConfirm.resetFields();

                        _this6.$message.success("Tracking# claim operation completed, quantity " + data.result + ".");
                    } else {
                        _this6.$message.success(data.message);
                    }
                    _this6.getInboundHistoryList();
                    _this6.confirmInboundItem(_this6.warehouseConfirm.inboundNo, 'warehouse', false);
                    _this6.getNurseConfirmList();
                    _this6.warehouseConfirm.bulkConfirmSize += 1;
                } else {
                    _this6.$message.error(data.message);
                }
            });
        },
        uploadSuccess: function uploadSuccess(a) {
            this.modalLoading = false;
            if (a.status === 200) {
                this.confirmInboundItem(this.warehouseConfirm.inboundNo, 'warehouse');
                this.excelImportVisible = false;
                this.$refs.upload.clearFiles();
            } else {
                this.$message.error(a.message);
                this.$refs.upload.clearFiles();
            }
        },
        uploadError: function uploadError(a) {
            this.modalLoading = false;
            this.$message.error(a.message);
            this.$refs.upload.clearFiles();
        },
        changeHistory: function changeHistory(val) {
            this.historyPage = val;
            this.getInboundHistoryList();
        },
        showCancelInbound: function showCancelInbound(inboundNo) {
            this.cancel.inboundNo = inboundNo;
            this.cancelInboundVisible = true;
        },
        cancelInbound: function cancelInbound() {
            var _this7 = this;

            if (!this.cancel.cancelNum) {
                this.$message.error("Cancel quantity is required.");
                return;
            }
            if (!this.cancel.cancelNum > 0) {
                this.$message.error("Cancel quantity must more than one.");
                return;
            }
            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _inboundService.cancelNurseInbound)({ inboundNo: _this7.cancel.inboundNo, cancelNum: _this7.cancel.cancelNum }).then(function (res) {
                    if (res.status === 200) {
                        _this7.$message.success(res.message);
                        _this7.getNurseConfirmList();
                        _this7.getInboundHistoryList();
                        _this7.cancel.cancelNum = 0;
                        _this7.cancel.inboundNo = "";
                        _this7.cancelInboundVisible = false;
                    } else {
                        _this7.$message.error(res.message);
                    }
                });
            }).catch(function () {});
        },
        checkQuantity: function checkQuantity(rule, value, callback) {
            if (!value > 0) {
                return callback(new Error('Inbound quantity must more than 1.'));
            } else if (value > this.selfConfirm.leftNum) {
                return callback(new Error("Inbound quantity can't more than left."));
            } else {
                callback();
            }
        },
        handleConfirmInbound: function handleConfirmInbound() {
            var _this8 = this;

            this.$refs.selfConfirm.validate(function (valid) {
                if (valid) {
                    _this8.loading = true;
                    var param = {
                        inboundNo: _this8.selfConfirm.inboundNo,
                        confirmNum: _this8.selfConfirm.quantity
                    };
                    (0, _inboundService.confirmNurseInbound)(param).then(function (res) {
                        _this8.loading = false;
                        if (res.status === 200) {
                            _this8.$message.success(res.message);
                            _this8.selfConfirmVisible = false;
                            _this8.$refs.selfConfirm.resetFields();
                            _this8.getNurseConfirmList();
                            _this8.getInboundHistoryList();
                        } else {
                            _this8.$message.error(res.message);
                        }
                    });
                }
            });
        },
        changeConfirmInboundPage: function changeConfirmInboundPage(val) {
            this.confirmInboundPage = val;
            this.getNurseConfirmList();
        },
        changeReportPage: function changeReportPage(val) {
            this.reportPage = val;
            this.getReportList();
        },
        removeRow: function removeRow(row) {
            var _this9 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    inboundNo: _this9.warehouseConfirm.inboundNo,
                    tracking: row.tracking
                };
                _this9.modalLoading = true;
                (0, _inboundService.removeImportTracking)(param).then(function (data) {
                    setTimeout(function () {
                        if (data.status === 200) {
                            _this9.$message.success(data.message);
                            _this9.confirmInboundItem(_this9.warehouseConfirm.inboundNo, 'warehouse', false).then(function () {
                                _this9.modalLoading = false;
                            });
                        }
                    }, 600);
                });
            }).catch(function () {});
        },
        importFromText: function importFromText() {
            var _this10 = this;

            this.loading = true;
            var text = this.text.trim();
            if (!text) {
                this.$message.error("Please enter import text.");
                this.loading = false;
                return;
            }
            var row = [];
            var existTrackings = [];
            var trackings = [];
            var lines = [];
            if (text.indexOf(" ") != -1) {
                lines = text.split(" ");
            } else if (text.indexOf(",") != -1) {
                lines = text.split(",");
            } else if (text.indexOf(";") != -1) {
                lines = text.split(";");
            } else if (text.indexOf(":") != -1) {
                lines = text.split(":");
            } else if (text.indexOf("\t") != -1) {
                lines = text.split("\t");
            } else {
                lines = text.split("\n");
            }

            lines.filter(function (line) {
                return line.trim() !== '';
            }).forEach(function (line) {
                var obj = {};
                obj.tracking = line.trim();

                var exist = trackings.find(function (item) {
                    return item === obj.tracking;
                });
                if (!exist) {
                    trackings.push(obj.tracking);
                } else {
                    existTrackings.push(obj.tracking);
                }
            });

            this.excelImportVisible = false;
            if (existTrackings.length > 0) {
                this.$message.info("Duplicate tracking: " + existTrackings.join(","));
                this.loading = false;
                return;
            }
            var param = {
                trackings: trackings.join(","),
                inboundNo: this.warehouseConfirm.inboundNo
            };
            var resultTrackings = [];
            var existList = [];
            (0, _inboundService.getQtyByTracking)(param).then(function (data) {
                _this10.loading = false;
                if (data.status === 200) {
                    _this10.textImportVisible = false;
                    _this10.confirmInboundItem(_this10.warehouseConfirm.inboundNo, 'warehouse');
                } else {
                    console.log(data);
                    _this10.$message.error(data.message);
                }
            });
        },
        confirmInboundItem: function confirmInboundItem(id, type, isShow) {
            var _this11 = this;

            return (0, _inboundService.getInboundDetail)({ inboundNo: id }).then(function (res) {
                if (res.status === 200) {
                    if (type == "self") {
                        _this11.selfConfirm.inboundNo = id;
                        _this11.selfConfirm.productName = res.result.productName;
                        _this11.selfConfirm.company = res.result.userName;
                        _this11.selfConfirm.price = res.result.price;
                        _this11.selfConfirm.num = res.result.num;
                        _this11.selfConfirm.leftNum = res.result.leftNum;
                        _this11.selfConfirm.warehouse = res.result.warehouse;
                        _this11.selfConfirmVisible = true;
                    } else {
                        _this11.text = "";
                        _this11.warehouseConfirm.inboundNo = id;
                        _this11.uploadData.inboundNo = id;
                        _this11.warehouseConfirm.productName = res.result.productName;
                        _this11.warehouseConfirm.company = res.result.userName;
                        _this11.warehouseConfirm.price = res.result.price;
                        _this11.warehouseConfirm.num = res.result.num;
                        _this11.warehouseConfirm.leftNum = res.result.leftNum;
                        _this11.warehouseConfirm.warehouse = res.result.warehouse;
                        _this11.warehouseConfirm.trackingStatus = "All";
                        _this11.warehouseConfirm.claimedList = res.result.trackingList;
                        _this11.warehouseConfirm.unClaimedList = res.result.unClaimedTrackingList;
                        _this11.warehouseConfirm.unMatchedList = res.result.unMatchedTrackingList;
                        _this11.warehouseConfirm.trackingNumbers = [];
                        _this11.warehouseConfirm.claimedList.forEach(function (item) {
                            item.confirmed = true;
                            item.matched = true;
                            item.loading = false;
                        });
                        _this11.warehouseConfirm.unClaimedList.forEach(function (item) {
                            item.confirmed = false;
                            item.matched = true;
                            item.loading = false;
                            item.canClaim = null;
                        });

                        _this11.checkTrackingClaimability(id);
                        _this11.warehouseConfirm.unMatchedList.forEach(function (item) {
                            item.confirmed = false;
                            item.matched = false;
                            item.loading = false;
                        });

                        _this11.warehouseConfirm.trackingNumbers = [].concat((0, _toConsumableArray3.default)(_this11.warehouseConfirm.unClaimedList), (0, _toConsumableArray3.default)(_this11.warehouseConfirm.unMatchedList), (0, _toConsumableArray3.default)(_this11.warehouseConfirm.claimedList));
                        _this11.warehouseConfirm.trackingNumbersPage = _this11.warehouseConfirm.trackingNumbers.slice(0, 100);
                        _this11.warehouseConfirm.total = _this11.warehouseConfirm.trackingNumbers.length;
                        _this11.warehouseConfirm.currentPage = 1;
                        if (isShow) {
                            _this11.warehouseConfirmVisible = true;
                        }
                    }
                } else {
                    _this11.$message.error(res.message);
                }
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.removeMultipleSelection = "";
            for (var i = 0; i < val.length; i++) {
                var item = val[i];
                if (i > 0) {
                    this.removeMultipleSelection = this.removeMultipleSelection + "," + item.tracking;
                } else {
                    this.removeMultipleSelection = item.tracking;
                }
            }
        },
        changeImportTrackingPage: function changeImportTrackingPage(val) {
            this.warehouseConfirm.currentPage = val;
            this.warehouseConfirm.trackingNumbersPage = this.warehouseConfirm.trackingNumbers.slice((val - 1) * 100, val * 100);
        },
        changeTrackingFilterStatus: function changeTrackingFilterStatus() {
            var status = this.warehouseConfirm.trackingStatus;

            if (status == "All") {
                this.warehouseConfirm.trackingNumbers = [].concat((0, _toConsumableArray3.default)(this.warehouseConfirm.unClaimedList), (0, _toConsumableArray3.default)(this.warehouseConfirm.unMatchedList), (0, _toConsumableArray3.default)(this.warehouseConfirm.claimedList));
            } else if (status == "Claimed") {
                this.warehouseConfirm.trackingNumbers = [].concat((0, _toConsumableArray3.default)(this.warehouseConfirm.claimedList));
            } else if (status == "Matched") {
                this.warehouseConfirm.trackingNumbers = [].concat((0, _toConsumableArray3.default)(this.warehouseConfirm.unClaimedList));
            } else if (status == "Unmatched") {
                this.warehouseConfirm.trackingNumbers = [].concat((0, _toConsumableArray3.default)(this.warehouseConfirm.unMatchedList));
            }
            this.warehouseConfirm.trackingNumbersPage = this.warehouseConfirm.trackingNumbers.slice(0, 100);
            this.warehouseConfirm.total = this.warehouseConfirm.trackingNumbers.length;
            this.warehouseConfirm.currentPage = 1;
        },
        getReportList: function getReportList() {
            var _this12 = this;

            var param = {
                current: this.reportPage,
                size: this.pageSize,
                condition: this.filters.reportFilter,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                status: this.filters.reportStatus
            };
            this.secondListLoading = true;
            (0, _inventoryService.getInventoryReportList)(param).then(function (data) {
                _this12.secondListLoading = false;
                if (data.status === 200) {
                    _this12.reportedInbound = data.result.records;
                    _this12.reportTotal = data.result.total;
                }
            });
        },
        getInboundHistoryList: function getInboundHistoryList() {
            var _this13 = this;

            this.thirdListLoading = true;
            var param = {
                current: this.historyPage,
                size: this.pageSize,
                productName: this.filters.historyFilter,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _inboundService.getInboundHistoryList)(param).then(function (data) {
                _this13.thirdListLoading = false;
                if (data.status === 200) {
                    _this13.inboundHistory = data.result.records;
                    _this13.historyTotal = data.result.total;
                }
            });
        },
        getNurseConfirmList: function getNurseConfirmList() {
            var _this14 = this;

            var param = {
                current: this.confirmInboundPage,
                size: this.pageSize,
                condition: this.filters.confirmInboundFilter,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                status: 0
            };
            this.firstListLoading = true;
            (0, _inboundService.getNurseConfirmList)(param).then(function (data) {
                _this14.firstListLoading = false;
                if (data.status === 200) {
                    _this14.confirmInbound = data.result.records;
                    _this14.confirmInboundTotal = data.result.total;
                }
            });
        }
    },
    mounted: function mounted() {
        this.getReportList();
        this.getInboundHistoryList();
        this.getNurseConfirmList();
    }
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(221);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _inventoryService = __webpack_require__(78);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(22);

var _memberService = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {
        var _this = this;

        this.$on('changeDoctor', function (value) {
            setTimeout(function () {
                _this.getInventory();
            }, 300);
        });
    },
    data: function data() {
        var _ref;

        return _ref = {
            filters: {
                name: '',
                zeroName: "",
                doctorProductName: "",
                productTemplateCondition: ""
            },

            conditions: _globalVar.conditions,

            doctorProductList: [],
            doctorProductTotal: 0,
            doctorProductPage: 1,

            zeroInventory: [],
            zeroInventroyTotal: 0,
            zeroInventoryPage: 1,

            products: [],
            total: 0,
            page: 1,

            pageSize: _globalVar.defaultPageSize,
            activeName: "first",

            listLoading: false,
            loading: false,
            sels: [],

            sizeList: [],

            editFormVisible: false,
            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            editForm: {
                id: 0,
                name: '',
                sex: -1,
                age: 0,
                birth: '',
                addr: ''
            },

            reportFormVisible: false,
            addFormVisible: false }, (0, _defineProperty3.default)(_ref, 'editFormVisible', false), (0, _defineProperty3.default)(_ref, 'formRules', {
            id: [{ required: true, message: 'Missing Item is required.', trigger: 'blur' }],
            quantity: [{ required: true, message: 'Quantity is required.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
        }), (0, _defineProperty3.default)(_ref, 'report', {
            id: "",
            product: '',
            company: "",
            price: "",
            note: "",
            warehouse: "",
            warehouseNo: "",
            quantity: 0,
            total: 0,
            items: []
        }), (0, _defineProperty3.default)(_ref, 'role', ""), (0, _defineProperty3.default)(_ref, 'editProduct', {
            id: "",
            product: '',
            condition: "New",
            price: "",
            asin: "",
            upc: "",
            weight: '',
            note: "",
            size: "",
            storageFreeDuration: undefined
        }), (0, _defineProperty3.default)(_ref, 'addProduct', {
            id: "",
            product: '',
            condition: "New",
            price: "",
            asin: "",
            upc: "",
            weight: '',
            note: "",
            size: "",
            storageFreeDuration: undefined
        }), (0, _defineProperty3.default)(_ref, 'productTemplatePage', 1), (0, _defineProperty3.default)(_ref, 'productTemplateList', []), (0, _defineProperty3.default)(_ref, 'productTemplateTotal', 0), (0, _defineProperty3.default)(_ref, 'productTemplateAddFormVisible', false), (0, _defineProperty3.default)(_ref, 'productTemplateEditFormVisible', false), (0, _defineProperty3.default)(_ref, 'editProductTemplate', {
            id: "",
            product: '',
            condition: "New",
            price: "",
            asin: "",
            upc: "",
            weight: '',
            note: "",
            size: "",
            storageFreeDuration: undefined
        }), (0, _defineProperty3.default)(_ref, 'addProductTemplate', {
            id: "",
            product: '',
            condition: "New",
            price: "",
            asin: "",
            upc: "",
            weight: '',
            note: "",
            size: "",
            storageFreeDuration: undefined
        }), (0, _defineProperty3.default)(_ref, 'distributeSelectedDoctors', []), (0, _defineProperty3.default)(_ref, 'selectedProductNo', null), (0, _defineProperty3.default)(_ref, 'selectDoctorsVisible', false), (0, _defineProperty3.default)(_ref, 'doctorList', []), (0, _defineProperty3.default)(_ref, 'selectedDoctorNames', []), (0, _defineProperty3.default)(_ref, 'productFormRules', {
            product: [{ required: true, message: 'Product Name is required.', trigger: 'blur' }],
            upc: [{ required: true, message: 'UPC is required.', trigger: 'blur' }],
            size: [{ required: true, message: 'Size is required.', trigger: 'blur' }]
        }), _ref;
    },

    methods: {
        changeItem: function changeItem() {
            var reportId = this.report.id;
            var selectItem = this.report.items.find(function (item) {
                return item.id == reportId;
            });
            this.report.total = selectItem.total;
        },
        exportExcel: function exportExcel(url, fileName, type) {
            var param = {
                url: url,
                fileName: fileName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },
        checkQuantity: function checkQuantity(rule, value, callback) {
            if (!value > 0) {
                return callback(new Error('Report quantity must more than 1.'));
            } else if (value > this.report.total) {
                return callback(new Error("Report quantity can't more than Total."));
            } else {
                callback();
            }
        },
        handleReportInventory: function handleReportInventory() {
            var _this2 = this;

            this.$refs.report.validate(function (valid) {
                if (valid) {
                    var param = {
                        itemId: _this2.report.id,
                        warehouseNo: _this2.report.warehouseNo,
                        note: _this2.report.note,
                        quantity: _this2.report.quantity,
                        doctorNo: window.sessionStorage.getItem("currentCompany")
                    };
                    _this2.loading = true;
                    (0, _inventoryService.reportInventory)(param).then(function (data) {
                        _this2.loading = false;
                        if (data.status === 200) {
                            _this2.$message.success(data.message);
                            _this2.reportFormVisible = false;
                            _this2.$refs.report.resetFields();
                            _this2.getInventory();
                        } else {
                            _this2.$message.error(data.message);
                        }
                    });
                }
            });
        },
        showReportInventory: function showReportInventory(row) {
            var _this3 = this;

            var param = {
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                productNo: row.productNo,
                warehouseNo: row.warehouseNo
            };
            (0, _inventoryService.getInventoryByProduct)(param).then(function (data) {
                _this3.report.items = data.result;
                _this3.report.product = row.productName;
                _this3.report.warehouse = row.warehouse;
                _this3.report.warehouseNo = row.warehouseNo;

                _this3.reportFormVisible = true;
            });
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
            this.getInventory();
        },
        handleZeroChange: function handleZeroChange(val) {
            this.zeroInventoryPage = val;
            this.getZeroInventory();
        },
        handleProductChange: function handleProductChange(val) {
            this.doctorProductPage = val;
            this.getDoctorProductList();
        },
        handleProductTemplateChange: function handleProductTemplateChange(val) {
            this.productTemplatePage = val;
            this.getProductTemplateList();
        },
        getSizeList: function getSizeList() {
            var _this4 = this;

            (0, _inventoryService.getSizeList)({}).then(function (data) {
                if (data.status === 200) {
                    _this4.sizeList = data.result;
                }
            });
        },
        getInventory: function getInventory() {
            var _this5 = this;

            var para = {
                current: this.page,
                size: this.pageSize,
                condition: this.filters.name,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.listLoading = true;
            (0, _inventoryService.getUserInventory)(para).then(function (res) {
                _this5.listLoading = false;
                if (res.status === 200) {
                    _this5.products = res.result.records;
                    _this5.total = res.result.total;
                }
            });
        },
        getZeroInventory: function getZeroInventory() {
            var _this6 = this;

            var para = {
                current: this.zeroInventoryPage,
                size: this.pageSize,
                condition: this.filters.zeroName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.listLoading = true;
            (0, _inventoryService.getZeroInventory)(para).then(function (res) {
                _this6.listLoading = false;
                if (res.status === 200) {
                    _this6.zeroInventory = res.result.records;
                    _this6.zeroInventroyTotal = res.result.total;
                }
            });
        },
        getDoctorProductList: function getDoctorProductList() {
            var _this7 = this;

            var para = {
                current: this.doctorProductPage,
                size: this.pageSize,
                condition: this.filters.doctorProductName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.listLoading = true;
            (0, _inventoryService.getDoctorProductList)(para).then(function (res) {
                _this7.listLoading = false;
                if (res.status === 200) {
                    _this7.doctorProductList = res.result.records;
                    _this7.doctorProductTotal = res.result.total;
                } else {
                    _this7.$message.error(res.message);
                }
            });
        },
        getProductTemplateList: function getProductTemplateList() {
            var _this8 = this;

            var para = {
                current: this.productTemplatePage,
                size: this.pageSize,
                upc: this.filters.productTemplateCondition
            };
            this.listLoading = true;
            (0, _inventoryService.getProductTemplateListByCondition)(para).then(function (res) {
                _this8.listLoading = false;
                if (res.status === 200) {
                    _this8.productTemplateList = res.result.records;
                    _this8.productTemplateTotal = res.result.total;
                } else {
                    _this8.$message.error(res.message);
                }
            });
        },

        editSubmit: function editSubmit() {
            var _this9 = this;

            this.$refs.editProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productNo: _this9.editProduct.productNo,

                        condition: _this9.editProduct.condition,
                        asin: _this9.editProduct.asin,
                        upc: _this9.editProduct.upc,
                        weight: _this9.editProduct.weight,
                        note: _this9.editProduct.note,
                        size: _this9.editProduct.size,
                        storageFreeDuration: _this9.editProduct.storageFreeDuration,
                        doctorNo: window.sessionStorage.getItem("currentCompany")

                    };
                    _this9.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this9.loading = false;
                        if (res.status === 200) {
                            _this9.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this9.editFormVisible = false;
                            _this9.$refs.editProduct.resetFields();
                            _this9.getDoctorProductList();
                        } else {
                            _this9.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },

        editSubmitTemplate: function editSubmitTemplate() {
            var _this10 = this;

            this.$refs.editProductTemplate.validate(function (valid) {
                if (valid) {
                    var param = {
                        productNo: _this10.editProductTemplate.productNo,
                        condition: _this10.editProductTemplate.condition,
                        asin: _this10.editProductTemplate.asin,
                        upc: _this10.editProductTemplate.upc,
                        weight: _this10.editProductTemplate.weight,
                        note: _this10.editProductTemplate.note,
                        size: _this10.editProductTemplate.size,
                        storageFreeDuration: _this10.editProductTemplate.storageFreeDuration

                    };
                    _this10.loading = true;
                    (0, _inventoryService.addProductTemplate)(param).then(function (res) {
                        _this10.loading = false;
                        if (res.status === 200) {
                            _this10.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this10.productTemplateEditFormVisible = false;
                            _this10.$refs.editProductTemplate.resetFields();
                            _this10.getProductTemplateList();
                        } else {
                            _this10.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },

        handleAddProduct: function handleAddProduct() {
            var _this11 = this;

            this.$refs.addProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productName: _this11.addProduct.product,
                        condition: _this11.addProduct.condition,
                        asin: _this11.addProduct.asin,
                        upc: _this11.addProduct.upc,
                        weight: _this11.addProduct.weight,
                        note: _this11.addProduct.note,
                        size: _this11.addProduct.size,
                        storageFreeDuration: _this11.addProduct.storageFreeDuration,
                        doctorNo: window.sessionStorage.getItem("currentCompany")
                    };
                    _this11.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this11.loading = false;
                        if (res.status === 200) {
                            _this11.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this11.addFormVisible = false;
                            _this11.$refs.addProduct.resetFields();
                            _this11.getDoctorProductList();
                        } else {
                            _this11.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },

        handleAddProductTemplate: function handleAddProductTemplate() {
            var _this12 = this;

            this.$refs.addProductTemplate.validate(function (valid) {
                if (valid) {
                    var param = {
                        productName: _this12.addProductTemplate.product,
                        condition: _this12.addProductTemplate.condition,
                        asin: _this12.addProductTemplate.asin,
                        upc: _this12.addProductTemplate.upc,
                        weight: _this12.addProductTemplate.weight,
                        note: _this12.addProductTemplate.note,
                        size: _this12.addProductTemplate.size,
                        storageFreeDuration: _this12.addProductTemplate.storageFreeDuration
                    };
                    _this12.loading = true;
                    (0, _inventoryService.addProductTemplate)(param).then(function (res) {
                        _this12.loading = false;
                        if (res.status === 200) {
                            _this12.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this12.productTemplateAddFormVisible = false;
                            _this12.$refs.addProductTemplate.resetFields();
                            _this12.getProductTemplateList();
                        } else {
                            _this12.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        handleEditProduct: function handleEditProduct(row) {
            var _this13 = this;

            var para = {
                productNo: row.productNo,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _inventoryService.getProductById)(para).then(function (data) {
                _this13.editProduct = data.result;
                _this13.editFormVisible = true;
                if (_this13.editProduct.storageFreeDuration == null) {
                    _this13.editProduct.storageFreeDuration = undefined;
                }
            });
        },
        handleEditProductTemplate: function handleEditProductTemplate(row) {
            var _this14 = this;

            var para = {
                productNo: row.productNo
            };
            (0, _inventoryService.getProductTemplateById)(para).then(function (data) {
                _this14.editProductTemplate = data.result;
                _this14.productTemplateEditFormVisible = true;
                if (_this14.editProductTemplate.storageFreeDuration == null) {
                    _this14.editProductTemplate.storageFreeDuration = undefined;
                }
            });
        },
        showDistributeSelectDoctorWin: function showDistributeSelectDoctorWin(row) {
            var _this15 = this;

            this.selectedProductNo = row.productNo;
            var para = {
                productNo: row.productNo
            };
            (0, _inventoryService.getDistributedDoctorName)(para).then(function (data) {
                if (data.status === 200) {
                    _this15.selectedDoctorNames = data.result;
                    (0, _memberService.getNurseDoctor)().then(function (res) {
                        _this15.doctorList = res.result;
                        _this15.selectDoctorsVisible = true;
                    });
                } else {
                    _this15.$message({
                        message: data.message,
                        type: "error"
                    });
                }
            });
        },
        distributeProductTempate: function distributeProductTempate() {
            var _this16 = this;

            var para = {
                productNo: this.selectedProductNo,
                doctorNos: this.distributeSelectedDoctors
            };

            this.loading = true;
            (0, _inventoryService.distributeProductTempate)(para).then(function (data) {
                if (data.status === 200) {
                    if (data.result.length == 0) {
                        _this16.$message({
                            message: data.message,
                            type: "success"
                        });
                        _this16.getProductTemplateList();
                        _this16.distributeSelectedDoctors = [];
                        _this16.selectDoctorsVisible = false;
                    } else {
                        var _para = {
                            productNo: _this16.selectedProductNo
                        };
                        (0, _inventoryService.getDistributedDoctorName)(_para).then(function (data) {
                            if (data.status === 200) {
                                _this16.selectedDoctorNames = data.result;
                                (0, _memberService.getNurseDoctor)().then(function (res) {
                                    _this16.doctorList = res.result;
                                    _this16.selectDoctorsVisible = true;
                                });
                            } else {
                                _this16.$message({
                                    message: data.message,
                                    type: "error"
                                });
                            }
                        });
                        _this16.$message({
                            message: "Distribute failed User:" + data.result,
                            type: "error"
                        });
                    }
                } else {
                    _this16.$message({
                        message: data.message,
                        type: "error"
                    });
                }
                _this16.loading = false;
            });
        },
        goToMixedPackageClaim: function goToMixedPackageClaim() {
            if (this.role === '3') {
                this.$router.push('/mixedPackageList');
            } else {
                this.$router.push('/mixedPackageClaim');
            }
        }
    },
    mounted: function mounted() {
        this.getInventory();
        this.getZeroInventory();
        this.getDoctorProductList();
        this.role = JSON.parse(window.sessionStorage.getItem("user")).roleId;
        if (this.role == '3') {
            this.getProductTemplateList();
            this.getSizeList();
        }
    }
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(17);

var _globalVar = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			firstLoading: false,
			secondLoading: false,
			thirdLoading: false,
			pageSize: _globalVar.defaultPageSize,

			activeName: "first",

			filters: {
				email: ''
			},

			members: [],

			groups: [],
			invitations: [],

			total: 0,

			invitationFilter: "",
			invitationTotalPage: 0,
			invitationPage: 1,

			membersFilter: "",
			membersTotalPage: 0,
			membersPage: 1,

			sels: [],
			editMemberObj: {},
			editMemberVisible: false,
			addGroupVisible: false,
			invitationVisible: false,

			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			},

			addFormVisible: false,
			addLoading: false,
			invitationRules: {
				role: [{ required: true, message: 'Role is required.', trigger: 'blur' }],
				email: [{ required: true, message: 'email is required.', trigger: 'blur' }, { validator: _util2.default.validateEmail, trigger: 'blur' }]
			},

			member: {
				id: "",
				userName: "",
				email: "",
				phone: "",
				status: "",
				pendingTransaction: 7,
				pendingAmount: "",
				alias: ""
			},
			group: {
				id: '',
				groupName: "",
				users: [],
				pendingTransaction: 7,
				pendingAmount: ""
			},
			invitation: {
				id: "",
				email: "",
				status: "",
				dateTime: "",
				role: ""
			}

		};
	},

	methods: {
		formatInvitationStatus: function formatInvitationStatus(row, column) {
			if (row.status === 0) {
				return "Pending";
			} else if (row.status === 1) {
				return "Approve";
			} else {
				return "Reject";
			}
		},
		formatTimesTamp: function formatTimesTamp(row, column) {
			return _util2.default.formatDate.format(new Date(row.createDate), 'yyyy-MM-dd hh:mm:ss');
		},
		handleInvitationPageChange: function handleInvitationPageChange(val) {
			this.invitationPage = val;
			this.getInvitations();
		},
		editInvitationStatus: function editInvitationStatus(id, status) {
			var _this = this;

			this.$confirm("Are you sure?", "Warning", {
				type: "warning"
			}).then(function () {
				(0, _memberService.editInvitationStatus)({ invitationNo: id, status: status }).then(function (res) {
					if (res.status === 200) {
						_this.$message({
							message: res.message,
							type: "success"
						});
						_this.getInvitations();
					} else {
						_this.$message({
							message: res.message,
							type: "error"
						});
					}
				});
			}).catch(function () {});
		},
		getInvitations: function getInvitations() {
			var _this2 = this;

			var para = {
				current: this.invitationPage,
				size: this.pageSize,
				condition: this.filters.email
			};

			this.firstLoading = true;
			(0, _memberService.getInvitations)(para).then(function (res) {
				_this2.firstLoading = false;
				if (res.status === 200) {
					_this2.invitations = res.result.records;
					_this2.invitationTotalPage = res.result.total;
				} else {
					_this2.$message({
						message: res.message,
						type: 'error'
					});
				}
			});
		},
		invitationRegister: function invitationRegister(param) {
			var _this3 = this;

			this.$refs.invitation.validate(function (valid) {
				if (valid) {
					(0, _memberService.invitationRegister)({ roleId: _this3.invitation.role, email: _this3.invitation.email }).then(function (res) {
						if (res.status === 200) {
							_this3.$message({
								message: 'Success',
								type: 'success'
							});
							_this3.invitationVisible = false;
							_this3.getInvitations();
						} else {
							_this3.$message({
								message: res.message,
								type: 'error'
							});
						}
					}).catch(function (error) {
						return console.log(error);
					});
				}
			});
		}
	},
	mounted: function mounted() {
		this.getInvitations();
	}
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _offerService = __webpack_require__(107);

var _warehouseService = __webpack_require__(50);

var _exportService = __webpack_require__(22);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

var _button = __webpack_require__(104);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
				components: {
								ElButton: _button2.default,
								ElOption: _option2.default },
				props: {
								'current-company': String
				},
				created: function created() {
								var _this = this;

								this.$on('changeDoctor', function (value) {
												setTimeout(function () {
																_this.getOpenOffers();
																_this.getWarehouse();
																_this.getProposedOffers();
																_this.getOfferHistroy();
												}, 300);
								});
				},
				data: function data() {
								return {
												loading: false,
												company: this.currentCompany,
												warehouses: [],
												options: [{
																label: 'Self Category',
																options: [{
																				value: '1',
																				label: 'FL 0001'
																}]
												}, {
																label: 'Warehouse',
																options: [{
																				value: '2',
																				label: 'FL 0002'
																}]
												}],

												pageSize: _globalVar.defaultPageSize,
												openOfferPage: 1,
												openOfferTotal: 0,

												proposedPage: 1,
												proposedTotal: 0,

												historyPage: 1,
												historyTotal: 0,

												expiredPage: 1,
												expiredTotal: 0,

												activeName: "first",
												filters: {
																historyStatus: "",
																historyFilter: "",
																proposedFilter: "",
																openOfferFilter: "",
																expiredFilter: "",
																name: ''
												},

												proposedList: [],

												historyList: [],

												openOffers: [],
												proposedOffers: [],

												expiredList: [],
												total: 0,
												page: 1,

												firstListLoading: false,
												secondListLoading: false,
												thirdListLoading: false,
												fourthListLoading: false,
												listLoading: false,
												sels: [],

												editFormVisible: false,
												editLoading: false,
												formRules: {
																warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
																quantity: [{ required: true, message: 'Quantity is required.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
												},

												editForm: {
																id: 0,
																name: '',
																sex: -1,
																age: 0,
																birth: '',
																addr: ''
												},

												takeOfferVisible: false,
												proposedOfferVisible: false,
												addLoading: false,
												proposedFormRules: {
																warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
																quantity: [{ required: true, message: 'Quantity is required.', trigger: 'blur' }, { validator: this.checkProposedQuantity, trigger: 'blur' }]
												},

												takeOffer: {
																createBy: "",
																price: "",
																quantity: 0,
																product: "",
																warehouseNo: ""
												},
												proposedOffer: {
																offer: "",
																createBy: "",
																price: "",
																quantity: "",
																product: "",
																warehouseNo: "",
																offerNo: ""
												}
								};
				},

				methods: {
								cancelProposed: function cancelProposed(id, status) {
												var _this2 = this;

												this.$confirm('Are you sure?', 'Warning', {
																type: 'warning'
												}).then(function () {
																(0, _offerService.removeProposedOffer)({ id: id }).then(function (res) {
																				if (res.status === 200) {
																								_this2.$message.success(res.message);
																								_this2.getProposedOffers();
																				} else {
																								_this2.$message.error(res.message);
																								_this2.getProposedOffers();
																				}
																});
												}).catch(function () {});
								},
								exportExcel: function exportExcel(url, fileName, type) {
												var param = {
																url: url,
																fileName: fileName,
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												(0, _exportService.postExportExcel)(param).then(function () {});
								},
								getOfferHistroy: function getOfferHistroy() {
												var _this3 = this;

												var param = {
																current: this.historyPage,
																size: this.pageSize,
																doctorNo: window.sessionStorage.getItem("currentCompany"),
																condition: this.filters.historyFilter,
																status: this.filters.historyStatus
												};
												this.thirdListLoading = true;
												(0, _offerService.getNurseOfferHistoryList)(param).then(function (data) {
																_this3.thirdListLoading = false;
																if (data.status === 200) {
																				_this3.historyList = data.result.records;
																				_this3.historyTotal = data.result.total;
																}
												});
								},
								getExpiredOffers: function getExpiredOffers() {
												var _this4 = this;

												var param = {
																current: this.expiredPage,
																size: this.pageSize,
																doctorNo: window.sessionStorage.getItem("currentCompany"),
																condition: this.filters.expiredFilter
												};
												this.fourthListLoading = true;
												(0, _offerService.expiredOffers)(param).then(function (data) {
																_this4.fourthListLoading = false;
																if (data.status === 200) {
																				_this4.expiredList = data.result.records;
																				_this4.expiredTotal = data.result.total;
																}
												});
								},
								selectProposedOffer: function selectProposedOffer(val) {
												var selected = this.proposedList.filter(function (item) {
																return item.offerNo === val;
												});
												if (selected && selected.length === 1) {
																this.proposedOffer.createBy = selected[0].createBy;
																this.proposedOffer.price = selected[0].price;
												}
								},
								showProposed: function showProposed() {
												var _this5 = this;

												this.getProposedOfferList().then(function () {
																_this5.proposedOfferVisible = true;
												});
								},
								getProposedOfferList: function getProposedOfferList() {
												var _this6 = this;

												var param = {
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												return (0, _offerService.getProposedOfferList)(param).then(function (data) {
																if (data.status === 200) {
																				_this6.proposedList = data.result;
																}
												});
								},
								formatProposedStatus: function formatProposedStatus(row, column) {
												if (row.status === 0) {
																return "Pending";
												} else if (row.status === 1) {
																return "Confirmed";
												} else {
																return "Rejected";
												}
								},
								requestProposed: function requestProposed() {
												var _this7 = this;

												this.$refs.proposedOffer.validate(function (valid) {
																if (valid) {
																				_this7.loading = true;
																				var param = {
																								doctorNo: window.sessionStorage.getItem("currentCompany"),
																								offerNo: _this7.proposedOffer.offerNo,
																								warehouseNo: _this7.proposedOffer.warehouseNo,
																								quantity: _this7.proposedOffer.quantity

																				};
																				(0, _offerService.requestProposedOffers)(param).then(function (data) {
																								_this7.loading = false;
																								if (data.status === 200) {
																												_this7.proposedOfferVisible = false;
																												_this7.$message.success(data.message);
																												_this7.$refs.proposedOffer.resetFields();
																												_this7.getProposedOffers();
																												_this7.getOpenOffers();
																								} else {
																												_this7.$message.error(data.message);
																								}
																				});
																}
												});
								},
								changeOfferPage: function changeOfferPage(val) {
												this.openOfferPage = val;
												this.getOpenOffers();
								},
								changeProposedPage: function changeProposedPage(val) {
												this.proposedPage = val;
												this.getProposedOffers();
								},
								changeHistoryPage: function changeHistoryPage(val) {
												this.historyPage = val;
												this.getOfferHistroy();
								},
								changeExpiredPage: function changeExpiredPage(val) {
												this.expiredPage = val;
												this.getExpiredOffers();
								},
								checkQuantity: function checkQuantity(rule, value, callback) {
												if (!value > 0) {
																return callback(new Error('Quantity must more than 1.'));
												} else if (value > this.takeOffer.leftNum) {
																return callback(new Error("Quantity can't more than left."));
												} else {
																callback();
												}
								},
								checkProposedQuantity: function checkProposedQuantity(rule, value, callback) {
												if (!value > 0) {
																return callback(new Error('Quantity must more than 1.'));
												} else {
																callback();
												}
								},
								formatTimesTamp: function formatTimesTamp(row, column) {
												return _util2.default.formatDate.format(new Date(row.createDate), 'yyyy-MM-dd hh:mm:ss');
								},
								getWarehouse: function getWarehouse() {
												var _this8 = this;

												var param = {
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												(0, _warehouseService.getNurseWarehouses)(param).then(function (res) {
																if (res.status === 200) {
																				_this8.warehouses = [];
																				var self = {
																								label: 'Self Storage',
																								options: []
																				};
																				var doctors = {
																								label: 'Warehouse',
																								options: []
																				};
																				res.result.forEach(function (item) {
																								if (item.isDoctor === 0) {
																												doctors.options.push(item);
																								} else {
																												self.options.push(item);
																								}
																				});
																				if (self.options.length > 0) {
																								_this8.warehouses.push(self);
																				}
																				if (doctors.options.length > 0) {
																								_this8.warehouses.push(doctors);
																				}
																}
												});
								},
								changeProposedOffer: function changeProposedOffer() {
												this.proposedOffer.product = this.proposedOffer.offer.product;
												this.proposedOffer.price = this.proposedOffer.offer.price;
												this.proposedOffer.createBy = this.proposedOffer.offer.createBy;
								},
								showTakeOffer: function showTakeOffer(offerId) {
												var _this9 = this;

												(0, _offerService.getOfferById)({ offerNo: offerId }).then(function (res) {
																if (res.status === 200) {
																				if (res.result.offer.leftNum > 0) {
																								_this9.takeOffer.offerNo = res.result.offer.offerNo;
																								_this9.takeOffer.product = res.result.productName;
																								_this9.takeOffer.price = res.result.offer.price;
																								_this9.takeOffer.leftNum = res.result.offer.leftNum;
																								_this9.takeOffer.bouns = res.result.offer.bouns;
																								_this9.takeOffer.createBy = res.result.doctorName;
																								_this9.takeOfferVisible = true;
																				} else {
																								_this9.$confirm("Offer quantity is take over, do you want to request a proposed?", "Warning", {
																												type: "warning"
																								}).then(function () {
																												return _this9.getProposedOfferList();
																								}).then(function () {
																												_this9.proposedOfferVisible = true;
																												_this9.proposedOffer.productName = res.result.productName;
																												_this9.proposedOffer.createBy = res.result.doctorName;
																												_this9.proposedOffer.price = res.result.offer.price;
																												_this9.proposedOffer.offerNo = res.result.offer.offerNo;
																								}).catch(function () {});
																				}
																}
												});
								},
								showProposedOffer: function showProposedOffer(offerId) {
												var _this10 = this;

												this.getProposedOfferList().then(function () {
																return (0, _offerService.getOfferById)({ offerNo: offerId });
												}).then(function (res) {
																if (res.status === 200) {
																				_this10.proposedOfferVisible = true;
																				_this10.proposedOffer.productName = res.result.productName;
																				_this10.proposedOffer.createBy = res.result.doctorName;
																				_this10.proposedOffer.price = res.result.offer.price;
																				_this10.proposedOffer.offerNo = res.result.offer.offerNo;
																}
												});
								},
								handleTakeOffer: function handleTakeOffer() {
												var _this11 = this;

												var param = {
																offerNo: this.takeOffer.offerNo,
																warehouseNo: this.takeOffer.warehouseNo,
																quantity: this.takeOffer.quantity,
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												this.$refs.takeOffer.validate(function (valid) {
																if (valid) {
																				_this11.loading = true;
																				(0, _offerService.takeOffer)(param).then(function (res) {
																								_this11.loading = false;
																								if (res.status === 200) {
																												_this11.$message.success(res.message);
																												_this11.takeOfferVisible = false;
																												_this11.$refs.takeOffer.resetFields();
																												_this11.getOpenOffers();
																												_this11.getOfferHistroy();
																								} else {
																												_this11.$message.error(res.message);
																								}
																				});
																}
												});
								},
								handleCurrentChange: function handleCurrentChange(val) {
												this.page = val;
								},
								getOpenOffers: function getOpenOffers() {
												var _this12 = this;

												var param = {
																current: this.openOfferPage,
																size: this.pageSize,
																condition: this.filters.openOfferFilter,
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												this.firstListLoading = true;
												(0, _offerService.getNurseOffer)(param).then(function (res) {
																_this12.firstListLoading = false;
																_this12.openOffers = res.result.records;
																_this12.openOfferTotal = res.result.total;
												});
								},
								getProposedOffers: function getProposedOffers() {
												var _this13 = this;

												var param = {
																current: this.proposedPage,
																size: this.pageSize,
																condition: this.filters.proposedFilter,
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												this.secondListLoading = true;
												(0, _offerService.getProposedOffers)(param).then(function (data) {
																_this13.secondListLoading = false;
																if (data.status === 200) {
																				_this13.proposedOffers = data.result.records;
																				_this13.proposedTotal = data.result.total;
																}
												});
								}
				},
				mounted: function mounted() {
								this.getOpenOffers();
								this.getProposedOffers();
								this.getWarehouse();
								this.getOfferHistroy();
								this.getExpiredOffers();
								var active = this.$route.params.active;
								if (active) {
												this.activeName = active;
								}
				}
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _outboundService = __webpack_require__(108);

var _button = __webpack_require__(104);

var _button2 = _interopRequireDefault(_button);

var _main = __webpack_require__(298);

var _main2 = _interopRequireDefault(_main);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

var _input = __webpack_require__(105);

var _input2 = _interopRequireDefault(_input);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(22);

var _jsbarcode = __webpack_require__(726);

var _jsbarcode2 = _interopRequireDefault(_jsbarcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		ElInput: _input2.default,
		ElOption: _option2.default,
		ElLink: _main2.default,
		ElButton: _button2.default },
	created: function created() {
		var _this = this;

		this.$on('changeDoctor', function (value) {
			setTimeout(function () {
				_this.getWorkingOutboundList();
				_this.getArchivedOutboundList();
			}, 300);
		});
	},
	data: function data() {
		return {
			currentCompany: "",
			activeName: "first",
			filters: {
				workingFilter: "",
				workingMainFilter: "",
				archivedFilter: "",
				archivedMainFilter: "",
				name: ''
			},

			pageSize: _globalVar.defaultPageSize,

			workingList: [],
			workingPage: 1,
			workingTotal: 0,
			workingLoading: false,

			archivedList: [],
			archivedPage: 1,
			archivedTotal: 0,
			archivedLoading: false,

			workingOutboundList: [],
			archivedOutboundList: [],
			total: 0,
			page: 1,
			listLoading: false,
			editMemberObj: {},
			packageDetailVisible: false,
			addGroupVisible: false,
			invitationVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},
			print: {
				instruction: "",
				note: "",
				outboundNo: "",
				outboundShipment: "",
				splitPackagesNum: 1,
				company: "",
				upcs: ""
			},

			editForm: {
				id: 0,
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			},
			detail: {},
			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			member: {
				id: "",
				userName: "",
				email: "",
				phone: "",
				status: "",
				pendingTransaction: 7,
				pendingAmount: ""
			},
			group: {
				id: '',
				groupName: "",
				users: [],
				pendingTransaction: 7,
				pendingAmount: ""
			},
			invitation: {
				id: "",
				email: "",
				status: "",
				dateTime: "",
				role: ""
			}

		};
	},

	methods: {
		exportExcel: function exportExcel(url, fileName, type) {
			var param = {
				url: url,
				fileName: fileName,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				status: type
			};
			(0, _exportService.postExportExcel)(param).then(function () {});
		},
		archivedOutbound: function archivedOutbound(id) {
			var _this2 = this;

			this.$confirm('Are you sure?', 'Warning', {
				type: 'warning'
			}).then(function () {
				var param = {
					outboundNo: id,
					status: 2
				};
				(0, _outboundService.updateOutboundStatus)(param).then(function (data) {
					if (data.status === 200) {
						_this2.$message.success(data.message);
						_this2.getWorkingOutboundList();
						_this2.getArchivedOutboundList();
					} else {
						_this2.$message.error(data.message);
					}
				});
			}).catch(function () {});
		},
		download: function download(id) {
			window.open(_globalVar.serverUrl + "/outboundFile/exportPackageLabelImageById?outboundNo=" + id, "_blank");
		},
		tableRowClassName: function tableRowClassName(_ref) {
			var row = _ref.row,
			    rowIndex = _ref.rowIndex;

			if (row.priority === 2) {
				return 'urgent-row';
			} else if (row.priority === 1) {
				return 'Medium-row';
			}
			return "";
		},
		packageDetail: function packageDetail(row) {
			this.detail = row;
			this.packageDetailVisible = true;
		},
		changeWorkingList: function changeWorkingList(val) {
			this.workingPage = val;
			this.getWorkingOutboundList();
		},
		getWorkingOutboundList: function getWorkingOutboundList() {
			var _this3 = this;

			var param = {
				current: this.workingPage,
				size: this.pageSize,
				status: 1,
				condition: this.filters.workingFilter,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				main: this.filters.workingMainFilter
			};
			this.workingLoading = true;
			(0, _outboundService.getOutboundList)(param).then(function (data) {
				_this3.workingLoading = false;
				if (data.status === 200) {
					_this3.workingList = data.result.records;
					_this3.workingTotal = data.result.total;
				}
			});
		},
		changeArchivedList: function changeArchivedList(val) {
			this.archivedPage = val;
			this.getArchivedOutboundList();
		},
		getArchivedOutboundList: function getArchivedOutboundList() {
			var _this4 = this;

			var param = {
				current: this.archivedPage,
				size: this.pageSize,
				status: 2,
				condition: this.filters.archivedFilter,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				main: this.filters.archivedMainFilter
			};
			this.archivedLoading = true;
			(0, _outboundService.getOutboundList)(param).then(function (data) {
				_this4.archivedLoading = false;
				if (data.status === 200) {
					_this4.archivedList = data.result.records;
					_this4.archivedTotal = data.result.total;
				}
			});
		},
		printNote: function printNote(row) {
			var _this5 = this;

			this.print.instruction = row.instruction;
			this.print.upcs = row.upcs;
			this.print.note = row.note;
			this.print.outboundNo = row.outboundId;
			this.print.company = row.company;
			this.print.outboundShipment = row.productName;
			this.print.splitPackagesNum = row.splitPackagesNum;
			this.packageDetailVisible = true;

			setTimeout(function () {
				$("#barcode1").attr('src', '');
				$("#barcode2").attr('src', '');
				$("#barcode3").attr('src', '');
				$("#barcode4").attr('src', '');
				$("#barcode5").attr('src', '');
				$("#barcode6").attr('src', '');
				if (_this5.print.upcs) {
					_this5.print.upcs.split("<br>").forEach(function (item, index) {
						var barHeight = 18;
						var svgId = "#barcode" + (index + 1);
						if (item) {
							(0, _jsbarcode2.default)(svgId, item, {
								format: "CODE128",
								width: 1,
								height: barHeight,
								lineColor: "#000",
								displayValue: false,
								margin: 2 });
						}
					});
				}

				var element = document.getElementById("printArea");
				_this5.$print(element);
				_this5.packageDetailVisible = false;
			}, 800);
		}
	},
	mounted: function mounted() {
		this.getWorkingOutboundList();
		this.getArchivedOutboundList();
	}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(286)))

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _securityService = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	created: function created() {
		var _this = this;

		this.$on('changeDoctor', function (value) {
			setTimeout(function () {
				_this.getNurseHome();
			}, 300);
		});
	},
	data: function data() {
		return {
			offers: {
				active: 0,
				expired: 0,
				proposed: 0
			},
			inbound: {
				inbound: 0,
				reported: 0
			},
			outbound: {
				outbound: 0
			},
			balance: {
				request: 0
			},
			loading: false
		};
	},

	methods: {
		getNurseHome: function getNurseHome() {
			var _this2 = this;

			var param = {
				doctorNo: window.sessionStorage.getItem("currentCompany")
			};
			this.loading = true;
			(0, _securityService.getNurseHome)(param).then(function (data) {
				_this2.loading = false;
				if (data.status === 200) {
					_this2.offers.active = data.result.activeOffer;
					_this2.offers.expired = data.result.expiredOffer;
					_this2.offers.proposed = data.result.proposedOffer;
					_this2.inbound.inbound = data.result.inboundItems;
					_this2.inbound.reported = data.result.reportItems;
					_this2.outbound.outbound = data.result.outBoundItems;
					_this2.balance.request = data.result.payment;
				} else {
					_this2.$message.error(data.message);
				}
			});
		}
	},
	mounted: function mounted() {
		this.getNurseHome();
	}
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueQuillEditor = __webpack_require__(76);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(17);

var _paymentService = __webpack_require__(109);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    created: function created() {
        var _this = this;

        this.$on('changeDoctor', function (value) {
            setTimeout(function () {
                _this.getPaymentRequest();
                _this.getPendingTransaction();
                _this.getBalance();
                _this.getTransactionHistory();
            }, 300);
        });
    },
    data: function data() {
        return {
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },
            currentUser: "",
            banks: [],
            currentCompany: "",
            activeName: "first",
            filters: {
                pendingFilter: "",
                paymentFilter: "",
                historyFilter: "",
                paymentStatus: "",
                name: ''
            },

            pageSize: _globalVar.defaultPageSize,
            paymentPage: 1,
            paymentTotal: 0,

            pendingPage: 1,
            pendingTotal: 0,

            balancePage: 1,
            balanceTotal: 0,

            historyPage: 1,
            historyTotal: 0,

            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,
            fourthListLoading: false,

            offers: [],
            transactions: [],
            pendingPayments: [],
            payments: [],
            paymentHistory: [],
            balances: [],
            total: 0,
            invitations: [],
            invitationTotalPage: 0,
            invitationPage: 1,
            listLoading: false,
            sels: [],
            requestVisible: false,
            addGroupVisible: false,
            invitationVisible: false,
            editLoading: false,
            requestFormRules: {
                amount: [{ required: true, message: 'Amount is required.', trigger: 'blur' }, { validator: this.validateAmount, trigger: 'blur' }],
                bank: [{ required: true, message: '', trigger: 'blur' }]
            },

            addFormVisible: false,
            loading: false,

            payment: {
                amount: "",
                bank: "",
                note: "",
                balance: 0,
                minPayment: 0
            }
        };
    },

    methods: {
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },

        formatMoney: function formatMoney(s, n) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            if (s < 0) {
                l = (Math.abs(s.split(".")[0]) + "").split("").reverse();
            }
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            if (s < 0) {
                t += "-";
            }
            var result = t.split("").reverse().join("") + "." + r;
            if (result == null || result == undefined || result.indexOf('NaN') >= 0 || result.indexOf('Undefined') >= 0) {
                result = '0.00';
            }
            return result;
        },
        showAddPayment: function showAddPayment() {
            var _this2 = this;

            var user = JSON.parse(sessionStorage.getItem("user"));
            var param = {
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                nurseNo: user.userNo
            };
            (0, _memberService.getUserBalance)(param).then(function (res) {
                if (res.status === 200) {
                    _this2.payment.balance = res.result.balance;
                    _this2.payment.minPayment = res.result.minPayment;
                    _this2.requestVisible = true;
                }
            });
        },
        tableRowClassName: function tableRowClassName(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            if (row.amount < 0 || row.total < 0) {
                return 'reported-row';
            } else {
                return '';
            }
        },
        changePaymentRequest: function changePaymentRequest(val) {
            this.paymentPage = val;
            this.getPaymentRequest();
        },
        changePendingRequest: function changePendingRequest(val) {
            this.pendingPage = val;
            this.getPendingTransaction();
        },
        changeBalance: function changeBalance(val) {
            this.balancePage = val;
            this.getBalance();
        },
        changeTransactionHistory: function changeTransactionHistory(val) {
            this.historyPage = val;
            this.getTransactionHistory();
        },
        getTransactionHistory: function getTransactionHistory() {
            var _this3 = this;

            var param = {
                current: this.historyPage,
                size: this.pageSize,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                condition: this.filters.historyFilter
            };
            this.thirdListLoading = true;
            (0, _paymentService.getTransactionHistory)(param).then(function (data) {
                _this3.thirdListLoading = false;
                if (data.status === 200) {
                    _this3.transactions = data.result.records;
                    _this3.historyTotal = data.result.total;
                }
            });
        },
        editPaymentStatus: function editPaymentStatus(paymentNo, status) {
            var _this4 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    paymentNo: paymentNo,
                    status: status
                };
                (0, _paymentService.editPaymentStatus)(param).then(function (data) {
                    if (data.status === 200) {
                        _this4.$message.success(data.message);
                        _this4.getPaymentRequest();
                    }
                });
            }).catch(function () {});
        },
        getBankList: function getBankList() {
            var _this5 = this;

            (0, _paymentService.getBankList)({}).then(function (data) {
                if (data.status === 200) {
                    _this5.banks = data.result;
                }
            });
        },
        getPendingTransaction: function getPendingTransaction() {
            var _this6 = this;

            var param = {
                current: this.pendingPage,
                size: this.pageSize,
                condition: this.filters.pendingFilter,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.secondListLoading = true;
            (0, _paymentService.getPendingTransaction)(param).then(function (data) {
                _this6.secondListLoading = false;
                if (data.status === 200) {
                    _this6.pendingPayments = data.result.records;
                    _this6.pendingTotal = data.result.total;
                }
            });
        },
        requestPayment: function requestPayment() {
            var _this7 = this;

            this.$refs.payment.validate(function (valid) {
                if (valid) {
                    _this7.loading = true;
                    var param = {
                        amount: _this7.payment.amount,
                        bankNo: _this7.payment.bank,
                        doctorNo: window.sessionStorage.getItem("currentCompany"),
                        nurseNote: _this7.payment.note
                    };
                    (0, _paymentService.addPaymentRequest)(param).then(function (data) {
                        _this7.loading = false;
                        if (data.status === 200) {
                            _this7.$message.success(data.message);
                            _this7.requestVisible = false;
                            _this7.$refs.payment.resetFields();
                            _this7.getPaymentRequest();
                            _this7.getTransactionHistory();
                        }
                    });
                }
            });
        },
        validateAmount: function validateAmount(rule, value, callback) {
            if (value > 0) {
                if (value < this.payment.minPayment) {
                    callback(new Error('Your amount must be greater than $' + this.payment.minPayment + '.'));
                } else {
                    callback();
                }
            } else {
                callback(new Error('Amount is required.'));
            }
        },
        getBalance: function getBalance() {
            var _this8 = this;

            var param = {
                current: this.balancePage,
                size: this.pageSize,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.fourthListLoading = true;
            (0, _paymentService.getBalance)(param).then(function (data) {
                _this8.fourthListLoading = false;
                if (data.status === 200) {
                    _this8.balances = data.result.records;
                    _this8.balanceTotal = data.result.total;
                }
            });
        },
        handleClick: function handleClick() {},
        getPaymentRequest: function getPaymentRequest() {
            var _this9 = this;

            var param = {
                current: this.paymentPage,
                size: this.pageSize,
                status: this.filters.paymentStatus,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.firstListLoading = true;
            (0, _paymentService.getPaymentRequest)(param).then(function (data) {
                _this9.firstListLoading = false;
                if (data.status === 200) {
                    _this9.payments = data.result.records;
                    _this9.paymentTotal = data.result.total;
                }
            });
        }
    },
    mounted: function mounted() {
        this.getPendingTransaction();
        this.getPaymentRequest();
        this.getBalance();
        this.getBankList();
        this.getTransactionHistory();
    }
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _warehouseService = __webpack_require__(50);

var _globalVar = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            categoryOption: [{
                value: 'Bill Pay',
                label: 'Bill Pay'
            }, {
                value: 'Bank Transfer',
                label: 'Bank Transfer'
            }],
            currencyOption: [{
                value: 'USD',
                label: 'United States Dollar'
            }, {
                value: 'CNY',
                label: 'China Yuan Renminbi'
            }, {
                value: 'BTC',
                label: 'Bitcoin'
            }],
            filters: {
                name: ''
            },
            editWarehouseObj: {},
            warehouses: [],

            listLoading: false,
            editFormVisible: false,
            editLoading: false,
            formRules: {
                state: [{ required: true, message: 'State is required', trigger: 'blur' }],
                city: [{ required: true, message: 'City is required', trigger: 'blur' }],
                address: [{ required: true, message: 'Address is required', trigger: 'blur' }],
                zipCode: [{ required: true, message: 'Zip Code is required', trigger: 'blur' }]
            },
            addFormVisible: false,
            addLoading: false,

            warehouseForm: {
                state: '',
                city: '',
                address: '',
                zipCode: '',
                admin: ''
            },

            page: 1,
            pageSize: _globalVar.defaultPageSize,
            total: 0

        };
    },

    methods: {
        formatAddress: function formatAddress(row, column) {
            return row.state + " " + row.city + " " + row.address;
        },
        pageChange: function pageChange(val) {
            this.page = val;
            this.getWarehouses();
        },
        deleteWarehouses: function deleteWarehouses(id) {
            var _this = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    warehouseNo: id
                };
                (0, _warehouseService.deleteWarehouses)(param).then(function (res) {
                    if (res.status === 200) {
                        _this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        _this.getWarehouses();
                    } else {
                        _this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }).catch(function () {});
        },
        getWarehousesById: function getWarehousesById(id) {
            var _this2 = this;

            var param = {
                warehouseNo: id
            };
            (0, _warehouseService.getWarehousesById)(param).then(function (res) {
                if (res.status === 200) {
                    _this2.editWarehouseObj = res.result.warehouse;
                    _this2.editFormVisible = true;
                } else {
                    _this2.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getWarehouses: function getWarehouses() {
            var _this3 = this;

            this.listLoading = true;
            var param = {
                current: this.page,
                size: this.pageSize,
                condition: this.filters.name
            };
            (0, _warehouseService.getWarehouses)(param).then(function (res) {
                _this3.listLoading = false;
                if (res.status === 200) {
                    _this3.warehouses = res.result.records;
                    _this3.total = res.result.total;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                _this3.listLoading = false;
                console.log(error);
            });
        },
        addWarehouse: function addWarehouse() {
            var _this4 = this;

            this.$refs.warehouseForm.validate(function (valid) {
                if (valid) {
                    _this4.addLoading = true;
                    (0, _warehouseService.addWarehouses)(_this4.warehouseForm).then(function (res) {
                        _this4.addLoading = false;
                        _this4.$refs["warehouseForm"].resetFields();
                        if (res.status === 200) {
                            _this4.$message({
                                message: res.message,
                                type: 'success'
                            });
                            _this4.addFormVisible = false;
                            _this4.getWarehouses();
                        } else {
                            _this4.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this4.addLoading = false;
                    });
                }
            });
        },
        editWarehouse: function editWarehouse() {
            var _this5 = this;

            this.$refs.editWarehouseObj.validate(function (valid) {
                if (valid) {
                    _this5.addLoading = true;
                    (0, _warehouseService.addWarehouses)(_this5.editWarehouseObj).then(function (res) {
                        _this5.addLoading = false;
                        if (res.status === 200) {
                            _this5.$message({
                                message: res.message,
                                type: 'success'
                            });
                            _this5.editFormVisible = false;
                            _this5.getWarehouses();
                        } else {
                            _this5.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this5.addLoading = false;
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getWarehouses();
    }
};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _securityService = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			account: {
				userName: "",
				phone: "",
				email: ""
			},
			loading: false,
			formRules: {
				phone: [{ validator: this.checkPhone, trigger: 'blur' }]
			}

		};
	},

	methods: {
		checkPhone: function checkPhone(rule, value, callback) {
			if (value.length === 10) {
				callback();
			} else {
				return callback(new Error("Phone only allow 10 digits."));
			}
		},
		changeUserInfo: function changeUserInfo() {
			var _this = this;

			this.$refs.account.validate(function (valid) {
				if (valid) {
					var param = {
						mobile: _this.account.phone
					};
					_this.loading = true;
					(0, _securityService.changeUserInfo)(param).then(function (res) {
						_this.loading = false;
						if (res.status === 200) {
							_this.getCurrentUser();
							_this.$message({
								message: res.message,
								type: "success"
							});
						} else {
							_this.$message({
								message: res.message,
								type: "error"
							});
						}
					});
				}
			});
		},
		getCurrentUser: function getCurrentUser() {
			var _this2 = this;

			(0, _securityService.getCurrentUser)().then(function (res) {
				if (res.status === 200) {
					_this2.account.userName = res.result.username;
					_this2.account.email = res.result.email;
					_this2.account.phone = res.result.mobile;
				}
			});
		}
	},
	mounted: function mounted() {
		var user = sessionStorage.getItem("user");
		this.getCurrentUser();
	}
};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(143);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			users: [],
			total: 0,
			page: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			addForm: {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			}

		};
	},

	methods: {
		formatSex: function formatSex(row, column) {
			return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
		},
		getUsers: function getUsers() {
			var _this = this;

			var para = {
				page: this.page,
				name: this.filters.name
			};
			this.listLoading = true;

			(0, _api.getUserListPage)(para).then(function (res) {
				_this.total = res.data.total;
				_this.users = res.data.users;
				_this.listLoading = false;
			});
		},

		handleDel: function handleDel(index, row) {
			var _this2 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(function () {
				_this2.listLoading = true;

				var para = { id: row.id };
				(0, _api.removeUser)(para).then(function (res) {
					_this2.listLoading = false;

					_this2.$message({
						message: '删除成功',
						type: 'success'
					});
					_this2.getUsers();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this3.editLoading = true;

						var para = (0, _assign2.default)({}, _this3.editForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.editUser)(para).then(function (res) {
							_this3.editLoading = false;

							_this3.$message({
								message: '提交成功',
								type: 'success'
							});
							_this3.$refs['editForm'].resetFields();
							_this3.editFormVisible = false;
							_this3.getUsers();
						});
					});
				}
			});
		},

		addSubmit: function addSubmit() {
			var _this4 = this;

			this.$refs.addForm.validate(function (valid) {
				if (valid) {
					_this4.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this4.addLoading = true;

						var para = (0, _assign2.default)({}, _this4.addForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.addUser)(para).then(function (res) {
							_this4.addLoading = false;

							_this4.$message({
								message: '提交成功',
								type: 'success'
							});
							_this4.$refs['addForm'].resetFields();
							_this4.addFormVisible = false;
							_this4.getUsers();
						});
					});
				}
			});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this5 = this;

			var ids = this.sels.map(function (item) {
				return item.id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then(function () {
				_this5.listLoading = true;

				var para = { ids: ids };
				(0, _api.batchRemoveUser)(para).then(function (res) {
					_this5.listLoading = false;

					_this5.$message({
						message: '删除成功',
						type: 'success'
					});
					_this5.getUsers();
				});
			}).catch(function () {});
		}
	},
	mounted: function mounted() {}
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _paymentService = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            categoryOption: [{
                value: 'Bill Pay',
                label: 'Bill Pay'
            }, {
                value: 'Bank Transfer',
                label: 'Bank Transfer'
            }],
            currencyOption: [{
                value: 'USD',
                label: 'United States Dollar'
            }, {
                value: 'CNY',
                label: 'China Yuan Renminbi'
            }, {
                value: 'BTC',
                label: 'Bitcoin'
            }],
            filters: {
                name: ''
            },
            list: [],
            page: 1,
            pageSize: _globalVar.defaultPageSize,
            total: 0,
            loading: false,
            listLoading: false,
            sels: [],

            editFormVisible: false,
            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            addFormVisible: false,
            addFormRules: {
                category: [{ required: true, message: 'Category is required.', trigger: 'blur' }],
                currency: [{ required: true, message: 'Currency is required.', trigger: 'blur' }],
                accountNumber: [{ required: true, message: 'Account Number is required.', trigger: 'blur' }]
            },

            payment: {
                category: '',
                currency: '',
                bankName: '',
                accountType: '',
                accountHolder: '',
                accountNumber: '',
                bankAddress: ''
            },
            editPayment: {
                bankNo: '',
                category: '',
                currency: '',
                bankName: '',
                accountType: '',
                accountHolder: '',
                accountNumber: '',
                bankAddress: ''
            }

        };
    },

    methods: {
        showEditBank: function showEditBank(id) {
            var _this = this;

            (0, _paymentService.queryBankById)({ bankNo: id }).then(function (res) {
                if (res.status === 200) {
                    _this.editPayment = res.result.bank;
                    _this.editFormVisible = true;
                } else {
                    _this.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        editBank: function editBank() {
            var _this2 = this;

            this.$refs.editPayment.validate(function (valid) {
                if (valid) {
                    var params = {
                        bankNo: _this2.editPayment.bankNo,
                        category: _this2.editPayment.category,
                        currency: _this2.editPayment.currency,
                        bankName: _this2.editPayment.bankName,
                        accountType: _this2.editPayment.accountType,
                        accountHolder: _this2.editPayment.accountHolder,
                        accountNumber: _this2.editPayment.accountNumber,
                        bankAddress: _this2.editPayment.bankAddress
                    };
                    _this2.loading = true;
                    (0, _paymentService.addBanks)(params).then(function (res) {
                        _this2.loading = false;
                        if (res.status === 200) {
                            _this2.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this2.$refs.editPayment.resetFields();
                            _this2.editFormVisible = false;
                            _this2.getNursePayments();
                        } else {
                            _this2.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this2.loading = false;
                    });
                }
            });
        },
        addBank: function addBank() {
            var _this3 = this;

            this.$refs.payment.validate(function (valid) {
                if (valid) {
                    var params = {
                        category: _this3.payment.category,
                        currency: _this3.payment.currency,
                        bankName: _this3.payment.bankName,
                        accountType: _this3.payment.accountType,
                        accountHolder: _this3.payment.accountHolder,
                        accountNumber: _this3.payment.accountNumber,
                        bankAddress: _this3.payment.bankAddress
                    };
                    _this3.loading = true;
                    (0, _paymentService.addBanks)(params).then(function (res) {
                        _this3.loading = false;
                        if (res.status === 200) {
                            _this3.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this3.$refs.payment.resetFields();
                            _this3.addFormVisible = false;
                            _this3.getNursePayments();
                        } else {
                            _this3.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this3.loading = false;
                    });
                }
            });
        },
        pageChange: function pageChange(val) {
            this.page = val;
            this.getNursePayments();
        },
        deleteBank: function deleteBank(id) {
            var _this4 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                (0, _paymentService.deleteNurseBanks)({ bankNo: id }).then(function (res) {
                    if (res.status === 200) {
                        _this4.$message({
                            message: res.message,
                            type: "success"
                        });
                        _this4.getNursePayments();
                    } else {
                        _this4.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                });
            }).catch(function () {});
        },
        getNursePayments: function getNursePayments() {
            var _this5 = this;

            this.listLoading = true;
            var params = {
                current: this.page,
                size: this.pageSize,
                condition: this.filters.name
            };
            (0, _paymentService.getNurseBanks)(params).then(function (res) {
                _this5.listLoading = false;
                if (res.status === 200) {
                    _this5.list = res.result.records;
                    _this5.total = res.result.total;
                } else {
                    _this5.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }).catch(function (err) {
                _this5.listLoading = false;
                console.log(err);
            });
        }
    },
    mounted: function mounted() {
        this.getNursePayments();
    }
};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _securityService = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            account: {
                old: "",
                new: "",
                confirm: ""
            },
            rule: {
                old: [{ required: true, message: 'Old password is required.', trigger: 'blur' }],
                new: [{ required: true, message: 'New Password is required.', trigger: 'blur' }],
                confirm: [{ required: true, message: 'Confirm Password is required.', trigger: 'blur' }, { validator: this.confirmPassword, trigger: 'blur' }]
            }
        };
    },

    methods: {
        confirmPassword: function confirmPassword(rule, value, callback) {
            if (this.account.new === this.account.confirm) {
                callback();
            } else {
                callback(new Error('Please confirm Password.'));
            }
        },
        changePassword: function changePassword() {
            var _this = this;

            this.$refs.account.validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    var user = JSON.parse(sessionStorage.getItem("user"));
                    var param = {
                        username: user.username,
                        password: _this.account.old,
                        newPassword: _this.account.new,
                        reNewPassword: _this.account.confirm
                    };
                    (0, _securityService.changePassword)(param).then(function (res) {
                        _this.loading = false;
                        if (res.status === 200) {
                            _this.$refs.account.resetFields();
                            _this.$message({
                                message: res.message,
                                type: 'Password changed success, Please login again.'
                            });
                            setTimeout(function () {
                                sessionStorage.removeItem('user');
                                sessionStorage.removeItem('authorization');
                                window.location.href = "/";
                            }, 3000);
                        } else {
                            _this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (res) {
                        console.log(res);
                        _this.loading = false;
                    });
                }
            });
        }
    },
    mounted: function mounted() {}
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _securityService = __webpack_require__(49);

var inviteId = "";
var validate = false;
exports.default = {
    data: function data() {
        return {
            validate: validate,
            laoding: false,
            ruleForm2: {
                inviteId: inviteId,
                role: "",
                username: '',
                password: '',
                rePassword: ''
            },
            rules2: {
                username: [{ required: true, message: 'Please enter username', trigger: 'blur' }],
                password: [{ required: true, message: 'Please enter password', trigger: 'blur' }],
                rePassword: [{ required: true, message: 'Please confirm password', trigger: 'blur' }, { validator: this.validatePassword, trigger: 'blur' }]
            },
            checked: true
        };
    },

    methods: {
        validatePassword: function validatePassword(rule, value, callback) {
            if (this.ruleForm2.password !== this.ruleForm2.rePassword) {
                callback(new Error('Password not match.'));
            } else {
                callback();
            }
        },
        submitRegister: function submitRegister() {},
        handleSubmit: function handleSubmit(ev) {
            var _this2 = this;

            var _this = this;
            this.$refs.ruleForm2.validate(function (valid) {
                if (valid) {
                    _this2.laoding = true;
                    var params = {
                        userName: _this2.ruleForm2.username,
                        password: _this2.ruleForm2.password,
                        inviteId: _this2.ruleForm2.inviteId
                    };
                    (0, _securityService.register)(params).then(function (data) {
                        _this2.laoding = false;
                        if (data.status === 200) {
                            _this2.$message.success("Regist Success.");
                            setTimeout(function () {
                                _this2.$router.push({ path: "/login" });
                            }, 3000);
                        } else {
                            _this2.$message.error(data.message);
                        }
                    }).catch(function (error) {
                        _this2.laoding = false;
                        console.log(error);
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
    created: function created() {
        var _this3 = this;

        var query = this.$route.query;
        if (!query.id) {
            this.$router.push({ path: "/login" });
        } else {
            this.ruleForm2.inviteId = query.id;
            (0, _securityService.validateRegister)({ id: this.ruleForm2.inviteId }).then(function (data) {
                if (data.status === 200) {
                    _this3.validate = true;
                    _this3.ruleForm2.role = data.result.roleName;
                } else {
                    _this3.validate = false;
                    setTimeout(function () {
                        _this3.$router.push({ path: "/login" });
                    }, 3000);
                    _this3.$message.error(data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    }
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(61);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(17);

var _inboundService = __webpack_require__(77);

var _option = __webpack_require__(24);

var _option2 = _interopRequireDefault(_option);

var _input = __webpack_require__(105);

var _input2 = _interopRequireDefault(_input);

var _globalVar = __webpack_require__(7);

var _warehouseService = __webpack_require__(50);

var _exportService = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	created: function created() {
		var _this = this;

		this.$on('changeDoctor', function (value) {
			setTimeout(function () {
				_this.getToConfirmTrackingList();
				_this.getWarehouses();
				_this.getHistoryList();
			}, 300);
		});
	},

	components: {
		ElInput: _input2.default,
		ElOption: _option2.default },
	data: function data() {
		return {
			text: "",
			warehouses: [],
			headers: {
				Authorization: window.sessionStorage.getItem("authorization")
			},
			uploadUrl: _globalVar.serverUrl + "/multiExcel/batchInboundExcelImport",
			placeholder: "trackNum,upc,quantity,note\r\n" + "trackNum,upc,quantity,note",
			currentCompany: "",
			activeName: "first",
			filters: {
				toConfirmFilter: "",
				historyFilter: "",
				name: ''
			},

			batchNumbers: [],
			bulkConfirmList: [],
			bulkRemoveList: [],
			bulkReverseList: [],

			pageSize: _globalVar.defaultPageSize,

			toConfirmPage: 1,
			toConfirmTotal: 0,

			historyPage: 1,
			historyTotal: 0,

			firstListLoading: false,
			secondListLoading: false,

			toConfirmList: [],
			confirmInbound: [],
			reportedInbound: [],
			inboundHistory: [],
			total: 0,
			page: 1,
			listLoading: false,

			textImportVisible: false,
			excelImportVisible: false,

			editInbound: {},
			editInboundHistoryVisible: false,
			editToConfirmInboundVisible: false,
			bulkConfirmVisible: false,
			bulkRemoveVisible: false,
			bulkReverseVisible: false,

			importTrack: {
				warehouseNo: "",
				trackingNumbers: [],
				batchNumber: ""
			},
			editTracking: {
				id: "",
				trackingNumber: "",
				upc: "",
				qty: "",
				note: "",
				warehouseNo: ""
			},
			batchNumber: "",
			warehouseImportVisible: false,

			editLoading: false,

			addFormVisible: false,
			loading: false,
			importRule: {
				warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
				trackingNumbers: [{ required: true, message: 'Tracking list is required.', trigger: 'blur' }, { validator: this.checkTracking, trigger: 'blur' }]
			},
			editRule: {
				trackingNumber: [{ required: true, message: 'Tracking Number is required.', trigger: 'blur' }],
				upc: [{ required: true, message: 'UPC Number is required.', trigger: 'blur' }],
				warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }]
			},
			user: sessionStorage.getItem('user')

		};
	},

	methods: {
		sendMail: function sendMail() {
			var _this2 = this;

			if (this.bulkConfirmList.length > 0) {
				var upcList = this.bulkConfirmList.filter(function (item) {
					return item.productsList.length == 0;
				});
				if (upcList.length > 0) {
					var upcStr = upcList.map(function (item) {
						return item.upc;
					}).join(",");
					var param = {
						doctorId: window.sessionStorage.getItem("currentCompany"),
						upc: upcStr
					};
					(0, _warehouseService.sendEmail)(param).then(function (data) {
						if (data.code == 200) {
							_this2.$message.success("Success");
						}
					});
				} else {
					this.$message.error("None unassigned upc founded");
				}
			} else {
				this.$message.error("Empty confirm list.");
			}
		},
		exportExcel: function exportExcel(url, fileName, type) {
			var param = {
				url: url,
				fileName: fileName,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				type: type
			};
			(0, _exportService.postExportExcel)(param).then(function () {});
		},
		editConfirmedTracking: function editConfirmedTracking() {
			var _this3 = this;

			var param = {
				cwId: this.editInbound.cwId,
				note: this.editInbound.note,
				qty: this.editInbound.qty,
				doctorNo: window.sessionStorage.getItem("currentCompany")
			};
			this.$confirm("1.reverse the tracking with the original<br>" + "2.reUpload Tracking with updated qty", 'Warning', {
				type: 'warning',
				dangerouslyUseHTMLString: true
			}).then(function () {
				_this3.loading = true;
				(0, _inboundService.editInboundTracking)(param).then(function (data) {
					_this3.loading = false;
					if (data.status === 200) {
						_this3.$message.success(data.message);
						_this3.getHistoryList();
						_this3.getToConfirmTrackingList();
						_this3.editInboundHistoryVisible = false;
					} else {
						_this3.$message.error(data.message);
					}
				});
			}).catch(function () {});
		},
		bulkReverse: function bulkReverse() {
			var _this4 = this;

			if (this.batchNumber) {
				this.$confirm('Are you sure?', 'Warning', {
					type: 'warning'
				}).then(function () {
					var param = {
						batchNumber: _this4.batchNumber,
						doctorNo: window.sessionStorage.getItem("currentCompany")
					};
					_this4.loading = true;
					(0, _inboundService.bulkReverse)(param).then(function (data) {
						_this4.loading = false;
						if (data.status === 200) {
							_this4.$message.success(data.message);
							_this4.getHistoryList();
							_this4.getToConfirmTrackingList();
							_this4.bulkReverseVisible = false;
						} else {
							_this4.$message.error(data.message);
						}
					});
				}).catch(function () {});
			}
		},
		reverseById: function reverseById(id) {
			var _this5 = this;

			this.$confirm('Are you sure?', 'Warning', {
				type: 'warning'
			}).then(function () {
				_this5.loading = true;
				var param = {
					cwId: id,
					doctorNo: window.sessionStorage.getItem("currentCompany")
				};
				(0, _inboundService.reverseById)(param).then(function (data) {
					_this5.loading = false;
					if (data.status === 200) {
						_this5.$message.success(data.message);
						_this5.getHistoryList();
						_this5.getToConfirmTrackingList();
					} else {
						_this5.$message.error(data.message);
					}
				});
			}).catch(function () {});
		},
		bulkConfirm: function bulkConfirm() {
			var _this6 = this;

			if (this.bulkConfirmList.length === 0) {
				this.$message.error('Bulk confirm list is empty.');
				return;
			}
			var list = [];
			for (var i = 0; i < this.bulkConfirmList.length; i++) {
				if (!this.bulkConfirmList[i].productNo) {
					this.bulkConfirmList[i].error = true;
				} else {
					this.bulkConfirmList[i].error = false;
					var item = { productNo: this.bulkConfirmList[i].productNo, upc: this.bulkConfirmList[i].upc, forceChargeTime: this.bulkConfirmList[i].forceChargeTime };
					list.push(item);
				}
			}
			var errorList = this.bulkConfirmList.filter(function (item) {
				return item.error;
			});
			if (errorList.length > 0) {
				this.$message.error('Please select a product for each row.');
				return;
			}
			var param = {
				batchNumber: this.batchNumber,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				data: list
			};
			this.loading = true;
			(0, _inboundService.bulkConfirm)(param).then(function (data) {
				_this6.loading = false;
				if (data.status === 200) {
					_this6.bulkConfirmVisible = false;
					_this6.bulkConfirmList = [];
					_this6.batchNumber = "";
					_this6.getToConfirmTrackingList();
					_this6.getHistoryList();
				} else {
					_this6.$message.error(data.message);
				}
			});
		},
		bulkRemove: function bulkRemove() {
			var _this7 = this;

			if (this.batchNumber) {
				this.loading = true;
				var param = {
					batchNumber: this.batchNumber,
					doctorNo: window.sessionStorage.getItem("currentCompany"),
					data: this.toConfirmList
				};
				(0, _inboundService.bulkRemove)(param).then(function (data) {
					_this7.loading = false;
					if (data.status === 200) {
						_this7.bulkRemoveVisible = false;
						_this7.getToConfirmTrackingList();
						_this7.getHistoryList();
					} else {
						_this7.$message.error(data.message);
					}
				});
			} else {
				this.$message.error("You must select a batch number before bulk remove.");
			}
		},
		changeBatchNumberForBulkReverse: function changeBatchNumberForBulkReverse() {
			var _this8 = this;

			if (this.batchNumber) {
				var param = {
					doctorNo: window.sessionStorage.getItem("currentCompany"),
					batchNumber: this.batchNumber,
					current: 1,
					size: 99999,
					isReverse: 1
				};
				this.listLoading = true;
				(0, _inboundService.getTrackingList)(param).then(function (data) {
					_this8.listLoading = false;
					if (data.status === 200) {
						_this8.bulkReverseList = data.result.records;
					}
				});
			} else {
				this.bulkReverseList = [];
			}
		},
		changeBatchNumberForBulkRemove: function changeBatchNumberForBulkRemove() {
			var _this9 = this;

			if (this.batchNumber) {
				var param = {
					doctorNo: window.sessionStorage.getItem("currentCompany"),
					batchNumber: this.batchNumber,
					current: 1,
					size: 99999,
					type: 1
				};
				this.listLoading = true;
				(0, _inboundService.getTrackingList)(param).then(function (data) {
					_this9.listLoading = false;
					if (data.status === 200) {
						_this9.bulkRemoveList = data.result.records;
					}
				});
			} else {
				this.bulkRemoveList = [];
			}
		},
		changeBatchNumberForBulkConfirm: function changeBatchNumberForBulkConfirm() {
			var _this10 = this;

			if (this.batchNumber) {
				var param = {
					batchNumber: this.batchNumber,
					doctorNo: window.sessionStorage.getItem("currentCompany"),
					current: 1,
					size: 99999,
					type: 1
				};
				this.listLoading = true;
				(0, _inboundService.getBulkConfirmListByBatchNum)(param).then(function (data) {
					_this10.listLoading = false;
					if (data.status === 200) {
						var records = [];
						for (var i = 0; i < data.result.records.length; i++) {
							var record = data.result.records[i];
							if (record.productsList.length === 1) {
								record.productNo = record.productsList[0].productNo;
							} else {
								record.productNo = "";
							}
							records.push(record);
						}
						_this10.bulkConfirmList = records;
					}
				});
			} else {
				this.bulkConfirmList = [];
			}
		},
		showBulkReverse: function showBulkReverse() {
			var _this11 = this;

			this.getBatchNumberList(3).then(function () {
				_this11.batchNumber = "";
				_this11.bulkReverseList = [];
				_this11.bulkReverseVisible = true;
			});
		},
		showBulkRemove: function showBulkRemove() {
			var _this12 = this;

			this.getBatchNumberList(1).then(function () {
				_this12.batchNumber = "";
				_this12.bulkRemoveList = [];
				_this12.bulkRemoveVisible = true;
			});
		},
		showBulkConfirm: function showBulkConfirm() {
			var _this13 = this;

			this.getBatchNumberList(1).then(function () {
				_this13.batchNumber = "";
				_this13.bulkConfirmList = [];
				_this13.bulkConfirmVisible = true;
			});
		},
		getBatchNumberList: function getBatchNumberList(type) {
			var _this14 = this;

			var param = {
				type: type,
				doctorNo: window.sessionStorage.getItem("currentCompany")
			};
			return (0, _inboundService.getBatchNumberList)(param).then(function (data) {
				console.log(data);
				if (data.status === 200) {
					_this14.batchNumbers = data.result;
				} else {
					_this14.$message.error(data.message);
				}
			});
		},
		handleEdit: function handleEdit() {
			var _this15 = this;

			this.$refs.editTracking.validate(function (valid) {
				if (valid) {
					_this15.loading = true;
					var param = {
						cwId: _this15.editTracking.id,
						warehouseNo: _this15.editTracking.warehouseNo,
						tracking: _this15.editTracking.trackingNumber,
						upc: _this15.editTracking.upc,
						qty: _this15.editTracking.qty,
						note: _this15.editTracking.note
					};
					(0, _inboundService.editTrackingById)(param).then(function (data) {
						_this15.loading = false;
						if (data.status === 200) {
							_this15.$message.success(data.message);
							_this15.getToConfirmTrackingList();
							_this15.$refs.editTracking.resetFields();
							_this15.editToConfirmInboundVisible = false;
						} else {
							_this15.$message.error(data.message);
						}
					});
				}
			});
		},
		showEdit: function showEdit(id) {
			var _this16 = this;

			(0, _inboundService.getTrackingById)({ cwId: id }).then(function (data) {
				if (data.status === 200) {
					_this16.editTracking.id = data.result.cwId;
					_this16.editTracking.note = data.result.note;
					_this16.editTracking.qty = data.result.qty;
					_this16.editTracking.upc = data.result.upc;
					_this16.editTracking.warehouseNo = data.result.warehouseNo;
					_this16.editTracking.trackingNumber = data.result.tracking;
					_this16.editToConfirmInboundVisible = true;
				} else {
					_this16.$message.error(data.message);
				}
			});
		},
		removeTracking: function removeTracking(id) {
			var _this17 = this;

			this.$confirm('Are you sure?', 'Warning', {
				type: 'warning'
			}).then(function () {
				(0, _inboundService.removeTracking)({ cwId: id }).then(function (data) {
					if (data.status === 200) {
						_this17.$message.success(data.message);
						_this17.getToConfirmTrackingList();
					} else {
						_this17.$message.error(data.message);
					}
				});
			}).catch(function () {});
		},
		importTracking: function importTracking() {
			var _this18 = this;

			this.$refs.importTrack.validate(function (valid) {
				if (valid) {
					_this18.loading = true;
					var param = {
						batchNumber: _this18.importTrack.batchNumber,
						doctorNo: window.sessionStorage.getItem("currentCompany"),
						warehouseNo: _this18.importTrack.warehouseNo,
						data: _this18.importTrack.trackingNumbers
					};
					(0, _inboundService.importTracking)(param).then(function (data) {
						_this18.loading = false;
						if (data.status === 200) {
							_this18.$message.success(data.message);
							_this18.$refs.importTrack.resetFields();
							_this18.importTrack.trackingNumbers = [];
							_this18.warehouseImportVisible = false;
							_this18.getToConfirmTrackingList();
						} else {
							_this18.$message.error(data.message);
						}
					});
				}
			});
		},
		checkTracking: function checkTracking(rule, value, callback) {
			if (!value.length > 0) {
				return callback(new Error('Tracking list is empty.'));
			} else {
				callback();
			}
		},
		uploadSuccess: function uploadSuccess(a) {
			var _this19 = this;

			if (a.status === 200) {
				var trackingNumbers = [];

				var _loop = function _loop(i) {
					var exsit = trackingNumbers.find(function (item) {
						return item.upc == a.result[i].upc && item.tracking == a.result[i].trackingNumber && item.qty == a.result[i].qty;
					});
					if (exsit) {
						_this19.$message.error("Same data exists, please check.");
						_this19.$refs.upload.clearFiles();
						return {
							v: void 0
						};
					}
					trackingNumbers.push({ note: a.result[i].note, qty: a.result[i].qty, upc: a.result[i].upc, tracking: a.result[i].trackingNumber });
				};

				for (var i = 0; i < a.result.length; i++) {
					var _ret = _loop(i);

					if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
				}
				this.importTrack.trackingNumbers = trackingNumbers;
				this.excelImportVisible = false;
				this.$refs.upload.clearFiles();
			} else {
				this.$message.error(a.message);
			}
		},
		uploadError: function uploadError(a) {
			this.$message.error(a.message);
			this.$refs.upload.clearFiles();
		},
		getWarehouses: function getWarehouses() {
			var _this20 = this;

			(0, _warehouseService.getWarehouseForWarehouseAdmin)({ doctorNo: window.sessionStorage.getItem("currentCompany") }).then(function (data) {
				if (data.code === 200) {
					_this20.warehouses = data.records;
				}
			});
		},
		changeConfirmPage: function changeConfirmPage(val) {
			this.toConfirmPage = val;
			this.getToConfirmTrackingList();
		},
		getToConfirmTrackingList: function getToConfirmTrackingList() {
			var _this21 = this;

			var param = {
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				current: this.toConfirmPage,
				size: this.pageSize,
				type: 1,
				condition: this.filters.toConfirmFilter
			};
			this.firstListLoading = true;
			(0, _inboundService.getTrackingList)(param).then(function (data) {
				_this21.firstListLoading = false;
				if (data.status === 200) {
					_this21.toConfirmList = data.result.records;
					_this21.toConfirmTotal = data.result.total;
				}
			});
		},
		changeHistoryList: function changeHistoryList(val) {
			this.historyPage = val;
			this.getHistoryList();
		},
		getHistoryList: function getHistoryList() {
			var _this22 = this;

			var param = {
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				current: this.historyPage,
				size: this.pageSize,
				type: 3,
				condition: this.filters.historyFilter
			};
			this.secondListLoading = true;
			(0, _inboundService.getTrackingList)(param).then(function (data) {
				_this22.secondListLoading = false;
				if (data.status === 200) {
					_this22.inboundHistory = data.result.records;
					_this22.historyTotal = data.result.total;
				}
			});
		},
		showImport: function showImport() {
			var _this23 = this;

			(0, _inboundService.getBatchNumber)().then(function (data) {
				if (data.status === 200) {
					_this23.importTrack.batchNumber = data.result.batchNumber;
					_this23.warehouseImportVisible = true;
				} else {
					_this23.$message.error(data.message);
				}
			});
		},
		removeRow: function removeRow(row) {
			this.importTrack.trackingNumbers.splice(this.importTrack.trackingNumbers.indexOf(row), 1);
		},
		removeAllItem: function removeAllItem() {
			this.importTrack.trackingNumbers.splice(0);
		},
		removeItem: function removeItem(row) {
			this.bulkConfirmList.splice(this.bulkConfirmList.indexOf(row), 1);
		},
		importFromText: function importFromText() {
			var _this24 = this;

			var text = this.text.trim();
			if (!text) {
				this.$message.error("Please enter import text.");
				return;
			}
			var row = [];
			var trackings = [];
			var existTrackings = [];
			var lines = text.split("\n");
			lines.filter(function (line) {
				return line.trim() !== '';
			}).forEach(function (line) {
				var obj = {};
				var columns = [];
				if (line.indexOf(" ") !== -1) {
					columns = line.split(" ");
				} else if (line.indexOf("\t") !== -1) {
					columns = line.split("\t");
				} else if (line.indexOf(",") !== -1) {
					columns = line.split(",");
				}
				obj.tracking = columns[0] ? columns[0].trim() : "";
				obj.upc = columns[1] ? columns[1].trim() : "";
				obj.qty = columns[2] ? columns[2].trim() : "";
				obj.note = columns[3] ? columns[3].trim() : "";

				var existInput = trackings.find(function (item) {
					return item.tracking === obj.tracking && item.upc === obj.upc && item.qty === obj.qty;
				});
				if (existInput) {
					existTrackings.push(obj.tracking);
				}

				var exist = _this24.importTrack.trackingNumbers.find(function (item) {
					return item.tracking === obj.tracking && item.upc === obj.upc && item.qty === obj.qty;
				});
				if (!exist) {
					trackings.push(obj);
				} else {
					existTrackings.push(obj.tracking);
				}
			});


			if (existTrackings.length > 0) {
				this.$message.error("Same data tracking for \"" + existTrackings.join(", ") + "\" exists, please check.");
				return;
			}
			this.text = "";
			this.importTrack.trackingNumbers.push.apply(this.importTrack.trackingNumbers, trackings);
			this.textImportVisible = false;
		},
		editInboundHistory: function editInboundHistory(row) {
			this.editInboundHistoryVisible = true;
			this.editInbound = {};
			this.editInbound = JSON.parse((0, _stringify2.default)(row));
		},
		confirmWarehouseItem: function confirmWarehouseItem(row) {
			this.importTrack.company = row.company;
			this.importTrack.warehouse = row.warehouse;
			this.importTrack.price = row.price;
			this.importTrack.quantity = row.quantity;
			this.importTrack.product = row.product;
			this.warehouseConfirmVisible = true;
		},
		goToMixedPackage: function goToMixedPackage() {
			this.$router.push('/mixedPackageList');
		},
		isMixedPackageRecord: function isMixedPackageRecord(row) {
			return row && row.note && typeof row.note === 'string' && row.note.indexOf('混寄包裹认领') !== -1;
		}
	},
	mounted: function mounted() {
		this.getWarehouses();
		this.getToConfirmTrackingList();
		this.getHistoryList();


		var user = sessionStorage.getItem('user');
		user = JSON.parse(user);
		this.user = user;
	}
};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _boxsizeService = __webpack_require__(411);

var _customBoxSizeConfigService = __webpack_require__(412);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            secondLoading: false,
            thirdLoading: false,
            pageSize: _globalVar.defaultPageSize,

            activeName: "first",

            filters: {
                email: ''
            },

            boxSizes: [],

            userRates: [],

            customCategoryConfigs: [],

            total: 0,
            page: 1,

            editVisible: false,
            customEditVisible: false,

            editLoading: false,
            customEditLoading: false,
            editFormRules: {
                sizeLabel: [{ required: true, message: 'Short label is required.', trigger: 'blur' }],
                sizeDefined: [{ required: true, message: 'Full label is required.', trigger: 'blur' }],
                inboundBaseFee: [{ required: true, message: 'Inbound Base Fee is required.', trigger: 'blur' }],
                inboundRate: [{ required: true, message: 'Inbound Rate is required.', trigger: 'blur' }],
                outboundBaseFee: [{ required: true, message: 'Outbound Base Fee is required.', trigger: 'blur' }],
                outboundRate: [{ required: true, message: 'Outbound Rate is required.', trigger: 'blur' }],
                storageBaseFee: [{ required: true, message: 'Storage Base Fee is required.', trigger: 'blur' }],
                storageBaseFeeOver: [{ required: true, message: 'Storage Base Fee Over is required.', trigger: 'blur' }],
                isPrintBarCode: [{ required: true, message: 'Please set is print bar code.', trigger: 'blur' }]
            },

            addCategory: {
                sizeLabel: "",
                sizeDefined: "",
                inboundBaseFee: 0.0,
                inboundRate: 0.0,
                outboundBaseFee: 0.0,
                outboundRate: 0.0,
                storageBaseFee: 0.0,
                storageBaseFeeOver: 0.0,
                desc: "",
                isPrintBarCode: 0,
                id: null
            },

            editCategory: {
                sizeLabel: "",
                sizeDefined: "",
                inboundBaseFee: 0.0,
                inboundRate: 0.0,
                outboundBaseFee: 0.0,
                outboundRate: 0.0,
                storageBaseFee: 0.0,
                storageBaseFeeOver: 0.0,
                desc: "",
                isPrintBarCode: 0,
                id: null
            },

            customEditCategory: {
                boxSizeId: null,
                doctorNo: "",
                inboundBaseFee: 0.0,
                inboundRate: 0.0,
                outboundBaseFee: 0.0,
                outboundRate: 0.0,
                storageBaseFee: 0.0,
                storageBaseFeeOver: 0.0,
                id: null
            },

            addFormVisible: false,
            userRateVisible: false,
            customCategoryVisible: false,
            formRules: {
                sizeLabel: [{ required: true, message: 'Short label is required.', trigger: 'blur' }],
                sizeDefined: [{ required: true, message: 'Full label is required.', trigger: 'blur' }],
                inboundBaseFee: [{ required: true, message: 'Inbound Base Fee is required.', trigger: 'blur' }],
                inboundRate: [{ required: true, message: 'Inbound Rate is required.', trigger: 'blur' }],
                outboundBaseFee: [{ required: true, message: 'Outbound Base Fee is required.', trigger: 'blur' }],
                outboundRate: [{ required: true, message: 'Outbound Rate is required.', trigger: 'blur' }],
                storageBaseFee: [{ required: true, message: 'Storage Base Fee is required.', trigger: 'blur' }],
                storageBaseFeeOver: [{ required: true, message: 'Storage Base Fee Over is required.', trigger: 'blur' }],
                isPrintBarCode: [{ required: true, message: 'Please set is print bar code.', trigger: 'blur' }]
            }
        };
    },

    methods: {
        formatHasBeanSet: function formatHasBeanSet(row, column) {
            if (row.hasSingleSeted === true) {
                return "Already Set";
            } else {
                return "Not Set";
            }
        },
        formatPrintStatus: function formatPrintStatus(row, column) {
            if (row.isPrintBarCode === 1) {
                return "Printed";
            } else {
                return "Not Print";
            }
        },
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.getBoxSizeList();
        },
        handleAddBoxSize: function handleAddBoxSize() {
            var _this = this;

            this.$refs.addCategory.validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    var param = {
                        sizeLabel: _this.addCategory.sizeLabel,
                        sizeDefined: _this.addCategory.sizeDefined,
                        inboundBaseFee: _this.addCategory.inboundBaseFee,
                        inboundRate: _this.addCategory.inboundRate,
                        outboundBaseFee: _this.addCategory.outboundBaseFee,
                        outboundRate: _this.addCategory.outboundRate,
                        storageBaseFee: _this.addCategory.storageBaseFee,
                        storageBaseFeeOver: _this.addCategory.storageBaseFeeOver,
                        desc: _this.addCategory.desc,
                        isPrintBarCode: _this.addCategory.isPrintBarCode,
                        id: null
                    };
                    (0, _boxsizeService.editBoxSize)(param).then(function (res) {
                        _this.loading = false;
                        if (res.status === 200) {
                            _this.addFormVisible = false;
                            _this.$message.success(res.message);
                            _this.$refs.addCategory.resetFields();
                            _this.getBoxSizeList();
                        } else {
                            _this.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        showAdd: function showAdd() {
            this.addFormVisible = true;
            this.addCategory.id = null;
            this.addCategory.sizeLabel = "";
            this.addCategory.sizeDefined = "";
            this.addCategory.inboundBaseFee = 0;
            this.addCategory.inboundRate = 0;
            this.addCategory.outboundBaseFee = 0;
            this.addCategory.outboundRate = 0;
            this.addCategory.storageBaseFee = 0;
            this.addCategory.storageBaseFeeOver = 0;
            this.addCategory.desc = "";
            this.addCategory.isPrintBarCode = 0;
        },
        showEdit: function showEdit(row) {
            var _this2 = this;

            (0, _boxsizeService.getBoxSizeById)(row).then(function (res) {
                if (res.status === 200) {
                    _this2.editVisible = true;
                    _this2.editCategory = res.result;
                }
            });
        },
        showCustomEdit: function showCustomEdit(row) {
            var _this3 = this;

            var para = {
                doctorNo: row.doctorNo,
                boxSizeId: row.boxSizeId,
                id: row.id
            };
            (0, _customBoxSizeConfigService.getCustomBoxSizeById)(para).then(function (res) {
                if (res.status === 200) {
                    _this3.customEditVisible = true;
                    _this3.customEditCategory = res.result;
                }
            });
        },
        deleteCustomItem: function deleteCustomItem(row) {
            var _this4 = this;

            this.editLoading = true;
            var para = {
                doctorNo: row.doctorNo,
                boxSizeId: row.boxSizeId,
                id: row.id
            };
            (0, _customBoxSizeConfigService.deleteCustomBoxSizeConfigs)(para).then(function (res) {
                _this4.editLoading = false;
                if (res.status === 200) {
                    _this4.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this4.showCategoryEdit(row.doctorNo);
                    _this4.editVisible = false;
                } else {
                    _this4.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        editSubmit: function editSubmit() {
            var _this5 = this;

            this.editLoading = true;
            var para = {
                sizeLabel: this.editCategory.sizeLabel,
                sizeDefined: this.editCategory.sizeDefined,
                inboundBaseFee: this.editCategory.inboundBaseFee,
                inboundRate: this.editCategory.inboundRate,
                outboundBaseFee: this.editCategory.outboundBaseFee,
                outboundRate: this.editCategory.outboundRate,
                storageBaseFee: this.editCategory.storageBaseFee,
                storageBaseFeeOver: this.editCategory.storageBaseFeeOver,
                desc: this.editCategory.desc,
                isPrintBarCode: this.editCategory.isPrintBarCode,
                id: this.editCategory.id
            };
            (0, _boxsizeService.editBoxSize)(para).then(function (res) {
                _this5.editLoading = false;
                if (res.status === 200) {
                    _this5.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this5.getBoxSizeList();
                    _this5.editVisible = false;
                } else {
                    _this5.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        customEditSubmit: function customEditSubmit() {
            var _this6 = this;

            this.customEditLoading = true;
            var para = {
                boxSizeId: this.customEditCategory.boxSizeId,
                doctorNo: this.customEditCategory.doctorNo,
                inboundBaseFee: this.customEditCategory.inboundBaseFee,
                inboundRate: this.customEditCategory.inboundRate,
                outboundBaseFee: this.customEditCategory.outboundBaseFee,
                outboundRate: this.customEditCategory.outboundRate,
                storageBaseFee: this.customEditCategory.storageBaseFee,
                storageBaseFeeOver: this.customEditCategory.storageBaseFeeOver,
                id: this.customEditCategory.id
            };
            (0, _customBoxSizeConfigService.editCustomBoxSizeConfigs)(para).then(function (res) {
                _this6.customEditLoading = false;
                _this6.customEditVisible = false;
                if (res.status === 200) {
                    _this6.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this6.getDoctorCustomCategoryRate(_this6.customEditCategory.doctorNo);
                } else {
                    _this6.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        getBoxSizeList: function getBoxSizeList() {
            var _this7 = this;

            var para = {
                current: this.page,
                size: this.pageSize
            };

            this.firstLoading = true;
            (0, _boxsizeService.getBoxSizeList)(para).then(function (res) {
                _this7.firstLoading = false;
                if (res.status === 200) {
                    _this7.boxSizes = res.result.records;
                    _this7.total = res.result.total;
                } else {
                    _this7.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getAllUserRate: function getAllUserRate() {
            var _this8 = this;

            var para = {
                current: 1,
                size: 1000
            };

            this.secondLoading = true;
            (0, _customBoxSizeConfigService.getDoctorUserList)(para).then(function (res) {
                _this8.secondLoading = false;
                if (res.status === 200) {
                    _this8.userRates = res.result.records;
                    _this8.total = res.result.total;
                } else {
                    _this8.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getDoctorCustomCategoryRate: function getDoctorCustomCategoryRate(rowDoctorNo) {
            var _this9 = this;

            var para = {
                current: 1,
                size: 1000,
                doctorNo: rowDoctorNo
            };

            this.thirdLoading = true;
            (0, _customBoxSizeConfigService.getCustomBoxSizeList)(para).then(function (res) {
                _this9.thirdLoading = false;
                if (res.status === 200) {
                    _this9.customCategoryConfigs = res.result;
                } else {
                    _this9.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        showUserRate: function showUserRate() {
            this.userRateVisible = true;
            this.getAllUserRate();
        },
        showCategoryEdit: function showCategoryEdit(rowDoctorNo) {
            this.customCategoryVisible = true;
            this.getDoctorCustomCategoryRate(rowDoctorNo);
        }
    },
    mounted: function mounted() {
        this.getBoxSizeList();
    }
};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _discountService = __webpack_require__(217);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            pageSize: _globalVar.defaultPageSize,

            activeName: "first",

            filters: {
                email: ''
            },

            discounts: [],

            total: 0,
            page: 1,

            editVisible: false,

            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            editDiscount: {
                userNo: "",
                doctorNo: "",
                doctorName: "",
                storageFreeDuration: 3,
                discountRate: 1.00,
                storageFeeOverDays: undefined,
                id: null
            },

            addFormVisible: false,
            addLoading: false,
            formRules: {
                storageFreeDuration: [{ required: true, message: 'Storage Free Duration is required.', trigger: 'blur' }],
                discountRate: [{ required: true, message: 'Discount Rate is required.', trigger: 'blur' }]
            }

        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.getDiscounts();
        },
        showEdit: function showEdit(row) {
            this.editDiscount = row;
            this.editVisible = true;
        },
        editSubmit: function editSubmit() {
            var _this = this;

            this.editLoading = true;
            var para = {
                userNo: this.editDiscount.userNo,
                doctorNo: this.editDiscount.doctorNo,
                doctorName: this.editDiscount.doctorName,
                storageFreeDuration: this.editDiscount.storageFreeDuration,
                discountRate: this.editDiscount.discountRate,
                storageFeeOverDays: this.editDiscount.storageFeeOverDays,
                id: this.editDiscount.id
            };
            (0, _discountService.editDiscount)(para).then(function (res) {
                _this.editLoading = false;
                if (res.status === 200) {
                    _this.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this.getDiscounts();
                    _this.editVisible = false;
                } else {
                    _this.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        getDiscounts: function getDiscounts() {
            var _this2 = this;

            var para = {
                current: this.page,
                size: this.pageSize
            };

            this.firstLoading = true;
            (0, _discountService.getDiscountList)(para).then(function (res) {
                _this2.firstLoading = false;
                if (res.status === 200) {
                    _this2.discounts = res.result.records;
                    _this2.total = res.result.total;
                } else {
                    _this2.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getDiscounts();
    }
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _discountService = __webpack_require__(217);

var _storageFeePaymentService = __webpack_require__(219);

var _paymentService = __webpack_require__(109);

var _paymentService4Warehouse = __webpack_require__(218);

var _exportService = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            pageSize: _globalVar.defaultPageSize,

            isEnable: true,

            filters: {
                productName: "",
                feeType: "",
                conditionSearch: "",
                paymentStatus: "",

                searchMonth: ""
            },

            activeName: "first",

            storageFeePayments: [],

            loading: false,

            warehouseFeeDetail: [],
            warehouseFeeSummary: [],

            storageFeePaymentPage: 1,
            storageFeePaymentTotal: 0,

            warehouseFeeDetailPage: 1,
            warehouseFeeDetailTotal: 0,
            warehouseFeeDetailModelVisible: false,

            warehouseFeeSummaryPage: 1,
            warehouseFeeSummaryTotal: 0,
            warehouseFeeSummaryModelVisible: false,

            warehouseFeeLoading: false,
            warehouseFeeSummaryLoading: false,
            warehouseFeeDetailId: null,
            warehouseFeeProductNo: null,
            conditionSearch: "",

            feeTypeList: [{ id: 0, value: "Inbound" }, { id: 1, value: "Outbound" }, { id: 2, value: "Storage" }],

            banks: [],
            requestFormRules: {
                amount: [{ required: true, message: 'Payable amount is required.', trigger: 'blur' }, { validator: this.validateAmount, trigger: 'blur' }],
                bank: [{ required: true, message: '', trigger: 'blur' }]
            },
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },

            editVisible: false,
            paymentListVisible: false,
            requestVisible: false,

            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            editDiscount: {
                userNo: "",
                doctorNo: "",
                doctorName: "",
                storageFreeDuration: 3,
                discountRate: 1.00,
                id: null
            },

            paymentPage: 1,
            paymentTotal: 0,
            payment: {
                amount: 0,
                bank: "",
                note: "",
                balance: 0,
                minPayment: 0.1,
                payStatus: 0,
                doctorNo: "",
                monthlyStorageFeeId: "" },
            isPaymentPending: false,
            paymentLoading: false,
            payments: [],

            addFormVisible: false,
            addLoading: false,
            formRules: {
                storageFreeDuration: [{ required: true, message: 'Storage Free Duration is required.', trigger: 'blur' }],
                discountRate: [{ required: true, message: 'Discount Rate is required.', trigger: 'blur' }]
            },
            user: sessionStorage.getItem('user'),

            requestRebuildVisible: false,
            rebuildDailyModel: {
                dates: ""
            },

            requestRebuildMonthVisible: false,
            rebuildMonthModel: {
                month: ""
            }

        };
    },

    methods: {
        dateFormat: function dateFormat(row, column) {
            if (row) {
                var dT = new Date(row);
                return dT.getFullYear() + "-" + (dT.getMonth() + 1) + "-" + dT.getDate();
            } else {
                return "";
            }
        },
        changeSearchMonth: function changeSearchMonth(val) {
            this.filters.searchMonth = val;
            this.getStorageFeePaymentList();
        },
        exportExcel: function exportExcel(url, fileName, type) {
            var param = {
                url: url,
                fileName: fileName,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                payNo: this.warehouseFeeDetailId,
                productNo: this.warehouseFeeProductNo,
                productName: this.filters.productName,
                feeType: this.filters.feeType,
                condition: this.filters.conditionSearch
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },
        changeStorageFeePayment: function changeStorageFeePayment(val) {
            this.storageFeePaymentPage = val;
            this.getStorageFeePaymentList();
        },

        formatMoney: function formatMoney(s, n) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            if (s < 0) {
                l = (Math.abs(s.split(".")[0]) + "").split("").reverse();
            }
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            if (s < 0) {
                t += "-";
            }
            var result = t.split("").reverse().join("") + "." + r;
            if (result == null || result == undefined || result.indexOf('NaN') >= 0 || result.indexOf('Undefined') >= 0) {
                result = '0.00';
            }
            return result;
        },
        changeWarehouseFeeDetail: function changeWarehouseFeeDetail(val) {
            this.warehouseFeeDetailPage = val;
            this.getStorageFeePaymentDetail(this.warehouseFeeProductNo, val);
        },
        changeWarehouseFeeSummary: function changeWarehouseFeeSummary(val) {
            this.warehouseFeeSummaryPage = val;
            this.getStorageFeePaymentSummary(this.warehouseFeeDetailId);
        },
        getStorageFeePaymentList: function getStorageFeePaymentList() {
            var _this = this;

            var param = {
                current: this.storageFeePaymentPage,
                size: this.pageSize,
                searchMonth: this.filters.searchMonth
            };
            this.loading = true;
            (0, _storageFeePaymentService.getWarehouseList)(param).then(function (data) {
                _this.loading = false;
                if (data.status === 200) {
                    _this.storageFeePayments = data.result.records;
                    _this.storageFeePaymentTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentDetail: function getStorageFeePaymentDetail(productNo, page) {
            var _this2 = this;

            this.warehouseFeeDetailPage = page;
            if (productNo) {
                this.warehouseFeeProductNo = productNo;
            }
            var param = {
                current: page,
                size: this.pageSize,
                payNo: this.warehouseFeeDetailId,
                productNo: this.warehouseFeeProductNo,
                productName: this.filters.productName,
                feeType: this.filters.feeType
            };
            this.warehouseFeeDetailModelVisible = true;
            this.warehouseFeeLoading = true;
            (0, _storageFeePaymentService.warehouseFeeDetail)(param).then(function (data) {
                _this2.warehouseFeeLoading = false;
                if (data.status === 200) {
                    _this2.warehouseFeeDetail = data.result.records;
                    _this2.warehouseFeeDetailTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentSummary: function getStorageFeePaymentSummary(id) {
            var _this3 = this;

            this.warehouseFeeDetailId = id;
            var param = {
                current: this.warehouseFeeSummaryPage,
                size: this.pageSize,
                condition: this.filters.conditionSearch,
                payNo: id
            };
            this.warehouseFeeSummaryModelVisible = true;
            this.warehouseFeeSummaryLoading = true;
            (0, _storageFeePaymentService.warehouseFeeSummary)(param).then(function (data) {
                _this3.warehouseFeeSummaryLoading = false;
                if (data.status === 200) {
                    _this3.warehouseFeeSummary = data.result.records;
                    _this3.warehouseFeeSummaryTotal = data.result.total;
                }
            });
        },
        getBankList: function getBankList() {
            var _this4 = this;

            (0, _paymentService.getBankList)({}).then(function (data) {
                if (data.status === 200) {
                    _this4.banks = data.result;
                }
            });
        },
        showPaymentList: function showPaymentList(row) {
            this.payment.balance = row.totalFee;
            this.payment.amount = parseFloat(row.totalFee);
            this.payment.payStatus = row.payStatus;
            this.payment.monthlyStorageFeeId = row.id;
            this.payment.doctorNo = row.doctorNo;
            this.paymentListVisible = true;
            this.getPaymentRequest();
        },
        showAddPayment: function showAddPayment() {
            this.getBankList();
            this.requestVisible = true;
        },
        requestPayment: function requestPayment() {
            var _this5 = this;

            this.$refs.payment.validate(function (valid) {
                if (valid) {
                    _this5.loading = true;
                    var param = {
                        amount: _this5.payment.amount,
                        bankNo: _this5.payment.bank,
                        doctorNo: _this5.payment.doctorNo,
                        warehouseNote: _this5.payment.note,
                        monthlyStorageFeeId: _this5.payment.monthlyStorageFeeId
                    };
                    (0, _paymentService4Warehouse.addPaymentRequest4Warehouse)(param).then(function (data) {
                        _this5.loading = false;
                        if (data.status === 200) {
                            _this5.$message.success(data.message);
                            _this5.requestVisible = false;
                            _this5.$refs.payment.resetFields();
                            _this5.getPaymentRequest();
                        }
                    });
                }
            });
        },
        getPaymentRequest: function getPaymentRequest() {
            var _this6 = this;

            var param = {
                current: this.paymentPage,
                size: this.pageSize,
                status: this.filters.paymentStatus,
                doctorNo: this.payment.doctorNo,
                storageFeeId: this.payment.monthlyStorageFeeId
            };
            this.paymentLoading = true;
            (0, _paymentService4Warehouse.getPaymentRequest4Warehouse)(param).then(function (data) {
                _this6.paymentLoading = false;
                _this6.isPaymentPending = false;
                if (data.status === 200) {
                    _this6.payments = data.result.records;
                    _this6.paymentTotal = data.result.total;
                    console.log('this.payments', _this6.payments);
                    for (var i = 0; i < _this6.payments.length; i++) {
                        var p = _this6.payments[i];
                        if (p.status == 0 || p.status == 1) {
                            _this6.isPaymentPending = true;
                            break;
                        }
                    }
                    console.log('this.isPaymentPending', _this6.isPaymentPending);
                }
            });
        },
        changePaymentRequest: function changePaymentRequest(val) {
            this.paymentPage = val;
            this.getPaymentRequest();
        },
        editPaymentStatus: function editPaymentStatus(paymentNo, status) {
            var _this7 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {

                _this7.loading = true;
                var param = {
                    paymentNo: paymentNo,
                    status: status
                };
                (0, _paymentService4Warehouse.editPaymentStatus4Warehouse)(param).then(function (data) {
                    _this7.loading = false;
                    if (data.status === 200) {
                        _this7.$message.success(data.message);
                        _this7.getPaymentRequest();
                    } else {
                        _this7.$message.error(data.message);
                    }
                });
            }).catch(function () {
                _this7.$message.error(data.message);
            });
        },
        validateAmount: function validateAmount(rule, value, callback) {
            if (value > 0) {
                if (value < this.payment.minPayment) {
                    callback(new Error('Your payable amount must be greater than $' + this.payment.minPayment + '.'));
                } else {
                    callback();
                }
            } else {
                callback(new Error('Payable amount is required.'));
            }
        },
        testGenStorageFeeByMonthly: function testGenStorageFeeByMonthly() {
            var _this8 = this;

            if (!this.isEnable) return;

            this.isEnable = false;
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var param = {
                logId: year + "-" + month
            };
            (0, _storageFeePaymentService.testGenStorageFeeByMonthly)(param).then(function (data) {
                if (data.status === 200) {
                    console.log("操作成功");
                    _this8.$message.success('Monthly Fee generate success');
                }
                setTimeout(function () {
                    _this8.isEnable = true;
                }, 5000);
            });
        },
        testGenStorageFeeByDaily: function testGenStorageFeeByDaily() {
            var _this9 = this;

            if (!this.isEnable) return;

            this.isEnable = false;
            var param = {};
            (0, _storageFeePaymentService.testGenStorageFeeByDaily)(param).then(function (data) {
                console.log("操作中...");
                if (data.status === 200) {
                    console.log("操作成功");
                    _this9.$message.success('Daily Fee generate success');
                }
                setTimeout(function () {
                    _this9.isEnable = true;
                }, 5000);
            });
        },
        showRebuildStorageFeeByDailyWin: function showRebuildStorageFeeByDailyWin() {
            this.requestRebuildVisible = true;
        },
        showRebuildStorageFeeByMonthWin: function showRebuildStorageFeeByMonthWin() {
            this.requestRebuildMonthVisible = true;
        },
        rebuildStorageFeeByDaily: function rebuildStorageFeeByDaily() {
            var _this10 = this;

            if (!this.isEnable) return;

            this.isEnable = false;
            var param = {
                dates: this.rebuildDailyModel.dates
            };
            (0, _storageFeePaymentService.testRebuildStorageFeeByDaily)(param).then(function (data) {
                if (data.status === 200) {
                    console.log("操作成功");
                    _this10.$message.success('Rebuild Storage Daily Fee success');
                    _this10.getPaymentRequest();
                }
                setTimeout(function () {
                    _this10.isEnable = true;
                    _this10.requestRebuildVisible = false;
                }, 5000);
            });
        },
        rebuildStorageFeeByMonth: function rebuildStorageFeeByMonth() {
            var _this11 = this;

            if (!this.isEnable) return;

            this.isEnable = false;
            var param = {
                logId: this.rebuildMonthModel.month
            };
            console.log('aaa ------>', param, this.rebuildMonthModel.month);
            (0, _storageFeePaymentService.testGenStorageFeeByMonthly)(param).then(function (data) {
                if (data.status === 200) {
                    console.log("操作成功");
                    _this11.$message.success('Rebuild Monthly Fee success');
                    _this11.getPaymentRequest();
                }
                setTimeout(function () {
                    _this11.isEnable = true;
                    _this11.requestRebuildMonthVisible = false;
                }, 5000);
            });
        }
    },
    mounted: function mounted() {
        this.getStorageFeePaymentList();

        var user = sessionStorage.getItem('user');
        user = JSON.parse(user);
        this.user = user;
    }
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _serviceFeeService = __webpack_require__(414);

var _customServiceFeeConfigService = __webpack_require__(413);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            pageSize: _globalVar.defaultPageSize,

            activeName: "first",

            filters: {
                email: ''
            },

            serviceFees: [],

            userRates: [],

            customServiceFeeConfigs: [],

            total: 0,
            page: 1,

            editVisible: false,
            secondLoading: false,
            thirdLoading: false,
            customEditLoading: false,

            editLoading: false,
            editFormRules: {
                serviceLabel: [{ required: true, message: 'Label is required.', trigger: 'blur' }]
            },

            addServiceFee: {
                serviceLabel: "",
                serviceBaseFee: 0.0,
                serviceDesc: "",
                id: null
            },

            editServiceFee: {
                serviceLabel: "",
                serviceBaseFee: 0.0,
                serviceDesc: "",
                id: null
            },

            addFormVisible: false,
            formRules: {
                serviceLabel: [{ required: true, message: 'Label is required.', trigger: 'blur' }]
            },

            userRateVisible: false,
            customServiceFeeVisible: false,

            editDoctorNo: '',

            customEditVisible: false,
            customEditServiceFee: {
                serviceFeeId: null,
                doctorNo: "",
                serviceBaseFee: 0.0,
                id: null
            }

        };
    },

    methods: {
        formatHasBeanSet: function formatHasBeanSet(row, column) {
            if (row.hasSingleSeted === true) {
                return "Already Set";
            } else {
                return "Not Set";
            }
        },
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.getServiceFeeList();
        },
        handleAddServiceFee: function handleAddServiceFee() {
            var _this = this;

            this.$refs.addServiceFee.validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    var param = {
                        serviceLabel: _this.addServiceFee.serviceLabel,
                        serviceBaseFee: _this.addServiceFee.serviceBaseFee,
                        serviceDesc: _this.addServiceFee.serviceDesc,
                        id: null
                    };
                    (0, _serviceFeeService.editServiceFee)(param).then(function (res) {
                        _this.loading = false;
                        if (res.status === 200) {
                            _this.addFormVisible = false;
                            _this.$message.success(res.message);
                            _this.$refs.addServiceFee.resetFields();
                            _this.getServiceFeeList();
                        } else {
                            _this.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        showAdd: function showAdd() {
            this.addFormVisible = true;
            this.addServiceFee.id = null;
            this.addServiceFee.serviceLabel = "";
            this.addServiceFee.serviceBaseFee = 0;
            this.addServiceFee.serviceDesc = "";
        },
        showEdit: function showEdit(row) {
            var _this2 = this;

            (0, _serviceFeeService.getServiceFeeById)(row).then(function (res) {
                if (res.status === 200) {
                    _this2.editVisible = true;
                    _this2.editServiceFee = res.result;
                }
            });
        },
        editSubmit: function editSubmit() {
            var _this3 = this;

            this.editLoading = true;
            var para = {
                serviceLabel: this.editServiceFee.serviceLabel,
                serviceBaseFee: this.editServiceFee.serviceBaseFee,
                serviceDesc: this.editServiceFee.serviceDesc,
                id: this.editServiceFee.id
            };
            (0, _serviceFeeService.editServiceFee)(para).then(function (res) {
                _this3.editLoading = false;
                if (res.status === 200) {
                    _this3.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this3.getServiceFeeList();
                    _this3.editVisible = false;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        getServiceFeeList: function getServiceFeeList() {
            var _this4 = this;

            var para = {
                current: this.page,
                size: this.pageSize
            };

            this.firstLoading = true;
            (0, _serviceFeeService.getServiceFeeList)(para).then(function (res) {
                _this4.firstLoading = false;
                if (res.status === 200) {
                    _this4.serviceFees = res.result.records;
                    _this4.total = res.result.total;
                } else {
                    _this4.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        showUserRate: function showUserRate() {
            this.userRateVisible = true;
            this.getAllUserRate();
        },
        showServiceFeeEdit: function showServiceFeeEdit(rowDoctorNo) {
            this.customServiceFeeVisible = true;;
            this.getDoctorCustomServiceFeeRate(rowDoctorNo);
        },
        getAllUserRate: function getAllUserRate() {
            var _this5 = this;

            var para = {
                current: 1,
                size: 1000
            };

            this.secondLoading = true;
            (0, _customServiceFeeConfigService.getDoctorUserList)(para).then(function (res) {
                _this5.secondLoading = false;
                if (res.status === 200) {
                    _this5.userRates = res.result.records;
                    _this5.total = res.result.total;
                } else {
                    _this5.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getDoctorCustomServiceFeeRate: function getDoctorCustomServiceFeeRate(rowDoctorNo) {
            var _this6 = this;

            var para = {
                current: 1,
                size: 1000,
                doctorNo: rowDoctorNo
            };

            this.thirdLoading = true;
            (0, _customServiceFeeConfigService.getCustomServiceFeeList)(para).then(function (res) {
                _this6.thirdLoading = false;
                if (res.status === 200) {
                    _this6.customServiceFeeConfigs = res.result;
                } else {
                    _this6.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        showCustomEdit: function showCustomEdit(row) {
            var _this7 = this;

            var para = {
                doctorNo: row.doctorNo,
                serviceFeeId: row.serviceFeeId,
                id: row.id
            };
            (0, _customServiceFeeConfigService.getCustomServiceFeeById)(para).then(function (res) {
                if (res.status === 200) {
                    _this7.customEditVisible = true;
                    _this7.customEditServiceFee = res.result;
                }
            });
        },
        deleteCustomItem: function deleteCustomItem(row) {
            var _this8 = this;

            this.editLoading = true;
            var para = {
                doctorNo: row.doctorNo,
                serviceFeeId: row.serviceFeeId,
                id: row.id
            };
            (0, _customServiceFeeConfigService.deleteCustomServiceFeeConfigs)(para).then(function (res) {
                _this8.editLoading = false;
                if (res.status === 200) {
                    _this8.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this8.showServiceFeeEdit(row.doctorNo);
                    _this8.editVisible = false;
                } else {
                    _this8.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        customEditSubmit: function customEditSubmit() {
            var _this9 = this;

            this.customEditLoading = true;
            var para = {
                serviceFeeId: this.customEditServiceFee.serviceFeeId,
                serviceLabel: this.customEditServiceFee.serviceLabel,
                serviceDesc: this.customEditServiceFee.serviceDesc,
                doctorNo: this.customEditServiceFee.doctorNo,
                serviceBaseFee: this.customEditServiceFee.serviceBaseFee,
                id: this.customEditServiceFee.id
            };
            (0, _customServiceFeeConfigService.editCustomServiceFeeConfigs)(para).then(function (res) {
                _this9.customEditLoading = false;
                _this9.customEditVisible = false;
                if (res.status === 200) {
                    _this9.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this9.getDoctorCustomServiceFeeRate(_this9.customEditServiceFee.doctorNo);
                } else {
                    _this9.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getServiceFeeList();
    }
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _outboundService = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            pageSize: _globalVar.defaultPageSize,
            workingPage: 1,
            workingTotal: 0,

            filters: {
                markChecked: "",
                conditionSearch: ""
            },

            dataList: [],

            loading: false,

            user: sessionStorage.getItem('user')
        };
    },
    created: function created() {
        var _this = this;

        this.$on('changeDoctor', function (value) {
            setTimeout(function () {
                _this.getTrasferUserInfo();
            }, 300);
        });
    },

    methods: {
        getTrasferUserInfo: function getTrasferUserInfo() {
            var _this2 = this;

            var param = {
                current: this.workingPage,
                size: this.pageSize,
                markChecked: this.filters.markChecked,
                conditionSearch: this.filters.conditionSearch,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.firstLoading = true;
            (0, _outboundService.getTransferUserInfoWithWarehouseByDoctorNo)(param).then(function (data) {
                _this2.firstLoading = false;
                if (data.status === 200) {
                    _this2.dataList = data.result.records;
                    _this2.workingTotal = data.result.total;
                }
            });
        },
        markChecked: function markChecked(id) {
            var _this3 = this;

            this.$confirm('Please confirm if the goods have been properly handled?', 'Warning', {
                type: 'warning'
            }).then(function () {
                var param = {
                    transferId: id
                };
                (0, _outboundService.markChecked)(param).then(function (data) {
                    if (data.status === 200 && data.result) {
                        _this3.getTrasferUserInfo();
                    } else {
                        _this3.$message.error(data.message);
                    }
                });
            }).catch(function () {
                _this3.$message.error('Cannot mark the transfer log, please try again later');
            });
        }
    },
    mounted: function mounted() {
        this.getTrasferUserInfo();
        var user = sessionStorage.getItem('user');
        user = JSON.parse(user);
        this.user = user;
    }
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUser = exports.editUser = exports.batchRemoveUser = exports.removeUser = exports.getUserListPage = exports.getUserList = exports.requestLogin = undefined;

var _axios = __webpack_require__(209);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestLogin = exports.requestLogin = function requestLogin(params) {
  return _axios2.default.post(base + '/login', params).then(function (res) {
    return res.data;
  });
};

var getUserList = exports.getUserList = function getUserList(params) {
  return _axios2.default.get(base + '/user/list', { params: params });
};

var getUserListPage = exports.getUserListPage = function getUserListPage(params) {
  return _axios2.default.get(base + '/user/listpage', { params: params });
};

var removeUser = exports.removeUser = function removeUser(params) {
  return _axios2.default.get(base + '/user/remove', { params: params });
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
  return _axios2.default.get(base + '/user/batchremove', { params: params });
};

var editUser = exports.editUser = function editUser(params) {
  return _axios2.default.get(base + '/user/edit', { params: params });
};

var addUser = exports.addUser = function addUser(params) {
  return _axios2.default.get(base + '/user/add', { params: params });
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBoxSizeById = exports.editBoxSize = exports.getBoxSizeList = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBoxSizeList = exports.getBoxSizeList = function getBoxSizeList(params) {
    return _axiosInit2.default.post("/boxsizes/getBoxSizeList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editBoxSize = exports.editBoxSize = function editBoxSize(params) {
    return _axiosInit2.default.post("/boxsizes/saveOrUpdateById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBoxSizeById = exports.getBoxSizeById = function getBoxSizeById(params) {
    return _axiosInit2.default.post("/boxsizes/getBoxSizeById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteCustomBoxSizeConfigs = exports.editCustomBoxSizeConfigs = exports.getCustomBoxSizeById = exports.getCustomBoxSizeList = exports.getDoctorUserList = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDoctorUserList = exports.getDoctorUserList = function getDoctorUserList(params) {
    return _axiosInit2.default.post('/custom_box_size_config/getDoctorUserList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomBoxSizeList = exports.getCustomBoxSizeList = function getCustomBoxSizeList(params) {
    return _axiosInit2.default.post('/custom_box_size_config/getBoxSizeList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomBoxSizeById = exports.getCustomBoxSizeById = function getCustomBoxSizeById(params) {
    return _axiosInit2.default.post('/custom_box_size_config/getBoxSizeById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editCustomBoxSizeConfigs = exports.editCustomBoxSizeConfigs = function editCustomBoxSizeConfigs(params) {
    return _axiosInit2.default.post('/custom_box_size_config/addOrEditCustomBoxSizeConfigs', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteCustomBoxSizeConfigs = exports.deleteCustomBoxSizeConfigs = function deleteCustomBoxSizeConfigs(params) {
    return _axiosInit2.default.post('/custom_box_size_config/restoreCustomBoxSizeConfigs', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteCustomServiceFeeConfigs = exports.editCustomServiceFeeConfigs = exports.getCustomServiceFeeById = exports.getCustomServiceFeeList = exports.getDoctorUserList = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDoctorUserList = exports.getDoctorUserList = function getDoctorUserList(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/getDoctorUserList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomServiceFeeList = exports.getCustomServiceFeeList = function getCustomServiceFeeList(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/getServiceFeeList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomServiceFeeById = exports.getCustomServiceFeeById = function getCustomServiceFeeById(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/getServiceFeeById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editCustomServiceFeeConfigs = exports.editCustomServiceFeeConfigs = function editCustomServiceFeeConfigs(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/addOrEditCustomServiceFeeConfigs', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteCustomServiceFeeConfigs = exports.deleteCustomServiceFeeConfigs = function deleteCustomServiceFeeConfigs(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/restoreCustomServiceFeeConfigs', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getServiceFeeById = exports.editServiceFee = exports.getServiceFeeList = undefined;

var _axiosInit = __webpack_require__(16);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getServiceFeeList = exports.getServiceFeeList = function getServiceFeeList(params) {
    return _axiosInit2.default.post("/serviceFee/getServiceFeeList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editServiceFee = exports.editServiceFee = function editServiceFee(params) {
    return _axiosInit2.default.post("/serviceFee/saveOrUpdateById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getServiceFeeById = exports.getServiceFeeById = function getServiceFeeById(params) {
    return _axiosInit2.default.post("/serviceFee/getServiceFeeById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _babelPolyfill = __webpack_require__(307);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(316);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(308);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _en = __webpack_require__(309);

var _en2 = _interopRequireDefault(_en);

__webpack_require__(310);

var _vueRouter = __webpack_require__(317);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(306);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(207);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueQuillEditor = __webpack_require__(76);

var _vueQuillEditor2 = _interopRequireDefault(_vueQuillEditor);

__webpack_require__(314);

__webpack_require__(315);

__webpack_require__(313);

var _nprogress = __webpack_require__(206);

var _nprogress2 = _interopRequireDefault(_nprogress);

__webpack_require__(312);

__webpack_require__(311);

var _routes = __webpack_require__(305);

var _routes2 = _interopRequireDefault(_routes);

var _print = __webpack_require__(304);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_elementUi2.default, { locale: _en2.default });
_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueQuillEditor2.default);
_vue2.default.use(_print2.default);

_vue2.default.config.errorHandler = function (err, vm, info) {
    console.error('Vue Error:', err, info);

    if (err.message && (err.message.includes('Token expired') || err.message.includes('401'))) {
        console.log('Vue errorHandler detected token expired error');

        sessionStorage.removeItem('user');
        sessionStorage.removeItem('authorization');
        localStorage.removeItem('authorization');

        if (vm && vm.$message) {
            vm.$message.error('登录已过期，请重新登录');
        }

        setTimeout(function () {
            window.location.href = window.location.origin + '/';
        }, 1000);
    }
};

_vue2.default.mixin({
    methods: {
        handleApiError: function handleApiError(error) {
            console.log('Component handleApiError:', error);
            if (error.response && error.response.status === 401) {
                this.$message.error('登录已过期，请重新登录');
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('authorization');
                localStorage.removeItem('authorization');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
                return true;
            }
            return false;
        }
    }
});

global.antRouter = '';

_nprogress2.default.configure({ showSpinner: false });
var router = new _vueRouter2.default({
    routes: _routes2.default
});
var addRouFlag = false;

router.beforeEach(function (to, from, next) {
    _nprogress2.default.start();
    if (to.path === '/login') {}
    var user = JSON.parse(sessionStorage.getItem('user'));
    var token = sessionStorage.getItem('authorization');

    if ((!user || !token) && to.path !== '/login' && to.path !== '/forgetPassword' && to.path !== '/changePassword' && to.path.indexOf("/register") === -1) {
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('authorization');
        localStorage.removeItem('authorization');
        next({ path: '/login' });
    } else {
        if (user && !addRouFlag) {
            var role = user.roleId;

            addRouFlag = true;

            var menu = getMenuByRole(role);

            global.antRouter = menu;

            router.addRoutes(menu);

            router.push({ path: to.path });
        }
        next();
    }
});

var getMenuByRole = function getMenuByRole(roleId) {
    if (roleId === "1") {
        return _routes.defaultRoutes.concat(_routes.doctorRoutes);
    } else if (roleId === "2") {
        return _routes.defaultRoutes.concat(_routes.nurseRoutes);
    } else if (roleId === "3") {
        return _routes.defaultRoutes.concat(_routes.warehouseAdminRoutes);
    } else if (roleId === '0') {
        return _routes.defaultRoutes.concat(_routes.superAdminRouter);
    }
};

router.afterEach(function (transition) {
    _nprogress2.default.done();
});

new _vue2.default({
    router: router,
    store: _store2.default,

    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(106);

var _Home2 = _interopRequireDefault(_Home);

var _overview = __webpack_require__(786);

var _overview2 = _interopRequireDefault(_overview);

var _inventory = __webpack_require__(783);

var _inventory2 = _interopRequireDefault(_inventory);

var _inbound = __webpack_require__(782);

var _inbound2 = _interopRequireDefault(_inbound);

var _offer = __webpack_require__(784);

var _offer2 = _interopRequireDefault(_offer);

var _outbound = __webpack_require__(785);

var _outbound2 = _interopRequireDefault(_outbound);

var _payments = __webpack_require__(787);

var _payments2 = _interopRequireDefault(_payments);

var _storageFee = __webpack_require__(789);

var _storageFee2 = _interopRequireDefault(_storageFee);

var _settings = __webpack_require__(788);

var _settings2 = _interopRequireDefault(_settings);

var _teams = __webpack_require__(790);

var _teams2 = _interopRequireDefault(_teams);

var _warehouse = __webpack_require__(791);

var _warehouse2 = _interopRequireDefault(_warehouse);

var _account = __webpack_require__(204);

var _account2 = _interopRequireDefault(_account);

var _amazon = __webpack_require__(799);

var _amazon2 = _interopRequireDefault(_amazon);

var _bank = __webpack_require__(205);

var _bank2 = _interopRequireDefault(_bank);

var _password = __webpack_require__(139);

var _password2 = _interopRequireDefault(_password);

var _mixedPackageClaim = __webpack_require__(299);

var _mixedPackageClaim2 = _interopRequireDefault(_mixedPackageClaim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doctorRoutes = [{
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-home',
    leaf: true,
    children: [{ path: '/overview', component: _overview2.default, name: 'Home' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-file-text-o',
    leaf: true,
    children: [{ path: '/offer', component: _offer2.default, name: 'Offers' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-inbox',
    leaf: true,
    children: [{ path: '/inbound', component: _inbound2.default, name: 'Inbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-product-hunt',
    leaf: true,
    children: [{ path: '/inventory', component: _inventory2.default, name: 'Inventory' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-outdent',
    leaf: true,
    children: [{ path: '/outbound', component: _outbound2.default, name: 'Outbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-usd',
    leaf: true,
    children: [{ path: '/storageFee', component: _storageFee2.default, name: 'Storage Fee' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-credit-card',
    leaf: true,
    children: [{ path: '/payments', component: _payments2.default, name: 'Payments' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-university',
    leaf: true,
    children: [{ path: '/warehouse', component: _warehouse2.default, name: 'Warehouse' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-users',
    leaf: true,
    children: [{ path: '/teams', component: _teams2.default, name: 'Teams' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-cubes',
    leaf: true,
    children: [{ path: '/mixedPackageClaim', component: _mixedPackageClaim2.default, name: 'Mixed Claim' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'Settings',
    iconCls: 'fa fa-cog',
    children: [{ path: '/account', iconCls: 'fa fa-user', component: _account2.default, name: 'Account' }, { path: '/password', iconCls: 'fa fa-key', component: _password2.default, name: 'Password' }]
}];

exports.default = doctorRoutes;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(106);

var _Home2 = _interopRequireDefault(_Home);

var _overview = __webpack_require__(796);

var _overview2 = _interopRequireDefault(_overview);

var _inventory = __webpack_require__(300);

var _inventory2 = _interopRequireDefault(_inventory);

var _Inbound = __webpack_require__(794);

var _Inbound2 = _interopRequireDefault(_Inbound);

var _offer = __webpack_require__(795);

var _offer2 = _interopRequireDefault(_offer);

var _outbound = __webpack_require__(302);

var _outbound2 = _interopRequireDefault(_outbound);

var _payments = __webpack_require__(797);

var _payments2 = _interopRequireDefault(_payments);

var _warehouse = __webpack_require__(798);

var _warehouse2 = _interopRequireDefault(_warehouse);

var _invitations = __webpack_require__(301);

var _invitations2 = _interopRequireDefault(_invitations);

var _account = __webpack_require__(204);

var _account2 = _interopRequireDefault(_account);

var _bank = __webpack_require__(205);

var _bank2 = _interopRequireDefault(_bank);

var _password = __webpack_require__(139);

var _password2 = _interopRequireDefault(_password);

var _mixedPackageClaim = __webpack_require__(299);

var _mixedPackageClaim2 = _interopRequireDefault(_mixedPackageClaim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nurseRoutes = [{
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-home',
    leaf: true,
    children: [{ path: '/overview', component: _overview2.default, name: 'Home' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-file-text-o',
    leaf: true,
    children: [{ path: '/offer', component: _offer2.default, name: 'Offers' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-inbox',
    leaf: true,
    children: [{ path: '/inbound', component: _Inbound2.default, name: 'Inbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-product-hunt',
    leaf: true,
    children: [{ path: '/inventory', component: _inventory2.default, name: 'Inventory' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-outdent',
    leaf: true,
    children: [{ path: '/outbound', component: _outbound2.default, name: 'Outbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-credit-card',
    leaf: true,
    children: [{ path: '/payments', component: _payments2.default, name: 'Payments' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-cubes',
    leaf: true,
    children: [{ path: '/mixedPackageClaim', component: _mixedPackageClaim2.default, name: 'Mixed Claim' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'Settings',
    iconCls: 'fa fa-cog',
    children: [{ path: '/account', iconCls: 'fa fa-user', component: _account2.default, name: 'Account' }, { path: '/password', iconCls: 'fa fa-key', component: _password2.default, name: 'Password' }, { path: '/bank', iconCls: 'fa fa-credit-card-alt', component: _bank2.default, name: 'Bank' }, { path: '/selfStorage', iconCls: 'fa fa-university', component: _warehouse2.default, name: 'Self Storage' }, { path: '/invitations', iconCls: 'fa fa-handshake-o', component: _invitations2.default, name: 'Invitations' }]
}];

exports.default = nurseRoutes;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(106);

var _Home2 = _interopRequireDefault(_Home);

var _userlist = __webpack_require__(780);

var _userlist2 = _interopRequireDefault(_userlist);

var _password = __webpack_require__(139);

var _password2 = _interopRequireDefault(_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adminRoutes = [{
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-users',
    leaf: true,
    children: [{ path: '/users', component: _userlist2.default, name: 'Users' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-user',
    leaf: true,
    children: [{ path: '/password', component: _password2.default, name: 'Password' }]
}];

exports.default = adminRoutes;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(106);

var _Home2 = _interopRequireDefault(_Home);

var _overview = __webpack_require__(804);

var _overview2 = _interopRequireDefault(_overview);

var _inventory = __webpack_require__(300);

var _inventory2 = _interopRequireDefault(_inventory);

var _Inbound = __webpack_require__(801);

var _Inbound2 = _interopRequireDefault(_Inbound);

var _outbound = __webpack_require__(302);

var _outbound2 = _interopRequireDefault(_outbound);

var _invitations = __webpack_require__(301);

var _invitations2 = _interopRequireDefault(_invitations);

var _account = __webpack_require__(204);

var _account2 = _interopRequireDefault(_account);

var _password = __webpack_require__(139);

var _password2 = _interopRequireDefault(_password);

var _discounts = __webpack_require__(803);

var _discounts2 = _interopRequireDefault(_discounts);

var _boxsizes = __webpack_require__(802);

var _boxsizes2 = _interopRequireDefault(_boxsizes);

var _payments = __webpack_require__(805);

var _payments2 = _interopRequireDefault(_payments);

var _bank = __webpack_require__(205);

var _bank2 = _interopRequireDefault(_bank);

var _transferCheck = __webpack_require__(807);

var _transferCheck2 = _interopRequireDefault(_transferCheck);

var _serviceFeeConfig = __webpack_require__(806);

var _serviceFeeConfig2 = _interopRequireDefault(_serviceFeeConfig);

var _MixedPackageList = __webpack_require__(793);

var _MixedPackageList2 = _interopRequireDefault(_MixedPackageList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warehouseAdminRouter = [{
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-inbox',
    leaf: true,
    children: [{ path: '/inbound', component: _Inbound2.default, name: 'Inbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-product-hunt',
    leaf: true,
    children: [{ path: '/inventory', component: _inventory2.default, name: 'Inventory' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-outdent',
    leaf: true,
    children: [{ path: '/outbound', component: _outbound2.default, name: 'Outbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-credit-card',
    leaf: true,
    children: [{ path: '/payments', component: _payments2.default, name: 'Payment' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-paper-plane',
    leaf: true,
    children: [{ path: '/transferCheck', component: _transferCheck2.default, name: 'Transfers' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'Mixed Package',
    iconCls: 'fa fa-cubes',
    leaf: true,
    children: [{ path: '/mixedPackageList', iconCls: 'fa fa-cubes', component: _MixedPackageList2.default, name: 'Mixed Package' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'Settings',
    iconCls: 'fa fa-cog',
    children: [{ path: '/account', iconCls: 'fa fa-user', component: _account2.default, name: 'Account' }, { path: '/password', iconCls: 'fa fa-key', component: _password2.default, name: 'Password' }, { path: '/bank', iconCls: 'fa fa-credit-card-alt', component: _bank2.default, name: 'Bank' }, { path: '/invitations', iconCls: 'fa fa-handshake-o', component: _invitations2.default, name: 'Invitations' }, { path: '/discounts', iconCls: 'fa fa-dollar', component: _discounts2.default, name: 'Discounts' }, { path: '/boxsizes', iconCls: 'fa fa-dollar', component: _boxsizes2.default, name: 'Category Set' }, { path: '/serviceFee', iconCls: 'fa fa-dollar', component: _serviceFeeConfig2.default, name: 'Service Fee Set' }]
}];

exports.default = warehouseAdminRouter;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(712)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(824),
  /* scopeId */
  "data-v-49118cb4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(711)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(823),
  /* scopeId */
  "data-v-39b5fece",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(719)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(843),
  /* scopeId */
  "data-v-7f532c88",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(722)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(850),
  /* scopeId */
  "data-v-c4e77826",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(715)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(831),
  /* scopeId */
  "data-v-5f4b1384",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(810),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(708)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(815),
  /* scopeId */
  "data-v-28631f46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(819),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(710)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(713)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(825),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(852),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(835),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(721)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(848),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(820),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(709)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(821),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(829),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(813),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(716)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(834),
  /* scopeId */
  "data-v-665f7a03",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(720)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(847),
  /* scopeId */
  "data-v-a4400a3c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(808),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(826),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(827),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(707)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(812),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(853),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(828),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(706)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(811),
  /* scopeId */
  "data-v-03abbdbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(714)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(830),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(849),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(832),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(817),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(833),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(845),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(839),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getNurseConfirmList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.confirmInboundFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "confirmInboundFilter", $$v)
      },
      expression: "filters.confirmInboundFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getNurseConfirmList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseToConfirm', 'toConfirm.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.confirmInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "inboundNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.productName) + "\n                        "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.createDate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor === 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmInboundItem(scope.row.inboundNo, 'self', true)
            }
          }
        }, [_vm._v("Confirm\n                        ")]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor === 0) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmInboundItem(scope.row.inboundNo, 'warehouse', true)
            }
          }
        }, [_vm._v("\n                            Confirm\n                        ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.showCancelInbound(scope.row.inboundNo)
            }
          }
        }, [_vm._v("Cancel")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.confirmInboundTotal
    },
    on: {
      "current-change": _vm.changeConfirmInboundPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Reported",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getReportList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.reportFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportFilter", $$v)
      },
      expression: "filters.reportFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getReportList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getReportList
    },
    model: {
      value: (_vm.filters.reportStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportStatus", $$v)
      },
      expression: "filters.reportStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseReported', 'report.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.reportedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Offer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.productName) + " (" + _vm._s(scope.row.offerCreateDate) + ")")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeReportPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundHistoryList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundHistoryList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseInboundHistory', 'inboundHistory.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundHistory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offerCreateDate",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeHistory
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Confirm Inbound Items to self storage",
      "width": "80%",
      "visible": _vm.selfConfirmVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.selfConfirmVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "selfConfirm",
    attrs: {
      "model": _vm.selfConfirm,
      "label-width": "220px",
      "rules": _vm.inboundFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.productName),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "productName", $$v)
      },
      expression: "selfConfirm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.company),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "company", $$v)
      },
      expression: "selfConfirm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.price),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "price", $$v)
      },
      expression: "selfConfirm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.num),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "num", $$v)
      },
      expression: "selfConfirm.num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "leftNum", $$v)
      },
      expression: "selfConfirm.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "quantity", $$v)
      },
      expression: "selfConfirm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "warehouse", $$v)
      },
      expression: "selfConfirm.warehouse"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.selfConfirmVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleConfirmInbound.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.modalLoading),
      expression: "modalLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "title": "Confirm Inbound Items to shared warehouse",
      "width": "80%",
      "visible": _vm.warehouseConfirmVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseConfirmVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehouseConfirm",
    attrs: {
      "model": _vm.warehouseConfirm,
      "label-width": "220px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.productName),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "productName", $$v)
      },
      expression: "warehouseConfirm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.company),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "company", $$v)
      },
      expression: "warehouseConfirm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.price),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "price", $$v)
      },
      expression: "warehouseConfirm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.num),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "num", $$v)
      },
      expression: "warehouseConfirm.num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "leftNum", $$v)
      },
      expression: "warehouseConfirm.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "warehouse", $$v)
      },
      expression: "warehouseConfirm.warehouse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('p', [_vm._v("Import tracking number as\n                "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.textImportVisible = true
      }
    }
  }, [_vm._v("Text")]), _vm._v("\n                or\n                "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.excelImportVisible = true
      }
    }
  }, [_vm._v("Excel")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Staus"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status"
    },
    on: {
      "change": _vm.changeTrackingFilterStatus
    },
    model: {
      value: (_vm.warehouseConfirm.trackingStatus),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "trackingStatus", $$v)
      },
      expression: "warehouseConfirm.trackingStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": "All"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Claimed",
      "value": "Claimed"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Matched",
      "value": "Matched"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Unmatched",
      "value": "Unmatched"
    }
  })], 1), _vm._v(" "), (_vm.warehouseConfirm.unClaimedList.length > 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v("Bulk Confirm")]) : _vm._e(), _vm._v(" "), (_vm.warehouseConfirm.unClaimedList.length > 0 || _vm.warehouseConfirm.unMatchedList.length > 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkRemoveSelected.apply(null, arguments)
      }
    }
  }, [_vm._v("Bulk Remove Seleted")]) : _vm._e(), _vm._v(" "), (_vm.warehouseConfirm.unMatchedList && _vm.warehouseConfirm.unMatchedList.length > 0) ? _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.goToMixedClaim
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("Go to Mixed Claim\n                ")]) : _vm._e(), _vm._v(" "), (_vm.warehouseConfirm.unMatchedList && _vm.warehouseConfirm.unMatchedList.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "Tracking numbers not found in warehouse records",
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                            Some tracking numbers couldn't be matched with existing warehouse records. This might be a mixed package containing multiple items from different orders. Use the \"Go to Mixed Claim\" button above to claim specific items.\n                        ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseConfirm.trackingNumbersPage,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.inboundDetailId) ? _c('span', [_vm._v(_vm._s(scope.row.inboundDetailId))]) : (scope.row.importId) ? _c('span', [_vm._v(_vm._s(scope.row.importId))]) : _c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.confirmed) ? _c('div', [(scope.row.matched && scope.row.canClaim !== false) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "loading": scope.row.loading
          },
          on: {
            "click": function($event) {
              return _vm.claim(scope.row)
            }
          }
        }, [_vm._v("Claim\n                                    ")]) : _vm._e(), _vm._v(" "), (scope.row.matched && scope.row.canClaim === false) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning",
            "disabled": "",
            "title": "UPC不匹配，无法认领"
          }
        }, [_vm._v("UPC不匹配\n                                    ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeRow(scope.row)
            }
          }
        }, [_vm._v("Remove\n                                    ")])], 1) : _c('div', [_vm._v("\n                                    claimed\n                                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.warehouseConfirm.currentPage,
      "page-size": 100,
      "total": _vm.warehouseConfirm.total
    },
    on: {
      "current-change": _vm.changeImportTrackingPage
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseConfirmVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.modalLoading),
      expression: "modalLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "title": "Import tracking number from text",
      "width": "80%",
      "visible": _vm.textImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.textImportVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.warehouseConfirm,
      "label-width": "220px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "10",
      "placeholder": _vm.placeholder,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("The tracking number import of text needs to contain tracking Numbers, multiple records must be separated by newline.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.textImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importFromText.apply(null, arguments)
      }
    }
  }, [_vm._v("Import")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.modalLoading),
      expression: "modalLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "title": "Import tracking number from excel",
      "width": "80%",
      "visible": _vm.excelImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.excelImportVisible = $event
      }
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "on-progress": _vm.preview,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "name": "filename",
      "drag": "",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "data": _vm.uploadData,
      "limit": 1,
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("click to upload")]), _vm._v(" or drag and drop file")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Only allowed .xls,.xlsx files, please follow the columns format with trackingNum. include the header.")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Cancel Inbound",
      "width": "80%",
      "visible": _vm.cancelInboundVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.cancelInboundVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.cancel,
      "label-width": "220px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cancel Number"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.cancel.cancelNum),
      callback: function($$v) {
        _vm.$set(_vm.cancel, "cancelNum", $$v)
      },
      expression: "cancel.cancelNum"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cancelInboundVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelInbound.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "UnClaimed Tracking#",
      "width": "80%",
      "visible": _vm.unClaimedTrackingVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.unClaimedTrackingVisiable = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking #"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "15"
    },
    model: {
      value: (_vm.unClaimedTracking),
      callback: function($$v) {
        _vm.unClaimedTracking = $$v
      },
      expression: "unClaimedTracking"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.unClaimedTrackingVisiable = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Working",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.workingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingFilter", $$v)
      },
      expression: "filters.workingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.workingMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingMainFilter", $$v)
      },
      expression: "filters.workingMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseOutbound', 'Working.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.workingLoading),
      expression: "workingLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.workingList,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "outboundId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Outbound Shipment"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Last Update"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.printNote(scope.row)
            }
          }
        }, [_vm._v("Print")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row.outboundId)
            }
          }
        }, [_vm._v("Package Label")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.archivedOutbound(scope.row.outboundId)
            }
          }
        }, [_vm._v("Archived")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.workingTotal
    },
    on: {
      "current-change": _vm.changeWorkingList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Archived",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Product Name or UPC"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.archivedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedFilter", $$v)
      },
      expression: "filters.archivedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Main Product"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.archivedMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedMainFilter", $$v)
      },
      expression: "filters.archivedMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseOutbound', 'Archived.xls', 2)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.archivedLoading),
      expression: "archivedLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.archivedList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "outboundId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outbound",
      "label": "Outbound Shipment"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Last Update"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.printNote(scope.row)
            }
          }
        }, [_vm._v("Print")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.archivedTotal
    },
    on: {
      "current-change": _vm.changeArchivedList
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Print",
      "width": "80%",
      "visible": _vm.packageDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.packageDetailVisible = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "printArea"
    }
  }, [_c('p', [_c('b', [_vm._v("Outbound ID : " + _vm._s(_vm.print.outboundNo))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Company : " + _vm._s(_vm.print.company))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Outbound Shipment : ")])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.print.outboundShipment)
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("Package Num : " + _vm._s(_vm.print.splitPackagesNum))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Instruction :")])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.print.instruction)
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("Note :")])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.print.note)
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode1"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode2"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode3"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode4"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode5"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode6"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "User List",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.email),
      callback: function($$v) {
        _vm.$set(_vm.filters, "email", $$v)
      },
      expression: "filters.email"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getUserList
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Date Time",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusName",
      "label": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.statusName === 'Enabled') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editUserStatus(scope.row.userNo, 2)
            }
          }
        }, [_vm._v("Disable\n                        ")]) : _vm._e(), _vm._v(" "), (scope.row.statusName === 'Disabled') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editUserStatus(scope.row.userNo, 1)
            }
          }
        }, [_vm._v("Enable\n                        ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleUserPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Invitation List",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.invitationEmail),
      callback: function($$v) {
        _vm.$set(_vm.filters, "invitationEmail", $$v)
      },
      expression: "filters.invitationEmail"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInvitationList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.invitationVisible = true
      }
    }
  }, [_vm._v("Invitation")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.invitations,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Time",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusName",
      "label": "Status",
      "formatter": _vm.formatRole
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.invitationTotal
    },
    on: {
      "current-change": _vm.handleInvitationPageChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Invite Doctor",
      "width": "80%",
      "visible": _vm.invitationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.invitationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "invitation",
    attrs: {
      "model": _vm.invitation,
      "label-width": "220px",
      "rules": _vm.invitationRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.invitation.email),
      callback: function($$v) {
        _vm.$set(_vm.invitation, "email", $$v)
      },
      expression: "invitation.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.invitationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.invitationRegister.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.validate) ? _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Register")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Role",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm2.role),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "role", $$v)
      },
      expression: "ruleForm2.role"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": "UserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "UserName"
    },
    model: {
      value: (_vm.ruleForm2.username),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "username", $$v)
      },
      expression: "ruleForm2.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "password", $$v)
      },
      expression: "ruleForm2.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rePassword",
      "label": "Confirm Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.ruleForm2.rePassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "rePassword", $$v)
      },
      expression: "ruleForm2.rePassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.laoding
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Register\n        ")])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Payment Requests",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentStatus", $$v)
      },
      expression: "filters.paymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNursePayment', 'payment.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddPayment
    }
  }, [_vm._v("Request a payment")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.payments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseNote",
      "label": "Nurse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.nurseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editPaymentStatus(scope.row.paymentNo, 2)
            }
          }
        }, [_vm._v("Cancel\n                            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Pending Transactions",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.pendingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pendingFilter", $$v)
      },
      expression: "filters.pendingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPendingTransaction
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.pendingPayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "offerNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.pendingTotal
    },
    on: {
      "current-change": _vm.changePendingRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Transaction History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search Product Name, Note, Account etc.",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTransactionHistory
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.transactions,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Transaction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'transaction') ? _c('div', [_c('p', [_vm._v("For " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'reported') ? _c('div', [_c('p', [_vm._v("Reported for " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'adjust') ? _c('div', [(scope.row.amount > 0) ? _c('p', [_vm._v("Increase Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), (scope.row.amount <= 0) ? _c('p', [_vm._v("Decrease Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.type == 'payment') ? _c('div', [_c('p', [_vm._v("Withdraw to " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime) + "\n                                    "), (scope.row.status === 0) ? _c('span', [_vm._v("(waiting for pay)")]) : (scope.row.status === 1) ? _c('span', [_vm._v("(paid)")]) : (scope.row.status === 2) ? _c('span', [_vm._v("(canceled)")]) : (scope.row.status === 3) ? _c('span', [_vm._v("(rollover)")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Balance",
      "prop": "balance"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeTransactionHistory
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Balance",
      "name": "fourth"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.balances,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "Total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.total, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pendingAmount",
      "label": "Pending"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.pendingAmount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requestAmount",
      "label": "Request Pay"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.requestAmount, 2)) + "\n                        ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.balanceTotal
    },
    on: {
      "current-change": _vm.changeBalance
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Request a payment",
      "width": "80%",
      "visible": _vm.requestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total Balance",
      "prop": "balance"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.payment.balance),
      callback: function($$v) {
        _vm.$set(_vm.payment, "balance", $$v)
      },
      expression: "payment.balance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.payment.balance
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.payment.bank),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bank", $$v)
      },
      expression: "payment.bank"
    }
  }, _vm._l((_vm.banks), function(bank, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bank.category + ' ' + bank.accountNumber + ' (' + bank.accountType + ')',
        "value": bank.bankNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.payment.note),
      callback: function($$v) {
        _vm.$set(_vm.payment, "note", $$v)
      },
      expression: "payment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestPayment.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add warehouse")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouses,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "warehouseNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address",
      "width": "400px",
      "formatter": _vm.formatAddress
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zipCode",
      "label": "Zip Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "admin",
      "label": "Admin"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getWarehousesById(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteWarehouses(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add warehouse",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehouseForm",
    attrs: {
      "model": _vm.warehouseForm,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.address),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "address", $$v)
      },
      expression: "warehouseForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.city),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "city", $$v)
      },
      expression: "warehouseForm.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.state),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "state", $$v)
      },
      expression: "warehouseForm.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "zipCode", $$v)
      },
      expression: "warehouseForm.zipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer Addr Key Wold",
      "prop": "transferAddrKeyWold"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.transferAddrKeyWold),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "transferAddrKeyWold", $$v)
      },
      expression: "warehouseForm.transferAddrKeyWold"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Physical Addr Key",
      "prop": "physicalAddrKey"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "物理仓库地址关键词，用于混寄包裹跨神医认领匹配"
    },
    model: {
      value: (_vm.warehouseForm.physicalAddrKey),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "physicalAddrKey", $$v)
      },
      expression: "warehouseForm.physicalAddrKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Admin",
      "prop": "adminNo"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.warehouseForm.adminNo),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "adminNo", $$v)
      },
      expression: "warehouseForm.adminNo"
    }
  }, _vm._l((_vm.adminList), function(admin, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": admin.userNo,
        "label": admin.username
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Visible",
      "prop": "hide"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.warehouseForm.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "isVisiable", $$v)
      },
      expression: "warehouseForm.isVisiable"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.warehouseForm.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "isVisiable", $$v)
      },
      expression: "warehouseForm.isVisiable"
    }
  }, [_vm._v("Hide")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addWarehouse.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit warehouse",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editWarehouseObj",
    attrs: {
      "model": _vm.editWarehouseObj,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.state),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "state", $$v)
      },
      expression: "editWarehouseObj.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.city),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "city", $$v)
      },
      expression: "editWarehouseObj.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.address),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "address", $$v)
      },
      expression: "editWarehouseObj.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "zipCode", $$v)
      },
      expression: "editWarehouseObj.zipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer Addr Key Wold",
      "prop": "transferAddrKeyWold"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.transferAddrKeyWold),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "transferAddrKeyWold", $$v)
      },
      expression: "editWarehouseObj.transferAddrKeyWold"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Physical Addr Key",
      "prop": "physicalAddrKey"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "物理仓库地址关键词，用于混寄包裹跨神医认领匹配"
    },
    model: {
      value: (_vm.editWarehouseObj.physicalAddrKey),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "physicalAddrKey", $$v)
      },
      expression: "editWarehouseObj.physicalAddrKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Admin",
      "prop": "adminNo"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.editWarehouseObj.adminNo),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "adminNo", $$v)
      },
      expression: "editWarehouseObj.adminNo"
    }
  }, _vm._l((_vm.adminList), function(admin, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": admin.userNo,
        "label": admin.username
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Visible",
      "prop": "isVisiable"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.editWarehouseObj.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "isVisiable", $$v)
      },
      expression: "editWarehouseObj.isVisiable"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.editWarehouseObj.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "isVisiable", $$v)
      },
      expression: "editWarehouseObj.isVisiable"
    }
  }, [_vm._v("Hide")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editWarehouse.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', _vm._b({
    class: [
      'el-link',
      _vm.type ? ("el-link--" + _vm.type) : '',
      _vm.disabled && 'is-disabled',
      _vm.underline && !_vm.disabled && 'is-underline'
    ],
    attrs: {
      "href": _vm.disabled ? null : _vm.href
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'a', _vm.$attrs, false), [(_vm.icon) ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('span', {
    staticClass: "el-link--inner"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.icon) ? [(_vm.$slots.icon) ? _vm._t("icon") : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.validate) ? _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "password", $$v)
      },
      expression: "ruleForm2.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rePassword",
      "label": "Confirm Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.ruleForm2.rePassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "rePassword", $$v)
      },
      expression: "ruleForm2.rePassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Submit\n        ")])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
      _vm.inputSize ? 'el-input--' + _vm.inputSize : '',
      {
        'is-disabled': _vm.inputDisabled,
        'is-exceed': _vm.inputExceed,
        'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
        'el-input-group--append': _vm.$slots.append,
        'el-input-group--prepend': _vm.$slots.prepend,
        'el-input--prefix': _vm.$slots.prefix || _vm.prefixIcon,
        'el-input--suffix': _vm.$slots.suffix || _vm.suffixIcon || _vm.clearable || _vm.showPassword
      }
    ],
    on: {
      "mouseenter": function($event) {
        _vm.hovering = true
      },
      "mouseleave": function($event) {
        _vm.hovering = false
      }
    }
  }, [(_vm.type !== 'textarea') ? [(_vm.$slots.prepend) ? _c('div', {
    staticClass: "el-input-group__prepend"
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', _vm._b({
    ref: "input",
    staticClass: "el-input__inner",
    attrs: {
      "tabindex": _vm.tabindex,
      "type": _vm.showPassword ? (_vm.passwordVisible ? 'text' : 'password') : _vm.type,
      "disabled": _vm.inputDisabled,
      "readonly": _vm.readonly,
      "autocomplete": _vm.autoComplete || _vm.autocomplete,
      "aria-label": _vm.label
    },
    on: {
      "compositionstart": _vm.handleCompositionStart,
      "compositionupdate": _vm.handleCompositionUpdate,
      "compositionend": _vm.handleCompositionEnd,
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": _vm.handleChange
    }
  }, 'input', _vm.$attrs, false)) : _vm._e(), _vm._v(" "), (_vm.$slots.prefix || _vm.prefixIcon) ? _c('span', {
    staticClass: "el-input__prefix"
  }, [_vm._t("prefix"), _vm._v(" "), (_vm.prefixIcon) ? _c('i', {
    staticClass: "el-input__icon",
    class: _vm.prefixIcon
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.getSuffixVisible()) ? _c('span', {
    staticClass: "el-input__suffix"
  }, [_c('span', {
    staticClass: "el-input__suffix-inner"
  }, [(!_vm.showClear || !_vm.showPwdVisible || !_vm.isWordLimitVisible) ? [_vm._t("suffix"), _vm._v(" "), (_vm.suffixIcon) ? _c('i', {
    staticClass: "el-input__icon",
    class: _vm.suffixIcon
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showClear) ? _c('i', {
    staticClass: "el-input__icon el-icon-circle-close el-input__clear",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": _vm.clear
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPwdVisible) ? _c('i', {
    staticClass: "el-input__icon el-icon-view el-input__clear",
    on: {
      "click": _vm.handlePasswordVisible
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isWordLimitVisible) ? _c('span', {
    staticClass: "el-input__count"
  }, [_c('span', {
    staticClass: "el-input__count-inner"
  }, [_vm._v("\n            " + _vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit) + "\n          ")])]) : _vm._e()], 2), _vm._v(" "), (_vm.validateState) ? _c('i', {
    staticClass: "el-input__icon",
    class: ['el-input__validateIcon', _vm.validateIcon]
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$slots.append) ? _c('div', {
    staticClass: "el-input-group__append"
  }, [_vm._t("append")], 2) : _vm._e()] : _c('textarea', _vm._b({
    ref: "textarea",
    staticClass: "el-textarea__inner",
    style: (_vm.textareaStyle),
    attrs: {
      "tabindex": _vm.tabindex,
      "disabled": _vm.inputDisabled,
      "readonly": _vm.readonly,
      "autocomplete": _vm.autoComplete || _vm.autocomplete,
      "aria-label": _vm.label
    },
    on: {
      "compositionstart": _vm.handleCompositionStart,
      "compositionupdate": _vm.handleCompositionUpdate,
      "compositionend": _vm.handleCompositionEnd,
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": _vm.handleChange
    }
  }, 'textarea', _vm.$attrs, false)), _vm._v(" "), (_vm.isWordLimitVisible && _vm.type === 'textarea') ? _c('span', {
    staticClass: "el-input__count"
  }, [_vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("Overview\n")])
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-select-dropdown__item",
    class: {
      'selected': _vm.itemSelected,
      'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
      'hover': _vm.hover
    },
    on: {
      "mouseenter": _vm.hoverItem,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectOptionClick.apply(null, arguments)
      }
    }
  }, [_vm._t("default", function() {
    return [_c('span', [_vm._v(_vm._s(_vm.currentLabel))])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.viewedInboundFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "viewedInboundFilter", $$v)
      },
      expression: "filters.viewedInboundFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundViewing', 'Viewing.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.viewedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "inboundNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "Take"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Not Claimed"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Take Offer Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelInbound(scope.row.inboundNo)
            }
          }
        }, [_vm._v("Cancel")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.viewInboundTotal
    },
    on: {
      "current-change": _vm.changeViewList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Reported/Missed",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getReportList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.reportFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportFilter", $$v)
      },
      expression: "filters.reportFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getReportList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getReportList
    },
    model: {
      value: (_vm.filters.reportStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportStatus", $$v)
      },
      expression: "filters.reportStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundViewingReported', 'reported.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.reportedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Offer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.productName) + " " + _vm._s(scope.row.offerCreateDate ? "(" + scope.row.offerCreateDate + ")" : ""))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "small",
            "loading": scope.row.loading || _vm.globalLoading
          },
          on: {
            "click": function($event) {
              return _vm.editReportStatus(scope.row.id, 1, scope.row)
            }
          }
        }, [_vm._v("Confirm")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "loading": scope.row.loading || _vm.globalLoading,
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editReportStatus(scope.row.id, 2, scope.row)
            }
          }
        }, [_vm._v("Reject")])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.reportTotal
    },
    on: {
      "current-change": _vm.changeReportPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundHistoryList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundHistoryList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundHistory', 'inboundHistory.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundHistory,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offerCreateDate",
      "label": "Offer Creation Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeHistoryList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Nurse Cancelled",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCancelInboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.cancelFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "cancelFilter", $$v)
      },
      expression: "filters.cancelFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCancelInboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundNurseCancel', 'cancel.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthLoading),
      expression: "fourthLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.cancelList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Cancel Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.cancelTotal
    },
    on: {
      "current-change": _vm.changeCancelList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Tracking",
      "name": "five"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number or UPC, Product Name, Offer Id ",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTrackingList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.trackingNumFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "trackingNumFilter", $$v)
      },
      expression: "filters.trackingNumFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTrackingList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "daterange",
      "range-separator": "to",
      "start-placeholder": "startDate",
      "end-placeholder": "endDate"
    },
    on: {
      "change": _vm.getTrackingList
    },
    model: {
      value: (_vm.filters.trackingDate),
      callback: function($$v) {
        _vm.$set(_vm.filters, "trackingDate", $$v)
      },
      expression: "filters.trackingDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundTracking', 'tracking.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fiveLoading),
      expression: "fiveLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.trackingList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trackingNumber",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.offerNo == 0) ? _c('p') : _c('p', [_vm._v(_vm._s(scope.row.offerNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateTime",
      "label": "DateTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.trackingTotal
    },
    on: {
      "current-change": _vm.changeTracking
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Offer Take Detail",
      "width": "80%",
      "visible": _vm.detailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.detailLoading),
      expression: "detailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundDetail,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "inboundNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Take Offer Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": function($event) {}
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("settings\n")])
},staticRenderFns: []}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.product),
      callback: function($$v) {
        _vm.$set(_vm.filters, "product", $$v)
      },
      expression: "filters.product"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getList()
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Warehouse",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getList()
      }
    },
    model: {
      value: (_vm.filters.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "warehouse", $$v)
      },
      expression: "filters.warehouse"
    }
  }, _vm._l((_vm.warehouseList), function(w, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": w.address + ' ' + w.city + ' ' + w.state,
        "value": w.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "monthrange",
      "value-format": "yyyy-MM",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "to",
      "start-placeholder": "start",
      "end-placeholder": "end",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.date),
      callback: function($$v) {
        _vm.$set(_vm.filters, "date", $$v)
      },
      expression: "filters.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportStorageFee', 'StorageFee.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "stripe": "",
      "data": _vm.list,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product_name",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "charge_total",
      "label": "Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.formatMoney(scope.row.charge_total, 2)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "charge_date",
      "label": "Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changePage
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInventory.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInventory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInventory', 'inventory.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.goToMixedPackageClaim
    }
  }, [_vm._v("Mixed Package")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.products,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Product",
      "width": "400px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.condition) + " - "), _c('b', [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" (" + _vm._s(scope.row.createDate) + ")\n                "), _c('p', [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Categroy"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inbound",
      "label": "INBD"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stock",
      "label": "FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "noClaimed",
      "label": "Not Claimed"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditProduct(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(scope.row.productNo)
            }
          }
        }, [_vm._v("Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteProduct(scope.row.productNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventoryTotal
    },
    on: {
      "current-change": _vm.handleInventoryChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProduct",
    attrs: {
      "model": _vm.addProduct,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.product),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "product", $$v)
      },
      expression: "addProduct.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addProduct.price),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "price", $$v)
      },
      expression: "addProduct.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "condition", $$v)
      },
      expression: "addProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "asin", $$v)
      },
      expression: "addProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "upc", $$v)
      },
      expression: "addProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "weight", $$v)
      },
      expression: "addProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "note", $$v)
      },
      expression: "addProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProduct.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product",
      "width": "80%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editProduct",
    attrs: {
      "model": _vm.editProduct,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.productName),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "productName", $$v)
      },
      expression: "editProduct.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editProduct.price),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "price", $$v)
      },
      expression: "editProduct.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.editProduct.size),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "size", $$v)
      },
      expression: "editProduct.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "condition", $$v)
      },
      expression: "editProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "asin", $$v)
      },
      expression: "editProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "upc", $$v)
      },
      expression: "editProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "weight", $$v)
      },
      expression: "editProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "note", $$v)
      },
      expression: "editProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product FBM",
      "width": "80%",
      "visible": _vm.editFBMVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFBMVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "fbm",
    attrs: {
      "model": _vm.fbm,
      "label-width": "220px",
      "rules": _vm.fbmFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "productName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fbm.productName),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "productName", $$v)
      },
      expression: "fbm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.fbm.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "warehouseNo", $$v)
      },
      expression: "fbm.warehouseNo"
    }
  }, _vm._l((_vm.warehouseList), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": warehouse.warehouseNo,
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.fbm.price),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "price", $$v)
      },
      expression: "fbm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.fbm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "quantity", $$v)
      },
      expression: "fbm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fbm.note),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "note", $$v)
      },
      expression: "fbm.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFBMVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addFBM.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product Detail",
      "width": "80%",
      "visible": _vm.detailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailVisible = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": function($event) {}
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.tracking),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tracking", $$v)
      },
      expression: "filters.tracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getInboundList()
      }
    },
    model: {
      value: (_vm.filters.inboundUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inboundUser", $$v)
      },
      expression: "filters.inboundUser"
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": member.username,
        "value": member.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Inbound Source",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getInboundList()
      }
    },
    model: {
      value: (_vm.filters.inboundType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inboundType", $$v)
      },
      expression: "filters.inboundType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "Offer",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Channel",
      "label": "Channel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportInventoryInboundHistory
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundType",
      "label": "Inbound Source"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inboundTotal
    },
    on: {
      "current-change": _vm.handleChangeInboundList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "FBM",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.inventoryProduct),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryProduct", $$v)
      },
      expression: "filters.inventoryProduct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getInventoryDetail(null)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter by user",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getInventoryDetail(null)
      }
    },
    model: {
      value: (_vm.filters.inventoryNurse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryNurse", $$v)
      },
      expression: "filters.inventoryNurse"
    }
  }, _vm._l((_vm.members), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fbmDetailLoading),
      expression: "fbmDetailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.fbmDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.fbmTotal
    },
    on: {
      "current-change": _vm.handleInventoryDetailPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Outbound History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getOutboundList
    },
    model: {
      value: (_vm.filters.outboundUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "outboundUser", $$v)
      },
      expression: "filters.outboundUser"
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": member.username,
        "value": member.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    attrs: {
      "stripe": "",
      "data": _vm.outboundList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 1) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Success")]) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Closed")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.outboundTotal
    },
    on: {
      "current-change": _vm.handleChangeOutboundList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Reported/Missed",
      "name": "fourth"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.reportedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Offer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.productName) + " " + _vm._s(scope.row.offerCreateDate ? "(" + scope.row.offerCreateDate + ")" : ""))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.reportTotal
    },
    on: {
      "current-change": _vm.changeReportPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Not Claimed",
      "name": "five"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.notClaimedTracking),
      callback: function($$v) {
        _vm.$set(_vm.filters, "notClaimedTracking", $$v)
      },
      expression: "filters.notClaimedTracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getNotClaimed
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fiveListLoading),
      expression: "fiveListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.notClaimed,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trackingNumber",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateTime",
      "label": "DateTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.notClaimedTotal
    },
    on: {
      "current-change": _vm.changeNotClaimedPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "FBM Operation Log",
      "name": "six"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Type",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getStockList
    },
    model: {
      value: (_vm.filters.stockFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "stockFilter", $$v)
      },
      expression: "filters.stockFilter"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Nurse Claimed",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Confirm Report",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Outbound",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Cancel Outbound",
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Inbound",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Reverse",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Batch Reverse",
      "value": 8
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Edit FBM",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Transfer",
      "value": 9
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Mixed Package Claim",
      "value": 10
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Mixed Package Reverse",
      "value": 15
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.sixListLoading),
      expression: "sixListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.stockList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "srcStock",
      "label": "Before operating FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "destStock",
      "label": "After operating FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.bizType == 1) ? _c('p', [_vm._v("Nurse Claimed")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 2) ? _c('p', [_vm._v("Doctor Confirm Report")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 3) ? _c('p', [_vm._v("Doctor Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 4) ? _c('p', [_vm._v("Warehouse Inbound")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 5) ? _c('p', [_vm._v("Warehouse Reverse")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 6) ? _c('p', [_vm._v("Warehouse Edit FBM")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 7) ? _c('p', [_vm._v("Doctor Cancel Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 8) ? _c('p', [_vm._v("Warehouse Batch Reverse")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 9) ? _c('p', [_vm._v("Doctor Transfer")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 10) ? _c('p', [_vm._v("Mixed Package Claim")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 15) ? _c('p', [_vm._v("Mixed Package Reverse")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operator",
      "prop": "userName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdTime",
      "label": "DateTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.stockTotal
    },
    on: {
      "current-change": _vm.changeStockPage
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "FBM Detail",
      "width": "80%",
      "visible": _vm.fbmDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.fbmDetailVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fbmDetailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Import Result Details",
      "visible": _vm.dialogVisible,
      "width": "95%",
      "close-on-click-modal": false,
      "close-on-press-escape": true,
      "custom-class": "import-result-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-card', {
    staticClass: "summary-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "summary-title"
  }, [_vm._v("Import Summary")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.result.failedCount === 0) ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "medium"
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _vm._v(" All Successful\n        ")]) : (_vm.result.successCount === 0) ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "medium"
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-close"
  }), _vm._v(" All Failed\n        ")]) : _c('el-tag', {
    attrs: {
      "type": "warning",
      "size": "medium"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v(" Partial Success\n        ")])], 1)]), _vm._v(" "), _c('el-row', {
    staticClass: "summary-stats",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.result.totalCount))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Total Records")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "stat-card success"
  }, [_c('div', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.result.successCount))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Successful")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "stat-card failed"
  }, [_c('div', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.result.failedCount))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Failed")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(Math.round((_vm.result.successCount / _vm.result.totalCount) * 100)) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Success Rate")])])])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    staticClass: "result-tabs",
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [(_vm.result.successCount > 0) ? _c('el-tab-pane', {
    attrs: {
      "name": "success"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _vm._v("\n        Success (" + _vm._s(_vm.result.successCount) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Search tracking numbers...",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    model: {
      value: (_vm.successSearch),
      callback: function($$v) {
        _vm.successSearch = $$v
      },
      expression: "successSearch"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": _vm.exportSuccessData
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" Export Success\n            ")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.filteredSuccessData,
      "height": _vm.tableHeight,
      "stripe": "",
      "empty-text": _vm.successSearch ? 'No matching records found' : 'No successful records'
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "success",
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.tracking || scope.row))])]
      }
    }], null, false, 588595142)
  }), _vm._v(" "), (_vm.result.successDetails) ? _c('el-table-column', {
    attrs: {
      "prop": "items",
      "label": "Items",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.items) ? _c('div', [_vm._l((scope.row.items.slice(0, 3)), function(item) {
          return _c('el-tag', {
            key: item.upc,
            staticStyle: {
              "margin-right": "5px",
              "margin-bottom": "2px"
            },
            attrs: {
              "size": "mini"
            }
          }, [_vm._v("\n                  " + _vm._s(item.upc) + " (" + _vm._s(item.quantity) + ")\n                ")])
        }), _vm._v(" "), (scope.row.items.length > 3) ? _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "mini"
          }
        }, [_vm._v("\n                  +" + _vm._s(scope.row.items.length - 3) + " more\n                ")]) : _vm._e()], 2) : _vm._e()]
      }
    }], null, false, 3145462316)
  }) : _vm._e(), _vm._v(" "), (_vm.result.successDetails) ? _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "Description",
      "show-overflow-tooltip": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.successData.length > _vm.successPageSize) ? _c('el-pagination', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.successCurrentPage,
      "page-size": _vm.successPageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.successData.length
    },
    on: {
      "current-change": _vm.handleSuccessPageChange
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.result.failedCount > 0) ? _c('el-tab-pane', {
    attrs: {
      "name": "failed"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-circle-close"
  }), _vm._v("\n        Failed (" + _vm._s(_vm.result.failedCount) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Search content or error messages...",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    model: {
      value: (_vm.failedSearch),
      callback: function($$v) {
        _vm.failedSearch = $$v
      },
      expression: "failedSearch"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "Filter by error type",
      "clearable": ""
    },
    model: {
      value: (_vm.errorTypeFilter),
      callback: function($$v) {
        _vm.errorTypeFilter = $$v
      },
      expression: "errorTypeFilter"
    }
  }, _vm._l((_vm.uniqueErrorTypes), function(errorType) {
    return _c('el-option', {
      key: errorType,
      attrs: {
        "label": errorType,
        "value": errorType
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.exportFailedData
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" Export Failed\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "size": "small"
    },
    on: {
      "click": _vm.copyFailedData
    }
  }, [_c('i', {
    staticClass: "el-icon-document-copy"
  }), _vm._v(" Copy for Retry\n            ")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.filteredFailedData,
      "height": _vm.tableHeight,
      "stripe": "",
      "empty-text": _vm.failedSearch || _vm.errorTypeFilter ? 'No matching records found' : 'No failed records'
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Line",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.lineNumber || scope.$index + 1))])]
      }
    }], null, false, 308761487)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Error Message",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "error-message-container"
        }, [_c('span', {
          staticClass: "error-message-text"
        }, [_vm._v("\n                  " + _vm._s(_vm.getDisplayErrorMessage(scope.row)) + "\n                ")]), _vm._v(" "), _c('el-button', {
          staticClass: "error-detail-btn",
          attrs: {
            "size": "mini",
            "type": "text",
            "icon": "el-icon-document",
            "title": "View full error message"
          },
          on: {
            "click": function($event) {
              return _vm.showFullErrorMessage(scope.row)
            }
          }
        })], 1)]
      }
    }], null, false, 2286998231)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text",
            "title": "Copy to clipboard"
          },
          on: {
            "click": function($event) {
              return _vm.copyToClipboard(scope.row.rawContent || scope.row.content)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document-copy"
        })])]
      }
    }], null, false, 3022992866)
  })], 1), _vm._v(" "), (_vm.failedData.length > _vm.failedPageSize) ? _c('el-pagination', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.failedCurrentPage,
      "page-size": _vm.failedPageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.failedData.length
    },
    on: {
      "current-change": _vm.handleFailedPageChange
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.result.failedCount > 0) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.handleRetryFailed
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" Retry " + _vm._s(_vm.result.failedCount) + " Failed Record(s)\n    ")]) : _vm._e(), _vm._v(" "), (_vm.result.successCount > 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleContinue
    }
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v(" Continue Import Process\n    ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "bulk-confirm-result-dialog",
    attrs: {
      "title": "Bulk Confirm Results",
      "width": "80%",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "result-summary"
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.summaryTitle,
      "type": _vm.summaryType,
      "closable": false,
      "show-icon": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_c('strong', [_vm._v("Total Packages:")]), _vm._v(" " + _vm._s(_vm.result.totalPackages))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Successful:")]), _vm._v(" " + _vm._s(_vm.result.successCount))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Failed:")]), _vm._v(" " + _vm._s(_vm.result.failedCount))]), _vm._v(" "), (_vm.result.batchNumber) ? _c('p', [_c('strong', [_vm._v("Batch Number:")]), _vm._v(" " + _vm._s(_vm.result.batchNumber))]) : _vm._e()])])], 1), _vm._v(" "), (_vm.result.successCount > 0) ? _c('div', {
    staticClass: "success-section"
  }, [_c('h3', {
    staticClass: "section-title success-title"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _vm._v("\n      Successfully Created Packages: " + _vm._s(_vm.result.successCount) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.result.failedCount > 0) ? _c('div', {
    staticClass: "failure-section"
  }, [_c('div', {
    staticClass: "failure-header"
  }, [_c('h3', {
    staticClass: "section-title error-title"
  }, [_c('i', {
    staticClass: "el-icon-circle-close"
  }), _vm._v("\n        Failed Packages (" + _vm._s(_vm.result.failedCount) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "failure-actions"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-document-copy"
    },
    on: {
      "click": _vm.copyFailedData
    }
  }, [_vm._v("\n          Copy to Clipboard\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.exportFailedData
    }
  }, [_vm._v("\n          Export to CSV\n        ")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.result.failureRecords,
      "max-height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('code', {
          staticClass: "tracking-code"
        }, [_vm._v(_vm._s(scope.row.tracking))])]
      }
    }], null, false, 1666644289)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemCount",
      "label": "UPC Items",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v(_vm._s(scope.row.itemCount || 0))])]
      }
    }], null, false, 4265133008)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "errorMessage",
      "label": "Error Reason",
      "min-width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "error-message-cell"
        }, [_c('el-tooltip', {
          attrs: {
            "content": scope.row.errorMessage,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "error-text"
        }, [_vm._v(_vm._s(scope.row.errorMessage))])]), _vm._v(" "), _c('el-tag', {
          staticClass: "retry-tag",
          attrs: {
            "type": scope.row.canRetry ? 'warning' : 'danger',
            "size": "mini"
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.canRetry ? 'Can Retry' : 'Cannot Retry') + "\n            ")])], 1)]
      }
    }], null, false, 3170467878)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.result.failedCount > 0) ? _c('div', {
    staticClass: "failure-statistics"
  }, [_c('h4', [_vm._v("Failure Analysis")]), _vm._v(" "), _c('div', {
    staticClass: "stats-grid"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Duplicate Tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "stat-value duplicate"
  }, [_vm._v(_vm._s(_vm.duplicateCount))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Retryable Errors:")]), _vm._v(" "), _c('span', {
    staticClass: "stat-value retryable"
  }, [_vm._v(_vm._s(_vm.retryableCount))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Non-retryable Errors:")]), _vm._v(" "), _c('span', {
    staticClass: "stat-value non-retryable"
  }, [_vm._v(_vm._s(_vm.nonRetryableCount))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "footer-left"
  }, [(_vm.hasRetryableFailures) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.retrying
    },
    on: {
      "click": _vm.retryFailures
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v("\n        Retry Failed Packages (" + _vm._s(_vm.retryableCount) + ")\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.result.successCount > 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.continueOperation
    }
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v("\n        Continue\n      ")]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Open",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOpenOffers.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.openOfferFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "openOfferFilter", $$v)
      },
      expression: "filters.openOfferFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOpenOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOfferOpen', 'Active Offer.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddProduct
    }
  }, [_vm._v("Add Offer")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.openOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + "\n\t\t\t\t\t\t\t"), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bouns",
      "label": "Bonus"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Total"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expireDate",
      "label": "Expiration Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.archiveOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Archived")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showOfferClaimDetails(scope.row.offerNo)
            }
          }
        }, [_vm._v("Claims")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.openOfferTotal
    },
    on: {
      "current-change": _vm.handleChangeOpenOffer
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Proposed",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getProposedOffers.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.proposedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "proposedFilter", $$v)
      },
      expression: "filters.proposedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProposedOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status : "
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getProposedOffers
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOfferProposed', 'Proposed Offer.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.proposedOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("cancelled")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expireDate",
      "label": "Offer Expiration Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmProposed(scope.row.id, 1)
            }
          }
        }, [_vm._v("Confirm")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.confirmProposed(scope.row.id, 2)
            }
          }
        }, [_vm._v("Reject")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.proposedTotal
    },
    on: {
      "current-change": _vm.getProposedOffers
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Offer History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOfferHistory.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOfferHistory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status : "
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getOfferHistory
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Offering",
      "value": "offering"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "archived"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Expired",
      "value": "expired"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOfferHistory', 'Offer History.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.offerHistory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Total"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status != 'offering') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.reListOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Relist")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getOfferDetail(scope.row.offerNo)
            }
          }
        }, [_vm._v("Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showOfferClaimDetails(scope.row.offerNo)
            }
          }
        }, [_vm._v("Claims")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.handleChangeOfferHistory
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Offer",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addOffer",
    attrs: {
      "model": _vm.addOffer,
      "label-width": "220px",
      "rules": _vm.addOfferFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "productNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "filterable": "",
      "auto-complete": "off",
      "clearable": ""
    },
    model: {
      value: (_vm.addOffer.productNo),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "productNo", $$v)
      },
      expression: "addOffer.productNo"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productName
      }
    }, [_vm._v(_vm._s(product.condition + ' - ' + product.productName + ' (' + product.createDate + ')'))])
  }), 1), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "20px",
      "text-decoration": "underline",
      "color": "blue",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addProductVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "price", $$v)
      },
      expression: "addOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total",
      "prop": "total"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addOffer.total),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "total", $$v)
      },
      expression: "addOffer.total"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expires At",
      "prop": "expireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.addOffer.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "expireDate", $$v)
      },
      expression: "addOffer.expireDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, expires in 3 days")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.addOffer.note),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "note", $$v)
      },
      expression: "addOffer.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus",
      "prop": "bouns"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "bouns", $$v)
      },
      expression: "addOffer.bouns"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "scope"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addOffer.scope),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "scope", $$v)
      },
      expression: "addOffer.scope"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "public"
    }
  }, [_vm._v("public")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "private"
    }
  }, [_vm._v("private")])], 1)], 1), _vm._v(" "), (_vm.addOffer.scope === 'private') ? _c('el-form-item', {
    attrs: {
      "label": "Users"
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.groups,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "userNo",
      "highlight-current": "",
      "props": _vm.defaultProps
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.addOffer.notify),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "notify", $$v)
      },
      expression: "addOffer.notify"
    }
  }, [_vm._v("Notify every who can see the offer")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddOffer.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Offer",
      "width": "80%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editOffer",
    attrs: {
      "model": _vm.editOffer,
      "label-width": "220px",
      "rules": _vm.editOfferFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "productNo"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editOffer.productNo),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "productNo", $$v)
      },
      expression: "editOffer.productNo"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productName
      }
    }, [_vm._v(_vm._s(product.condition + ' - ' + product.productName + ' (' + product.createDate + ')'))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "price", $$v)
      },
      expression: "editOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Total",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "quantity", $$v)
      },
      expression: "editOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left",
      "prop": "leftNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.editOffer.quantity
    },
    model: {
      value: (_vm.editOffer.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "leftNum", $$v)
      },
      expression: "editOffer.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expires At",
      "prop": "expireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.editOffer.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "expireDate", $$v)
      },
      expression: "editOffer.expireDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, expires in 3 days")])]), _vm._v(" "), (_vm.editOffer.scope == 'private') ? _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, _vm._l((_vm.editOffer.users), function(user, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "info"
      }
    }, [_vm._v(_vm._s(user))])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.editOffer.note),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "note", $$v)
      },
      expression: "editOffer.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus",
      "prop": "bouns"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "bouns", $$v)
      },
      expression: "editOffer.bouns"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleEditOffer.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "ReList Offer",
      "width": "80%",
      "visible": _vm.relistFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.relistFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "relistOffer",
    attrs: {
      "model": _vm.relistOffer,
      "label-width": "220px",
      "rules": _vm.editOfferFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "productNo"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.relistOffer.productNo),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "productNo", $$v)
      },
      expression: "relistOffer.productNo"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productName
      }
    }, [_vm._v(_vm._s(product.condition + ' - ' + product.productName + ' (' + product.createDate + ')'))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.relistOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "price", $$v)
      },
      expression: "relistOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Total",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.relistOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "quantity", $$v)
      },
      expression: "relistOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left",
      "prop": "leftNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.relistOffer.quantity
    },
    model: {
      value: (_vm.relistOffer.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "leftNum", $$v)
      },
      expression: "relistOffer.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expires At",
      "prop": "expireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": true
    },
    model: {
      value: (_vm.relistOffer.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "expireDate", $$v)
      },
      expression: "relistOffer.expireDate"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Expires At",
      "prop": "newExpireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.relistOffer.newExpireDate),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "newExpireDate", $$v)
      },
      expression: "relistOffer.newExpireDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, expires in 3 days")])]), _vm._v(" "), (_vm.relistOffer.scope == 'private') ? _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, _vm._l((_vm.relistOffer.users), function(user, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "info"
      }
    }, [_vm._v(_vm._s(user))])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.relistOffer.note),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "note", $$v)
      },
      expression: "relistOffer.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus",
      "prop": "bouns"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.relistOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "bouns", $$v)
      },
      expression: "relistOffer.bouns"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.relistFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleReListOffer.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addProductVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addProductVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProduct",
    attrs: {
      "model": _vm.addProduct,
      "label-width": "220px",
      "rules": _vm.addProductFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.product),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "product", $$v)
      },
      expression: "addProduct.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addProduct.price),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "price", $$v)
      },
      expression: "addProduct.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "condition", $$v)
      },
      expression: "addProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "asin", $$v)
      },
      expression: "addProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "upc", $$v)
      },
      expression: "addProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "weight", $$v)
      },
      expression: "addProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "note", $$v)
      },
      expression: "addProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addProductVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProduct.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Offer Detail",
      "width": "80%",
      "visible": _vm.offerDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.offerDetailVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getOfferDetail()
      }
    },
    model: {
      value: (_vm.filters.offerDetailFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "offerDetailFilter", $$v)
      },
      expression: "filters.offerDetailFilter"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.offerDetails,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Offer Take Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.offerDetailTotal
    },
    on: {
      "current-change": _vm.handleChangeOfferDetail
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.offerDetailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Offer Claim Details",
      "width": "50%",
      "visible": _vm.claimDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.claimDetailVisible = $event
      }
    }
  }, [(_vm.claimDetails) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v("Offer Information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('p', [_c('strong', [_vm._v("Offer #:")]), _vm._v(" " + _vm._s(_vm.claimDetails.offerNo))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Product:")]), _vm._v(" " + _vm._s(_vm.claimDetails.productName))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("UPC:")]), _vm._v(" " + _vm._s(_vm.claimDetails.upc))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('p', [_c('strong', [_vm._v("Price:")]), _vm._v(" $" + _vm._s(_vm.claimDetails.price))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Total Qty:")]), _vm._v(" " + _vm._s(_vm.claimDetails.totalQuantity))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Left Qty:")]), _vm._v(" " + _vm._s(_vm.claimDetails.leftQuantity))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('p', [_c('strong', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.claimDetails.status))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Claimed Records:")]), _vm._v(" " + _vm._s(_vm.claimDetails.totalClaimedRecords))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Claimed Qty:")]), _vm._v(" " + _vm._s(_vm.claimDetails.totalClaimedQuantity))])])], 1)], 1), _vm._v(" "), (_vm.claimDetails.firstClaimTime) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v("Claim Statistics")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_c('strong', [_vm._v("First Claim Time:")]), _vm._v(" " + _vm._s(_vm.claimDetails.firstClaimTime))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_c('strong', [_vm._v("Last Claim Time:")]), _vm._v(" " + _vm._s(_vm.claimDetails.lastClaimTime))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v("Claim Records")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.claimDetailLoading),
      expression: "claimDetailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.claimDetails.claimRecords,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "inboundNo",
      "label": "Inbound #",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Nurse",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(scope.row.nurseName) + "\n\t\t\t\t\t\t\t")]
      }
    }], null, false, 3468582989)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "width": "250",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQuantity",
      "label": "Qty",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimTime",
      "label": "Claim Time",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.warehouseState && scope.row.warehouseCity && scope.row.warehouseAddress) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.warehouseState) + ", " + _vm._s(scope.row.warehouseCity) + ", " + _vm._s(scope.row.warehouseAddress) + "\n\t\t\t\t\t\t\t\t")]) : (scope.row.warehouseAddress) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.warehouseAddress) + "\n\t\t\t\t\t\t\t\t")]) : _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\tWarehouse #" + _vm._s(scope.row.warehouseNo) + "\n\t\t\t\t\t\t\t\t")])]
      }
    }], null, false, 2182010892)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "UPC Check",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isUpcMismatch === true) ? _c('div', {
          staticStyle: {
            "color": "#F56C6C"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning"
        }), _vm._v(" Mismatch\n\t\t\t\t\t\t\t\t")]) : (scope.row.isUpcMismatch === false) ? _c('div', {
          staticStyle: {
            "color": "#67C23A"
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-check"
        }), _vm._v(" Matched\n\t\t\t\t\t\t\t\t")]) : _c('div', {
          staticStyle: {
            "color": "#E6A23C"
          }
        }, [_c('i', {
          staticClass: "el-icon-question"
        }), _vm._v(" Anomaly\n\t\t\t\t\t\t\t\t")])]
      }
    }], null, false, 4176030519)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.claimDetailPageSize,
      "total": _vm.claimDetailTotal,
      "current-page": _vm.claimDetailPage
    },
    on: {
      "current-change": _vm.handleChangeClaimDetail
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.claimDetailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Active",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOpenOffers.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.openOfferFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "openOfferFilter", $$v)
      },
      expression: "filters.openOfferFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOpenOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseActiveOffer', 'activeOffer.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.openOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + "\n\t\t\t\t\t\t\t"), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createBy",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bouns",
      "label": "Bouns"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.leftNum > 0) ? _c('p', [_c('el-tag', [_vm._v("Can Take")])], 1) : _vm._e(), _vm._v(" "), (scope.row.leftNum <= 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("No surplus")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showTakeOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Take")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.openOfferTotal
    },
    on: {
      "current-change": _vm.changeOfferPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Proposed",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getProposedOffers.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.proposedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "proposedFilter", $$v)
      },
      expression: "filters.proposedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProposedOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showProposed
    }
  }, [_vm._v("Request")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseProposedOffer', 'proposedOffer.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.proposedOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("cancelled")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelProposed(scope.row.id, 2)
            }
          }
        }, [_vm._v("Cancel")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.proposedTotal
    },
    on: {
      "current-change": _vm.changeProposedPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Expired",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getExpiredOffers.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.expiredFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "expiredFilter", $$v)
      },
      expression: "filters.expiredFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getExpiredOffers
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.expiredList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + "\n\t\t\t\t\t\t\t"), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createBy",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bouns",
      "label": "Bouns"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showProposedOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Propose")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.expiredTotal
    },
    on: {
      "current-change": _vm.changeExpiredPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Offer History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOfferHistroy.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOfferHistroy
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": _vm.getOfferHistroy
    },
    model: {
      value: (_vm.filters.historyStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyStatus", $$v)
      },
      expression: "filters.historyStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Completed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseOfferHistory', 'offerHistory.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.historyList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "offerNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctor",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offerCreateTime",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Take Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Completed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Take Offer",
      "width": "80%",
      "visible": _vm.takeOfferVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.takeOfferVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "takeOffer",
    attrs: {
      "model": _vm.takeOffer,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "company",
      "prop": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.takeOffer.createBy),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "createBy", $$v)
      },
      expression: "takeOffer.createBy"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.takeOffer.product),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "product", $$v)
      },
      expression: "takeOffer.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.takeOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "price", $$v)
      },
      expression: "takeOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true
    },
    model: {
      value: (_vm.takeOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "bouns", $$v)
      },
      expression: "takeOffer.bouns"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left",
      "prop": "leftNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.takeOffer.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "leftNum", _vm._n($$v))
      },
      expression: "takeOffer.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.takeOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "quantity", _vm._n($$v))
      },
      expression: "takeOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.takeOffer.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "warehouseNo", $$v)
      },
      expression: "takeOffer.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.state + ' ' + item.city + ' ' + item.address,
          "value": item.warehouseNo
        }
      })
    }), 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.takeOfferVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleTakeOffer.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Proposed offer",
      "width": "80%",
      "visible": _vm.proposedOfferVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.proposedOfferVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "proposedOffer",
    attrs: {
      "model": _vm.proposedOffer,
      "label-width": "220px",
      "rules": _vm.proposedFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "offerNo"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off",
      "clearable": "",
      "disabled": ""
    },
    on: {
      "change": _vm.selectProposedOffer
    },
    model: {
      value: (_vm.proposedOffer.offerNo),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "offerNo", $$v)
      },
      expression: "proposedOffer.offerNo"
    }
  }, _vm._l((_vm.proposedList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.productName + ' (' + item.createDate + ')',
        "value": item.offerNo
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.proposedOffer.offerNo) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "company",
      "prop": "createBy"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.proposedOffer.createBy),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "createBy", $$v)
      },
      expression: "proposedOffer.createBy"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.proposedOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "price", $$v)
      },
      expression: "proposedOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.proposedOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "quantity", $$v)
      },
      expression: "proposedOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.proposedOffer.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "warehouseNo", $$v)
      },
      expression: "proposedOffer.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.state + ' ' + item.city + ' ' + item.address,
          "value": item.warehouseNo
        }
      })
    }), 1)
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.proposedOfferVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestProposed.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Offers")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Offers',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.offers.active) + " active offers")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Offers',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.offers.proposed) + " proposed offers")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Inbound")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Inbound',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.inbound.inbound) + " inbound items")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Inbound',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.inbound.reported) + " reported item")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Outbound")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/outbound')
      }
    }
  }, [_vm._v(_vm._s(_vm.outbound.outbound) + " outbound shipments")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Payments")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/payments')
      }
    }
  }, [_vm._v(_vm._s(_vm.balance.request) + " payment request")])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("Add Offer")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "生日",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "地址",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sex", $$v)
      },
      expression: "editForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.editForm.age),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "age", $$v)
      },
      expression: "editForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "birth", $$v)
      },
      expression: "editForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "addr", $$v)
      },
      expression: "editForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sex", $$v)
      },
      expression: "addForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.addForm.age),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "age", $$v)
      },
      expression: "addForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.addForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "birth", $$v)
      },
      expression: "addForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "addr", $$v)
      },
      expression: "addForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Member List",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "User Name",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.username),
      callback: function($$v) {
        _vm.$set(_vm.filters, "username", $$v)
      },
      expression: "filters.username"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getDoctorMembers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": _vm.getDoctorMembers
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "1",
      "label": "Active"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "Limited"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "Blocked"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.memberList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "User Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleId",
      "label": "role"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.roleId == '2') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Nurse")]) : _vm._e(), _vm._v(" "), (scope.row.roleId == '3') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Wareshoue Admin")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "alias",
      "label": "Alias"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "Phone"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "formatter": _vm.formatMemberStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditMember(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.membersTotalPage
    },
    on: {
      "current-change": _vm.handleMembersPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Groups",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Group Name",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.groupCondition),
      callback: function($$v) {
        _vm.$set(_vm.filters, "groupCondition", $$v)
      },
      expression: "filters.groupCondition"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getGroupList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddGroup
    }
  }, [_vm._v("Add Group")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.groups,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "groupNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Users"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.userList), function(user, index) {
          return _c('el-tag', {
            key: index,
            attrs: {
              "type": "success",
              "disable-transitions": ""
            }
          }, [_vm._v(_vm._s(user.username) + "\n                        ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditGroup(scope.row.groupNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteGroup(scope.row.groupNo)
            }
          }
        }, [_vm._v("Delete\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.groupTotalPage
    },
    on: {
      "current-change": _vm.handleGroupPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Invitations",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.invitationEmail),
      callback: function($$v) {
        _vm.$set(_vm.filters, "invitationEmail", $$v)
      },
      expression: "filters.invitationEmail"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInvitations
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.invitationVisible = true
      }
    }
  }, [_vm._v("Invitation")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.invitations
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "invitationNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role_name",
      "label": "Role"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "DateTime",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "formatter": _vm.formatRole
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.invitationTotalPage
    },
    on: {
      "current-change": _vm.handleInvitationPageChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Member",
      "width": "80%",
      "visible": _vm.editMemberVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editMemberVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.editMemberObj,
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UserName",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editMemberObj.userName),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "userName", $$v)
      },
      expression: "editMemberObj.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editMemberObj.status),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "status", $$v)
      },
      expression: "editMemberObj.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("Limited")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("Blocked")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Alias"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editMemberObj.alias),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "alias", $$v)
      },
      expression: "editMemberObj.alias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending transactions"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editMemberObj.pendingTransaction),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "pendingTransaction", $$v)
      },
      expression: "editMemberObj.pendingTransaction"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editMemberObj.pendingAmount),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "pendingAmount", $$v)
      },
      expression: "editMemberObj.pendingAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimum Payment"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editMemberObj.minPayment),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "minPayment", $$v)
      },
      expression: "editMemberObj.minPayment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editMemberVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editMember.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Group",
      "width": "80%",
      "visible": _vm.addGroupVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addGroupVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "group",
    attrs: {
      "model": _vm.group,
      "label-width": "220px",
      "rules": _vm.groupFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Group Name",
      "prop": "groupName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.group.groupName),
      callback: function($$v) {
        _vm.$set(_vm.group, "groupName", $$v)
      },
      expression: "group.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.group.users),
      callback: function($$v) {
        _vm.$set(_vm.group, "users", $$v)
      },
      expression: "group.users"
    }
  }, _vm._l((_vm.nurseList), function(user, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": user.username,
        "value": user.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending transactions"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.group.pendingTransaction),
      callback: function($$v) {
        _vm.$set(_vm.group, "pendingTransaction", $$v)
      },
      expression: "group.pendingTransaction"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.group.pendingAmount),
      callback: function($$v) {
        _vm.$set(_vm.group, "pendingAmount", $$v)
      },
      expression: "group.pendingAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimum Payment"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.group.minPayment),
      callback: function($$v) {
        _vm.$set(_vm.group, "minPayment", $$v)
      },
      expression: "group.minPayment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addGroupVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addGroup.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Group",
      "width": "80%",
      "visible": _vm.editGroupVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editGroupVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editGroupObj",
    attrs: {
      "model": _vm.editGroupObj,
      "label-width": "220px",
      "rules": _vm.groupFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Group Name",
      "prop": "groupName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editGroupObj.groupName),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "groupName", $$v)
      },
      expression: "editGroupObj.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.editGroupObj.users),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "users", $$v)
      },
      expression: "editGroupObj.users"
    }
  }, _vm._l((_vm.nurseList), function(user, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": user.username,
        "value": user.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending transactions"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editGroupObj.pendingTransaction),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "pendingTransaction", $$v)
      },
      expression: "editGroupObj.pendingTransaction"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editGroupObj.pendingAmount),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "pendingAmount", $$v)
      },
      expression: "editGroupObj.pendingAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimum Payment"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editGroupObj.minPayment),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "minPayment", $$v)
      },
      expression: "editGroupObj.minPayment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editGroupVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editGroup.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Invitation",
      "width": "80%",
      "visible": _vm.invitationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.invitationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "invitation",
    attrs: {
      "model": _vm.invitation,
      "label-width": "220px",
      "rules": _vm.invitationRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role Name",
      "prop": "role"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.invitation.role),
      callback: function($$v) {
        _vm.$set(_vm.invitation, "role", $$v)
      },
      expression: "invitation.role"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "2",
      "label": "Nurse"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "Warehouse Admin"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.invitation.email),
      callback: function($$v) {
        _vm.$set(_vm.invitation, "email", $$v)
      },
      expression: "invitation.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.invitationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.invitationRegister.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getToConfirmTrackingList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.toConfirmFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "toConfirmFilter", $$v)
      },
      expression: "filters.toConfirmFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getToConfirmTrackingList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showImport
    }
  }, [_vm._v("Import")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBulkConfirm
    }
  }, [_vm._v("Bulk Confirm")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBulkRemove
    }
  }, [_vm._v("Bulk Remove")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseTracking', 'Tracking.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.toConfirmList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "batchNumber",
      "label": "Batch Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.tracking))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Import Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isMixedPackage === 1) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Mixed Package")])], 1) : _c('div', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row.cwId)
            }
          }
        }, [_vm._v("Edit\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeTracking(scope.row.cwId)
            }
          }
        }, [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.toConfirmTotal
    },
    on: {
      "current-change": _vm.changeConfirmPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Name、Tracking or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getHistoryList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getHistoryList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBulkReverse
    }
  }, [_vm._v("Bulk Reverse")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseInboundHistory', 'inboundHistory.xls', 3)
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.goToMixedPackage
    }
  }, [_vm._v("Mixed Package")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundHistory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "cwId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Shared warehouse inbound"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " (" + _vm._s(scope.row.lastUpdateDate) + ")\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-table-column', {
    attrs: {
      "prop": "forceChargeTime",
      "label": "Force Charge Time"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productStatus",
      "label": "productStatus"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.isMixedPackageRecord(scope.row)) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editInboundHistory(scope.row)
            }
          }
        }, [_vm._v("Edit\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.isMixedPackageRecord(scope.row) && scope.row.productStatus && scope.row.productStatus.indexOf('Can be reverse') !== -1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.reverseById(scope.row.cwId)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\tReverse\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.isMixedPackageRecord(scope.row)) ? _c('el-tooltip', {
          attrs: {
            "content": "混寄包裹记录不支持在此处编辑或撤销，请在混寄包裹管理界面操作",
            "placement": "top"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#909399",
            "font-size": "12px"
          }
        }, [_c('i', {
          staticClass: "el-icon-info"
        }), _vm._v(" Mixed Package Record\n\t\t\t\t\t\t\t\t")])]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeHistoryList
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Inbound",
      "width": "80%",
      "visible": _vm.editToConfirmInboundVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editToConfirmInboundVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editTracking",
    attrs: {
      "model": _vm.editTracking,
      "label-width": "220px",
      "rules": _vm.editRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "warehouseNo", $$v)
      },
      expression: "editTracking.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": warehouse.warehouseNo,
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Number",
      "prop": "trackingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.trackingNumber),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "trackingNumber", $$v)
      },
      expression: "editTracking.trackingNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.upc),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "upc", $$v)
      },
      expression: "editTracking.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Qty",
      "prop": "qty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.qty),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "qty", $$v)
      },
      expression: "editTracking.qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.note),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "note", $$v)
      },
      expression: "editTracking.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editToConfirmInboundVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleEdit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Inbound",
      "width": "80%",
      "visible": _vm.editInboundHistoryVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editInboundHistoryVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editInbound",
    attrs: {
      "model": _vm.editInbound,
      "label-width": "220px",
      "rules": _vm.editRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.productName),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "productName", $$v)
      },
      expression: "editInbound.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.company),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "company", $$v)
      },
      expression: "editInbound.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Number"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.tracking),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "tracking", $$v)
      },
      expression: "editInbound.tracking"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.upc),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "upc", $$v)
      },
      expression: "editInbound.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "warehouse", $$v)
      },
      expression: "editInbound.warehouse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Qty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.qty),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "qty", $$v)
      },
      expression: "editInbound.qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.note),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "note", $$v)
      },
      expression: "editInbound.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editInboundHistoryVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editConfirmedTracking.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Import",
      "width": "80%",
      "visible": _vm.warehouseImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseImportVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "importTrack",
    attrs: {
      "model": _vm.importTrack,
      "label-width": "220px",
      "rules": _vm.importRule
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.removeAllItem.apply(null, arguments)
      }
    }
  }, [_vm._v("Remove All Tracking")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importTracking.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Batch number",
      "prop": "batchNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off",
      "value": _vm.batchNumber
    },
    model: {
      value: (_vm.importTrack.batchNumber),
      callback: function($$v) {
        _vm.$set(_vm.importTrack, "batchNumber", $$v)
      },
      expression: "importTrack.batchNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off",
      "clearable": ""
    },
    model: {
      value: (_vm.importTrack.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.importTrack, "warehouseNo", $$v)
      },
      expression: "importTrack.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": warehouse.warehouseNo,
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Number",
      "prop": "trackingNumbers"
    }
  }, [(_vm.importTrack.trackingNumbers.length > 0) ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.importTrack.trackingNumbers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeRow(scope.row)
            }
          }
        }, [_vm._v("Remove\n\t\t\t\t\t\t\t\t\t")])]
      }
    }], null, false, 3656174827)
  })], 1)], 1) : _c('div', [_c('p', {
    staticStyle: {
      "padding": "0",
      "margin": "0",
      "font-size": "18px",
      "color": "#11b95c"
    }
  }, [_vm._v("You have not uploaded tracking\n\t\t\t\t\t\t\tnumber, please upload tracking number.")])]), _vm._v(" "), _c('p', [_vm._v("Import tracking number as\n\t\t\t\t\t\t"), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.textImportVisible = true
      }
    }
  }, [_vm._v("Text")]), _vm._v("\n\t\t\t\t\t\tor\n\t\t\t\t\t\t"), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.excelImportVisible = true
      }
    }
  }, [_vm._v("Excel")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.removeAllItem.apply(null, arguments)
      }
    }
  }, [_vm._v("Remove All Tracking")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importTracking.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk confirm shared warehouse inbound items",
      "width": "80%",
      "visible": _vm.bulkConfirmVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkConfirmVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkConfirm
    },
    model: {
      value: (_vm.batchNumber),
      callback: function($$v) {
        _vm.batchNumber = $$v
      },
      expression: "batchNumber"
    }
  }, _vm._l((_vm.batchNumbers), function(b, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": b,
        "label": b
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v("Send Email")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.bulkConfirmList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "select a product"
          },
          model: {
            value: (scope.row.productNo),
            callback: function($$v) {
              _vm.$set(scope.row, "productNo", $$v)
            },
            expression: "scope.row.productNo"
          }
        }, _vm._l((scope.row.productsList), function(p, i) {
          return _c('el-option', {
            key: i,
            attrs: {
              "label": p.productName,
              "value": p.productNo
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-table-column', {
    attrs: {
      "label": "Force Charge Time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          attrs: {
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "Force Charge Time"
          },
          model: {
            value: (scope.row.forceChargeTime),
            callback: function($$v) {
              _vm.$set(scope.row, "forceChargeTime", $$v)
            },
            expression: "scope.row.forceChargeTime"
          }
        })]
      }
    }], null, false, 403668256)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeItem(scope.row)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v("Bulk Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk remove shared warehouse inbound items",
      "width": "80%",
      "visible": _vm.bulkRemoveVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkRemoveVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkRemove
    },
    model: {
      value: (_vm.batchNumber),
      callback: function($$v) {
        _vm.batchNumber = $$v
      },
      expression: "batchNumber"
    }
  }, _vm._l((_vm.batchNumbers), function(b, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": b,
        "label": b
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.bulkRemoveList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkRemove.apply(null, arguments)
      }
    }
  }, [_vm._v("Bulk Remove")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk reverse",
      "width": "80%",
      "visible": _vm.bulkReverseVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkReverseVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkReverse
    },
    model: {
      value: (_vm.batchNumber),
      callback: function($$v) {
        _vm.batchNumber = $$v
      },
      expression: "batchNumber"
    }
  }, _vm._l((_vm.batchNumbers), function(b, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": b,
        "label": b
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.bulkReverseList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Shared warehouse inbound"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " (" + _vm._s(scope.row.lastUpdateDate) + ")\n\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-table-column', {
    attrs: {
      "prop": "forceChargeTime",
      "label": "Force Charge Time"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkReverse.apply(null, arguments)
      }
    }
  }, [_vm._v("Bulk Reverse")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Import tracking number from text",
      "width": "80%",
      "visible": _vm.textImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.textImportVisible = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "10",
      "placeholder": _vm.placeholder,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("The tracking number import of text needs to contain tracking Numbers, upc, quantity, note,\n\t\t\t\tseparated by commas,space or tab, and multiple records must be separated by newline.")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.textImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importFromText.apply(null, arguments)
      }
    }
  }, [_vm._v("Import")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Import tracking number from excel",
      "width": "80%",
      "visible": _vm.excelImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.excelImportVisible = $event
      }
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "name": "filename",
      "drag": "",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "limit": 1,
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("click to upload")]), _vm._v(" or drag and drop file")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Only allowed .xls,.xlsx files, please follow the columns format with trackingNum,upc,quantity,note, include the header.")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Login")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "UserName"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "margin-bottom": "15px",
      "cursor": "pointer",
      "color": "#409eff"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('forgetPassword')
      }
    }
  }, [_vm._v("Forgot Password")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "native-type": "submit",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Login\n            ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Choose Company",
      "width": "80%",
      "visible": _vm.selectCompanyVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.selectCompanyVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "obj",
    attrs: {
      "model": _vm.obj,
      "label-width": "220px",
      "rules": _vm.rule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company",
      "prop": "currentCompany"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.obj.currentCompany),
      callback: function($$v) {
        _vm.$set(_vm.obj, "currentCompany", $$v)
      },
      expression: "obj.currentCompany"
    }
  }, _vm._l((_vm.doctors), function(doctor, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": doctor.userName,
        "value": doctor.userNo
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.selectCompanyVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleSelectCompany.apply(null, arguments)
      }
    }
  }, [_vm._v("Choose")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.discounts,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFreeDuration",
      "label": "Free duration (Month)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "discountRate",
      "label": "Discount rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFeeOverDays",
      "label": "Storage Fee Over days"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Discount",
      "width": "80%",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editDiscount",
    attrs: {
      "model": _vm.editDiscount,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Doctor Name",
      "prop": "doctorName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editDiscount.doctorName),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "doctorName", $$v)
      },
      expression: "editDiscount.doctorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 3
    },
    model: {
      value: (_vm.editDiscount.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "storageFreeDuration", $$v)
      },
      expression: "editDiscount.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Discount Rate",
      "prop": "discountRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "step": 0.05,
      "min": 0.01,
      "max": 1.0
    },
    model: {
      value: (_vm.editDiscount.discountRate),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "discountRate", $$v)
      },
      expression: "editDiscount.discountRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Fee Over days",
      "prop": "storageFeeOverDays"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 0,
      "step": 1,
      "min": 0
    },
    model: {
      value: (_vm.editDiscount.storageFeeOverDays),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "storageFeeOverDays", $$v)
      },
      expression: "editDiscount.storageFeeOverDays"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editVisible = false;
        _vm.getDiscounts();
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM",
      "placeholder": "Search by Month",
      "type": "month"
    },
    on: {
      "change": _vm.changeSearchMonth
    },
    model: {
      value: (_vm.filters.searchMonth),
      callback: function($$v) {
        _vm.$set(_vm.filters, "searchMonth", $$v)
      },
      expression: "filters.searchMonth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.testGenStorageFeeByDaily
    }
  }, [_vm._v("Build Storage Fee for Today")]) : _vm._e(), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.testGenStorageFeeByMonthly
    }
  }, [_vm._v("Build Storage Fee for Month")]) : _vm._e(), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.showRebuildStorageFeeByDailyWin
    }
  }, [_vm._v("Rebuild Storage Fee for Daily")]) : _vm._e(), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.showRebuildStorageFeeByMonthWin
    }
  }, [_vm._v("Rebuild Fee for Month")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.storageFeePayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportMonth",
      "label": "Report Month"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payStatus",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payStatus == 0 && scope.row.totalFee > 0) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Created")]) : (scope.row.payStatus == 0 && scope.row.totalFee <= 0) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("No need to pay")]) : (scope.row.payStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")]) : (scope.row.payStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Canceled")]) : (scope.row.payStatus == 3) ? _c('el-tag', [_vm._v("Archived")]) : (scope.row.payStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")]) : (scope.row.payStatus == 5) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Requested")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentSummary(scope.row.id)
            }
          }
        }, [_vm._v("\n                        Detail\n                    ")]), _vm._v(" "), (scope.row.totalFee > 0) ? _c('el-button', {
          attrs: {
            "type": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showPaymentList(scope.row)
            }
          }
        }, [_vm._v("Payment")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.storageFeePaymentTotal
    },
    on: {
      "current-change": _vm.changeStorageFeePayment
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Detail",
      "width": "90%",
      "visible": _vm.warehouseFeeDetailModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeDetailModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.productName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productName", $$v)
      },
      expression: "filters.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseFeeDetail', 'Warehouse Fee Detail.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter Fee Type",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.feeType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "feeType", $$v)
      },
      expression: "filters.feeType"
    }
  }, _vm._l((_vm.feeTypeList), function(fee, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": fee.value,
        "value": fee.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeLoading),
      expression: "warehouseFeeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "feeType",
      "label": "Fee Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.feeType == 0) ? _c('p', [_vm._v("Inbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 1) ? _c('p', [_vm._v("Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 2) ? _c('p', [_vm._v("Storage")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.totalFee, 4)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productSize",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFee",
      "label": "Storage Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFeeOver",
      "label": "Storage > Years Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Storage Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundQty",
      "label": "Inbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundQty",
      "label": "Outbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceFee",
      "label": "Service Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceType",
      "label": "Service Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceQty",
      "label": "Service Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.inboundDate)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.reportDate)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "descs",
      "label": "Desc"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeDetailTotal,
      "current-page": _vm.warehouseFeeDetailPage
    },
    on: {
      "current-change": _vm.changeWarehouseFeeDetail,
      "update:currentPage": function($event) {
        _vm.warehouseFeeDetailPage = $event
      },
      "update:current-page": function($event) {
        _vm.warehouseFeeDetailPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeDetailModelVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Summary",
      "width": "80%",
      "visible": _vm.warehouseFeeSummaryModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeSummaryModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    model: {
      value: (_vm.filters.conditionSearch),
      callback: function($$v) {
        _vm.$set(_vm.filters, "conditionSearch", $$v)
      },
      expression: "filters.conditionSearch"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseFeeSummary', 'Warehouse Fee Summary.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeSummaryLoading),
      expression: "warehouseFeeSummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeSummary,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productNo",
      "label": "Product No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.inboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.outboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFee",
      "label": "Storage Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.storageFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentDetail(scope.row.productNo, 1)
            }
          }
        }, [_vm._v("\n                            Detail\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeSummaryTotal
    },
    on: {
      "current-change": _vm.changeWarehouseFeeSummary
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeSummaryModelVisible = false;
        _vm.filters.conditionSearch = ''
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Payment List",
      "width": "80%",
      "visible": _vm.paymentListVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.paymentListVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentStatus", $$v)
      },
      expression: "filters.paymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [(!_vm.isPaymentPending) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddPayment
    }
  }, [_vm._v("Request a payment")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.paymentLoading),
      expression: "paymentLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.payments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Apply amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseNote",
      "label": "Warehouse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.warehouseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.editPaymentStatus(scope.row.paymentNo, 2)
            }
          }
        }, [_vm._v("Cancel\n                        ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.paymentListVisible = false;
        _vm.filters.paymentStatus = '';
        _vm.getStorageFeePaymentList();
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Request a payment",
      "width": "80%",
      "visible": _vm.requestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total payment",
      "prop": "balance"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.payment.balance),
      callback: function($$v) {
        _vm.$set(_vm.payment, "balance", $$v)
      },
      expression: "payment.balance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payable amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.payment.bank),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bank", $$v)
      },
      expression: "payment.bank"
    }
  }, _vm._l((_vm.banks), function(bank, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bank.category + ' ' + bank.accountNumber + ' (' + bank.accountType + ')',
        "value": bank.bankNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.payment.note),
      callback: function($$v) {
        _vm.$set(_vm.payment, "note", $$v)
      },
      expression: "payment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestPayment.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rebuild Daily for Storage Fee",
      "width": "80%",
      "visible": _vm.requestRebuildVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestRebuildVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "rebuildDailyModel",
    attrs: {
      "model": _vm.rebuildDailyModel,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rebuild Date",
      "prop": "dates"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Rebuild dates, example: 2023-09-01,2023-09-02,2023-09-10 etc.",
      "clearable": ""
    },
    model: {
      value: (_vm.rebuildDailyModel.dates),
      callback: function($$v) {
        _vm.$set(_vm.rebuildDailyModel, "dates", $$v)
      },
      expression: "rebuildDailyModel.dates"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestRebuildVisible = false;
        _vm.rebuildDailyModel.dates = '';
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isEnable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rebuildStorageFeeByDaily.apply(null, arguments)
      }
    }
  }, [_vm._v("Rebuild")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rebuild Month for Storage Fee",
      "width": "80%",
      "visible": _vm.requestRebuildMonthVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestRebuildMonthVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "rebuildMonthModel",
    attrs: {
      "model": _vm.rebuildMonthModel,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rebuild Month",
      "prop": "month"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Monthly Fee Report Rebuild, example: 2023-09  only one, dont set multiple month`s.",
      "clearable": ""
    },
    model: {
      value: (_vm.rebuildMonthModel.month),
      callback: function($$v) {
        _vm.$set(_vm.rebuildMonthModel, "month", $$v)
      },
      expression: "rebuildMonthModel.month"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestRebuildMonthVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isEnable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rebuildStorageFeeByMonth.apply(null, arguments)
      }
    }
  }, [_vm._v("Rebuild")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Forget Password")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": "UserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "UserName"
    },
    model: {
      value: (_vm.ruleForm2.username),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "username", $$v)
      },
      expression: "ruleForm2.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "email", $$v)
      },
      expression: "ruleForm2.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "margin-bottom": "15px",
      "cursor": "pointer",
      "color": "#409eff"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('login')
      }
    }
  }, [_vm._v("Login")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Submit\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Offers")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Offers',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.offers.open) + " open offers")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Offers',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.offers.proposed) + " proposed offers")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Inbound")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Inbound',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.inbound.inbound) + " inbound items")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Inbound',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.inbound.reported) + " reported item")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Outbound")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Outbound',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.outbound.outbound) + " outbound shipments")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Payments")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Payments',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.balance.request) + " Nurse payment request")]), _vm._v(" for a total of $" + _vm._s(_vm.balance.requestTotal))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_vm._v("Balance: $" + _vm._s(_vm.balance.totalBalance))]), _vm._v(" "), _c('p', [_vm._v("Pending: $" + _vm._s(_vm.balance.totalPending))])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Claim Items",
      "name": "claim"
    }
  }, [(_vm.currentDoctorName && _vm.isNurse) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "title": ("Currently claiming for: " + _vm.currentDoctorName),
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "claimForm",
    attrs: {
      "model": _vm.claimForm,
      "rules": _vm.claimRules,
      "label-width": "120px"
    }
  }, [(_vm.isNurse) ? _c('el-row', {
    staticClass: "form-row-spaced",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Available Inbound",
      "prop": "inboundNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Filter Inbound by typing 4+ UPC characters, or select Inbound to batch import.",
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchAvailableInbounds,
      "loading": _vm.availableInboundsLoading
    },
    on: {
      "change": _vm.onInboundChange
    },
    model: {
      value: (_vm.claimForm.inboundNo),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "inboundNo", $$v)
      },
      expression: "claimForm.inboundNo"
    }
  }, [_vm._l((_vm.availableInbounds), function(inbound) {
    return _c('el-option', {
      key: inbound.inboundNo,
      attrs: {
        "label": ((inbound.productName) + " - Qty: " + (inbound.qty) + ", Left: " + (inbound.leftNum) + " (" + (inbound.warehouse) + ")"),
        "value": inbound.inboundNo
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(inbound.productName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tLeft: " + _vm._s(inbound.leftNum) + "/" + _vm._s(inbound.qty) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
  }), _vm._v(" "), (_vm.availableInbounds.length === 0) ? _c('el-option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tNo incomplete inbound records available\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isNurse && _vm.selectedInboundInfo) ? _c('el-row', {
    staticClass: "form-row-spaced",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('InboundStatusCard', {
    attrs: {
      "inbound": _vm.selectedInboundInfo,
      "show-actions": false
    },
    on: {
      "status-refreshed": _vm.onInboundStatusRefreshed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "form-row-spaced",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking #",
      "prop": "tracking"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter tracking number",
      "clearable": ""
    },
    on: {
      "blur": _vm.searchTrackingInfo
    },
    model: {
      value: (_vm.claimForm.tracking),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "tracking", $$v)
      },
      expression: "claimForm.tracking"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    class: {
      'readonly-input': _vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.upc
    },
    attrs: {
      "placeholder": _vm.getUpcPlaceholder(),
      "readonly": !!(_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.upc),
      "clearable": ""
    },
    on: {
      "blur": _vm.validateUpcMatch
    },
    model: {
      value: (_vm.claimForm.upc),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "upc", $$v)
      },
      expression: "claimForm.upc"
    }
  }, [(_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.upc) ? _c('template', {
    slot: "suffix"
  }, [_c('i', {
    staticClass: "el-icon-lock",
    staticStyle: {
      "color": "#909399"
    }
  })]) : _vm._e()], 2), _vm._v(" "), (_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.upc) ? _c('div', {
    staticClass: "readonly-hint"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" Automatically filled from selected Inbound record\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1,
      "max": _vm.getMaxClaimableQty(),
      "placeholder": "Quantity"
    },
    model: {
      value: (_vm.claimForm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "quantity", $$v)
      },
      expression: "claimForm.quantity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    class: {
      'readonly-select': _vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.warehouseNo
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.getWarehousePlaceholder(),
      "disabled": !!(_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.warehouseNo)
    },
    model: {
      value: (_vm.claimForm.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "warehouseNo", $$v)
      },
      expression: "claimForm.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.state + ' ' + item.city + ' ' + item.address,
          "value": item.warehouseNo
        }
      })
    }), 1)
  }), 1), _vm._v(" "), (_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.warehouseNo) ? _c('div', {
    staticClass: "readonly-hint"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" Automatically selected from Inbound record\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.addToListLoading
    },
    on: {
      "click": _vm.addToClaimList
    }
  }, [_vm._v("Add to Claim List")]), _vm._v(" "), (_vm.isNurse) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "disabled": !_vm.claimForm.inboundNo || !_vm.isNurse,
      "loading": _vm.batchImportLoading
    },
    on: {
      "click": _vm.showBatchImportDialog
    }
  }, [_vm._v("Batch Upload")]) : _vm._e(), _vm._v(" "), (!_vm.isNurse) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "disabled": !_vm.claimForm.warehouseNo || _vm.isNurse,
      "loading": _vm.doctorBatchImportLoading
    },
    on: {
      "click": _vm.showDoctorBatchImportDialog
    }
  }, [_vm._v("Batch Upload")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.claimLoading,
      "disabled": _vm.selectedClaims.length === 0
    },
    on: {
      "click": _vm.submitSelectedClaims
    }
  }, [_vm._v("Submit Selected Claims (" + _vm._s(_vm.selectedClaims.length) + ")")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": "Claim Instructions",
      "description": 'Enter tracking number, UPC, quantity, and select warehouse. Add items to claim list, then submit all claims together.',
      "type": "info",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), (_vm.claimList.length > 0) ? _c('el-card', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Claim List (" + _vm._s(_vm.claimList.length) + " items, " + _vm._s(_vm.selectedClaims.length) + " selected)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.claimList.length === 0
    },
    on: {
      "click": _vm.selectAllClaims
    }
  }, [_vm._v("Select All")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning",
      "disabled": _vm.selectedClaims.length === 0
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("Clear Selection")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.clearClaimList
    }
  }, [_vm._v("Clear All")])], 1)]), _vm._v(" "), _c('el-table', {
    ref: "claimTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.claimList,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), (_vm.isNurse) ? _c('el-table-column', {
    attrs: {
      "prop": "inboundInfo",
      "label": "Inbound",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Inbound #" + _vm._s(scope.row.inboundNo))])]
      }
    }], null, false, 1996151786)
  }) : _vm._e(), _vm._v(" "), (!_vm.isNurse) ? _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Mixed Package Item")])]
      }
    }], null, false, 1752774166)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "width": "320px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Quantity",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseName",
      "label": "Warehouse",
      "min-width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "100px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeFromClaimList(scope.$index)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }], null, false, 244834889)
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "My Claims",
      "name": "myClaims"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.myClaimFilters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getMyClaimList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.myClaimFilters.tracking),
      callback: function($$v) {
        _vm.$set(_vm.myClaimFilters, "tracking", $$v)
      },
      expression: "myClaimFilters.tracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getMyClaimList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getMyClaimList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.myClaimFilters.upc),
      callback: function($$v) {
        _vm.$set(_vm.myClaimFilters, "upc", $$v)
      },
      expression: "myClaimFilters.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    model: {
      value: (_vm.myClaimFilters.claimStatus),
      callback: function($$v) {
        _vm.$set(_vm.myClaimFilters, "claimStatus", $$v)
      },
      expression: "myClaimFilters.claimStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending Review",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Approved",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Distributed",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Quantity Adjusted",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getMyClaimList
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.myClaimListLoading),
      expression: "myClaimListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.myClaimList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "width": "320px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "width": "250px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quantity Info",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Original: "), _c('strong', [_vm._v(_vm._s(scope.row.originalClaimedQty || scope.row.claimedQty))])]), _vm._v(" "), (scope.row.originalClaimedQty && scope.row.originalClaimedQty !== scope.row.claimedQty) ? _c('p', {
          staticClass: "note"
        }, [_vm._v("\n\t\t\t\t\t\t\t\tFinal: "), _c('strong', [_vm._v(_vm._s(scope.row.claimedQty))])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimDate",
      "label": "Claim Date",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.formatDate(scope.row.claimDate)) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getClaimStatusTagType(scope.row.claimStatus),
            "size": "small"
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getClaimStatusText(scope.row.claimStatus)) + "\n\t\t\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewReason",
      "label": "Review Note",
      "min-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.reviewReason) ? _c('p', [_vm._v(_vm._s(scope.row.reviewReason))]) : _c('span', {
          staticClass: "note"
        }, [_vm._v("—")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "min-width": "140",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "action-buttons"
        }, [(scope.row.claimStatus === 0) ? _c('el-button', {
          staticClass: "action-btn",
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelClaim(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCancel\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticClass: "action-btn",
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\tView\n\t\t\t\t\t\t\t\t")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.myClaimCurrentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.myClaimSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.myClaimTotal
    },
    on: {
      "size-change": _vm.handleMyClaimSizeChange,
      "current-change": _vm.handleMyClaimCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Upload Claims (Nurse)",
      "width": "85%",
      "visible": _vm.batchImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchImportVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.batchImportForm
    }
  }, [_c('el-form-item', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('strong', [_vm._v("Selected Inbound:")]), _vm._v(" " + _vm._s(_vm.selectedInboundInfo ? _vm.selectedInboundInfo.productName : 'Not selected') + "\n\t\t\t\t\t"), (_vm.selectedInboundInfo) ? _c('span', {
    staticStyle: {
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_vm._v("(" + _vm._s(_vm.selectedInboundInfo.inboundNo) + ")")]) : _vm._e()])]), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "12",
      "placeholder": _vm.batchImportPlaceholder
    },
    model: {
      value: (_vm.batchImportText),
      callback: function($$v) {
        _vm.batchImportText = $$v
      },
      expression: "batchImportText"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('strong', [_vm._v("Format: Tracking,Quantity or Tracking Quantity (one record per line)")]), _vm._v(" "), _c('br'), _vm._v("Supports separators: comma, space, or tab\n\t\t\t\t\t"), _c('br'), _vm._v("Examples:\n\t\t\t\t\t"), _c('br'), _vm._v("123456789012,5\n\t\t\t\t\t"), _c('br'), _vm._v("234567890123\t10\n\t\t\t\t\t"), _c('br'), _vm._v("345678901234 3\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.batchImportLoading
    },
    on: {
      "click": _vm.importBatchClaims
    }
  }, [_vm._v("Import to Claim List")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Upload Claims (Doctor)",
      "width": "85%",
      "visible": _vm.doctorBatchImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.doctorBatchImportVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.batchImportForm
    }
  }, [_c('el-form-item', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('strong', [_vm._v("Selected Warehouse:")]), _vm._v(" " + _vm._s(_vm.claimForm.warehouseNo ? _vm.getWarehouseNameByNo(_vm.claimForm.warehouseNo) : 'Not selected') + "\n\t\t\t\t")])]), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "12",
      "placeholder": _vm.doctorBatchImportPlaceholder
    },
    model: {
      value: (_vm.doctorBatchImportText),
      callback: function($$v) {
        _vm.doctorBatchImportText = $$v
      },
      expression: "doctorBatchImportText"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('strong', [_vm._v("Format: Tracking,UPC,Quantity or Tracking UPC Quantity (one record per line)")]), _vm._v(" "), _c('br'), _vm._v("Supports separators: comma, space, or tab\n\t\t\t\t\t"), _c('br'), _vm._v("Examples:\n\t\t\t\t\t"), _c('br'), _vm._v("123456789012,012345678901,5\n\t\t\t\t\t"), _c('br'), _vm._v("234567890123\t098765432109\t10\n\t\t\t\t\t"), _c('br'), _vm._v("345678901234 111111111111 3\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.doctorBatchImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.doctorBatchImportLoading
    },
    on: {
      "click": _vm.importDoctorBatchClaims
    }
  }, [_vm._v("Import to Claim List")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Claim Detail",
      "visible": _vm.claimDetailDialog,
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        _vm.claimDetailDialog = $event
      }
    }
  }, [(_vm.claimDetail) ? _c('div', [_c('el-descriptions', {
    attrs: {
      "title": "Claim Information",
      "column": 2,
      "border": ""
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label": "Tracking #"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.tracking))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.upc))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Original Claimed Qty"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.originalClaimedQty || _vm.claimDetail.claimedQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Final Quantity"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.claimedQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Claim Date"
    }
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.claimDetail.claimDate)))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.getClaimStatusTagType(_vm.claimDetail.claimStatus)
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getClaimStatusText(_vm.claimDetail.claimStatus)) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Review Note",
      "span": 2
    }
  }, [(_vm.claimDetail.reviewReason) ? _c('p', [_vm._v(_vm._s(_vm.claimDetail.reviewReason))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("No review note")])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showScrollToTopButton) ? _c('el-button', {
    staticClass: "scroll-to-top-button",
    attrs: {
      "type": "primary",
      "icon": "el-icon-arrow-up",
      "circle": "",
      "title": "Scroll to top"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleScrollToTopClick.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "debug-scroll-info"
  }, [_vm._v("\n\t\tshowScrollToTopButton: " + _vm._s(_vm.showScrollToTopButton) + ", scrollY: " + _vm._s(_vm.window.pageYOffset) + "\n\t")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('el-form', {
    ref: "account",
    attrs: {
      "model": _vm.account,
      "rules": _vm.rule,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Old Password",
      "prop": "old"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.account.old),
      callback: function($$v) {
        _vm.$set(_vm.account, "old", $$v)
      },
      expression: "account.old"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Password",
      "prop": "new"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.account.new),
      callback: function($$v) {
        _vm.$set(_vm.account, "new", $$v)
      },
      expression: "account.new"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "confirm"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.account.confirm),
      callback: function($$v) {
        _vm.$set(_vm.account, "confirm", $$v)
      },
      expression: "account.confirm"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'el-input-number',
      _vm.inputNumberSize ? 'el-input-number--' + _vm.inputNumberSize : '',
      {
        'is-disabled': _vm.inputNumberDisabled
      },
      {
        'is-without-controls': !_vm.controls
      },
      {
        'is-controls-right': _vm.controlsAtRight
      }
    ],
    on: {
      "dragstart": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.controls) ? _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.decrease),
      expression: "decrease"
    }],
    staticClass: "el-input-number__decrease",
    class: {
      'is-disabled': _vm.minDisabled
    },
    attrs: {
      "role": "button"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.decrease.apply(null, arguments)
      }
    }
  }, [_c('i', {
    class: ("el-icon-" + (_vm.controlsAtRight ? 'arrow-down' : 'minus'))
  })]) : _vm._e(), _vm._v(" "), (_vm.controls) ? _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.increase),
      expression: "increase"
    }],
    staticClass: "el-input-number__increase",
    class: {
      'is-disabled': _vm.maxDisabled
    },
    attrs: {
      "role": "button"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.increase.apply(null, arguments)
      }
    }
  }, [_c('i', {
    class: ("el-icon-" + (_vm.controlsAtRight ? 'arrow-up' : 'plus'))
  })]) : _vm._e(), _vm._v(" "), _c('el-input', {
    ref: "input",
    attrs: {
      "value": _vm.displayValue,
      "placeholder": _vm.placeholder,
      "disabled": _vm.inputNumberDisabled,
      "size": _vm.inputNumberSize,
      "max": _vm.max,
      "min": _vm.min,
      "name": _vm.name,
      "label": _vm.label
    },
    on: {
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus,
      "input": _vm.handleInput,
      "change": _vm.handleInputChange
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.increase.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.decrease.apply(null, arguments)
      }]
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTrasferUserInfo.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.conditionSearch),
      callback: function($$v) {
        _vm.$set(_vm.filters, "conditionSearch", $$v)
      },
      expression: "filters.conditionSearch"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTrasferUserInfo
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Select Mark Checked",
      "clearable": ""
    },
    on: {
      "change": _vm.getTrasferUserInfo
    },
    model: {
      value: (_vm.filters.markChecked),
      callback: function($$v) {
        _vm.$set(_vm.filters, "markChecked", $$v)
      },
      expression: "filters.markChecked"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.dataList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferNo",
      "label": "Transfer#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Transferer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToUserName",
      "label": "Acceptor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseAddress",
      "label": "Transfer Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToAddress",
      "label": "Acceptor Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Transfer Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "moved",
      "label": "Checked"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.moved ? 'green' : 'red'
          })
        }, [_vm._v("\n                        " + _vm._s(scope.row.moved ? "Yes" : "No") + "\n                    ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateDate",
      "label": "Checked Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.markChecked(scope.row.id)
            }
          }
        }, [_vm._v("\n                        Mark Down\n                    ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.workingTotal
    },
    on: {
      "current-change": _vm.getTrasferUserInfo
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "el-button",
    class: [
      _vm.type ? 'el-button--' + _vm.type : '',
      _vm.buttonSize ? 'el-button--' + _vm.buttonSize : '',
      {
        'is-disabled': _vm.buttonDisabled,
        'is-loading': _vm.loading,
        'is-plain': _vm.plain,
        'is-round': _vm.round,
        'is-circle': _vm.circle
      }
    ],
    attrs: {
      "disabled": _vm.buttonDisabled || _vm.loading,
      "autofocus": _vm.autofocus,
      "type": _vm.nativeType
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v(" "), (_vm.icon && !_vm.loading) ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('el-form', {
    ref: "account",
    attrs: {
      "model": _vm.account,
      "label-width": "200px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.account.userName),
      callback: function($$v) {
        _vm.$set(_vm.account, "userName", $$v)
      },
      expression: "account.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.account.email),
      callback: function($$v) {
        _vm.$set(_vm.account, "email", $$v)
      },
      expression: "account.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.account.phone),
      callback: function($$v) {
        _vm.$set(_vm.account, "phone", $$v)
      },
      expression: "account.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.changeUserInfo
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbound-status-card"
  }, [_c('div', {
    staticClass: "status-header"
  }, [_c('h5', [_vm._v("Inbound Status")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "size": "mini",
      "icon": "el-icon-refresh",
      "loading": _vm.refreshing
    },
    on: {
      "click": _vm.refreshStatus
    }
  }, [_vm._v("\n      Refresh\n    ")])], 1), _vm._v(" "), (_vm.hasValidData) ? _c('div', {
    staticClass: "status-content"
  }, [_c('div', {
    staticClass: "status-grid"
  }, [_c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Take Quantity:")]), _vm._v(" "), _c('span', {
    staticClass: "value primary"
  }, [_vm._v(_vm._s(_vm.takeQuantity))])]), _vm._v(" "), _c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Total Remaining:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalRemaining))])]), _vm._v(" "), (_vm.safePendingClaims > 0) ? _c('div', {
    staticClass: "status-item warning"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.safePendingClaims))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "status-item success"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "value emphasis"
  }, [_vm._v(_vm._s(_vm.availableToClaim))])]), _vm._v(" "), (_vm.safePrice !== null) ? _c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Price:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("$" + _vm._s(_vm.safePrice.toFixed(2)))])]) : _vm._e()]), _vm._v(" "), (_vm.safePendingClaims > 0) ? _c('div', {
    staticClass: "pending-note"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v("\n        " + _vm._s(_vm.safePendingClaims) + " items awaiting warehouse review\n      ")])]) : _vm._e()]) : _c('div', {
    staticClass: "no-data-state"
  }, [_vm._m(2)]), _vm._v(" "), (_vm.pendingClaims > 0) ? _c('div', {
    staticClass: "status-tips"
  }, [_c('el-alert', {
    attrs: {
      "title": "Notice",
      "description": _vm.getStatusTipMessage(),
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showActions && _vm.hasValidData) ? _c('div', {
    staticClass: "status-actions"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.availableToClaim <= 0
    },
    on: {
      "click": function($event) {
        return _vm.$emit('select-inbound', _vm.inbound)
      }
    }
  }, [_vm._v("\n      Select This Inbound\n    ")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("\n          Pending Claims:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v("\n          Available:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data-content"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v(" "), _c('p', [_vm._v("No inbound data available")])])
}]}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add a payment method")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.list,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "bankNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "category",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "currency",
      "label": "Currency"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountNumber",
      "label": "Account Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditBank(scope.row.bankNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteBank(scope.row.bankNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add a payment method",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "180px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.payment.category),
      callback: function($$v) {
        _vm.$set(_vm.payment, "category", $$v)
      },
      expression: "payment.category"
    }
  }, _vm._l((_vm.categoryOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Currency",
      "prop": "currency"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.payment.currency),
      callback: function($$v) {
        _vm.$set(_vm.payment, "currency", $$v)
      },
      expression: "payment.currency"
    }
  }, _vm._l((_vm.currencyOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.payment.category) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.payment.category == 'Bill Pay' ? 'Credit card company' : 'Bank Name',
      "prop": "company"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.payment.company),
      callback: function($$v) {
        _vm.$set(_vm.payment, "company", $$v)
      },
      expression: "payment.company"
    }
  }), _vm._v(" "), (_vm.payment.category == 'Bill Pay') ? _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Chase, Bank of America, Wells Fargo,\n                        U.S. Bank, Citibank, Captial One, PNC, BarclayCard US, Staples, Office Depot, Dell,\n                        Target.")]) : _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Chase, Bank of America, Wells Fargo, Citibank, PNC.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.payment.category == 'Bill Pay' ? 'Card network' : 'Account type',
      "prop": "accountType"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.payment.accountType),
      callback: function($$v) {
        _vm.$set(_vm.payment, "accountType", $$v)
      },
      expression: "payment.accountType"
    }
  }), _vm._v(" "), (_vm.payment.category == 'Bill Pay') ? _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Visa, MasterCard, American Express,\n                        Discover, Store credit card.")]) : _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Checking, Saving.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account holder",
      "prop": "accountHolder"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.payment.accountHolder),
      callback: function($$v) {
        _vm.$set(_vm.payment, "accountHolder", $$v)
      },
      expression: "payment.accountHolder"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account number",
      "prop": "accountNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.payment.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.payment, "accountNumber", $$v)
      },
      expression: "payment.accountNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.payment.category == 'Bill Pay' ? 'Bank address (PO box)' : 'Account holder\'s address',
      "prop": "bankAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.payment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bankAddress", $$v)
      },
      expression: "payment.bankAddress"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addBank.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit payment method",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editPayment",
    attrs: {
      "model": _vm.editPayment,
      "label-width": "180px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editPayment.category),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "category", $$v)
      },
      expression: "editPayment.category"
    }
  }, _vm._l((_vm.categoryOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Currency",
      "prop": "currency"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editPayment.currency),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "currency", $$v)
      },
      expression: "editPayment.currency"
    }
  }, _vm._l((_vm.currencyOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.editPayment.category) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.editPayment.category == 'Bill Pay' ? 'Credit card company' : 'Bank Name',
      "prop": "company"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editPayment.bankName),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "bankName", $$v)
      },
      expression: "editPayment.bankName"
    }
  }), _vm._v(" "), (_vm.editPayment.category == 'Bill Pay') ? _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Chase, Bank of America, Wells Fargo,\n                        U.S. Bank, Citibank, Captial One, PNC, BarclayCard US, Staples, Office Depot, Dell,\n                        Target.")]) : _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Chase, Bank of America, Wells Fargo, Citibank, PNC.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.editPayment.category == 'Bill Pay' ? 'Card network' : 'Account type',
      "prop": "accountType"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editPayment.accountType),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "accountType", $$v)
      },
      expression: "editPayment.accountType"
    }
  }), _vm._v(" "), (_vm.editPayment.category == 'Bill Pay') ? _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Visa, MasterCard, American Express,\n                        Discover, Store credit card.")]) : _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Checking, Saving.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account holder",
      "prop": "accountHolder"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editPayment.accountHolder),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "accountHolder", $$v)
      },
      expression: "editPayment.accountHolder"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account number",
      "prop": "accountNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editPayment.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "accountNumber", $$v)
      },
      expression: "editPayment.accountNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.editPayment.category == 'Bill Pay' ? 'Bank address (PO box)' : 'Account holder\'s address',
      "prop": "bankAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.editPayment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "bankAddress", $$v)
      },
      expression: "editPayment.bankAddress"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editBank.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAdd
    }
  }, [_vm._v("Add Service Fee")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showUserRate
    }
  }, [_vm._v("User Rate")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.serviceFees,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "serviceLabel",
      "label": "Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceBaseFee",
      "label": "Service Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceDesc",
      "label": "Desc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Category",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addServiceFee",
    attrs: {
      "model": _vm.addServiceFee,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Label",
      "prop": "serviceLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addServiceFee.serviceLabel),
      callback: function($$v) {
        _vm.$set(_vm.addServiceFee, "serviceLabel", $$v)
      },
      expression: "addServiceFee.serviceLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Service Fee",
      "prop": "serviceBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addServiceFee.serviceBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addServiceFee, "serviceBaseFee", $$v)
      },
      expression: "addServiceFee.serviceBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc",
      "prop": "serviceDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addServiceFee.serviceDesc),
      callback: function($$v) {
        _vm.$set(_vm.addServiceFee, "serviceDesc", $$v)
      },
      expression: "addServiceFee.serviceDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddServiceFee.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Category",
      "width": "80%",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editServiceFee",
    attrs: {
      "model": _vm.editServiceFee,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Label",
      "prop": "serviceLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editServiceFee.serviceLabel),
      callback: function($$v) {
        _vm.$set(_vm.editServiceFee, "serviceLabel", $$v)
      },
      expression: "editServiceFee.serviceLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Service Fee",
      "prop": "serviceBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editServiceFee.serviceBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editServiceFee, "serviceBaseFee", $$v)
      },
      expression: "editServiceFee.serviceBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc",
      "prop": "serviceDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editServiceFee.serviceDesc),
      callback: function($$v) {
        _vm.$set(_vm.editServiceFee, "serviceDesc", $$v)
      },
      expression: "editServiceFee.serviceDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "User Rate List",
      "width": "80%",
      "visible": _vm.userRateVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.userRateVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.userRates,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hasSingleSeted",
      "label": "Has bean set"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.hasSingleSeted ? "Already Set" : "Not Set") + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showServiceFeeEdit(scope.row.doctorNo)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.userRateVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Service Fee Set",
      "width": "80%",
      "visible": _vm.customServiceFeeVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customServiceFeeVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customServiceFeeConfigs,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "serviceLabel",
      "label": "Service Label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.serviceLabel) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceBaseFee",
      "label": "Service Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.serviceBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceDesc",
      "label": "Description"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.serviceDesc) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showCustomEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), (scope.row.hasSingleSeted) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCustomItem(scope.row)
            }
          }
        }, [_vm._v("Restore")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customServiceFeeVisible = false;
        _vm.getAllUserRate()
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Edit Service Fee",
      "width": "80%",
      "visible": _vm.customEditVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customEditVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "customEditServiceFee",
    attrs: {
      "model": _vm.customEditServiceFee,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Service Label",
      "prop": "serviceLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.customEditServiceFee.serviceLabel),
      callback: function($$v) {
        _vm.$set(_vm.customEditServiceFee, "serviceLabel", $$v)
      },
      expression: "customEditServiceFee.serviceLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Service Fee",
      "prop": "serviceBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditServiceFee.serviceBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditServiceFee, "serviceBaseFee", $$v)
      },
      expression: "customEditServiceFee.serviceBaseFee"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customEditVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.customEditLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.customEditSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.email),
      callback: function($$v) {
        _vm.$set(_vm.filters, "email", $$v)
      },
      expression: "filters.email"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInvitations
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.invitations,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Time",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "formatter": _vm.formatInvitationStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editInvitationStatus(scope.row.invitationNo, 1)
            }
          }
        }, [_vm._v("Approve")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editInvitationStatus(scope.row.invitationNo, 2)
            }
          }
        }, [_vm._v("Reject")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.invitationTotalPage
    },
    on: {
      "current-change": _vm.handleInvitationPageChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "toConfirm"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "Select Batch Number (Type 2+ chars to search)",
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchPendingBatchNumbers,
      "loading": _vm.availableBatchesLoading
    },
    on: {
      "change": _vm.handlePendingBatchNumberChange,
      "visible-change": _vm.handlePendingBatchDropdownVisible,
      "clear": _vm.handlePendingBatchNumberClear
    },
    model: {
      value: (_vm.filters.batchFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "batchFilter", $$v)
      },
      expression: "filters.batchFilter"
    }
  }, _vm._l((_vm.availableBatches), function(batch) {
    return _c('el-option', {
      key: batch.batchNumber,
      attrs: {
        "label": batch.batchNumber,
        "value": batch.batchNumber
      }
    }, [_c('span', {
      staticClass: "batch-number"
    }, [_vm._v(_vm._s(batch.batchNumber))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking #",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getPendingPackages.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.trackingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "trackingFilter", $$v)
      },
      expression: "filters.trackingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPendingPackages
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBatchImport
    }
  }, [_vm._v("Batch Import")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.showBulkConfirm
    }
  }, [_vm._v("Bulk Confirm")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.showBatchCancel
    }
  }, [_vm._v("Batch Remove")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportPendingBatches
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pendingBatchLoading),
      expression: "pendingBatchLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.pendingPackageList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handlePackageSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "batchNumber",
      "label": "Batch Number",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('strong', [_vm._v(_vm._s(scope.row.tracking))])]), _vm._v(" "), (scope.row.note) ? _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemCount",
      "label": "UPC Items",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseName",
      "label": "Warehouse",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "importDate",
      "label": "Import Time",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "240",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.viewPendingPackageDetail(scope.row)
            }
          }
        }, [_vm._v("Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.confirmSinglePackage(scope.row)
            }
          }
        }, [_vm._v("Confirm")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelSinglePackage(scope.row)
            }
          }
        }, [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPendingBatchPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.dynamicPendingPageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pendingBatchTotal
    },
    on: {
      "size-change": _vm.handlePendingBatchSizeChange,
      "current-change": _vm.changePendingBatchPage
    }
  }), _vm._v(" "), (_vm.filters.batchFilter) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" Filtered by batch, showing 50 items per page\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Mixed Packages",
      "name": "packages"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.packageFilters
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "Select Batch Number (Type 2+ chars to search)",
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchBatchNumbers,
      "loading": _vm.mixedPackageBatchesLoading
    },
    on: {
      "change": _vm.handleBatchNumberChange,
      "visible-change": _vm.handleBatchDropdownVisible,
      "clear": _vm.handleBatchNumberClear
    },
    model: {
      value: (_vm.packageFilters.batchNumber),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "batchNumber", $$v)
      },
      expression: "packageFilters.batchNumber"
    }
  }, _vm._l((_vm.mixedPackageBatches), function(batch) {
    return _c('el-option', {
      key: batch.batchNumber,
      attrs: {
        "label": batch.batchNumber,
        "value": batch.batchNumber
      }
    }, [_c('span', {
      staticClass: "batch-number"
    }, [_vm._v(_vm._s(batch.batchNumber))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getMixedPackageList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.packageFilters.tracking),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "tracking", $$v)
      },
      expression: "packageFilters.tracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getMixedPackageList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Full UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getMixedPackageList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.packageFilters.upc),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "upc", $$v)
      },
      expression: "packageFilters.upc"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getMixedPackageList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Warehouse",
      "clearable": ""
    },
    model: {
      value: (_vm.packageFilters.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "warehouseNo", $$v)
      },
      expression: "packageFilters.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse) {
    return _c('el-option', {
      key: warehouse.warehouseNo,
      attrs: {
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address,
        "value": warehouse.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    model: {
      value: (_vm.packageFilters.packageStatus),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "packageStatus", $$v)
      },
      expression: "packageFilters.packageStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Partial Claimed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "All Claimed",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Completed",
      "value": "3"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showCreatePackage
    }
  }, [_vm._v("Create Mixed Package")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning",
      "disabled": _vm.selectedPackages.length === 0
    },
    on: {
      "click": _vm.showBulkReverse
    }
  }, [_vm._v("\n              Bulk Reverse (" + _vm._s(_vm.selectedPackages.length) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportMixedPackages
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.packageLoading),
      expression: "packageLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.packageList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handlePackageSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('strong', [_vm._v(_vm._s(scope.row.tracking))])]), _vm._v(" "), (scope.row.batchNumber) ? _c('p', {
          staticClass: "batch-number-display"
        }, [_c('el-tag', {
          attrs: {
            "type": "info",
            "size": "mini"
          }
        }, [_vm._v("Batch: " + _vm._s(scope.row.batchNumber))])], 1) : _vm._e(), _vm._v(" "), (scope.row.note) ? _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Items Status",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Total: " + _vm._s(scope.row.totalItems) + " items")]), _vm._v(" "), _c('p', [_vm._v("Claimed: " + _vm._s(scope.row.claimedItems) + " items")]), _vm._v(" "), _c('p', [_vm._v("Remaining: " + _vm._s(scope.row.unclaimedItems) + " items")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Package Status",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getStatusTagType(scope.row.packageStatus),
            "size": "small"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.getStatusText(scope.row.packageStatus)) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.formatDate(scope.row.createDate)))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("by " + _vm._s(scope.row.createUserName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "min-width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewPackageDetail(scope.row)
            }
          }
        }, [_vm._v("View Details")]), _vm._v(" "), (scope.row.packageStatus >= 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimsForPackage(scope.row)
            }
          }
        }, [_vm._v("\n              View Claims\n            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.confirmReversePackage(scope.row)
            }
          }
        }, [_vm._v("\n              Reverse\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.packageCurrentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.packageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.packageTotal
    },
    on: {
      "size-change": _vm.handlePackageSizeChange,
      "current-change": _vm.handlePackageCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "claims"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n        Claims Review\n        "), _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.pendingClaimsCount,
      "hidden": _vm.pendingClaimsCount === 0
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.claimFilters
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "Select Batch Number (Type 2+ chars to search)",
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchClaimsBatchNumbers,
      "loading": _vm.claimsBatchesLoading
    },
    on: {
      "change": _vm.handleClaimsBatchNumberChange,
      "visible-change": _vm.handleClaimsBatchDropdownVisible,
      "clear": _vm.handleClaimsBatchNumberClear
    },
    model: {
      value: (_vm.claimFilters.batchNumber),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "batchNumber", $$v)
      },
      expression: "claimFilters.batchNumber"
    }
  }, _vm._l((_vm.claimsBatches), function(batch) {
    return _c('el-option', {
      key: batch.batchNumber,
      attrs: {
        "label": batch.batchNumber,
        "value": batch.batchNumber
      }
    }, [_c('span', {
      staticClass: "batch-number"
    }, [_vm._v(_vm._s(batch.batchNumber))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number",
      "clearable": ""
    },
    model: {
      value: (_vm.claimFilters.tracking),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "tracking", $$v)
      },
      expression: "claimFilters.tracking"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "UPC",
      "clearable": ""
    },
    model: {
      value: (_vm.claimFilters.upc),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "upc", $$v)
      },
      expression: "claimFilters.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Warehouse",
      "clearable": ""
    },
    model: {
      value: (_vm.claimFilters.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "warehouseNo", $$v)
      },
      expression: "claimFilters.warehouseNo"
    }
  }, _vm._l((_vm.claimWarehouses), function(warehouse) {
    return _c('el-option', {
      key: warehouse.warehouseNo,
      attrs: {
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address,
        "value": warehouse.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Claim Status",
      "clearable": ""
    },
    model: {
      value: (_vm.claimFilters.claimStatus),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "claimStatus", $$v)
      },
      expression: "claimFilters.claimStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending Review",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Approved",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Distributed",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Quantity Adjusted",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getClaimList
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.canBatchApprove
    },
    on: {
      "click": _vm.showBatchApprove
    }
  }, [_vm._v("\n              Batch Approve (" + _vm._s(_vm.approvableClaimsCount) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": !_vm.canBatchReject
    },
    on: {
      "click": _vm.showBatchReject
    }
  }, [_vm._v("\n              Batch Reject (" + _vm._s(_vm.rejectableClaimsCount) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.canBatchDistribute
    },
    on: {
      "click": _vm.showBatchDistribute
    }
  }, [_vm._v("\n              Batch Distribute (" + _vm._s(_vm.distributableClaimsCount) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning",
      "disabled": !_vm.canSetForceChargeTime
    },
    on: {
      "click": _vm.showSetChargeTime
    }
  }, [_vm._v("\n              Set Charge Time (" + _vm._s(_vm.chargeEditableClaimsCount) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.exportClaimList
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.claimLoading),
      expression: "claimLoading"
    }],
    ref: "claimTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.claimList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handleClaimSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse",
      "min-width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Claimer",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.claimerName))]), _vm._v(" "), _c('el-tag', {
          attrs: {
            "size": "mini",
            "type": scope.row.claimerType === 1 ? 'success' : 'info'
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.claimerTypeDesc) + "\n            ")]), _vm._v(" "), (scope.row.claimerType === 2 && scope.row.targetDoctorName) ? _c('p', {
          staticStyle: {
            "margin-top": "4px",
            "font-size": "12px",
            "color": "#606266"
          }
        }, [_c('i', {
          staticClass: "el-icon-user"
        }), _vm._v(" Doctor: " + _vm._s(scope.row.targetDoctorName) + "\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quantity Info",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Claimed:\n              "), _c('el-tag', {
          attrs: {
            "type": _vm.getQuantityTagType(scope.row),
            "size": "mini"
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.claimedQty) + "\n              ")])], 1), _vm._v(" "), _c('p', [_vm._v("Available:\n              "), (scope.row.unclaimedQty < 0) ? _c('el-tag', {
          staticClass: "negative-quantity-alert",
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning"
        }), _vm._v(" " + _vm._s(scope.row.unclaimedQty) + "\n              ")]) : _c('span', [_vm._v(_vm._s(scope.row.unclaimedQty))])], 1), _vm._v(" "), _c('p', [_vm._v("Total: " + _vm._s(scope.row.totalQty))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimDate",
      "label": "Claim Date",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.formatDate(scope.row.claimDate)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getClaimStatusTagType(scope.row.claimStatus),
            "size": "small"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.getClaimStatusText(scope.row.claimStatus)) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Charge Time",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "charge-time-display"
        }, [(scope.row.forceChargeTime) ? _c('div', {
          staticClass: "charge-time-forced"
        }, [_c('i', {
          staticClass: "el-icon-time"
        }), _vm._v("\n                Force: " + _vm._s(_vm.formatDate(scope.row.forceChargeTime)) + "\n              ")]) : _c('div', {
          staticClass: "charge-time-normal"
        }, [_c('i', {
          staticClass: "el-icon-clock"
        }), _vm._v("\n                Normal Period\n              ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "min-width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.claimStatus === 0) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.approveClaim(scope.row)
            }
          }
        }, [_vm._v("Approve")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.showAdjustQuantity(scope.row)
            }
          }
        }, [_vm._v("Adjust")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.showRejectClaim(scope.row)
            }
          }
        }, [_vm._v("Reject")])], 1) : (scope.row.claimStatus === 1) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showSingleDistribute(scope.row)
            }
          }
        }, [_vm._v("Distribute")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "title": "Reject this claim if you find errors before distribution"
          },
          on: {
            "click": function($event) {
              return _vm.showRejectClaim(scope.row)
            }
          }
        }, [_vm._v("Reject")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("View Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning",
            "title": "Rollback this claim to pending status for re-processing"
          },
          on: {
            "click": function($event) {
              return _vm.rollbackClaimToPending(scope.row)
            }
          }
        }, [_vm._v("Rollback")])], 1) : (scope.row.claimStatus === 2) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("View Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning",
            "title": "Rollback this claim to pending status for re-processing"
          },
          on: {
            "click": function($event) {
              return _vm.rollbackClaimToPending(scope.row)
            }
          }
        }, [_vm._v("Rollback")])], 1) : (scope.row.claimStatus === 4) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showSingleDistribute(scope.row)
            }
          }
        }, [_vm._v("Distribute")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "title": "Reject this claim if you find errors before distribution"
          },
          on: {
            "click": function($event) {
              return _vm.showRejectClaim(scope.row)
            }
          }
        }, [_vm._v("Reject")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("View Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning",
            "title": "Rollback this claim to pending status for re-processing"
          },
          on: {
            "click": function($event) {
              return _vm.rollbackClaimToPending(scope.row)
            }
          }
        }, [_vm._v("Rollback")])], 1) : _c('div', [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("View Detail")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.claimCurrentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.claimSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.claimTotal
    },
    on: {
      "size-change": _vm.handleClaimSizeChange,
      "current-change": _vm.handleClaimCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Unclaimed Items",
      "name": "unclaimed"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.unclaimedFilters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUnclaimedItemsList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.unclaimedFilters.upc),
      callback: function($$v) {
        _vm.$set(_vm.unclaimedFilters, "upc", $$v)
      },
      expression: "unclaimedFilters.upc"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getUnclaimedItemsList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportUnclaimed
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.unclaimedLoading),
      expression: "unclaimedLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.unclaimedList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unclaimedQty",
      "label": "Unclaimed Qty",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.unclaimedQty))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalPackages",
      "label": "Packages Count",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trackingList",
      "label": "Related Trackings",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "tracking-list-container"
        }, [(_vm.getTrackingArray(scope.row.trackingList).length <= 2) ? _c('div', {
          staticClass: "tracking-simple"
        }, _vm._l((_vm.getTrackingArray(scope.row.trackingList)), function(tracking, index) {
          return _c('el-tooltip', {
            key: index,
            attrs: {
              "effect": "dark",
              "content": tracking,
              "placement": "top"
            }
          }, [_c('el-tag', {
            staticClass: "tracking-tag",
            attrs: {
              "size": "mini",
              "type": "info"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.getDisplayTracking(tracking)) + "\n                  ")])], 1)
        }), 1) : _c('div', {
          staticClass: "tracking-with-more"
        }, [_vm._l((_vm.getTrackingArray(scope.row.trackingList).slice(0, 2)), function(tracking, index) {
          return _c('el-tooltip', {
            key: index,
            attrs: {
              "effect": "dark",
              "content": tracking,
              "placement": "top"
            }
          }, [_c('el-tag', {
            staticClass: "tracking-tag",
            attrs: {
              "size": "mini",
              "type": "info"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.getDisplayTracking(tracking)) + "\n                  ")])], 1)
        }), _vm._v(" "), _c('el-popover', {
          attrs: {
            "placement": "top",
            "width": "400",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticClass: "tracking-popover"
        }, [_c('p', {
          staticClass: "popover-title"
        }, [_vm._v("All Related Tracking Numbers (" + _vm._s(_vm.getTrackingArray(scope.row.trackingList).length) + ")")]), _vm._v(" "), _c('div', {
          staticClass: "tracking-grid"
        }, _vm._l((_vm.getTrackingArray(scope.row.trackingList)), function(tracking, index) {
          return _c('el-tag', {
            key: index,
            staticClass: "tracking-tag-full",
            attrs: {
              "size": "small",
              "type": "info"
            }
          }, [_vm._v("\n                        " + _vm._s(tracking) + "\n                      ")])
        }), 1)]), _vm._v(" "), _c('el-tag', {
          staticClass: "tracking-more-tag",
          attrs: {
            "slot": "reference",
            "size": "mini",
            "type": "warning"
          },
          slot: "reference"
        }, [_vm._v("\n                    +" + _vm._s(_vm.getTrackingArray(scope.row.trackingList).length - 2) + " more\n                  ")])], 1)], 2)])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.unclaimedCurrentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.unclaimedSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.unclaimedTotal
    },
    on: {
      "size-change": _vm.handleUnclaimedSizeChange,
      "current-change": _vm.handleUnclaimedCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Import Mixed Packages",
      "width": "80%",
      "visible": _vm.batchImportDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchImportDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "importForm",
    attrs: {
      "model": _vm.importForm,
      "rules": _vm.importRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Batch Number",
      "prop": "batchNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "placeholder": "Loading..."
    },
    model: {
      value: (_vm.importForm.batchNumber),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "batchNumber", $$v)
      },
      expression: "importForm.batchNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select warehouse"
    },
    model: {
      value: (_vm.importForm.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "warehouseNo", $$v)
      },
      expression: "importForm.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse) {
    return _c('el-option', {
      key: warehouse.warehouseNo,
      attrs: {
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address,
        "value": warehouse.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Import Method"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.importForm.importMethod),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "importMethod", $$v)
      },
      expression: "importForm.importMethod"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "text"
    }
  }, [_vm._v("Text Format")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "excel"
    }
  }, [_vm._v("Excel File")])], 1)], 1), _vm._v(" "), (_vm.importForm.importMethod === 'text') ? _c('el-form-item', {
    attrs: {
      "label": "Package Data",
      "prop": "textContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "Format: Tracking,UPC,Quantity or Tracking[Tab]UPC[Tab]Quantity (one per line)&#10;Example: 1Z999AA1234567890,123456789012,2"
    },
    model: {
      value: (_vm.importForm.textContent),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "textContent", $$v)
      },
      expression: "importForm.textContent"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "import-hint"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('span', [_vm._v("Supports multi-line, tab-separated fields, comma-separated, and space-separated formats")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "right",
      "effect": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "tooltip-format-guide"
  }, [_c('div', [_c('strong', [_vm._v("📋 Supported Formats:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("🔹 Multi-line comma-separated (Recommended):")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  1Z999AA1234567890,123456789012,2"), _c('br'), _vm._v("\n                  1Z888BB9876543210,987654321098,1"), _c('br'), _vm._v("\n                  1Z777CC5555555555,456789123456,3\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("🔹 Tab-separated fields (one per line):")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  1Z999AA1234567890[Tab]123456789012[Tab]2"), _c('br'), _vm._v("\n                  1Z888BB9876543210[Tab]987654321098[Tab]1"), _c('br'), _vm._v("\n                  Format: Tracking[Tab]UPC[Tab]Quantity\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("🔹 Space-separated packages (single line):")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  1Z999-AA1234567890,123456789012,2 1Z888-BB9876543210,987654321098,1\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("🔹 With spaces around commas:")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  1Z999-AA1234567890 , 123456789012 , 2"), _c('br'), _vm._v("\n                  1Z888-BB9876543210 , 987654321098 , 1\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#E6A23C"
    }
  }, [_c('strong', [_vm._v("⚠️ Important:")]), _vm._v(" Each package needs exactly 3 fields (Tracking, UPC, Quantity)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#67C23A",
      "margin-top": "8px"
    }
  }, [_c('strong', [_vm._v("✓ Note:")]), _vm._v(" Extra spaces will be automatically cleaned up")])])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question hover-help-icon"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.importForm.importMethod === 'excel') ? _c('el-form-item', {
    attrs: {
      "label": "Excel File",
      "prop": "excelFile"
    }
  }, [_c('el-upload', {
    ref: "excelUpload",
    attrs: {
      "action": _vm.excelUploadUrl,
      "headers": _vm.uploadHeaders,
      "data": _vm.excelUploadData,
      "on-success": _vm.handleExcelUploadSuccess,
      "on-error": _vm.handleExcelUploadError,
      "file-list": _vm.excelFileList,
      "limit": 1,
      "name": "file",
      "accept": ".xlsx,.xls",
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Only .xlsx/.xls files are supported")])]), _vm._v(" "), _c('div', {
    staticClass: "import-hint"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('span', [_vm._v("Excel format: Column A=Tracking, Column B=UPC, Column C=Quantity")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "right",
      "effect": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "tooltip-format-guide"
  }, [_c('div', [_c('strong', [_vm._v("📊 Excel File Requirements:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Required columns (in exact order):")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_c('strong', [_vm._v("Column A:")]), _vm._v(" Tracking Number"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Column B:")]), _vm._v(" UPC Code"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Column C:")]), _vm._v(" Quantity\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Example:")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  A1: 1Z999AA1234567890    B1: 123456789012    C1: 2"), _c('br'), _vm._v("\n                  A2: 1Z888BB9876543210    B2: 987654321098    C2: 1\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#E6A23C"
    }
  }, [_c('strong', [_vm._v("⚠️ Important:")]), _vm._v(" No headers, start with data from row 1")])])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question hover-help-icon"
  })])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeBatchImportDialog
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.importing
    },
    on: {
      "click": _vm.validateImportData
    }
  }, [_vm._v("\n        Import\n      ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "package-detail-dialog",
    attrs: {
      "title": "Package Detail & Management",
      "width": "95%",
      "visible": _vm.batchDetailDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDetailDialogVisible = $event
      }
    }
  }, [(_vm.currentPackageDetail) ? _c('div', [_c('el-card', {
    staticClass: "batch-summary-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "header-title"
  }, [_c('i', {
    staticClass: "el-icon-box"
  }), _vm._v("\n            Package Information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "3px 8px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.refreshPendingPackageDetail
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" Refresh\n            ")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Batch Number:")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "info",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.batchNumber))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Tracking Number:")]), _vm._v(" "), _c('code', {
    staticClass: "tracking-code"
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.tracking))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Total UPC Items:")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.itemCount))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("UPC Types:")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v(_vm._s((_vm.currentPackageDetail.items || []).length))])], 1)])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": _vm.getBatchStatusType(_vm.currentPackageDetail.status)
    }
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.status))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Warehouse:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.warehouseName))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Import Date:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.importDate))])])])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "items-card",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "header-title"
  }, [_c('i', {
    staticClass: "el-icon-goods"
  }), _vm._v("\n            UPC Items Management (" + _vm._s((_vm.currentPackageDetail.items || []).length) + " items)\n          ")]), _vm._v(" "), (_vm.currentPackageDetail.status === 'pending') ? _c('div', {
    staticClass: "header-actions"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-delete",
      "disabled": _vm.selectedUPCs.length === 0
    },
    on: {
      "click": _vm.bulkDeleteUPCs
    }
  }, [_vm._v("\n              Delete Selected (" + _vm._s(_vm.selectedUPCs.length) + ")\n            ")])], 1) : _vm._e()]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.batchDetailLoading),
      expression: "batchDetailLoading"
    }],
    ref: "upcTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.currentPackageDetail.items || [],
      "row-key": "upc"
    },
    on: {
      "selection-change": _vm.handleUPCSelectionChange
    }
  }, [(_vm.currentPackageDetail.status === 'pending') ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC Code",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 3454015104)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name",
      "min-width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.productName) ? _c('span', {
          staticClass: "product-name"
        }, [_vm._v(_vm._s(scope.row.productName))]) : _c('span', {
          staticClass: "no-data"
        }, [_vm._v("No product info")])]
      }
    }], null, false, 1232526568)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Quantity",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "success",
            "size": "medium"
          }
        }, [_vm._v(_vm._s(scope.row.quantity))])]
      }
    }], null, false, 77797758)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.status === 'pending' ? 'warning' : 'success',
            "size": "small"
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.status) + "\n              ")])]
      }
    }], null, false, 2733133994)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "importDate",
      "label": "Import Time",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "import-time"
        }, [_vm._v(_vm._s(scope.row.importDate))])]
      }
    }], null, false, 887448748)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Validation",
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.errorMessage) ? _c('div', {
          staticClass: "validation-error"
        }, [_c('el-tooltip', {
          attrs: {
            "content": scope.row.errorMessage,
            "placement": "top"
          }
        }, [_c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "small"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning"
        }), _vm._v(" Error\n                  ")])], 1)], 1) : _c('div', {
          staticClass: "validation-success"
        }, [_c('el-tag', {
          attrs: {
            "type": "success",
            "size": "small"
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-check"
        }), _vm._v(" Valid\n                ")])], 1)]
      }
    }], null, false, 1424992424)
  }), _vm._v(" "), (_vm.currentPackageDetail.status === 'pending') ? _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "150",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit",
            "title": "Edit this UPC"
          },
          on: {
            "click": function($event) {
              return _vm.editSingleUPC(scope.row, scope.$index)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete",
            "title": "Remove this UPC from package"
          },
          on: {
            "click": function($event) {
              return _vm.deleteSingleUPC(scope.row, scope.$index)
            }
          }
        })]
      }
    }], null, false, 1521781754)
  }) : _vm._e()], 1)], 1)], 1) : _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "el-icon-box"
  }), _vm._v(" "), _c('p', [_vm._v("No package detail available")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "footer-left"
  }, [(_vm.currentPackageDetail && _vm.currentPackageDetail.items) ? _c('span', {
    staticClass: "item-count-info"
  }, [_vm._v("\n          Total: " + _vm._s(_vm.currentPackageDetail.items.length) + " UPC types,\n          " + _vm._s(_vm.currentPackageDetail.items.reduce(function (sum, item) { return sum + item.quantity; }, 0)) + " items\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchDetailDialogVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.currentPackageDetail && _vm.currentPackageDetail.status === 'pending') ? _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-check"
    },
    on: {
      "click": _vm.confirmBatchFromDetail
    }
  }, [_vm._v("\n          Confirm This Package\n        ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk Confirm Packages",
      "width": "70%",
      "visible": _vm.bulkConfirmDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkConfirmDialogVisible = $event
      }
    }
  }, [(_vm.selectedPackages.length > 0) ? _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": ("You are about to confirm " + (_vm.selectedPackages.length) + " package(s)"),
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.selectedPackages
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "batchNumber",
      "label": "Batch Number",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemCount",
      "label": "UPC Items",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseName",
      "label": "Warehouse",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "importDate",
      "label": "Import Date",
      "min-width": "140"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#909399",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("\n        This operation will confirm and create mixed packages from all selected packages. This action cannot be undone.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.bulkConfirmDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.bulkConfirming
    },
    on: {
      "click": _vm.executeBulkConfirm
    }
  }, [_vm._v("\n        Confirm All Packages\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Package Detail",
      "width": "90%",
      "visible": _vm.packageDetailDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.packageDetailDialogVisible = $event
      }
    }
  }, [(_vm.currentPackageDetail) ? _c('div', [_c('el-card', {
    staticClass: "package-info-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v("Package Information")])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.refreshMixedPackageDetail
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" Refresh\n          ")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.packageInfoRows,
      "border": "",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "label1",
      "width": "120",
      "class-name": "info-label-cell"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('strong', [_vm._v(_vm._s(scope.row.label1))])]
      }
    }], null, false, 257521838)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value1",
      "min-width": "160",
      "class-name": "info-value-cell"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.label1 === 'Status:') ? _c('span', [_c('el-tag', {
          attrs: {
            "type": _vm.getPackageStatusType(_vm.currentPackageDetail.packageStatus)
          }
        }, [_vm._v("\n                  " + _vm._s(scope.row.value1) + "\n                ")])], 1) : _c('span', [_vm._v(_vm._s(scope.row.value1))])]
      }
    }], null, false, 3442002515)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "label2",
      "width": "120",
      "class-name": "info-label-cell"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('strong', [_vm._v(_vm._s(scope.row.label2))])]
      }
    }], null, false, 3252667821)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value2",
      "min-width": "160",
      "class-name": "info-value-cell"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "label3",
      "width": "120",
      "class-name": "info-label-cell"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('strong', [_vm._v(_vm._s(scope.row.label3))])]
      }
    }], null, false, 4148063532)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value3",
      "min-width": "160",
      "class-name": "info-value-cell"
    }
  })], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "package-items-card",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v("Package Items")])])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.packageDetailLoading),
      expression: "packageDetailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.currentPackageDetail.details || []
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalQty",
      "label": "Total Qty",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Claimed",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unclaimedQty",
      "label": "Remaining",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: {
            'text-warning': scope.row.unclaimedQty > 0
          }
        }, [_vm._v(_vm._s(scope.row.unclaimedQty))])]
      }
    }], null, false, 3644581712)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "detailStatus",
      "label": "Status",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getDetailStatusTagType(scope.row.detailStatus),
            "size": "small"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.getDetailStatusText(scope.row.detailStatus)) + "\n              ")])]
      }
    }], null, false, 3309153939)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showEditUPCQty(scope.row)
            }
          }
        }, [_vm._v("\n                Edit UPC Qty\n              ")])]
      }
    }], null, false, 496122323)
  })], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "package-claims-card",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v("Claim Records")])])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.packageDetailLoading),
      expression: "packageDetailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.currentPackageDetail.claims || []
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Claimer",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.claimerName))]), _vm._v(" "), _c('el-tag', {
          attrs: {
            "size": "mini",
            "type": scope.row.claimerType === 1 ? 'success' : 'info'
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.claimerTypeDesc) + "\n              ")])]
      }
    }], null, false, 1677758685)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Claimed Qty",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getClaimStatusTagType(scope.row.claimStatus),
            "size": "small"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.getClaimStatusText(scope.row.claimStatus)) + "\n              ")])]
      }
    }], null, false, 2461212755)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimDate",
      "label": "Claim Date",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.formatDate(scope.row.claimDate)) + "\n            ")]
      }
    }], null, false, 3999726357)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Distribute Date",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.distributeDate) ? _c('div', {
          staticClass: "distribute-date"
        }, [_c('i', {
          staticClass: "el-icon-box"
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(scope.row.distributeDate)))])]) : _c('span', {
          staticClass: "note"
        }, [_vm._v("Not distributed")])]
      }
    }], null, false, 851131742)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewReason",
      "label": "Review Note",
      "min-width": "200"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.packageDetailDialogVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.currentPackageDetail && _vm.currentPackageDetail.packageStatus === 'active') ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.reversePackageFromDetail
    }
  }, [_vm._v("\n        Reverse Package\n      ")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Approve Claims",
      "width": "70%",
      "visible": _vm.batchApproveDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchApproveDialogVisible = $event
      }
    }
  }, [(_vm.selectedClaims.length > 0) ? _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": ("You are about to approve " + (_vm.selectedClaims.length) + " claim(s)"),
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.selectedClaims
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "claimId",
      "label": "Claim ID",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Quantity",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimDate",
      "label": "Claim Date",
      "min-width": "140"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "color": "#909399",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "el-icon-info-filled"
  }), _vm._v("\n        This operation will approve all selected claims. Approved claims can then be distributed.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchApproveDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.batchApproving
    },
    on: {
      "click": _vm.executeBatchApprove
    }
  }, [_vm._v("\n        Approve All Claims\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Distribute Claims",
      "width": "70%",
      "visible": _vm.batchDistributeDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDistributeDialogVisible = $event
      }
    }
  }, [(_vm.selectedClaims.length > 0) ? _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": ("You are about to distribute " + (_vm.selectedClaims.length) + " claim(s) to inventory"),
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.selectedClaims
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "claimId",
      "label": "Claim ID",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Quantity",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimStatusDesc",
      "label": "Status",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getClaimStatusType(scope.row.claimStatus),
            "size": "small"
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.claimStatusDesc) + "\n            ")])]
      }
    }], null, false, 3999149988)
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#909399",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("\n        This operation will distribute inventory to claimers and generate FBM records for billing. This action cannot be undone.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchDistributeDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.batchDistributing
    },
    on: {
      "click": _vm.executeBatchDistribute
    }
  }, [_vm._v("\n        Distribute All Claims\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Adjust Claim Quantity",
      "width": "50%",
      "visible": _vm.adjustClaimDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.adjustClaimDialogVisible = $event
      }
    }
  }, [(_vm.currentClaimForAdjust) ? _c('div', [_c('el-form', {
    ref: "adjustForm",
    attrs: {
      "model": _vm.adjustForm,
      "rules": _vm.adjustRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Claim ID:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.claimId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.tracking))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.upc))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Claimer:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.claimerName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Qty:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.claimedQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Quantity:",
      "prop": "newQuantity"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "min": 1,
      "max": _vm.currentClaimForAdjust.availableQty || 999
    },
    model: {
      value: (_vm.adjustForm.newQuantity),
      callback: function($$v) {
        _vm.$set(_vm.adjustForm, "newQuantity", $$v)
      },
      expression: "adjustForm.newQuantity"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#909399"
    }
  }, [_vm._v("\n            Available: " + _vm._s(_vm.currentClaimForAdjust.availableQty || 0) + "\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reason:",
      "prop": "adjustReason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Please explain the reason for quantity adjustment"
    },
    model: {
      value: (_vm.adjustForm.adjustReason),
      callback: function($$v) {
        _vm.$set(_vm.adjustForm, "adjustReason", $$v)
      },
      expression: "adjustForm.adjustReason"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.adjustClaimDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.adjusting
    },
    on: {
      "click": _vm.executeAdjustClaim
    }
  }, [_vm._v("\n        Adjust Quantity\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Reject Claim",
      "width": "50%",
      "visible": _vm.rejectClaimDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectClaimDialogVisible = $event
      }
    }
  }, [(_vm.currentClaimForReject) ? _c('div', [_c('el-form', {
    ref: "rejectForm",
    attrs: {
      "model": _vm.rejectForm,
      "rules": _vm.rejectRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Claim ID:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.claimId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.tracking))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.upc))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Claimer:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.claimerName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.claimedQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reject Reason:",
      "prop": "rejectReason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Please explain why this claim is being rejected"
    },
    model: {
      value: (_vm.rejectForm.rejectReason),
      callback: function($$v) {
        _vm.$set(_vm.rejectForm, "rejectReason", $$v)
      },
      expression: "rejectForm.rejectReason"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.rejectClaimDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.rejecting
    },
    on: {
      "click": _vm.executeRejectClaim
    }
  }, [_vm._v("\n        Reject Claim\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Set Force Charge Time",
      "width": "60%",
      "visible": _vm.forceChargeTimeDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.forceChargeTimeDialogVisible = $event
      }
    }
  }, [(_vm.selectedClaims.length > 0) ? _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": ("Setting force charge time for " + (_vm.selectedClaims.length) + " claim(s)"),
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "forceChargeForm",
    attrs: {
      "model": _vm.forceChargeForm,
      "rules": _vm.forceChargeRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Force Charge Time:",
      "prop": "forceChargeTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select date and time",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.forceChargeForm.forceChargeTime),
      callback: function($$v) {
        _vm.$set(_vm.forceChargeForm, "forceChargeTime", $$v)
      },
      expression: "forceChargeForm.forceChargeTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reason:",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Please explain why force charge time is being set"
    },
    model: {
      value: (_vm.forceChargeForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.forceChargeForm, "reason", $$v)
      },
      expression: "forceChargeForm.reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h4', [_vm._v("Selected Claims:")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.selectedClaims
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "claimId",
      "label": "Claim ID",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimStatusDesc",
      "label": "Status",
      "width": "120",
      "align": "center"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "color": "#909399",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "el-icon-info-filled"
  }), _vm._v("\n        Force charge time will override the normal free storage period. Claims will start incurring storage fees from the specified time.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.forceChargeTimeDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.settingForceCharge
    },
    on: {
      "click": _vm.executeSetForceChargeTime
    }
  }, [_vm._v("\n        Set Force Charge Time\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit UPC Item",
      "visible": _vm.editUPCDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editUPCDialog = $event
      },
      "close": _vm.cancelUPCEdit
    }
  }, [_c('el-form', {
    ref: "editUPCForm",
    attrs: {
      "model": _vm.editUPCForm,
      "rules": _vm.editUPCRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UPC Code",
      "prop": "upc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter UPC code",
      "maxlength": 50,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.editUPCForm.upc),
      callback: function($$v) {
        _vm.$set(_vm.editUPCForm, "upc", $$v)
      },
      expression: "editUPCForm.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1,
      "max": 9999,
      "controls-position": "right"
    },
    model: {
      value: (_vm.editUPCForm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.editUPCForm, "quantity", $$v)
      },
      expression: "editUPCForm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "placeholder": "Original UPC code"
    },
    model: {
      value: (_vm.editUPCForm.originalUpc),
      callback: function($$v) {
        _vm.$set(_vm.editUPCForm, "originalUpc", $$v)
      },
      expression: "editUPCForm.originalUpc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Qty"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": true,
      "controls-position": "right"
    },
    model: {
      value: (_vm.editUPCForm.originalQuantity),
      callback: function($$v) {
        _vm.$set(_vm.editUPCForm, "originalQuantity", $$v)
      },
      expression: "editUPCForm.originalQuantity"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelUPCEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.savingUPCEdit
    },
    on: {
      "click": _vm.saveUPCEdit
    }
  }, [_vm._v("\n        Save Changes\n      ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Create Mixed Package",
      "visible": _vm.createPackageDialog,
      "width": "760px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.createPackageDialog = $event
      },
      "close": _vm.resetCreateForm
    }
  }, [_c('el-form', {
    ref: "createPackageForm",
    attrs: {
      "model": _vm.createPackageForm,
      "rules": _vm.createPackageRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking #",
      "prop": "tracking"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "570px"
    },
    attrs: {
      "placeholder": "Enter tracking number"
    },
    model: {
      value: (_vm.createPackageForm.tracking),
      callback: function($$v) {
        _vm.$set(_vm.createPackageForm, "tracking", $$v)
      },
      expression: "createPackageForm.tracking"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "570px"
    },
    attrs: {
      "placeholder": "Select warehouse"
    },
    model: {
      value: (_vm.createPackageForm.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.createPackageForm, "warehouseNo", $$v)
      },
      expression: "createPackageForm.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address,
        "value": warehouse.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Items"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "570px"
    },
    attrs: {
      "data": _vm.createPackageForm.items,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "UPC",
      "prop": "upc",
      "width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "Enter UPC"
          },
          model: {
            value: (scope.row.upc),
            callback: function($$v) {
              _vm.$set(scope.row, "upc", $$v)
            },
            expression: "scope.row.upc"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quantity",
      "prop": "qty",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "min": 1,
            "placeholder": "Qty"
          },
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "140px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removePackageItem(scope.$index)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPackageItem
    }
  }, [_vm._v("Add Item")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelCreatePackage
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.createPackageLoading
    },
    on: {
      "click": _vm.createMixedPackage
    }
  }, [_vm._v("Create")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Adjust Claim Quantity",
      "visible": _vm.adjustQuantityDialog,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.adjustQuantityDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "adjustQuantityForm",
    attrs: {
      "model": _vm.adjustQuantityForm,
      "rules": _vm.adjustQuantityRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Original Qty"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.adjustQuantityForm.originalQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Quantity",
      "prop": "newQuantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.adjustQuantityForm.maxQty,
      "placeholder": "New quantity"
    },
    model: {
      value: (_vm.adjustQuantityForm.newQuantity),
      callback: function($$v) {
        _vm.$set(_vm.adjustQuantityForm, "newQuantity", $$v)
      },
      expression: "adjustQuantityForm.newQuantity"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "5px",
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_vm._v("\n          Max adjustable: " + _vm._s(_vm.adjustQuantityForm.maxQty) + "\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reason (Optional)",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Enter adjustment reason (optional)"
    },
    model: {
      value: (_vm.adjustQuantityForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.adjustQuantityForm, "reason", $$v)
      },
      expression: "adjustQuantityForm.reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.adjustQuantityDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.adjustQuantityLoading
    },
    on: {
      "click": _vm.confirmAdjustQuantity
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Reject Claim",
      "visible": _vm.rejectClaimDialog,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectClaimDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "rejectClaimForm",
    attrs: {
      "model": _vm.rejectClaimForm,
      "rules": _vm.rejectClaimRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Reason",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Please enter rejection reason"
    },
    model: {
      value: (_vm.rejectClaimForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.rejectClaimForm, "reason", $$v)
      },
      expression: "rejectClaimForm.reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.rejectClaimDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.rejectClaimLoading
    },
    on: {
      "click": _vm.confirmRejectClaim
    }
  }, [_vm._v("Reject")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Distribute Inventory",
      "visible": _vm.singleDistributeDialog,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.singleDistributeDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Claim Information")]), _vm._v(" "), (_vm.singleDistributeClaim) ? _c('div', {
    staticStyle: {
      "background": "#f5f7fa",
      "padding": "15px",
      "border-radius": "4px",
      "margin-bottom": "20px"
    }
  }, [_c('p', [_c('strong', [_vm._v("Tracking:")]), _vm._v(" " + _vm._s(_vm.singleDistributeClaim.tracking))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("UPC:")]), _vm._v(" " + _vm._s(_vm.singleDistributeClaim.upc))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Quantity:")]), _vm._v(" " + _vm._s(_vm.singleDistributeClaim.claimedQty))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Claimer:")]), _vm._v(" " + _vm._s(_vm.singleDistributeClaim.claimerName) + " (" + _vm._s(_vm.singleDistributeClaim.claimerTypeDesc) + ")")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Current Charge Time:")]), _vm._v(" "), (_vm.singleDistributeClaim.forceChargeTime) ? _c('span', {
    staticClass: "charge-time-forced"
  }, [_vm._v("\n            " + _vm._s(_vm.formatDate(_vm.singleDistributeClaim.forceChargeTime)) + "\n          ")]) : _c('span', {
    staticClass: "charge-time-normal"
  }, [_vm._v("Normal Period")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Charge Strategy Setting")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.singleDistributeForm.chargeTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.singleDistributeForm, "chargeTimeOption", $$v)
      },
      expression: "singleDistributeForm.chargeTimeOption"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "normal"
    }
  }, [_vm._v("Use normal free period (Product > User > Default 3 months)")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "immediate"
    }
  }, [_vm._v("Start charging immediately")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("Custom charge start time")])], 1)]), _vm._v(" "), (_vm.singleDistributeForm.chargeTimeOption === 'custom') ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select charge start time",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.singleDistributeForm.customChargeTime),
      callback: function($$v) {
        _vm.$set(_vm.singleDistributeForm, "customChargeTime", $$v)
      },
      expression: "singleDistributeForm.customChargeTime"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.singleDistributeDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.singleDistributeLoading
    },
    on: {
      "click": _vm.confirmSingleDistribute
    }
  }, [_vm._v("\n        Confirm Distribute\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Distribute Inventory",
      "visible": _vm.batchDistributeDialog,
      "width": "900px"
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDistributeDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Selected Claims (" + _vm._s(_vm.selectedClaims.length) + " items)")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.selectedClaims,
      "size": "small",
      "max-height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Qty",
      "width": "60",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Current Charge Time",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "datetime",
            "placeholder": "Select charge time",
            "format": "yyyy-MM-dd HH:mm:ss",
            "value-format": "yyyy-MM-dd HH:mm:ss",
            "size": "mini",
            "clearable": ""
          },
          model: {
            value: (scope.row.editableChargeTime),
            callback: function($$v) {
              _vm.$set(scope.row, "editableChargeTime", $$v)
            },
            expression: "scope.row.editableChargeTime"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Batch Charge Time Setting")]), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "title": "Select a batch setting option and click Apply to quickly fill all Current Charge Time values in the table above. You can then adjust individual values before confirming.",
      "type": "info",
      "closable": false
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start",
      "gap": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "8px"
    },
    model: {
      value: (_vm.batchDistributeForm.chargeTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.batchDistributeForm, "chargeTimeOption", $$v)
      },
      expression: "batchDistributeForm.chargeTimeOption"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "normal"
    }
  }, [_vm._v("Use normal free period (Product > User > Default 3 months)")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "immediate"
    }
  }, [_vm._v("Start charging immediately")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("Custom charge start time")])], 1), _vm._v(" "), (_vm.batchDistributeForm.chargeTimeOption === 'custom') ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select charge start time",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.batchDistributeForm.customChargeTime),
      callback: function($$v) {
        _vm.$set(_vm.batchDistributeForm, "customChargeTime", $$v)
      },
      expression: "batchDistributeForm.customChargeTime"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.batchDistributeForm.chargeTimeOption || (_vm.batchDistributeForm.chargeTimeOption === 'custom' && !_vm.batchDistributeForm.customChargeTime)
    },
    on: {
      "click": _vm.applyBatchChargeTime
    }
  }, [_vm._v("\n            Apply to All\n          ")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchDistributeDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.batchDistributeLoading
    },
    on: {
      "click": _vm.confirmBatchDistribute
    }
  }, [_vm._v("\n        Confirm Distribute\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Set Force Charge Time",
      "visible": _vm.setChargeTimeDialog,
      "width": "900px"
    },
    on: {
      "update:visible": function($event) {
        _vm.setChargeTimeDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Editable Claims (" + _vm._s(_vm.editableClaimIds.length) + " items)")]), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "title": "Note: Only approved and quantity-adjusted claims can have their charge time modified before distribution.",
      "type": "info",
      "closable": false
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.editableClaims,
      "size": "small",
      "max-height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Qty",
      "width": "60",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Current Charge Time",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "datetime",
            "placeholder": "Select charge time",
            "format": "yyyy-MM-dd HH:mm:ss",
            "value-format": "yyyy-MM-dd HH:mm:ss",
            "size": "mini",
            "clearable": ""
          },
          model: {
            value: (scope.row.editableChargeTime),
            callback: function($$v) {
              _vm.$set(scope.row, "editableChargeTime", $$v)
            },
            expression: "scope.row.editableChargeTime"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Batch Charge Time Setting")]), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "title": "Select a batch setting option and click Apply to quickly fill all Current Charge Time values in the table above. You can then adjust individual values before confirming.",
      "type": "info",
      "closable": false
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start",
      "gap": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "8px"
    },
    model: {
      value: (_vm.setChargeTimeForm.chargeTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.setChargeTimeForm, "chargeTimeOption", $$v)
      },
      expression: "setChargeTimeForm.chargeTimeOption"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "normal"
    }
  }, [_vm._v("Restore to normal free period")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "immediate"
    }
  }, [_vm._v("Start charging immediately")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("Set custom charge start time")])], 1), _vm._v(" "), (_vm.setChargeTimeForm.chargeTimeOption === 'custom') ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select charge start time",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.setChargeTimeForm.customChargeTime),
      callback: function($$v) {
        _vm.$set(_vm.setChargeTimeForm, "customChargeTime", $$v)
      },
      expression: "setChargeTimeForm.customChargeTime"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.setChargeTimeForm.chargeTimeOption || (_vm.setChargeTimeForm.chargeTimeOption === 'custom' && !_vm.setChargeTimeForm.customChargeTime)
    },
    on: {
      "click": _vm.applyBatchChargeTimeSetting
    }
  }, [_vm._v("\n            Apply to All\n          ")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.setChargeTimeDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.setChargeTimeLoading
    },
    on: {
      "click": _vm.confirmSetChargeTime
    }
  }, [_vm._v("\n        Confirm Setting\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Claim Detail",
      "visible": _vm.claimDetailDialog,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.claimDetailDialog = $event
      },
      "close": _vm.onClaimDetailClose
    }
  }, [(_vm.claimDetail) ? _c('div', [_c('el-descriptions', {
    staticClass: "claim-detail-descriptions",
    attrs: {
      "title": "Claim Information",
      "column": 3,
      "border": ""
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label": "Tracking #",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.tracking))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "UPC",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.upc))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Claimer",
      "label-class-name": "claim-label"
    }
  }, [_c('div', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.claimDetail.claimerName))])]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": _vm.claimDetail.claimerType === 1 ? 'success' : 'info'
    }
  }, [_vm._v("\n              " + _vm._s(_vm.claimDetail.claimerTypeDesc) + "\n            ")])], 1)]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Product Name",
      "span": 3,
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.productName) ? _c('div', {
    staticClass: "product-name-container"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.claimDetail.productName,
      "placement": "top-start"
    }
  }, [_c('span', {
    staticClass: "product-name-text"
  }, [_vm._v(_vm._s(_vm.claimDetail.productName))])])], 1) : _c('span', {
    staticClass: "note"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Claimed Qty",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.claimedQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Total Available",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.totalQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Unclaimed Qty",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.unclaimedQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Claim Date",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.claimDetail.claimDate)))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Status",
      "label-class-name": "claim-label"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.getClaimStatusTagType(_vm.claimDetail.claimStatus)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getClaimStatusText(_vm.claimDetail.claimStatus)) + "\n          ")])], 1), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Charge Time",
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.forceChargeTime) ? _c('div', {
    staticClass: "charge-time-forced"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v("\n            Force: " + _vm._s(_vm.formatDate(_vm.claimDetail.forceChargeTime)) + "\n          ")]) : _c('div', {
    staticClass: "charge-time-normal"
  }, [_c('i', {
    staticClass: "el-icon-clock"
  }), _vm._v("\n            Normal Period\n          ")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Review Date",
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.reviewDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.claimDetail.reviewDate)))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("Not reviewed yet")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Reviewed By",
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.reviewByName) ? _c('span', [_vm._v(_vm._s(_vm.claimDetail.reviewByName))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Distribute Date",
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.distributeDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.claimDetail.distributeDate)))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("Not distributed yet")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Review Note",
      "span": 3,
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.reviewReason) ? _c('p', [_vm._v(_vm._s(_vm.claimDetail.reviewReason))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("No review note")])])], 1)], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "40px"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#909399",
      "font-size": "14px"
    }
  }, [_vm._v("No claim detail data available")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk Reverse by Batch",
      "width": "80%",
      "visible": _vm.batchBulkReverseDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchBulkReverseDialogVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkReverse
    },
    model: {
      value: (_vm.selectedBatchNumber),
      callback: function($$v) {
        _vm.selectedBatchNumber = $$v
      },
      expression: "selectedBatchNumber"
    }
  }, _vm._l((_vm.availableBatchNumbers), function(batch, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": batch,
        "label": batch
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.batchPackagesLoading),
      expression: "batchPackagesLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.batchPackagesList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Items Status",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Total: " + _vm._s(scope.row.totalItems) + " items")]), _vm._v(" "), _c('p', [_vm._v("Claimed: " + _vm._s(scope.row.claimedItems) + " items")]), _vm._v(" "), _c('p', [_vm._v("Remaining: " + _vm._s(scope.row.unclaimedItems) + " items")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Package Status",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getStatusTagType(scope.row.packageStatus),
            "size": "small"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.getStatusText(scope.row.packageStatus)) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.formatDate(scope.row.createDate)))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("by " + _vm._s(scope.row.createUserName))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchBulkReverseDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.batchBulkReverseLoading,
      "disabled": !_vm.selectedBatchNumber || _vm.batchPackagesList.length === 0
    },
    on: {
      "click": _vm.executeBatchBulkReverse
    }
  }, [_vm._v("\n        Bulk Reverse (" + _vm._s(_vm.batchPackagesList.length) + " packages)\n      ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit UPC Quantity in Mixed Package",
      "visible": _vm.editMixedPackageUPCQtyDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editMixedPackageUPCQtyDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "editMixedPackageUPCQtyForm",
    attrs: {
      "model": _vm.editMixedPackageUPCQtyForm,
      "rules": _vm.editMixedPackageUPCQtyRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editMixedPackageUPCQtyForm.upc))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editMixedPackageUPCQtyForm.productName || 'N/A'))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Current Total Qty"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editMixedPackageUPCQtyForm.currentTotalQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Claimed Qty"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editMixedPackageUPCQtyForm.claimedQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Total Qty",
      "prop": "newTotalQty"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": _vm.editMixedPackageUPCQtyForm.claimedQty,
      "max": 99999,
      "placeholder": "Enter new total quantity"
    },
    model: {
      value: (_vm.editMixedPackageUPCQtyForm.newTotalQty),
      callback: function($$v) {
        _vm.$set(_vm.editMixedPackageUPCQtyForm, "newTotalQty", $$v)
      },
      expression: "editMixedPackageUPCQtyForm.newTotalQty"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "5px",
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_vm._v("\n          Note: New total quantity cannot be less than claimed quantity (" + _vm._s(_vm.editMixedPackageUPCQtyForm.claimedQty) + ")\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editMixedPackageUPCQtyDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editingMixedPackageUPCQty
    },
    on: {
      "click": _vm.confirmEditMixedPackageUPCQty
    }
  }, [_vm._v("\n        Confirm\n      ")])], 1)], 1), _vm._v(" "), _c('ImportResultDialog', {
    attrs: {
      "visible": _vm.importResultDialogVisible,
      "result": _vm.importResultData
    },
    on: {
      "update:visible": function($event) {
        _vm.importResultDialogVisible = $event
      },
      "continue": _vm.handleImportContinue,
      "retry-failed": _vm.handleRetryFailed,
      "close": _vm.handleImportResultClose
    }
  }), _vm._v(" "), _c('BulkConfirmResultDialog', {
    attrs: {
      "visible": _vm.bulkConfirmResultDialogVisible,
      "result": _vm.bulkConfirmResultData
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkConfirmResultDialogVisible = $event
      },
      "continue": _vm.handleBulkConfirmContinue,
      "retry-failed": _vm.handleBulkConfirmRetryFailed,
      "close": _vm.handleBulkConfirmResultClose
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Nurse Payment Requests",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentFilter", $$v)
      },
      expression: "filters.paymentFilter"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentStatus", $$v)
      },
      expression: "filters.paymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportPaymentRequest', 'Active Offer.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAdjust()
      }
    }
  }, [_vm._v("Adjust Balance")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.payments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseNote",
      "label": "Nurse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.nurseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.requestPayment(scope.row.paymentNo)
            }
          }
        }, [_vm._v("Pay")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editPaymentStatus(scope.row.paymentNo, 4)
            }
          }
        }, [_vm._v("\n                                Reject\n                            ")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Pending Transactions",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.pendingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pendingFilter", $$v)
      },
      expression: "filters.pendingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPendingTransaction
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getPendingTransaction
    },
    model: {
      value: (_vm.filters.pendingUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pendingUser", $$v)
      },
      expression: "filters.pendingUser"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.pendingPayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "offerNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.pendingTotal
    },
    on: {
      "current-change": _vm.changePendingRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Transaction",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getTransactionHistory
    },
    model: {
      value: (_vm.filters.currentUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "currentUser", $$v)
      },
      expression: "filters.currentUser"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search Product Name, Note, Account etc.",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTransactionHistory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportTransactionHistory
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.transactions,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateTime",
      "label": "Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Transaction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'transaction') ? _c('div', [_c('p', [_vm._v("For " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'reported') ? _c('div', [_c('p', [_vm._v("Reported for " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'adjust') ? _c('div', [(scope.row.amount > 0) ? _c('p', [_vm._v("Increase Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), (scope.row.amount <= 0) ? _c('p', [_vm._v("Decrease Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.type == 'payment') ? _c('div', [_c('p', [_vm._v("Withdraw to " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime) + "\n                                    "), (scope.row.status === 0) ? _c('span', [_vm._v("(waiting for pay)")]) : (scope.row.status === 1) ? _c('span', [_vm._v("(paid)")]) : (scope.row.status === 2) ? _c('span', [_vm._v("(canceled)")]) : (scope.row.status === 3) ? _c('span', [_vm._v("(rollover)")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.amount >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.amount, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.amount, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Balance",
      "prop": "balance"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Nurse",
      "prop": "nurseName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeTransactionHistory
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Balance",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getBalance
    },
    model: {
      value: (_vm.filters.balanceFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "balanceFilter", $$v)
      },
      expression: "filters.balanceFilter"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.balances,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "Balance"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.total >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.total, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.total, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pendingAmount",
      "label": "Pending"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pendingAmount >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.pendingAmount, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.pendingAmount, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requestAmount",
      "label": "Requestable"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.requestAmount >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.requestAmount, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.requestAmount, 2)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.balanceTotal
    },
    on: {
      "current-change": _vm.changeBalance
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Warehouse fee payment",
      "name": "fifth"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fifthListLoading),
      expression: "fifthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.storageFeePayments,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportMonth",
      "label": "Report Month"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payStatus",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payStatus == 0 && scope.row.totalFee > 0) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Created")]) : (scope.row.payStatus == 0 && scope.row.totalFee <= 0) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("No need to pay")]) : (scope.row.payStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")]) : (scope.row.payStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Canceled")]) : (scope.row.payStatus == 3) ? _c('el-tag', [_vm._v("Archived")]) : (scope.row.payStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")]) : (scope.row.payStatus == 5) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Requested")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.totalFee > 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.showAddWarehousePayment(scope.row.id)
            }
          }
        }, [_vm._v("to Pay")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentSummary(scope.row.id)
            }
          }
        }, [_vm._v("\n                                Detail\n                            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.storageFeePaymentTotal
    },
    on: {
      "current-change": _vm.changeStorageFeePayment
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Payment List",
      "width": "80%",
      "visible": _vm.paymentListVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.paymentListVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest4Warehouse()
      }
    },
    model: {
      value: (_vm.filters.warehousePaymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "warehousePaymentStatus", $$v)
      },
      expression: "filters.warehousePaymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.paymentLoading),
      expression: "paymentLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehousePayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Apply amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseNote",
      "label": "Warehouse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.warehouseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 5) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Requested")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.requestWarehousePayment(scope.row.paymentNo)
            }
          }
        }, [_vm._v("Pay")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.editWarehousePaymentStatus(scope.row.paymentNo, 4)
            }
          }
        }, [_vm._v("\n                            Reject\n                        ")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.paymentListVisible = false;
        _vm.filters.paymentStatus = '';
        _vm.getStorageFeePaymentList();
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Confirm a payment",
      "width": "80%",
      "visible": _vm.requestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "220px",
      "rules": _vm.payRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "nurseName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.payment.nurseName),
      callback: function($$v) {
        _vm.$set(_vm.payment, "nurseName", $$v)
      },
      expression: "payment.nurseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.payment.bank),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bank", $$v)
      },
      expression: "payment.bank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Address",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.payment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bankAddress", $$v)
      },
      expression: "payment.bankAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.payment.note),
      callback: function($$v) {
        _vm.$set(_vm.payment, "note", $$v)
      },
      expression: "payment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.pay.apply(null, arguments)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Confirm a payment 4 warehouse",
      "width": "80%",
      "visible": _vm.warehouseRequestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseRequestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehousePayment",
    attrs: {
      "model": _vm.warehousePayment,
      "label-width": "220px",
      "rules": _vm.payRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "warehouseUserName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehousePayment.warehouseUserName),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "warehouseUserName", $$v)
      },
      expression: "warehousePayment.warehouseUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total Amount",
      "prop": "totalFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.warehousePayment.totalFee),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "totalFee", $$v)
      },
      expression: "warehousePayment.totalFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payable amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.warehousePayment.amount),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "amount", $$v)
      },
      expression: "warehousePayment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.warehousePayment.bank),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "bank", $$v)
      },
      expression: "warehousePayment.bank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Address",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.warehousePayment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "bankAddress", $$v)
      },
      expression: "warehousePayment.bankAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse Note",
      "prop": "warehouseNote"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    staticStyle: {
      "background-color": "#F5F7FA"
    },
    attrs: {
      "disabled": true,
      "options": _vm.readOlnyEditorOption,
      "type": "textarea"
    },
    model: {
      value: (_vm.warehousePayment.warehouseNote),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "warehouseNote", $$v)
      },
      expression: "warehousePayment.warehouseNote"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.warehousePayment.note),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "note", $$v)
      },
      expression: "warehousePayment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseRequestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toWarehousePay.apply(null, arguments)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Adjust Balance",
      "width": "80%",
      "visible": _vm.adjustVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.adjustVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "adjust",
    attrs: {
      "model": _vm.adjust,
      "label-width": "220px",
      "rules": _vm.adjustRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "nurseId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getNusreBalance
    },
    model: {
      value: (_vm.adjust.nurseId),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "nurseId", $$v)
      },
      expression: "adjust.nurseId"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total Balance",
      "prop": "balance"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.adjust.balance),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "balance", $$v)
      },
      expression: "adjust.balance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.adjust.amount),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "amount", $$v)
      },
      expression: "adjust.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-radio', {
    attrs: {
      "label": 1,
      "che": ""
    },
    model: {
      value: (_vm.adjust.type),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "type", $$v)
      },
      expression: "adjust.type"
    }
  }, [_vm._v("Decrease Balance")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.adjust.type),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "type", $$v)
      },
      expression: "adjust.type"
    }
  }, [_vm._v("Increase Balance")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.adjust.note),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "note", $$v)
      },
      expression: "adjust.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.adjustVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addAdjust.apply(null, arguments)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Detail",
      "width": "80%",
      "visible": _vm.warehouseFeeDetailModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeDetailModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.productName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productName", $$v)
      },
      expression: "filters.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.postExportExcel('/excel/exportWarehouseFeeDetail', 'Warehouse Fee Detail.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter Fee Type",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.feeType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "feeType", $$v)
      },
      expression: "filters.feeType"
    }
  }, _vm._l((_vm.feeTypeList), function(fee, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": fee.value,
        "value": fee.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeLoading),
      expression: "warehouseFeeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "feeType",
      "label": "Fee Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.feeType == 0) ? _c('p', [_vm._v("Inbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 1) ? _c('p', [_vm._v("Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 2) ? _c('p', [_vm._v("Storage")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productSize",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFee",
      "label": "Storage Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFeeOver",
      "label": "Storage > Years Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Storage Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundQty",
      "label": "Inbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundQty",
      "label": "Outbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceFee",
      "label": "Service Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceType",
      "label": "Service Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceQty",
      "label": "Service Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.totalFee, 5)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.inboundDate)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.reportDate)) + "\n                    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeDetailTotal,
      "current-page": _vm.warehouseFeeDetailPage
    },
    on: {
      "current-change": _vm.changeWarehouseFeeDetail,
      "update:currentPage": function($event) {
        _vm.warehouseFeeDetailPage = $event
      },
      "update:current-page": function($event) {
        _vm.warehouseFeeDetailPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeDetailModelVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Summary",
      "width": "80%",
      "visible": _vm.warehouseFeeSummaryModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeSummaryModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    model: {
      value: (_vm.filters.conditionSearch),
      callback: function($$v) {
        _vm.$set(_vm.filters, "conditionSearch", $$v)
      },
      expression: "filters.conditionSearch"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.postExportExcel('/excel/exportWarehouseFeeSummary', 'Warehouse Fee Summary.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeSummaryLoading),
      expression: "warehouseFeeSummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeSummary,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productNo",
      "label": "Product No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.inboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.outboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFee",
      "label": "Storage Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.storageFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentDetail(scope.row.productNo, 1)
            }
          }
        }, [_vm._v("\n                            Detail\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeSummaryTotal
    },
    on: {
      "current-change": _vm.changeWarehouseFeeSummary
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeSummaryModelVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAdd
    }
  }, [_vm._v("Add Category")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showUserRate
    }
  }, [_vm._v("User Rate")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.boxSizes,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sizeDefined",
      "label": "Full Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sizeLabel",
      "label": "Short Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundBaseFee",
      "label": "Inbound Base Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundBaseFee",
      "label": "Outbound Base Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFee",
      "label": "Storage Base Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFeeOver",
      "label": "Storage Base Fee > Years"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isPrintBarCode",
      "label": "Print Bar Code",
      "formatter": _vm.formatPrintStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Category",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addCategory",
    attrs: {
      "model": _vm.addCategory,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Label",
      "prop": "sizeLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addCategory.sizeLabel),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "sizeLabel", $$v)
      },
      expression: "addCategory.sizeLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full Label",
      "prop": "sizeDefined"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addCategory.sizeDefined),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "sizeDefined", $$v)
      },
      expression: "addCategory.sizeDefined"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Base Fee",
      "prop": "inboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.inboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "inboundBaseFee", $$v)
      },
      expression: "addCategory.inboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Rate",
      "prop": "inboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.inboundRate),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "inboundRate", $$v)
      },
      expression: "addCategory.inboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Base Fee",
      "prop": "outboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.outboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "outboundBaseFee", $$v)
      },
      expression: "addCategory.outboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Rate",
      "prop": "outboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.outboundRate),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "outboundRate", $$v)
      },
      expression: "addCategory.outboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee",
      "prop": "storageBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.storageBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "storageBaseFee", $$v)
      },
      expression: "addCategory.storageBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee >Years",
      "prop": "storageBaseFeeOver"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.storageBaseFeeOver),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "storageBaseFeeOver", $$v)
      },
      expression: "addCategory.storageBaseFeeOver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Print Bar Code",
      "prop": "isPrintBarCode"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Print Bar Code",
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.addCategory.isPrintBarCode),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "isPrintBarCode", $$v)
      },
      expression: "addCategory.isPrintBarCode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "Printed"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 0,
      "label": "Not Print"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddBoxSize.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Category",
      "width": "80%",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editCategory",
    attrs: {
      "model": _vm.editCategory,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Label",
      "prop": "sizeLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editCategory.sizeLabel),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "sizeLabel", $$v)
      },
      expression: "editCategory.sizeLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full Label",
      "prop": "sizeDefined"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editCategory.sizeDefined),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "sizeDefined", $$v)
      },
      expression: "editCategory.sizeDefined"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Base Fee",
      "prop": "inboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.inboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "inboundBaseFee", $$v)
      },
      expression: "editCategory.inboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Rate",
      "prop": "inboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.inboundRate),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "inboundRate", $$v)
      },
      expression: "editCategory.inboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Base Fee",
      "prop": "outboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.outboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "outboundBaseFee", $$v)
      },
      expression: "editCategory.outboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Rate",
      "prop": "outboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.outboundRate),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "outboundRate", $$v)
      },
      expression: "editCategory.outboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee",
      "prop": "storageBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.storageBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "storageBaseFee", $$v)
      },
      expression: "editCategory.storageBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee >Years",
      "prop": "storageBaseFeeOver"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.storageBaseFeeOver),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "storageBaseFeeOver", $$v)
      },
      expression: "editCategory.storageBaseFeeOver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Print Bar Code",
      "prop": "isPrintBarCode"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Print Bar Code",
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.editCategory.isPrintBarCode),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "isPrintBarCode", $$v)
      },
      expression: "editCategory.isPrintBarCode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "Printed"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 0,
      "label": "Not Print"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "User Rate List",
      "width": "80%",
      "visible": _vm.userRateVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.userRateVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.userRates,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hasSingleSeted",
      "label": "Has bean set"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.hasSingleSeted ? "Already Set" : "Not Set") + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showCategoryEdit(scope.row.doctorNo)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.userRateVisible = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Category Set",
      "width": "80%",
      "visible": _vm.customCategoryVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customCategoryVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customCategoryConfigs,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sizeDefined",
      "label": "Full Label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.sizeDefined) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sizeLabel",
      "label": "Short Label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.sizeLabel) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundBaseFee",
      "label": "Inbound Base Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.inboundBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.inboundRate) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundBaseFee",
      "label": "Outbound Base Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.outboundBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.outboundRate) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFee",
      "label": "Storage Base Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.storageBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFeeOver",
      "label": "Storage Base Fee > Years"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.storageBaseFeeOver) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showCustomEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), (scope.row.hasSingleSeted) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCustomItem(scope.row)
            }
          }
        }, [_vm._v("Restore")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customCategoryVisible = false;
        _vm.getAllUserRate()
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Edit Category",
      "width": "80%",
      "visible": _vm.customEditVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customEditVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "customEditCategory",
    attrs: {
      "model": _vm.customEditCategory,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Label",
      "prop": "sizeLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.customEditCategory.sizeLabel),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "sizeLabel", $$v)
      },
      expression: "customEditCategory.sizeLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full Label",
      "prop": "sizeDefined"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.customEditCategory.sizeDefined),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "sizeDefined", $$v)
      },
      expression: "customEditCategory.sizeDefined"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Base Fee",
      "prop": "inboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.inboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "inboundBaseFee", $$v)
      },
      expression: "customEditCategory.inboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Rate",
      "prop": "inboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.inboundRate),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "inboundRate", $$v)
      },
      expression: "customEditCategory.inboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Base Fee",
      "prop": "outboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.outboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "outboundBaseFee", $$v)
      },
      expression: "customEditCategory.outboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Rate",
      "prop": "outboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.outboundRate),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "outboundRate", $$v)
      },
      expression: "customEditCategory.outboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee",
      "prop": "storageBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.storageBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "storageBaseFee", $$v)
      },
      expression: "customEditCategory.storageBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee >Years",
      "prop": "storageBaseFeeOver"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.storageBaseFeeOver),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "storageBaseFeeOver", $$v)
      },
      expression: "customEditCategory.storageBaseFeeOver"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customEditVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.customEditLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.customEditSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 8
    }
  }, [_c('el-dropdown', {
    staticClass: "pull-right",
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o user-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("Logout")])], 1)], 1), _vm._v(" "), (_vm.user.roleId == 2 || _vm.user.roleId == 3) ? _c('el-select', {
    staticClass: "pull-right",
    attrs: {
      "size": "small",
      "placeholder": "Company"
    },
    on: {
      "change": _vm.changeDoctor
    },
    model: {
      value: (_vm.currentCompany),
      callback: function($$v) {
        _vm.currentCompany = $$v
      },
      expression: "currentCompany"
    }
  }, _vm._l((_vm.doctors), function(doctor, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": doctor.userName,
        "value": doctor.userNo
      }
    })
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo el-menu-open",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    }
  }, [_vm._l((_vm.getRoutes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "el-menu-item"
    }, [_c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 10
      }
    }, [_c('i', {
      class: item.iconCls,
      staticStyle: {
        "margin-left": "12px"
      }
    })]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "span": 14
      }
    }, [_vm._v(_vm._s(item.name))])], 1)]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_c('el-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 10
        }
      }, [_c('i', {
        class: child.iconCls
      })]), _vm._v(" "), _c('el-col', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "span": 14
        }
      }, [_vm._v(_vm._s(child.name))])], 1) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 10
      }
    }, [_c('i', {
      class: item.iconCls,
      staticStyle: {
        "margin-left": "12px"
      }
    })]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "span": 14
      }
    }, [_vm._v(_vm._s(item.children[0].name))])], 1) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.getRoutes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    ref: "child",
    attrs: {
      "current-company": _vm.currentCompany
    }
  })], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To anyone",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "outbound",
    attrs: {
      "model": _vm.outbound,
      "label-position": "top",
      "label-width": "220px"
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("Outbound items")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-left": "20px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.showAddInventory
    }
  }, [_vm._v("Add Product")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changeCustomizationPage(1)
      }
    }
  }, [_vm._v("Add customization Product")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.outbound.items,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h3', [_vm._v(_vm._s(scope.row.productNme))]), _vm._v(" "), (scope.row.mainProductName) ? _c('h3', [_vm._v(_vm._s("Main Product : " + scope.row.mainProductName))]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _vm._l((scope.row.items), function(sub, index) {
          return _c('p', {
            key: index,
            staticClass: "note",
            staticStyle: {
              "margin-bottom": "2px"
            }
          }, [_vm._v("\n                                        " + _vm._s(sub.qty) + " x " + _vm._s(sub.productName) + "(" + _vm._s(sub.upc) + ") "), (sub.service && sub.service !== 'None') ? _c('span', {
            staticStyle: {
              "color": "#ff2218"
            }
          }, [_vm._v(_vm._s(sub.service))]) : _vm._e()])
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "To ship",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          attrs: {
            "min": 1,
            "max": scope.row.qty ? parseInt(scope.row.qty) : 99999
          },
          model: {
            value: (scope.row.toShip),
            callback: function($$v) {
              _vm.$set(scope.row, "toShip", $$v)
            },
            expression: "scope.row.toShip"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "width": "100px",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeInventory(scope.row)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Package Label"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "auto-upload": false,
      "name": "file",
      "drag": "",
      "action": _vm.uploadUrl,
      "http-request": _vm.upload,
      "file-list": _vm.fileList,
      "headers": _vm.headers
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("click to upload")]), _vm._v(" or drag and drop file")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking number",
      "prop": "trackingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.trackingNumber),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "trackingNumber", $$v)
      },
      expression: "outbound.trackingNumber"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Optional.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Carrier",
      "prop": "carrier"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.carrier),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "carrier", $$v)
      },
      expression: "outbound.carrier"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Optional.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Carrier name",
      "prop": "carrierName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.carrierName),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "carrierName", $$v)
      },
      expression: "outbound.carrierName"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Required if carrier is  'Other'.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "user"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.user),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "user", $$v)
      },
      expression: "outbound.user"
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": member.username,
        "value": member.userNo
      }
    })
  }), 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, the user of the first shipment item will be notified.")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Priority",
      "prop": "priority"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.priority),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "priority", $$v)
      },
      expression: "outbound.priority"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 0,
      "label": "Normal"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 1,
      "label": "Medium"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "Urgent"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Numb of box Per Shipment",
      "prop": "splitPackagesNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 99999
    },
    model: {
      value: (_vm.outbound.splitPackagesNum),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "splitPackagesNum", $$v)
      },
      expression: "outbound.splitPackagesNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Instruction",
      "prop": "instruction"
    }
  }, [_c('el-row', [_c('el-select', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "Append preset",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeInstruction
    },
    model: {
      value: (_vm.selectedInstruction),
      callback: function($$v) {
        _vm.selectedInstruction = $$v
      },
      expression: "selectedInstruction"
    }
  }, _vm._l((_vm.instructionTemps), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item,
        "label": item.instructionName
      }
    })
  }), 1), _vm._v(" "), _c('el-link', {
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "click": _vm.getInstructionListByPage
    }
  }, [_vm._v("Instruction Template")])], 1), _vm._v(" "), _c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.outbound.instruction),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "instruction", $$v)
      },
      expression: "outbound.instruction"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Instruction (optional) will only appear in the email sent to the user.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.outbound.note),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "note", $$v)
      },
      expression: "outbound.note"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Store essential information in note for future reference.")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleOutbound
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Working",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.workingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingFilter", $$v)
      },
      expression: "filters.workingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.workingMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingMainFilter", $$v)
      },
      expression: "filters.workingMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOutboundByType', 'working.xls', '1')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.workingLoading),
      expression: "workingLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.workingList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "min-width": "3%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name",
      "min-width": "30%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction",
      "min-width": "22%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note",
      "min-width": "15%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users",
      "min-width": "8%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num",
      "min-width": "5%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "min-width": "12%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row.outboundId)
            }
          }
        }, [_vm._v("Package Label")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.closeOutbound(scope.row.outboundId)
            }
          }
        }, [_vm._v("Cancel")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.workingTotal
    },
    on: {
      "current-change": _vm.changeWorkingList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Archived",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.archivedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedFilter", $$v)
      },
      expression: "filters.archivedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.archivedMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedMainFilter", $$v)
      },
      expression: "filters.archivedMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOutboundByType', 'archived.xls', '2')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.archivedLoading),
      expression: "archivedLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.archivedList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row.outboundId)
            }
          }
        }, [_vm._v("Package Label")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.archivedTotal
    },
    on: {
      "current-change": _vm.changeArchivedList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Cancelled",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCloseOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.closeFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "closeFilter", $$v)
      },
      expression: "filters.closeFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCloseOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCloseOutboundList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.closeMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "closeMainFilter", $$v)
      },
      expression: "filters.closeMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCloseOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOutboundByType', 'Cancelled.xls', '3')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.closeLoading),
      expression: "closeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.closeList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.closeTotal
    },
    on: {
      "current-change": _vm.changeCloseList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Transfer To",
      "name": "five"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "inline": true
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTransferProductList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.productFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productFilter", $$v)
      },
      expression: "filters.productFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTransferProductList
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.productLoading),
      expression: "productLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.productList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Product",
      "width": "400px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.condition) + " - "), _c('b', [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" (" + _vm._s(scope.row.createDate) + ")\n                            "), _c('p', [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stock",
      "label": "FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showWarehouseFBM(scope.row.productNo)
            }
          }
        }, [_vm._v("Transfer")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.productTotal
    },
    on: {
      "current-change": _vm.handleProductPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    key: 'transferLogsTab',
    attrs: {
      "label": "Transfer Logs",
      "name": "six"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.transferLogsLoading),
      expression: "transferLogsLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.transferLogsList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferNo",
      "label": "Transfer#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Transferer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToUserName",
      "label": "Acceptor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseAddress",
      "label": "Transfer Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToAddress",
      "label": "Acceptor Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Transfer Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "moved",
      "label": "Checked"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.moved ? 'green' : 'red'
          })
        }, [_vm._v("\n                                " + _vm._s(scope.row.moved ? "Yes" : "No") + "\n                            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateDate",
      "label": "Checked Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.transferLogsPageSize,
      "total": _vm.transferLogsWorkingTotal
    },
    on: {
      "current-change": _vm.getTrasferUserLogs
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product Summary",
      "width": "80%",
      "visible": _vm.inventroySummary,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.inventroySummary = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchInventorySummary.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.inventoryProductSummary),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryProductSummary", $$v)
      },
      expression: "filters.inventoryProductSummary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchInventorySummary
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter by user",
      "filterable": true
    },
    on: {
      "change": _vm.getInventorySummaryByUser
    },
    model: {
      value: (_vm.filters.inventorySummaryNurse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventorySummaryNurse", $$v)
      },
      expression: "filters.inventorySummaryNurse"
    }
  }, _vm._l((_vm.members), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.filters.inventorySummaryNurse) ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inventorySummaryLoading),
      expression: "inventorySummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inventoriesSummary,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.getInventory(scope.row.productNo)
            }
          }
        }, [_vm._v("Detail")])]
      }
    }], null, false, 2992596343)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventorySummaryTotal
    },
    on: {
      "current-change": _vm.handleInventorySummaryPageChange
    }
  })], 1)], 1) : _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inventorySummaryLoading),
      expression: "inventorySummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inventoriesSummaryByUser,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.selectInventory(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.selected ? 'selected' : 'select'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventorySummaryByUserTotal
    },
    on: {
      "current-change": _vm.handleInventorySummaryByUserPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.inventroySummary = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addInventory,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addInventory = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInventory(null)
      }
    },
    model: {
      value: (_vm.filters.inventoryProduct),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryProduct", $$v)
      },
      expression: "filters.inventoryProduct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getInventory(null)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter by user",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getInventory(null)
      }
    },
    model: {
      value: (_vm.filters.inventoryNurse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryNurse", $$v)
      },
      expression: "filters.inventoryNurse"
    }
  }, _vm._l((_vm.members), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inventoryLoading),
      expression: "inventoryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inventories,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.selectInventory(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.selected ? 'selected' : 'select'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventoryTotal
    },
    on: {
      "current-change": _vm.handleInventoryPageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addInventory = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Customization Product",
      "width": "80%",
      "visible": _vm.customizationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customizationVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Template Name or Mian Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomizationProduct.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.customizationName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "customizationName", $$v)
      },
      expression: "filters.customizationName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCustomizationProduct
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openNewCustomizationWindow
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.customizationLoading),
      expression: "customizationLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customizationProduct,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "templateName",
      "label": "Template Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mainProductName",
      "label": "Main Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h3', [_vm._v(_vm._s(scope.row.product))]), _vm._v(" "), _vm._l((scope.row.items), function(sub, index) {
          return _c('p', {
            key: index,
            staticClass: "note"
          }, [_vm._v("\n                            " + _vm._s(sub.productName) + " * " + _vm._s(sub.qty) + " "), (sub.service && sub.service !== 'None') ? _c('span', {
            staticStyle: {
              "color": "#ff2218"
            }
          }, [_vm._v("(" + _vm._s(sub.service) + ")")]) : _vm._e()])
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.selectCustomization(scope.row)
            }
          }
        }, [_vm._v("Select")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.eitCustomization(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCustomization(scope.row.id)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customizationVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Customization Product",
      "width": "80%",
      "visible": _vm.addCustomizationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addCustomizationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "customization",
    attrs: {
      "model": _vm.customization,
      "label-width": "220px",
      "rules": _vm.customizationRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouse"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.getProductsByWarehouseId
    },
    model: {
      value: (_vm.customization.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.customization, "warehouse", $$v)
      },
      expression: "customization.warehouse"
    }
  }, _vm._l((_vm.warehouses), function(w, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": w.state + ' ' + w.city + ' ' + w.address,
        "value": w.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.customization.warehouse) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Main Product",
      "prop": "mainProduct"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": true
    },
    model: {
      value: (_vm.customization.mainProduct),
      callback: function($$v) {
        _vm.$set(_vm.customization, "mainProduct", $$v)
      },
      expression: "customization.mainProduct"
    }
  }, _vm._l((_vm.inventories), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productNme + '(Stock:' + product.stock + ')'
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Product Qty",
      "prop": "mainProductQty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.customization.mainProductQty),
      callback: function($$v) {
        _vm.$set(_vm.customization, "mainProductQty", $$v)
      },
      expression: "customization.mainProductQty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.customization.name),
      callback: function($$v) {
        _vm.$set(_vm.customization, "name", $$v)
      },
      expression: "customization.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Products"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAccessories
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customization.sub,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.productNo),
            callback: function($$v) {
              _vm.$set(scope.row, "productNo", $$v)
            },
            expression: "scope.row.productNo"
          }
        }, _vm._l((_vm.inventories), function(product, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": product.productNo,
              "label": product.productNme + '(Stock:' + product.stock + ')'
            }
          })
        }), 1)]
      }
    }], null, false, 3483873928)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Qty",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        })]
      }
    }], null, false, 4082218523)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Service",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.service),
            callback: function($$v) {
              _vm.$set(scope.row, "service", $$v)
            },
            expression: "scope.row.service"
          }
        }, [_c('el-option', {
          attrs: {
            "value": "None"
          }
        }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.serviceList), function(service, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": service,
              "label": service
            }
          })
        })], 2)]
      }
    }], null, false, 2962174138)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteSub(scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }], null, false, 1512946399)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addCustomizationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addCustomizationTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Customization Product",
      "width": "80%",
      "visible": _vm.editCustomizationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editCustomizationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editCustomization",
    attrs: {
      "model": _vm.editCustomization,
      "label-width": "220px",
      "rules": _vm.customizationRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouse"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.getProductsByWarehouseId
    },
    model: {
      value: (_vm.editCustomization.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "warehouse", $$v)
      },
      expression: "editCustomization.warehouse"
    }
  }, _vm._l((_vm.warehouses), function(w, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": w.state + ' ' + w.city + ' ' + w.address,
        "value": w.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.editCustomization.warehouse) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editCustomization.name),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "name", $$v)
      },
      expression: "editCustomization.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Product",
      "prop": "mainProduct"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": true
    },
    model: {
      value: (_vm.editCustomization.mainProduct),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "mainProduct", $$v)
      },
      expression: "editCustomization.mainProduct"
    }
  }, _vm._l((_vm.inventories), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productNme + '(Stock:' + product.stock + ')'
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Product Qty",
      "prop": "mainProductQty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.editCustomization.mainProductQty),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "mainProductQty", $$v)
      },
      expression: "editCustomization.mainProductQty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Products"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addEditAccessories
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.editCustomization.sub,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.productNo),
            callback: function($$v) {
              _vm.$set(scope.row, "productNo", $$v)
            },
            expression: "scope.row.productNo"
          }
        }, _vm._l((_vm.inventories), function(product, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": product.productNo,
              "label": product.productNme + '(Stock:' + product.stock + ')'
            }
          })
        }), 1)]
      }
    }], null, false, 3483873928)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Qty",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        })]
      }
    }], null, false, 4082218523)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Service",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.service),
            callback: function($$v) {
              _vm.$set(scope.row, "service", $$v)
            },
            expression: "scope.row.service"
          }
        }, [_c('el-option', {
          attrs: {
            "value": "None"
          }
        }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.serviceList), function(service, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": service,
              "label": service
            }
          })
        })], 2)]
      }
    }], null, false, 2962174138)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteEditSub(scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }], null, false, 1628885603)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editCustomizationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editCustomizationTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Instruction Template",
      "width": "80%",
      "visible": _vm.instructionTemplateVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.instructionTemplateVisiable = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addInstructionVisible = true
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.instructionLoading),
      expression: "instructionLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.instructionListPage,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instructionName",
      "label": "Instruction Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Text"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instructionText)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instructionNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editInstruction(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteInstruction(scope.row.id)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.instructionTotal
    },
    on: {
      "current-change": _vm.handleInventoryPageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.instructionTemplateVisiable = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Instruction",
      "width": "80%",
      "visible": _vm.addInstructionVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addInstructionVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addInstruction",
    attrs: {
      "model": _vm.addInstruction,
      "label-width": "220px",
      "rules": _vm.addInstructionRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addInstruction.name),
      callback: function($$v) {
        _vm.$set(_vm.addInstruction, "name", $$v)
      },
      expression: "addInstruction.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Text",
      "prop": "text"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.addInstruction.text),
      callback: function($$v) {
        _vm.$set(_vm.addInstruction, "text", $$v)
      },
      expression: "addInstruction.text"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.addInstruction.note),
      callback: function($$v) {
        _vm.$set(_vm.addInstruction, "note", $$v)
      },
      expression: "addInstruction.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addInstructionVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddInstruction.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Instruction",
      "width": "80%",
      "visible": _vm.editInstructionVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editInstructionVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editInstructionObj",
    attrs: {
      "model": _vm.editInstructionObj,
      "label-width": "220px",
      "rules": _vm.addInstructionRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editInstructionObj.name),
      callback: function($$v) {
        _vm.$set(_vm.editInstructionObj, "name", $$v)
      },
      expression: "editInstructionObj.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Text",
      "prop": "text"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.editInstructionObj.text),
      callback: function($$v) {
        _vm.$set(_vm.editInstructionObj, "text", $$v)
      },
      expression: "editInstructionObj.text"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.editInstructionObj.note),
      callback: function($$v) {
        _vm.$set(_vm.editInstructionObj, "note", $$v)
      },
      expression: "editInstructionObj.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editInstructionVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleEditInstruction.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product FBM List",
      "width": "80%",
      "visible": _vm.fbmModelVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.fbmModelVisiable = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fbmLoading),
      expression: "fbmLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.fbmDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showTransfer(scope.row.productNo, scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Transfer To")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.fbmTotal
    },
    on: {
      "current-change": _vm.handleInventoryDetailPageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fbmModelVisiable = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Transfer To",
      "width": "40%",
      "visible": _vm.transferModelVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.transferModelVisiable = $event
      }
    }
  }, [_c('el-form', {
    ref: "transferForm",
    attrs: {
      "model": _vm.transferForm,
      "label-width": "220px",
      "rules": _vm.transferRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.productName),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "productName", $$v)
      },
      expression: "transferForm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "warehouse", $$v)
      },
      expression: "transferForm.warehouse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.upc),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "upc", $$v)
      },
      expression: "transferForm.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Qty"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.qty),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "qty", $$v)
      },
      expression: "transferForm.qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer To",
      "prop": "to"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "User Name"
    },
    model: {
      value: (_vm.transferForm.to),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "to", $$v)
      },
      expression: "transferForm.to"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer Qty",
      "prop": "transferQty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "max": parseInt(_vm.transferForm.qty)
    },
    model: {
      value: (_vm.transferForm.transferQty),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "transferQty", $$v)
      },
      expression: "transferForm.transferQty"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.transferModelVisiable = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.transferTo.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add Self Storage")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouses,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "City"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "State"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zipCode",
      "label": "Zip Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getWarehousesById(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteWarehouses(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": function($event) {}
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add warehouse",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehouseForm",
    attrs: {
      "model": _vm.warehouseForm,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.address),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "address", $$v)
      },
      expression: "warehouseForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.city),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "city", $$v)
      },
      expression: "warehouseForm.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.state),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "state", $$v)
      },
      expression: "warehouseForm.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "zipCode", $$v)
      },
      expression: "warehouseForm.zipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addWarehouse.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit warehouse",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editWarehouseObj",
    attrs: {
      "model": _vm.editWarehouseObj,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.state),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "state", $$v)
      },
      expression: "editWarehouseObj.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.city),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "city", $$v)
      },
      expression: "editWarehouseObj.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.address),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "address", $$v)
      },
      expression: "editWarehouseObj.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "zipCode", $$v)
      },
      expression: "editWarehouseObj.zipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editWarehouse.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Inventory",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInventory.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInventory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseInventory', 'Inventory.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.goToMixedPackageClaim
    }
  }, [_vm._v("Mixed Package")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.products,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "left",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showReportInventory(scope.row)
            }
          }
        }, [_vm._v("Report")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), (_vm.role == 3) ? _c('el-tab-pane', {
    attrs: {
      "label": "Zero Storage",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getZeroInventory.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.zeroName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "zeroName", $$v)
      },
      expression: "filters.zeroName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getZeroInventory
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.zeroInventory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 1750233183)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 1926563046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "left",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.zeroInventroyTotal
    },
    on: {
      "current-change": _vm.handleZeroChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.role == 3) ? _c('el-tab-pane', {
    attrs: {
      "label": "Products",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDoctorProductList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.doctorProductName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "doctorProductName", $$v)
      },
      expression: "filters.doctorProductName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getDoctorProductList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.doctorProductList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 1750233183)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 1926563046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditProduct(scope.row)
            }
          }
        }, [_vm._v("Edit Product")])]
      }
    }], null, false, 2749166596)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleProductChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.role == 3) ? _c('el-tab-pane', {
    attrs: {
      "label": "Product Pool",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getProductTemplateList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.productTemplateCondition),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productTemplateCondition", $$v)
      },
      expression: "filters.productTemplateCondition"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProductTemplateList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.productTemplateAddFormVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.productTemplateList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 1750233183)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 1926563046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFreeDuration",
      "label": "Storage Free Duration (Month)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.storageFreeDuration != null ? scope.row.storageFreeDuration : "Not Set") + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 2879858912)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Not Distribute")]) : (scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Distributed")]) : _vm._e()]
      }
    }], null, false, 1894842330)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditProductTemplate(scope.row)
            }
          }
        }, [_vm._v("Edit Product Template")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.showDistributeSelectDoctorWin(scope.row)
            }
          }
        }, [_vm._v("Distribute")])]
      }
    }], null, false, 1468722737)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.productTemplateTotal
    },
    on: {
      "current-change": _vm.handleProductTemplateChange
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Report Missing Items",
      "width": "80%",
      "visible": _vm.reportFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.reportFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "report",
    attrs: {
      "model": _vm.report,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.report.product),
      callback: function($$v) {
        _vm.$set(_vm.report, "product", $$v)
      },
      expression: "report.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Missing Item",
      "prop": "id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeItem()
      }
    },
    model: {
      value: (_vm.report.id),
      callback: function($$v) {
        _vm.$set(_vm.report, "id", $$v)
      },
      expression: "report.id"
    }
  }, _vm._l((_vm.report.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.displayName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.report.quantity),
      callback: function($$v) {
        _vm.$set(_vm.report, "quantity", $$v)
      },
      expression: "report.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.report.note),
      callback: function($$v) {
        _vm.$set(_vm.report, "note", $$v)
      },
      expression: "report.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.reportFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleReportInventory.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProduct",
    attrs: {
      "model": _vm.addProduct,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.product),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "product", $$v)
      },
      expression: "addProduct.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.size),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "size", $$v)
      },
      expression: "addProduct.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.addProduct.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "storageFreeDuration", $$v)
      },
      expression: "addProduct.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "condition", $$v)
      },
      expression: "addProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "asin", $$v)
      },
      expression: "addProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "upc", $$v)
      },
      expression: "addProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "weight", $$v)
      },
      expression: "addProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "note", $$v)
      },
      expression: "addProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProduct.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product",
      "width": "80%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editProduct",
    attrs: {
      "model": _vm.editProduct,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.productName),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "productName", $$v)
      },
      expression: "editProduct.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editProduct.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "storageFreeDuration", $$v)
      },
      expression: "editProduct.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.size),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "size", $$v)
      },
      expression: "editProduct.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "condition", $$v)
      },
      expression: "editProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "asin", $$v)
      },
      expression: "editProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "upc", $$v)
      },
      expression: "editProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "weight", $$v)
      },
      expression: "editProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "note", $$v)
      },
      expression: "editProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product Template",
      "width": "80%",
      "visible": _vm.productTemplateAddFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.productTemplateAddFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProductTemplate",
    attrs: {
      "model": _vm.addProductTemplate,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.product),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "product", $$v)
      },
      expression: "addProductTemplate.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.size),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "size", $$v)
      },
      expression: "addProductTemplate.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.addProductTemplate.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "storageFreeDuration", $$v)
      },
      expression: "addProductTemplate.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "condition", $$v)
      },
      expression: "addProductTemplate.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProductTemplate.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "asin", $$v)
      },
      expression: "addProductTemplate.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProductTemplate.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "upc", $$v)
      },
      expression: "addProductTemplate.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProductTemplate.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "weight", $$v)
      },
      expression: "addProductTemplate.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.note),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "note", $$v)
      },
      expression: "addProductTemplate.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.productTemplateAddFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProductTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product Template",
      "width": "80%",
      "visible": _vm.productTemplateEditFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.productTemplateEditFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editProductTemplate",
    attrs: {
      "model": _vm.editProductTemplate,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.productName),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "productName", $$v)
      },
      expression: "editProductTemplate.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editProductTemplate.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "storageFreeDuration", $$v)
      },
      expression: "editProductTemplate.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.size),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "size", $$v)
      },
      expression: "editProductTemplate.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.condition),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "condition", $$v)
      },
      expression: "editProductTemplate.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProductTemplate.asin),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "asin", $$v)
      },
      expression: "editProductTemplate.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.editProductTemplate.status == 1 ? true : false
    },
    model: {
      value: (_vm.editProductTemplate.upc),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "upc", $$v)
      },
      expression: "editProductTemplate.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProductTemplate.weight),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "weight", $$v)
      },
      expression: "editProductTemplate.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.note),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "note", $$v)
      },
      expression: "editProductTemplate.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.productTemplateEditFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmitTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Select which users to send under",
      "width": "80%",
      "visible": _vm.selectDoctorsVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.selectDoctorsVisible = $event
      }
    }
  }, [_c('div', _vm._l((_vm.selectedDoctorNames), function(userName, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "effect": "dark"
      }
    }, [_vm._v(_vm._s(userName))])
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.distributeSelectedDoctors),
      callback: function($$v) {
        _vm.distributeSelectedDoctors = $$v
      },
      expression: "distributeSelectedDoctors"
    }
  }, _vm._l((_vm.doctorList), function(user, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": user.userName,
        "value": user.userNo
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.selectDoctorsVisible = false;
        _vm.distributeSelectedDoctors = [];
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.distributeProductTempate.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })
],[415]);


// WEBPACK FOOTER //
// static/js/app.c79eab23fd237bac0274.js